<template>
  <div>
    <div class="lds-ring" v-if="!isLoad">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <main class="main-content">
      <div :class="['page-content', printMode]" v-if="isLoad">
        <form
            action="javascript:void(0)"
            @keydown.enter.prevent
            @keypress.enter.prevent
            @submit.prevent
            class="make-story-form"
            id="group-info">
          <section class="make-story">
            <div class="container-lg">
              <div class="page-title">
                <h2>Make a Story</h2>
              </div>
              <div class="managers-header-wrapper"
                   v-if="user.scope.includes('ADMIN') || user.scope.includes('ACCOUNTANT')">
                <span class="managers-header__title">Managers:</span>
                <span v-for="user in sharedUsers" class="managers-item__wrapper">
                  <span class="managers-icon-resize">
                    <img
                        v-if="user.photoId"
                        :src="`${API}/documents/share/images/${user.photoId}?size=SMALL`"
                        alt="image"
                        draggable="false"/>
                  </span>
                  <span class="managers-header__name">{{ user.name }}</span>
                </span>
              </div>
              <div class="main-top">
                <div class="btn-recover">
                  <a
                      v-if="boardLeadId"
                      class="btn btn--green"
                      :href="`https://board.altezza.travel/crm/leads/${boardLeadId}/`"
                      target="_blank"
                      rel="noopener noreferrer">
                    <span>Open in Board</span>
                  </a>
                  <button v-else type="button" class="btn btn--green" disabled>
                    <span>Open in Board</span>
                  </button>
                  <button
                      type="button"
                      class="btn btn--blue"
                      @click="recoveryPopup = true">
                    <span>Recover version</span>
                  </button>
                </div>
                <div class="tabs-nav">
                  <a
                      :class="['tabs-nav__item', {active: tab === 0}]"
                      @click="tab = 0">
                    <svg width="1em" height="1em" class="icon icon-itinerary">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-itinerary"></use>
                    </svg>
                    <span class="tabs-nav__text">Itinerary</span>
                  </a>
                  <a
                      :class="[
                      'tabs-nav__item',
                      {active: tab === 1},
                      {disabled: data.id ? false : true},
                    ]"
                      @click="tab = 1">
                    <svg width="1em" height="1em" class="icon icon-details">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-details"></use>
                    </svg>
                    <span class="tabs-nav__text">Quick Details</span>
                  </a>
                  <a
                      :class="[
                      'tabs-nav__item',
                      {active: tab === 2},
                      {disabled: data.id ? false : true},
                    ]"
                      @click="tab = 2">
                    <svg width="1em" height="1em" class="icon icon-cost">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-cost"></use>
                    </svg>
                    <span class="tabs-nav__text">Cost</span>
                  </a>
                  <a
                      :class="[
                      'tabs-nav__item',
                      {active: tab === 3},
                      {disabled: data.id ? false : true},
                    ]"
                      @click="tab = 3">
                    <svg width="1em" height="1em" class="icon icon-invoices">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-invoices"></use>
                    </svg>
                    <span class="tabs-nav__text">Invoices</span>
                  </a>
                </div>
              </div>
              <div class="make-story-form__content" v-show="tab === 0">
                <div class="make-story-form__options">
                  <!-- <div class="make-story__settings">
							<div class="form-control-group"><span class="form-control-label">Group Name</span>
							<div :class="['form-control-wrap', { 'is-error' : mainErrors.name }]">
								<input type="text" Placeholder="Group Name" v-model="data.groupName" @input="isEditFlag = true" @focus="mainErrors.name = false" class="form-control" />
							</div>
							</div>
							<div class="form-control-group"><span class="form-control-label">Group Email (Optional)</span>
							<div :class="['form-control-wrap', { 'is-error' : mainErrors.email }]">
								<input type="email" Placeholder="Group Email" v-model="data.groupEmail" @click="mainErrors.email = false" @input="isEditFlag = true;data.groupEmail = $event.target.value.replace(/[^A-Za-z0-9@\-_\.]/g, '')" class="form-control" />
							</div>
							</div>
							<div class="form-control-group"><span class="form-control-label">Status</span>
							<div :class="['select-wrapper form-control__help', {'is-active' : selects.status} ]" @click="changeSelectsMain('status');isEditFlag = true;participants = participants.map(item => ({...item, genderSelect: false, residenceSelect: false}))">
								<div class="select-trigger"> <span class="select-trigger__name"><span :class="['status-item-new', currentStatusOption.class]">{{currentStatusOption.name}}</span></span> <span
									class="select-trigger__icon">
									<svg width="1em" height="1em" class="icon icon-chevron ">
									<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
									</svg></span></div>
								<div class="select-body">
									<div
										v-for="item in dataSelects.status"
										:key="item.data"
										:class="['select-option', { 'is-selected' : item.active }]" @click="dataSelects.status = dataSelects.status.map(i => i.data === item.data ? ({...i, active: true}) : ({...i, active: false}));calcTemplatePriceHandler()"><span :class="['status-item-new select-option__name', item.class]">{{item.name}}</span>
									</div>
								</div>
							</div>
							</div>
						</div>
						<div class="make-story__settings">
							<div class="form-control-group"><span class="form-control-label">Tour Operator</span>
							<div :class="['select-wrapper form-control__help', {'is-active' : selects.operator} ]" @click="changeSelectsMain('operator');isEditFlag = true;participants = participants.map(item => ({...item, genderSelect: false,residenceSelect: false}))">
								<div class="select-trigger"><span class="select-trigger__name">{{dataSelects.operator.find(item => item.active).name}}</span><span
									class="select-trigger__icon">
									<svg width="1em" height="1em" class="icon icon-chevron ">
									<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
									</svg></span></div>
								<div class="select-body">
								<div class="select-inner js-scrollbar">
									<div
										v-for="item in dataSelects.operator"
										:key="item.name"
										:class="['select-option', { 'is-selected' : item.active }]" @click="dataSelects.operator = dataSelects.operator.map(i => i.name === item.name ? ({...i, active: true}) : ({...i, active: false}));calcTemplatePriceHandler()"><span class="select-option__name">{{item.name}}</span>
									</div>
								</div>
								</div>
							</div>
							</div>
							<div class="form-control-group form-control-group--sm"><span
								class="form-control-label">Currency</span>
							<div :class="['select-wrapper select-wrapper--sm', {'is-active' : selects.currency} ]" @click="changeSelectsMain('currency');isEditFlag = true;participants = participants.map(item => ({...item, genderSelect: false, residenceSelect: false}))">
								<div class="select-trigger"><span class="select-trigger__name">{{dataSelects.currency.find(item => item.active).name}}</span><span
									class="select-trigger__icon">
									<svg width="1em" height="1em" class="icon icon-chevron ">
									<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
									</svg></span></div>
								<div class="select-body">
								<div class="select-inner js-scrollbar">
									<div
										v-for="item in dataSelects.currency"
										:key="item.name"
										:class="['select-option', { 'is-selected' : item.active }]" @click="dataSelects.currency = dataSelects.currency.map(i => i.name === item.name ? ({...i, active: true}) : ({...i, active: false}));calcTemplatePriceHandler()"><span class="select-option__name">{{item.name}}</span>
									</div>
								</div>
								</div>
							</div>
							</div>
							<div class="form-control-group"><span class="form-control-label">Choose Language:</span>
							<div :class="['select-wrapper select-wrapper__lang', {'is-active' : selects.lang} ]" @click="changeSelectsMain('lang');isEditFlag = true;participants = participants.map(item => ({...item, genderSelect: false, residenceSelect: false}))">
								<div class="select-trigger">
								<div class="select-trigger__flag__icon">
									<svg width="1em" height="1em" class="icon icon-gb" :style="{width: '18px', height: '18px'}">
										<use :xlink:href="'/images/useful/svg/theme/symbol-defs.svg#icon-' + dataSelects.lang.find(item => item.active).icon"></use>
									</svg>
								</div><span class="select-trigger__name">{{dataSelects.lang.find(item => item.active).name}}</span><span class="select-trigger__icon">
									<svg width="1em" height="1em" class="icon icon-chevron ">
									<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
									</svg></span>
								</div>
								<div class="select-body">
								<div class="select-inner js-scrollbar">
									<div
										v-for="item in dataSelects.lang"
										:key="item.name"
										:class="['select-option', { 'is-selected' : item.active }]" @click="dataSelects.lang = dataSelects.lang.map(i => i.name === item.name ? ({...i, active: true}) : ({...i, active: false}));calcTemplatePriceHandler()">
										<span class="select-option__name"><div class="select-trigger__flag__icon">
											<svg width="1em" height="1em" class="icon icon-gb " :style="{width: '18px', height: '18px', marginBottom: '1px'}">
												<use :xlink:href="'/images/useful/svg/theme/symbol-defs.svg#icon-' + item.icon"></use>
											</svg>
											</div>{{item.name}}
										</span>
									</div>
									</div>
								</div>
							</div>
							</div>
							<div class="form-control-group"><span class="form-control-label">Price Valid up to:</span>

							<div :class="['select-wrapper form-control__help', {'is-active' : selects.priceValid} ]" @click="changeSelectsMain('priceValid');isEditFlag = true;participants = participants.map(item => ({...item, genderSelect: false, residenceSelect: false}))">
								<span class="form-control__help-icon">
								<span class="form-control__help-content">Укажите на какое время будет актуальна данная стоимость тура для клиента, по-умолчанию 60 дней, если в течении этого периода депозит не будет внесен, стоимость может быть пересчитана. Во время действия специальных акций сокращайте до 30 дней.</span>
								<img src="/images/useful/svg/help-icon.svg" alt="">
								</span>
								<div class="select-trigger"><span class="select-trigger__name">{{dataSelects.valid.find(item => item.active).name}} days</span><span
									class="select-trigger__icon">
									<svg width="1em" height="1em" class="icon icon-chevron ">
									<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
									</svg></span></div>
								<div class="select-body">
								<div class="select-inner js-scrollbar">
									<div
										v-for="item in dataSelects.valid"
										:key="item.name"
										:class="['select-option', { 'is-selected' : item.active }]" @click="dataSelects.valid = dataSelects.valid.map(i => i.name === item.name ? ({...i, active: true}) : ({...i, active: false}));calcTemplatePriceHandler()"><span class="select-option__name">{{item.name}} days</span>
									</div>
								</div>
								</div>
							</div>
							</div>
						</div> -->
                  <div class="make-story__settings">
                    <div class="form-control-group">
                      <span class="form-control-label">Status</span>
                      <div
                          :class="[
                          'select-wrapper form-control__help',
                          {'is-active': selects.status},
                        ]"
                          @click="
                          changeSelectsMain('status')
                          isEditFlag = true
                          participants = participants.map((item) => ({
                            ...item,
                            genderSelect: false,
                            residenceSelect: false,
                          }))
                        ">
                        <div class="select-trigger">
                          <span class="select-trigger__name"
                          ><span
                              :class="[
                                'status-item-new',
                                currentStatusOption.class,
                              ]"
                          >{{
                              currentStatusOption.name
                            }}</span
                          ></span
                          >
                          <span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div
                              v-for="item in dataSelects.status"
                              :key="item.data"
                              :class="[
                              'select-option',
                              {'is-selected': item.active},
                            ]"
                              @click="
                              dataSelects.status = dataSelects.status.map((i) =>
                                i.data === item.data
                                  ? {...i, active: true}
                                  : {...i, active: false}
                              )
                              calcTemplatePriceHandler()
                            ">
                            <span
                                :class="[
                                'status-item-new select-option__name',
                                item.class,
                              ]"
                            >{{ item.name }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-control-group">
                      <span class="form-control-label">Operator</span>
                      <div
                          :class="[
                          'select-wrapper form-control__help',
                          {'is-active': selects.operator},
                        ]"
                          @click="
                          changeSelectsMain('operator')
                          isEditFlag = true
                          participants = participants.map((item) => ({
                            ...item,
                            genderSelect: false,
                            residenceSelect: false,
                          }))
                        ">
                        <div class="select-trigger">
                          <span class="select-trigger__name">{{
                              dataSelects.operator.find((item) => item.active)
                                  ? dataSelects.operator.find((item) => item.active)
                                      .companyName
                                  : ''
                            }}</span
                          ><span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="item in dataSelects.operator"
                                :key="item.id"
                                :class="[
                                'select-option',
                                {'is-selected': item.active},
                              ]"
                                @click="
                                dataSelects.operator = dataSelects.operator.map(
                                  (i) =>
                                    i.companyName === item.companyName
                                      ? {...i, active: true}
                                      : {...i, active: false}
                                )
                                calcTemplatePriceHandler()
                              ">
                              <span class="select-option__name">{{
                                  item.companyName
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-control-group form-control-group--sm">
                      <span class="form-control-label">Currency</span>
                      <div
                          :class="[
                          'select-wrapper select-wrapper--sm',
                          {'is-active': selects.currency},
                        ]"
                          @click="
                          changeSelectsMain('currency')
                          isEditFlag = true
                          participants = participants.map((item) => ({
                            ...item,
                            genderSelect: false,
                            residenceSelect: false,
                          }))
                        ">
                        <div class="select-trigger">
                          <span class="select-trigger__name">{{
                              dataSelects.currency.find((item) => item.active)
                                  .name
                            }}</span
                          ><span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="item in dataSelects.currency"
                                :key="item.name"
                                :class="[
                                'select-option',
                                {'is-selected': item.active},
                              ]"
                                @click="
                                dataSelects.currency = dataSelects.currency.map(
                                  (i) =>
                                    i.name === item.name
                                      ? {...i, active: true}
                                      : {...i, active: false}
                                )
                                calcTemplatePriceHandler()
                              ">
                              <span class="select-option__name">{{
                                  item.name
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-control-group">
                      <span class="form-control-label">Language:</span>
                      <div
                          :class="[
                          'select-wrapper select-wrapper__lang',
                          {'is-active': selects.lang},
                        ]"
                          @click="
                          changeSelectsMain('lang')
                          isEditFlag = true
                          participants = participants.map((item) => ({
                            ...item,
                            genderSelect: false,
                            residenceSelect: false,
                          }))
                        ">
                        <div class="select-trigger">
                          <div class="select-trigger__flag__icon">
                            <img
                                :src="`/countries/${dataSelects.lang.find((item) => item.active).icon}.svg`"
                                :alt="dataSelects.lang.find((item) => item.active).name"
                                class="language-flag"
                                draggable="false"
                                :style="{width: '18px', height: '18px'}"/>
                          </div>
                          <span class="select-trigger__name">{{
                              dataSelects.lang.find((item) => item.active).name
                            }}</span
                          ><span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="item in dataSelects.lang"
                                :key="item.name"
                                :class="[
                                'select-option',
                                {'is-selected': item.active},
                              ]"
                                @click="
                                dataSelects.lang = dataSelects.lang.map((i) =>
                                  i.name === item.name
                                    ? {...i, active: true}
                                    : {...i, active: false}
                                )
                                calcTemplatePriceHandler()
                              ">
                              <span class="select-option__name"
                              ><div class="select-trigger__flag__icon">
                                  <img
                                      :src="`/countries/${item.icon}.svg`"
                                      :alt="item.name"
                                      class="language-flag"
                                      draggable="false"
                                      :style="{
                                      width: '18px',
                                      height: '18px',
                                      marginBottom: '3px',
                                    }"/>
                                </div>
                                {{ item.name }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-control-group form-control-group-vaild">
                      <span class="form-control-label">Valid up to:</span>
                      <div class="form-control__help">
                        <span class="form-control__help-icon">
                          <span class="form-control__help-content">
                            Используется для фиксирования стоимости тура. <br/>
                            Пример: вы поставили, что цена валидна до 31 января
                            2022 года. Даже если в этот период изменятся цены на
                            отели, перелеты, машины, парковые сборы - программа
                            не будет пересчитываться и мы гарантируем цену для
                            клиента. Но 1 февраля 2022, если клиент не внес
                            предоплату, калькулятор предложит вам пересчитать
                            программу.
                            <br/><b
                          >Оптимально выставлять на 60 дней вперед.</b
                          >
                          </span>
                          <img src="/images/useful/svg/help-icon.svg" alt=""/>
                        </span>

                        <div class="form-control-wrap">
                          <input
                              type="text"
                              placeholder="Date"
                              v-model="data.priceValidUpTo"
                              @blur="data.priceValidUpTo = $event.target.value"
                              class="form-control js-datepicker-single"/>
                          <div class="form-control-icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-calendar">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="make-story__settings">
                    <div class="form-control-group">
                      <span class="form-control-label">Group Name</span>
                      <div
                          :class="[
                          'form-control-wrap',
                          {'is-error': mainErrors.name},
                        ]">
                        <input
                            type="text"
                            Placeholder="Group Name"
                            v-model="data.groupName"
                            @input="isEditFlag = true"
                            @focus="mainErrors.name = false"
                            class="form-control"/>
                      </div>
                      <div class="form-control-group">
                        <label for="chk_telegram" class="form-control-checkbox">
                          <input
                              id="chk_telegram"
                              type="checkbox"
                              v-model="data.priority"/><span
                            class="form-control-checkbox__box">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-check">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                        ><span class="form-control-checkbox__name"
                        >Priority Client</span
                        >
                          <svg width="1em" height="1em" class="icon icon-fire">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fire"></use>
                          </svg>
                        </label>
                      </div>
                    </div>
                    <div class="form-control-group">
                      <span class="form-control-label">Email</span>
                      <div
                          :class="[
                          'form-control-wrap',
                          {'is-error': mainErrors.email},
                        ]">
                        <input
                            type="email"
                            Placeholder="Email"
                            v-model="data.groupEmail"
                            @click="mainErrors.email = false"
                            @input="
                            isEditFlag = true
                            data.groupEmail = $event.target.value.replace(
                              /[^A-Za-z0-9@\-_\.]/g,
                              ''
                            )
                          "
                            @focus="emailEnter = true"
                            @blur="emailEnter = false"
                            class="form-control"/>
                      </div>
                      <label
                          for="chk_1"
                          class="form-control-checkbox"
                          :style="{opacity: 0, visibility: 'hidden'}">
                        <input
                            id="chk_1"
                            type="checkbox"
                            v-model="data.groupEmailCheck"/><span
                          class="form-control-checkbox__box">
                          <svg width="1em" height="1em" class="icon icon-check">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                      ><span
                          class="form-control-checkbox__name form-control__help"
                      >Group email
                          <span class="form-control__help-icon">
                            <span class="form-control__help-content"
                            >Подробнее читайте в нашем
                              <a href="#">FAQ</a></span
                            >
                            <img
                                src="/images/useful/svg/help-icon.svg"
                                alt=""/> </span
                          ></span>
                      </label>
                    </div>
                    <div
                        class="managers-add-form__col managers-add-form__col--xl"
                        :style="{marginBottom: '2rem'}">
                      <div class="form-control-group">
                        <span class="form-control-label">Phone</span>
                        <div class="form-control-wrap">
                          <app-phone
                              v-model="data.number"
                              placeholder="Start typing the number"/>
                        </div>
                      </div>

                      <div class="managers-add-form__socials">
                        <div class="form-control-group">
                          <label
                              for="chk_telegram2"
                              class="form-control-checkbox">
                            <input
                                id="chk_telegram2"
                                type="checkbox"
                                v-model="data.telegram"/><span
                              class="form-control-checkbox__box">
                              <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-check">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                          ><span class="form-control-checkbox__name"
                          >Telegram</span
                          ><img
                              src="/images/useful/svg/telegram.svg"
                              alt="telegram"
                              class="form-control-checkbox__img"/>
                          </label>
                        </div>
                        <div class="form-control-group">
                          <label
                              for="chk_wahtsapp"
                              class="form-control-checkbox">
                            <input
                                id="chk_wahtsapp"
                                type="checkbox"
                                v-model="data.whatsapp"/><span
                              class="form-control-checkbox__box">
                              <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-check">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                          ><span class="form-control-checkbox__name"
                          >WhatsApp</span
                          ><img
                              src="/images/useful/svg/whatsapp.svg"
                              alt="whatsapp"
                              class="form-control-checkbox__img"/>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="make-story__bottom" v-show="tab === 0">
            <div class="container-lg">
              <div class="make-story__collapse__inner__line">
                <div class="form-control-group">
                  <span class="form-control-label">Duration:</span>
                  <div
                      :class="[
                      'form-control-wrap form-control-wrap--days',
                      {'is-error': mainErrors.duration},
                    ]">
                    <input
                        type="text"
                        Placeholder="0"
                        v-model="duration"
                        @input="
                        duration = $event.target.value.replace(/[^0-9]/g, '')
                        duration = +duration > 45 ? 45 : duration
                      "
                        @focus="
                        isEditFlag = true
                        mainErrors.duration = false
                      "
                        class="form-control"/>
                    <div class="form-control-label-descr">
                      <span>Days</span>
                    </div>
                  </div>
                </div>
                <div
                    class="form-control-datepicker form-control-datepicker--labeled">
                  <div class="form-control-group">
                    <span class="form-control-label-main">Start</span
                    ><span class="form-control-label">From</span>
                    <div class="form-control-wrap">
                      <input
                          type="text"
                          ref="tourStart"
                          @blur="
                          tourStart = $event.target.value
                          isEditFlag = true
                        "
                          @keydown.prevent="
                          ($event) => {
                            let key = $event.keyCode || $event.charCode
                            if (key == 8 || key == 46) {
                              tourStart = ''
                              $event.target.value = ''
                            }
                          }
                        "
                          @keypress.prevent
                          @keyup.prevent
                          Placeholder="Date From"
                          class="form-control js-datepicker-single"/>
                      <div class="form-control-icon">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-calendar">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="form-control-group">
                    <span class="form-control-label-main">Finish</span
                    ><span class="form-control-label">To</span>
                    <div class="form-control-wrap">
                      <input
                          type="text"
                          ref="tourFinish"
                          disabled="true"
                          @blur="
                          tourFinish = $event.target.value
                          isEditFlag = true
                        "
                          Placeholder="Date To"
                          class="form-control js-datepicker-single"/>
                      <div class="form-control-icon">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-calendar">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                    class="btn btn--green edit-popup__submit make-story__collapse__inner__line-btn"
                    @click="
                    changeNumDays()
                    !isEdit
                      ? createClientsHandler(true, false)
                      : updateClientsHandler()
                  ">
                  <span>{{ !isEdit ? 'Apply' : 'Update' }}</span>
                </button>
              </div>
              <div
                  class="form-control-group make-story__checkbox"
                  v-if="data.id">
                <label
                    class="form-control-checkbox"
                    @click.prevent="
                    data.itineraryWithoutPrice = !data.itineraryWithoutPrice
                    isEditFlag = true
                    calcTemplatePriceHandler()
                  ">
                  <input
                      type="checkbox"
                      :checked="data.itineraryWithoutPrice"
                      @click.stop.prevent/><span
                    class="form-control-checkbox__box">
                    <svg width="1em" height="1em" class="icon icon-check">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                ><span class="form-control-checkbox__name form-control__help"
                >Make itinerary without price
                    <span class="form-control__help-icon">
                      <span class="form-control__help-content"
                      >Check the box if you need to offer the client a
                        provisional program without calculating the cost.</span
                      >
                      <img
                          src="/images/useful/svg/help-icon.svg"
                          alt=""/> </span
                    ></span>
                </label>
                <label
                    class="form-control-checkbox"
                    @click.prevent="
                    data.itineraryWithNames = !data.itineraryWithNames
                    calcTemplatePriceHandler()
                    isEditFlag = true
                  ">
                  <input
                      type="checkbox"
                      :checked="data.itineraryWithNames"
                      @click.stop.prevent/><span
                    class="form-control-checkbox__box">
                    <svg width="1em" height="1em" class="icon icon-check">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                ><span class="form-control-checkbox__name form-control__help"
                >Make itinerary with names
                    <span class="form-control__help-icon">
                      <span class="form-control__help-content"
                      >Check the box if customers' names shouldn't be on the
                        program - relevant for cases when you do not know the
                        names.</span
                      >
                      <img
                          src="/images/useful/svg/help-icon.svg"
                          alt=""/> </span
                    ></span>
                </label>
                <Checkbox label="Hide welcome texts" v-model="data.hideWelcomeTexts"/>
              </div>
            </div>
          </div>
          <div
              class="participants"
              ref="participants"
              v-if="data.id"
              v-show="tab === 0">
            <div class="container-lg">
              <div class="section-title">
                <h3>Group Participants</h3>
              </div>
              <div class="participants-content">
                <div
                    class="make-story__settings participants-item"
                    :style="{paddingBottom: '0px', marginBottom: '0px'}"
                    v-for="(item, index) in participants"
                    :key="index">
                  <div
                      class="participants-num"
                      :style="index > 0 ? {marginBottom: '2rem'} : {}">
                    {{ index + 1 }}.
                  </div>
                  <div class="form-control-group">
                    <span class="form-control-label" v-if="index === 0"
                    >Name and Surname</span
                    >
                    <div>
                      <input
                          type="text"
                          Placeholder="Client Name"
                          v-model="item.name"
                          @input="
                          isEditFlag = true
                        "
                          class="form-control"/>
                    </div>
                  </div>
                  <div class="form-control-group form-control-group--sm">
                    <span v-if="index === 0" class="form-control-label"
                    >Date of Birth</span
                    >
                    <div
                        :class="[
                        'form-control-wrap',
                        {'is-error': item.errorBirth},
                      ]">
                      <input
                          type="text"
                          placeholder="Date"
                          :value="item.dateOfBirth"
                          :ref="'participantsDateRef' + index"
                          @focus="
                          isEditFlag = true
                          item.errorBirth = false
                        "
                          @blur="onChangeBirthdayCalendar($event, item)"
                          @keydown.prevent
                          @keypress.prevent
                          @keyup.prevent
                          class="form-control js-datepicker-single-age"/>
                      <div class="form-control-icon">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-calendar">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="form-control-group form-control-group--age">
                    <span v-if="index === 0" class="form-control-label"
                    >Age</span
                    >
                    <div class="form-control-wrap">
                      <input
                          type="text"
                          Placeholder="Age"
                          disabled
                          :value="item.age"
                          class="form-control form-control-age"/>
                      <div class="form-control-icon age-box__icon">
                        <svg
                            width="1em"
                            height="1em"
                            :class="[
                            'icon icon-' +
                              (item.age > 0 && item.age <= 4
                                ? 'child'
                                : item.age > 4 && item.age <= 15
                                ? 'teenager'
                                : 'adult'),
                          ]">
                          <use
                              :xlink:href="
                              '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                              (item.age > 0 && item.age <= 4
                                ? 'child'
                                : item.age > 4 && item.age <= 15
                                ? 'teenager'
                                : 'adult')
                            "></use>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div class="form-control-group select-wrapper__gender">
                    <span v-if="index === 0" class="form-control-label"
                    >Gender</span
                    >
                    <div
                        :class="[
                        'select-wrapper select-wrapper_gender',
                        {'is-active': item.genderSelect},
                      ]"
                        @click="
                        changeSelectsMain()
                        isEditFlag = true
                        participants = participants.map((par, i) => ({
                          ...par,
                          genderSelect: index === i ? !par.genderSelect : false,
                          residenceSelect: false,
                        }))
                      ">
                      <div class="select-trigger">
                        <span
                            class="select-trigger__gender-icon"
                            v-if="item.gender"
                            :style="{marginRight: '-8px'}">
                          <svg
                              width="1em"
                              height="1em"
                              :class="'icon icon-' + item.gender">
                            <use
                                :xlink:href="
                                '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                                item.gender
                              "></use>
                          </svg> </span
                        ><span
                          class="select-trigger__name"
                          :style="{textTransform: 'capitalize'}"
                      >{{
                          item.gender ? item.gender.slice(0, 1) : 'Select'
                        }}</span
                      ><span class="select-trigger__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                      </div>
                      <div class="select-body">
                        <div class="select-inner js-scrollbar">
                          <div
                              :class="[
                              'select-option',
                              {'is-selected': item.gender === 'male'},
                            ]"
                              :style="{paddingLeft: '2px'}"
                              @click="item.gender = 'male'">
                            <span class="select-option__name">
                              <span
                                  class="select-trigger__gender-icon"
                                  :style="{marginRight: '8px'}">
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-male">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-male"></use>
                                </svg> </span
                              >Male
                            </span>
                          </div>
                          <div
                              :class="[
                              'select-option',
                              {'is-selected': item.gender === 'female'},
                            ]"
                              :style="{paddingLeft: '2px'}"
                              @click="item.gender = 'female'">
                            <span class="select-option__name">
                              <span
                                  class="select-trigger__gender-icon"
                                  :style="{marginRight: '8px'}">
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-female">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-female"></use>
                                </svg> </span
                              >Female
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-control-group form-control-group--sm">
                    <span class="form-control-label" v-if="index === 0"
                    >Residence</span
                    >
                    <div
                        :class="[
                        'select-wrapper select-wrapper--sm',
                        {'is-active': item.residenceSelect},
                      ]"
                        @click="
                        isEditFlag = true
                        changeSelectsMain()
                        participants = participants.map((par, i) => ({
                          ...par,
                          residenceSelect:
                            index === i ? !par.residenceSelect : false,
                          genderSelect: false,
                        }))
                      ">
                      <div class="select-trigger">
                        <span
                            class="select-trigger__name select-trigger__name--mw"
                        >{{ item.residence.name }}</span
                        ><span class="select-trigger__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                      </div>
                      <div class="select-body">
                        <div class="select-inner js-scrollbar">
                          <div
                              class="select-option"
                              v-for="res in dataSelects.residence"
                              :key="res.data"
                              :class="[
                              'select-option',
                              {'is-selected': item.residence.data === res.data},
                            ]"
                              @click="
                              item.residence = res
                              calcTemplatePriceHandler()
                            ">
                            <span class="select-option__name">{{
                                res.name
                              }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                      class="tour-program-table__btn-group"
                      :style="
                      index > 0
                        ? {marginTop: '-15px', marginRight: '0px'}
                        : {marginRight: '0px'}
                    ">
                    <button
                        type="button"
                        data-popover="Meal preferences"
                        :class="[
                        'btn btn--green btn--sm-squared btn--popover',
                        {'btn--popover-disabled': !item.dietarySave},
                      ]"
                        @click="
                        item.dietaryPopup = true
                        dietaryPopup = true
                      ">
                      <svg width="1em" height="1em" class="icon icon-fish">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fish"></use>
                      </svg>
                    </button>
                    <button
                        type="button"
                        data-popover="Insurance"
                        :class="[
                        'btn btn--green btn--sm-squared btn--popover',
                        {
                          'btn--popover-disabled': !(
                            item.insurance.companyName &&
                            item.insurance.policyNumber &&
                            item.insurance.validFrom &&
                            item.insurance.validUpTo &&
                            item.insurance.validFrom < item.insurance.validUpTo
                          ),
                        },
                      ]"
                        @click="
                        item.insurancePopup = true
                        insurancePopup = true
                      ">
                      <svg width="1em" height="1em" class="icon icon-shield">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-shield"></use>
                      </svg>
                    </button>
                    <button
                        type="button"
                        data-popover="Wedding"
                        :class="[
                        'btn btn--green btn--sm-squared btn--popover',
                        {
                          'btn--popover-disabled':
                            item.weddingDate == null ||
                            item.weddingDate == '' ||
                            item.coupleId == null ||
                            item.coupleId < 1,
                        },
                      ]"
                        @click="
                        item.weddingPopup = true
                        weddingPopup = true
                      ">
                      <svg width="1em" height="1em" class="icon icon-ring">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-ring"></use>
                      </svg>
                    </button>
                    <button
                        v-if="participants.length > 1"
                        type="button"
                        class="btn btn--remove"
                        @click="
                        participants.length - 1 === 0
                          ? false
                          : $emit('deleteModalHandler', {
                              entity: 'Client',
                              name: 'this',
                              handler: removeParticipant,
                              id: index,
                            })
                         removeParticipantPersonalDiscounts(item)
                         removeParticipantFromClimbing(item);
                      ">
                      <svg width="1em" height="1em" class="icon icon-close">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                      </svg>
                    </button>
                  </div>
                </div>
                <button
                    type="button"
                    class="btn btn--rounded2 btn--green btn--add"
                    @click="
                    addParticipant()
                    isEditFlag = true
                  ">
                  <svg width="1em" height="1em" class="icon icon-plus-o-white">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                  </svg>
                  <span>Add Participant</span>
                </button>
              </div>
              <div class="make-story-form__notes">
                <div class="form-control-group">
                  <span class="form-control-label">
                    <div class="form-control-icon form-control-icon__green">
                      <svg width="1em" height="1em" class="icon icon-calendar">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-eye"></use>
                      </svg>
                    </div>
                    Notes for the Clients
                    <span class="form-control-label__grey"
                    >(visible for clients)</span
                    >
                  </span>
                  <div class="js-ckeditor">
                    <editor
                        :editor="editor"
                        v-model="data.notesForClients"
                        @input="isEditFlag = true"
                        :config="editorConfig"></editor>
                  </div>
                </div>

                <div class="form-control-group">
                  <span class="form-control-label"
                  >Notes from the Manager
                    <span class="form-control-label__grey"
                    >(hidden for clients)</span
                    >
                  </span>
                  <div class="js-ckeditor">
                    <editor
                        :editor="editor"
                        v-model="data.notesForManager"
                        @input="isEditFlag = true"
                        :config="editorConfig"></editor>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Program start-->
          <div
              class="tour-program"
              id="tour-program"
              ref="program"
              v-if="data.id"
              v-show="tab === 0">
            <div class="container-lg">
              <div class="section-title">
                <h3>Program</h3>
              </div>

              <!--Program LIST start-->
              <div class="tour-program-table">
                <div
                    v-for="(item, index) in data.program"
                    :key="item.id"
                    :ref="'programItem'"
                    :class="[
                    'tour-program-table__row',
                    {error: item.dayTripError},
                    {
                      'tour-program-table__row--labeled':
                        item.type.data === 'CLIMBING' ||
                        item.type.data === 'SAFARI' ||
                        item.type.data === 'ISLAND' ||
                        item.type.data === 'ISLAND_COMPACTED',
                    },
                    {dragged: item.drag},
                  ]"
                    @mouseup="
                    () => {
                      if (item.drag) {
                        item.drag = false
                        dragDay(index)
                      }
                    }
                  "
                    @mouseleave="item.drag = false"
                    @mousemove="
                    item.drag
                      ? (() => {
                          mouseFind($event)
                          dragDayFly(index)
                        })()
                      : false
                    item.dayTripError = false
                  "
                    :style="{
                    top: item.drag ? mouse.top + 'px' : 'unset',
                    marginBottom: item.pre
                      ? index === data.program.length - 1
                        ? dragHeight + 50 + 'px'
                        : dragHeight + 'px'
                      : '0px',
                    marginTop: item.post ? dragHeight + 30 + 'px' : '0px',
                  }"
                    :data-index="index">
                  <button
                      type="button"
                      class="tour-program-table__replace"
                      @mousedown="
                      mouseFind($event)
                      item.drag = true
                    ">
                    <svg width="1em" height="1em" class="icon icon-move">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-move"></use>
                    </svg>
                  </button>
                  <button
                      type="button"
                      class="tour-program-table__remove"
                      @click="
                      $emit('deleteModalHandler', {
                        entity: 'Day',
                        name: 'this',
                        handler: removeProgramDay,
                        id: index,
                        isOpenModal: isOpenModalDelete,
                      })
                    ">
                    <svg width="1em" height="1em" class="icon icon-close">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                    </svg>
                  </button>
                  <div
                      class="tour-program-table__line tour-program-table__line_3"
                      :style="{opacity: item.drag ? 0.8 : 1}">
                    <div
                        :class="[
                        'tour-program-table__day',
                        {'tooltip-wrap': item.type.data === 'OWN_ARRANGEMENTS'},
                      ]">
                      <div
                          class="tour-program-table__day__icon tour-program-table__day__icon--green"
                          v-if="item.type.data === 'ARRIVAL'">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-airplane">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                        </svg>
                      </div>
                      <div
                          class="tour-program-table__day__icon tour-program-table__day__icon--red"
                          v-if="item.type.data === 'DEPARTURE'">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-airplane">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                        </svg>
                      </div>
                      <div
                          class="tour-program-table__day__dot tour-program-table__day__dot--silver"
                          v-if="
                          item.type.data === 'OWN_ARRANGEMENTS' ||
                          item.type.data === 'REST_DAY'
                        "></div>
                      <div
                          class="tour-program-table__day__dot tour-program-table__day__dot--blue"
                          v-if="item.type.data === 'DAY_TRIP'"></div>
                      <div
                          v-if="item.type.data === 'SAFARI'"
                          :class="[
                          'tour-program-table__day__label tour-program-table__day__label--orange',
                          {'non-after': !item.duration},
                        ]">
                        <div class="tour-program-table__day__label__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-safari">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-safari"></use>
                          </svg>
                        </div>
                        <span>Safari</span>
                      </div>
                      <div
                          v-if="item.type.data === 'CLIMBING'"
                          :class="[
                          'tour-program-table__day__label tour-program-table__day__label--green',
                          ,
                          {'non-after': !item.climb},
                        ]">
                        <div class="tour-program-table__day__label__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-climbing">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-climbing"></use>
                          </svg>
                        </div>
                        <span>Climbing</span>
                      </div>
                      <div
                          v-if="item.type.data === 'ISLAND'"
                          :class="[
                          'tour-program-table__day__label tour-program-table__day__label--red',
                          {'non-after': !item.duration},
                        ]">
                        <div class="tour-program-table__day__label__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-zanzibar">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-zanzibar"></use>
                          </svg>
                        </div>
                        <span>Island</span>
                      </div>
                      <div
                          v-if="item.type.data === 'ISLAND_COMPACTED'"
                          :class="[
                          'tour-program-table__day__label tour-program-table__day__label--red',
                          {'non-after': !item.duration},
                        ]">
                        <div class="tour-program-table__day__label__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-zanzibar">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-zanzibar"></use>
                          </svg>
                        </div>
                        <span>Island</span>
                      </div>
                      <span
                          v-if="
                          item.type.data !== 'SAFARI' &&
                          item.type.data !== 'CLIMBING' &&
                          item.type.data !== 'ISLAND' &&
                          item.type.data !== 'ISLAND_COMPACTED'
                        "
                          class="tour-program-table__day__num"
                      >Day {{ item.day }}</span
                      ><span
                        v-if="
                          item.type.data !== 'SAFARI' &&
                          item.type.data !== 'CLIMBING' &&
                          item.type.data !== 'ISLAND' &&
                          item.type.data !== 'ISLAND_COMPACTED'
                        "
                        class="tour-program-table__day__date"
                    >{{ item.date }}</span
                    >

                      <span
                          class="form-control__help-icon form-control__help-icon-2"
                          :style="{top: '25px'}"
                          v-if="
                          (item.hotelsData &&
                            item.hotelsData.find(
                              (hotel) => hotel.price === 'error'
                            )) ||
                          (item.days.length &&
                            item.days.find(
                              (day) =>
                                day.hotelsData &&
                                day.hotelsData.find(
                                  (hotel) => hotel.price === 'error'
                                )
                            ))
                        ">
                        <span class="form-control__help-content"
                        >Prices for the chosen date are not listed in the
                          hotel database. Please contact the reservations
                          department to confirm the price and report the problem
                          to the admin.</span
                        >
                        <svg width="2.4rem" height="2.4rem">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#tooltip-icon"></use>
                        </svg>
                      </span>
                    </div>

                    <div
                        :class="[
                        'form-control-group',
                        {'is-error': item.typeError},
                      ]">
                      <div
                          :class="[
                          'select-wrapper',
                          {'is-active': item.typeSelect},
                        ]"
                          @click="
                          data.program = data.program.map((day, i) =>
                            {
                              return i === index
                              ? {
                                  ...day,
                                  typeSelect: !day.typeSelect,
                                  airstripSelect: false,
                                  typeError: false,
                                  activitySelect: false,
                                  climbSelect: false,
                                  tourLeaderSelect: false,
                                  priceForSelect: false,
                                  islandSelect: false,
                                  carsSelect: false,
                                  includeHotelsAndTransfers: true,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                              : {
                                  ...day,
                                  typeSelect: false,
                                  airstripSelect: false,
                                  activitySelect: false,
                                  tourLeaderSelect: false,
                                  climbSelect: false,
                                  priceForSelect: false,
                                  islandSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                            }
                          )
                        ">
                        <div class="select-trigger">
                          <!--<span class="select-trigger__name">{{ item.type.name }}</span>-->
                          <span class="select-trigger__name">{{
                              itemTypeName(item.type.name)
                            }}</span>

                          <span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>

                        <!--Select TYPE PROGRAM start  -->
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="(
                                type, typeIndex
                              ) in dataSelects.programTypes"
                                :key="typeIndex"
                                :class="[
                                'select-option',
                                {
                                  'is-selected': type.subData
                                    ? type.subData === item.type.subData
                                    : type.data === item.type.data,
                                },
                              ]"
                                @click="
                                type.data === 'CLIMBING'
                                  ? type.subData === 'JOIN'
                                    ? calcProgramDaysForDuration(
                                        index,
                                        1,
                                        item.duration
                                      )
                                    : calcProgramDaysForDuration(
                                        index,
                                        1,
                                        item.duration
                                      )
                                  : calcProgramDaysForDuration(
                                      index,
                                      1,
                                      item.duration
                                    )
                                item.type = {...type}
                                item.duration = 1
                                item.mountain = ''
                                type.data === 'CLIMBING'
                                  ? (item.climb = null)
                                  : null
                                durationData = duration = +data.program.reduce(
                                  (acc, day) => acc + +day.duration,
                                  0
                                )
                                type.subData &&
                                (type.subData === 'CLASSIC' ||
                                  type.subData === 'PREMIUM')
                                  ? (item.climbingId = dataSelects.routes[0].id)
                                  : false
                                type.data === 'CLIMBING'
                                  ? calcTemplatePriceHandler()
                                  : false
                                type.data === 'CLIMBING' &&
                                (type.subData === 'CLASSIC' ||
                                  type.subData === 'PREMIUM')
                                  ? (item.priceFor =
                                      item.participantsIds.filter(
                                        (p) => p.active && p.ageType !== 'child'
                                      ).length)
                                  : type.subData === 'JOIN'
                                  ? (item.priceFor = 3)
                                  : false
                                type.data === 'ISLAND'
                                  ? (item.island = dataSelects.islandsCompacted[0])
                                  : false
                                type.data === 'ISLAND_COMPACTED'
                                  ? (item.islandCompacted = dataSelects.islandsCompacted[0])
                                  : false
                                // type.data === 'ISLAND' ? item.island = dataSelects.islands[0].location.names.EN : false;
                                type.data === 'SAFARI' ? (item.pax = 5) : false
                                type.data === 'SAFARI'
                                  ? (item.days = [
                                      ...item.days.map((d) => ({
                                        ...d,
                                        totalCars:
                                          d.totalCars === 0 || d.totalCars
                                            ? d.totalCars
                                            : Math.ceil(
                                                participants.length / 5
                                              ),
                                      })),
                                    ])
                                  : false
                                type.data === 'SAFARI'
                                  ? (item.days = [
                                      ...item.days.map((d) => ({
                                        ...d,
                                        priceFor: participants.length,
                                      })),
                                    ])
                                  : false
                                type.data === 'ARRIVAL' ||
                                type.data === 'DEPARTURE'
                                  ? (item.airport = {
                                      ...dataSelects.airstrips.find(
                                        (airport) =>
                                          airport.names.EN &&
                                          airport.names.EN ===
                                            'Kilimanjaro Airport'
                                      ),
                                    })
                                  : false
                                calcDates()
                                isEditFlag = true
                              ">
                              <span class="select-option__name">{{
                                  type.name
                                }}</span>
                            </div>
                          </div>
                        </div>
                        <!--Select TYPE PROGRAM end  -->


                      </div>
                    </div>

                    <div
                        :class="[
                        'form-control-group',
                        {'is-error': item.airportError},
                      ]"
                        v-if="
                        item.type.data === 'ARRIVAL' ||
                        item.type.data === 'DEPARTURE'
                      ">
                      <div
                          :class="[
                          'select-wrapper',
                          {'is-active': item.airstripSelect},
                        ]"
                          @click="
                          isEditFlag = true
                          data.program = data.program.map((day, i) => {
                            return i === index
                              ? {
                                  ...day,
                                  airstripSelect: !day.airstripSelect,
                                  airportError: false,
                                  typeSelect: false,
                                  climbSelect: false,
                                  tourLeaderSelect: false,
                                  priceForSelect: false,
                                  islandSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                              : {
                                  ...day,
                                  airstripSelect: false,
                                  typeSelect: false,
                                  activitySelect: false,
                                  tourLeaderSelect: false,
                                  climbSelect: false,
                                  priceForSelect: false,
                                  islandSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                          }
                          )
                        ">
                        <div class="select-trigger">
                          <span class="select-trigger__name">{{
                              item.airport.names && item.airport.names.EN
                                  ? item.airport.names.EN
                                  : ''
                            }}</span>
                          <span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg>
                          </span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="airport in dataSelects.airstrips"
                                :key="airport.id + Math.random()"
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    item.airport &&
                                    airport.id === item.airport.id,
                                },
                              ]"
                                @click="
                                item.airport = {...airport}
                                calcTemplatePriceHandler()
                              ">
                              <span class="select-option__name"
                              >{{ airport.names.EN }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- <div :class="['form-control-group', {'is-error' : item.activityError}]" v-if="item.type.data === 'DAY_TRIP'">
									<div :class="['select-wrapper', { 'is-active' : item.activitySelect }]" @click="data.program = data.program.map((day, i) => i === index ? ({ ...day, activitySelect: !day.activitySelect, activityError: false, typeSelect: false , climbSelect: false, priceForSelect: false, islandSelect: false, carsSelect: false, days: day.days.map(d => ({...d, parkSelect: false}))}) : ({...day, activitySelect: false, airstripSelect: false, typeSelect: false, climbSelect: false, priceForSelect: false, islandSelect: false, carsSelect: false, days: day.days.map(d => ({...d, parkSelect: false}))}))">
										<div class="select-trigger"><span class="select-trigger__name">{{item.activity ? item.activity.name : ''}}</span><span class="select-trigger__icon">
											<svg width="1em" height="1em" class="icon icon-chevron ">
											<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
											</svg></span></div>
										<div class="select-body">
										<div class="select-inner js-scrollbar">
											<div
												v-for="activity in dataSelects.activitiesTrips"
												:key="activity.id"
												:class="['select-option', { 'is-selected' : item.activity && (activity.id === item.activity.id) }]" @click="item.activity = {...activity};calcTemplatePriceHandler()"><span class="select-option__name">{{activity.name}}</span></div>
										</div>
										</div>
									</div>
								</div>
								<div class="form-control-group form-control-group--time" v-if="item.type.data === 'DAY_TRIP'"><span class="form-control-label">Pick up
									time</span>
								<div class="form-control-wrap">
									<the-mask type="text" v-model="item.pickUpTime" @input="item.pickUpTime = +item.pickUpTime.slice(0, 2) > 23 ? 23 :item.pickUpTime;item.pickUpTime.length === 4 ? item.pickUpTime = +item.pickUpTime.slice(2, 5) > 59 ? item.pickUpTime.slice(0, 2) + '59' : item.pickUpTime : false " class="form-control form-control-time" :mask="'##:##'" placeholder="--:--"/>
								</div>
								</div>
								<div class="form-control-group form-control-group--labeled" v-if="item.type.data === 'DAY_TRIP'"><span
										class="form-control-label">Pax</span>
									<div class="form-control-wrap">
										<input type="number" placeholder="0" v-model="item.pax" @change="calcTemplatePriceHandler()" class="form-control" />
									</div>
								</div> -->

                    <div
                        class="form-control-group form-control-group_4"
                        v-if="item.type.data === 'CLIMBING'">
                      <div
                          :class="[
                          'select-wrapper',
                          {'is-active': item.mountainSelect},
                        ]"
                          @click="
                          isEditFlag = true
                          data.program = data.program.map((day, i) =>
                            i === index
                              ? {
                                  ...day,
                                  mountainSelect: !day.mountainSelect,
                                  activitySelect: false,
                                  airstripSelect: false,
                                  typeSelect: false,
                                  priceForSelect: false,
                                  islandSelect: false,
                                  climbSelect: false,
                                  tourLeaderSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                              : {
                                  ...day,
                                  mountainSelect: false,
                                  tourLeaderSelect: false,
                                  climbSelect: false,
                                  activitySelect: false,
                                  airstripSelect: false,
                                  typeSelect: false,
                                  priceForSelect: false,
                                  islandSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                          )
                        ">
                        <div class="select-trigger" :style="{width: '13rem'}">
                          <span class="select-trigger__name">{{
                              item.mountain || 'Select'
                            }}</span
                          ><span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                :class="[
                                'select-option',
                                {'is-selected': item.mountain === 'Meru'},
                              ]"
                                @click="
                                item.days = []
                                calcProgramDaysForDuration(
                                  index,
                                  1,
                                  item.duration
                                )
                                item.mountain = 'Meru'
                                item.climb = null
                                item.duration = 1
                              ">
                              <span class="select-option__name">Meru</span>
                            </div>
                            <div
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    item.mountain === 'Kilimanjaro',
                                },
                              ]"
                                @click="
                                item.days = []
                                calcProgramDaysForDuration(
                                  index,
                                  1,
                                  item.duration
                                )
                                item.mountain = 'Kilimanjaro'
                                item.climb = null
                                item.duration = 1
                                currentClimbDay = item.date
                              ">
                              <span class="select-option__name"
                              >Kilimanjaro</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                        class="form-control-group form-control-group_4"
                        v-if="
                        item.type.data === 'CLIMBING' &&
                        (item.type.subData === 'CLASSIC' ||
                          item.type.subData === 'PREMIUM') &&
                        item.mountain
                      ">
                      <div
                          :class="[
                          'select-wrapper',
                          {'is-active': item.climbSelect},
                        ]"
                          :style="{
                          opacity: dataSelects.routes.filter(
                            (route) => route.mountTitle === item.mountain
                          ).length
                            ? 1
                            : 0.6,
                          cursor: dataSelects.routes.filter(
                            (route) => route.mountTitle === item.mountain
                          ).length
                            ? 'pointer'
                            : 'default',
                          pointerEvents: dataSelects.routes.filter(
                            (route) => route.mountTitle === item.mountain
                          ).length
                            ? 'auto'
                            : 'none',
                        }"
                          @click="
                          isEditFlag = true
                          data.program = data.program.map((day, i) =>
                            i === index
                              ? {
                                  ...day,
                                  climbSelect: !day.climbSelect,
                                  tourLeaderSelect: false,
                                  activitySelect: false,
                                  airstripSelect: false,
                                  mountainSelect: false,
                                  typeSelect: false,
                                  priceForSelect: false,
                                  islandSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                              : {
                                  ...day,
                                  tourLeaderSelect: false,
                                  climbSelect: false,
                                  activitySelect: false,
                                  mountainSelect: false,
                                  airstripSelect: false,
                                  typeSelect: false,
                                  priceForSelect: false,
                                  islandSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                          )
                        ">
                        <div class="select-trigger" :style="{width: '22rem'}">
                          <span class="select-trigger__name"
                          >{{ item.climb ? item.climb.name : '' }}
                            {{ item.climb ? item.climb.durationDays : '' }}
                            {{ item.climb ? 'days' : '' }}</span
                          ><span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="climb in getClimbingRoutes(item)"
                                :key="climb.id"
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    item.climb && climb.id === item.climb.id,
                                },
                              ]"
                                @click="
                                calcProgramDaysForDuration(
                                  index,
                                  climb.durationDays,
                                  item.duration
                                )
                                item.climb = {...climb}
                                item.duration = +climb.durationDays
                                item.climbingId = climb.id
                                calcTemplatePriceHandler()
                              ">
                              <span class="select-option__name"
                              >{{ climb.name }}
                                {{ climb.durationDays }} days</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                        class="form-control-group form-control-group_4"
                        v-if="
                        item.type.data === 'CLIMBING' &&
                        item.type.subData === 'JOIN' &&
                        item.mountain
                      ">
                      <div
                          :class="[
                          'select-wrapper',
                          {
                            'is-active': item.climbSelect,
                            'is-error': item.climbingError,
                          },
                        ]"
                          @click="
                          item.climbingError = false
                          isEditFlag = true
                          data.program = data.program.map((day, i) =>
                            i === index
                              ? {
                                  ...day,
                                  climbSelect: !day.climbSelect,
                                  tourLeaderSelect: false,
                                  activitySelect: false,
                                  airstripSelect: false,
                                  typeSelect: false,
                                  priceForSelect: false,
                                  islandSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                              : {
                                  ...day,
                                  tourLeaderSelect: false,
                                  climbSelect: false,
                                  activitySelect: false,
                                  airstripSelect: false,
                                  typeSelect: false,
                                  priceForSelect: false,
                                  islandSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                          )
                        "
                          :style="{
                          opacity: filteredRoutesGroup.filter(
                            (route) => route.mountTitle === item.mountain
                          ).length
                            ? 1
                            : 0.6,
                          cursor: filteredRoutesGroup.filter(
                            (route) => route.mountTitle === item.mountain
                          ).length
                            ? 'pointer'
                            : 'default',
                          pointerEvents: filteredRoutesGroup.filter(
                            (route) => route.mountTitle === item.mountain
                          ).length
                            ? 'auto'
                            : 'none',
                        }">
                        <div class="select-trigger" :style="{width: '22rem'}">
                          <span class="select-trigger__name"
                          >{{ item.climb ? item.climb.route : '' }}
                            {{
                              item.climb
                                  ? item.climb.days + ' - ' + item.climb.dateStart
                                  : ''
                            }}</span
                          ><span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div
                            class="select-body"
                            v-if="
                            filteredRoutesGroup.filter(
                              (route) => route.mountTitle === item.mountain
                            ).length
                          ">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="(climb, climbIndex) in filteredRoutesGroup"
                                :key="climbIndex"
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    item.climb &&
                                    (
                                        (climb.id && item.climb.id && climb.id === item.climb.id) ||
                                        // TODO: remove condition below after release new join groups
                                        (climb.route === item.climb.route && climb.days === item.climb.days && climb.dateStart === item.climb.dateStart && climb.dateEnd === item.climb.dateEnd)
                                    ),
                                },
                              ]"
                                @click="
                                calcProgramDaysForDuration(
                                  index,
                                  climb.days,
                                  item.duration
                                )
                                item.climb = {...climb}
                                item.duration = +climb.days
                                calcTemplatePriceHandler()
                              ">
                              <span class="select-option__name"
                              >{{ climb.route }}
                                {{ climb.days + ' - ' + climb.dateStart }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="form-control-group form-control-group_price-for form-control__help form-control__help-offset" v-if="item.type.data === 'CLIMBING'">
								<span class="form-control-group_price-for__label">Price for:</span>
									<div :class="['select-wrapper select-wrapper--xs', { 'is-active' : item.priceForSelect }]" @click="isEditFlag = true;data.program = data.program.map((day, i) => i === index ? ({ ...day, priceForSelect: !day.priceForSelect, climbSelect: false, activitySelect: false, mountainSelect: false, airstripSelect: false, typeSelect: false, islandSelect: false, carsSelect: false, days: day.days.map(d => ({...d, parkSelect: false})) }) : ({...day, priceForSelect: false, mountainSelect: false, climbSelect: false, activitySelect: false, airstripSelect: false, typeSelect: false, islandSelect: false, carsSelect: false, days: day.days.map(d => ({...d, parkSelect: false}))}))"
										:style="{opacity: !participants.length ? .6 : 1, cursor: !participants.length ? 'default' : 'pointer', pointerEvents:  !participants.length ? 'none' : 'auto'}">
										<div class="select-trigger" :style="{width: '8rem'}"><span class="select-trigger__name">{{item.priceFor ? item.priceFor : ''}}</span><span class="select-trigger__icon">
											<svg width="1em" height="1em" class="icon icon-chevron ">
											<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
											</svg></span></div>
										<div class="select-body">
										<div class="select-inner js-scrollbar">
											<div
												v-for="price in Array(participants.length).fill(true).map((_, index) => index + 1)"
												:key="price"
												:class="['select-option', { 'is-selected' : price === item.priceFor }]" @click="item.priceFor = price;calcTemplatePriceHandler()"><span class="select-option__name">{{price}}</span></div>
										</div>
										</div>
									</div>
								<span class="form-control__help-icon">
									<span class="form-control__help-content">Укажите для какого размера группы посчитать цену за восхождение. Если у вас один человек в групповое восхождение, по-умолчанию укажите 3. Чек-бокс турлидер необходимо поставить, чтобы в группе один из участников посчитался по цене тур-лидера.</span>
									<img src="/images/useful/svg/help-icon.svg" alt="">
								</span>
								</div>
								<div class="form-control-group" v-if="item.type.data === 'CLIMBING'">
								<label  class="form-control-checkbox" @click.prevent="item.tourLeader = !item.tourLeader;isEditFlag = true;calcTemplatePriceHandler()">
									<input  type="checkbox" :checked="item.tourLeader" @click.prevent /><span class="form-control-checkbox__box">
									<svg width="1em" height="1em" class="icon icon-check ">
										<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
									</svg></span><span class="form-control-checkbox__name">Tour Leader</span>
								</label>
								</div> -->

                    <div
                        class="tour-program-table__btn-group tour-program-table__btn-group_11"
                        v-if="item.type.data === 'CLIMBING'">
                      <!-- <button type="button" data-popover="Additional Options" :disabled="!(item.type && item.type.name)" @click="additionalPopup = item" :class="['btn btn--green btn--sm-squared btn--popover', { 'btn--popover-disabled' : !(item.additionalOptions && item.additionalOptions.length) }]">
										<svg width="1em" height="1em" class="icon icon-taxi " :style="{marginLeft: '4px', marginBottom: '2px'}">
											<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-tel"></use>
										</svg>
									</button> -->
                      <button
                          type="button"
                          :data-popover="`Climbing Members`"
                          @click="
                          item.participantsIds = item.participantsIds
                            ? participants
                                .filter((p) => !(p.ageType === 'child'))
                                .map((p) => ({
                                  ...p,
                                  active: item.participantsIds.find(
                                    (par) => par.id === p.id
                                  )
                                    ? item.participantsIds
                                        .filter((par) => par.active)
                                        .map((par) => par.id)
                                        .includes(p.id)
                                    : true,
                                }))
                            : participants
                                .filter((p) => !(p.ageType === 'child'))
                                .map((item) => ({...item, active: true}))
                          participantsPopup = item
                        "
                          :class="[
                          'btn btn--green btn--sm-squared btn--popover',
                          {'btn--popover-disabled': !item.participantsSave},
                        ]">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-adult"
                            :style="{fontSize: '2rem'}">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                        </svg>
                      </button>
                      <button
                          type="button"
                          data-popover="Transfers"
                          :disabled="!(item.type && item.type.name)"
                          @click="
                          transfersPopup = item
                          transfersPopup.firstDay = true
                          transfersPopupData.transfersData = JSON.parse(
                            JSON.stringify(
                              item.transfersData.filter(
                                (t) => t.firstDay === true
                              )
                            )
                          )
                        "
                          :class="[
                          'btn btn--green btn--sm-squared btn--popover',
                          {
                            'btn--popover-disabled': !item.transfersData.filter(
                              (t) => t.firstDay
                            ).length,
                          },
                        ]">
                        <svg width="1em" height="1em" class="icon icon-taxi">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-taxi"></use>
                        </svg>
                      </button>
                      <button
                          @click="onNotesButtonClick(item)"
                          type="button"
                          data-popover="Notes"
                          :class="[
                          'btn btn--green btn--sm-squared btn--popover',
                          {'btn--popover-disabled': !item.notes},
                        ]">
                        <svg width="1em" height="1em" class="icon icon-taxi">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-notes"></use>
                        </svg>
                      </button>
                    </div>

                    <!--Select type island default start-->
                    <div
                        class="form-control-group"
                        v-if="item.type.data === 'ISLAND'">
                      <div
                          :class="[
                          'select-wrapper',
                          {'is-active': item.islandSelect},
                        ]"
                          @click="
                          isEditFlag = true
                          data.program = data.program.map((day, i) =>
                            i === index
                              ? {
                                  ...day,
                                  islandSelect: !day.islandSelect,
                                  climbSelect: false,
                                  tourLeaderSelect: false,
                                  activitySelect: false,
                                  mountainSelect: false,
                                  airstripSelect: false,
                                  typeSelect: false,
                                  priceForSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                              : {
                                  ...day,
                                  tourLeaderSelect: false,
                                  climbSelect: false,
                                  islandSelect: false,
                                  activitySelect: false,
                                  mountainSelect: false,
                                  airstripSelect: false,
                                  typeSelect: false,
                                  priceForSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                          )
                        ">
                        <div class="select-trigger">
                          <span class="select-trigger__name">
                            {{
                              item.island.location ? item.island.location.names.EN : ''
                            }}
                          </span
                          ><span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <!--                            <div-->
                            <!--                                v-for="(island, islandIndex) in dataSelects.islands"-->
                            <!--                                :key="islandIndex"-->
                            <!--                                :class="['select-option', { 'is-selected' : island.location.names.EN ===  item.island}]"-->
                            <!--                                @click="item.island = island.location.names.EN;calcTemplatePriceHandler();"-->
                            <!--                            >-->
                            <!--                              <span class="select-option__name">{{ island.location.names.EN }}</span>-->
                            <!--                            </div>-->
                            <div
                                v-for="(
                                island, islandIndex
                              ) in dataSelects.islandsCompacted"
                                :key="islandIndex"
                                :class="[
                                'select-option',
                                {'is-selected': island === item.island},
                              ]"
                                @click="
                                item.island = island
                                calcTemplatePriceHandler()
                              ">
                              <span class="select-option__name">{{
                                  island.location.names.EN
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--Select type island default end-->

                    <!--Select type island NEW start-->
                    <div
                        class="form-control-group"
                        v-if="item.type.data === 'ISLAND_COMPACTED'">
                      <div
                          :class="[
                          'select-wrapper',
                          {'is-active': item.islandSelect},
                        ]"
                          @click="
                          isEditFlag = true
                          data.program = data.program.map((day, i) =>
                            i === index
                              ? {
                                  ...day,
                                  islandSelect: !day.islandSelect,
                                  climbSelect: false,
                                  tourLeaderSelect: false,
                                  activitySelect: false,
                                  mountainSelect: false,
                                  airstripSelect: false,
                                  typeSelect: false,
                                  priceForSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                              : {
                                  ...day,
                                  tourLeaderSelect: false,
                                  climbSelect: false,
                                  islandSelect: false,
                                  activitySelect: false,
                                  mountainSelect: false,
                                  airstripSelect: false,
                                  typeSelect: false,
                                  priceForSelect: false,
                                  carsSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                          )
                        ">
                        <div class="select-trigger">
                          <span class="select-trigger__name">
                            {{ item.islandCompacted.location.names.EN }}
                          </span
                          ><span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <!--                            <div-->
                            <!--                                v-for="(island, islandIndex) in dataSelects.islands"-->
                            <!--                                :key="islandIndex"-->
                            <!--                                :class="['select-option', { 'is-selected' : island.location.names.EN ===  item.island}]"-->
                            <!--                                @click="item.island = island.location.names.EN;calcTemplatePriceHandler();"-->
                            <!--                            >-->
                            <!--                              <span class="select-option__name">{{ island.location.names.EN }}</span>-->
                            <!--                            </div>-->
                            <div
                                v-for="(
                                island, islandIndex
                              ) in dataSelects.islandsCompacted"
                                :key="islandIndex"
                                :class="[
                                'select-option',
                                {'is-selected': island === item.island},
                              ]"
                                @click="
                                item.islandCompacted = island
                                calcTemplatePriceHandler()
                              ">
                              <span class="select-option__name">{{
                                  island.location.names.EN
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--Select type island NEW end-->

                    <div
                        class="form-control-group form-control-group--labeled"
                        v-if="
                        item.type.data === 'SAFARI' ||
                        item.type.data === 'ISLAND' ||
                        item.type.data === 'ISLAND_COMPACTED'
                      ">
                      <span class="form-control-label">Duration</span>
                      <div class="form-control-wrap">
                        <input
                            type="number"
                            placeholder="0"
                            :value="item.duration"
                            @keydown.enter="
                            item.days =
                              (+$event.target.value || 1) > item.duration
                                ? item.days.concat(
                                    Array(
                                      (+$event.target.value || 1) -
                                        item.duration
                                    ).fill({
                                      type: item.type.data,
                                      activitiesData: [],
                                      flightsData: [],
                                      hotelsData: [],
                                      transfersData: [],
                                      park: {},
                                    })
                                  )
                                : (+$event.target.value || 1) < item.duration
                                ? item.days.slice(0, +$event.target.value || 1)
                                : item.days
                            calcProgramDaysForDuration(
                              index,
                              +$event.target.value || 1,
                              item.duration
                            )
                            $event.target.value = item.duration =
                              +$event.target.value === 0
                                ? 1
                                : +$event.target.value
                            durationData = duration = +data.program.reduce(
                              (acc, day) => acc + +day.duration,
                              0
                            )
                            calcDates()
                            isEditFlag = true
                          "
                            @focusout="
                            item.days =
                              (+$event.target.value || 1) > item.duration
                                ? item.days.concat(
                                    Array(
                                      (+$event.target.value || 1) -
                                        item.duration
                                    ).fill({
                                      type: item.type.data,
                                      activitiesData: [],
                                      flightsData: [],
                                      hotelsData: [],
                                      transfersData: [],
                                      park: {},
                                    })
                                  )
                                : (+$event.target.value || 1) < item.duration
                                ? item.days.slice(0, +$event.target.value || 1)
                                : item.days
                            calcProgramDaysForDuration(
                              index,
                              +$event.target.value || 1,
                              item.duration
                            )
                            $event.target.value = item.duration =
                              +$event.target.value === 0
                                ? 1
                                : +$event.target.value
                            durationData = duration = +data.program.reduce(
                              (acc, day) => acc + +day.duration,
                              0
                            )
                            calcDates()
                            isEditFlag = true
                          "
                            class="form-control"/>
                      </div>
                    </div>

                    <div
                        class="tour-program-table__btn-group"
                        :style="{position: 'relative'}"
                        v-if="item.type.data === 'SAFARI'">
                      <div
                          class="form-control-group form-control-group--labeled">
                        <span
                            class="form-control-label"
                            :style="{width: '6rem'}"
                        >Pax per car</span
                        >
                        <div class="form-control-wrap">
                          <input
                              type="number"
                              placeholder="0"
                              v-model.number="item.pax"
                              max="7"
                              min="1"
                              @input="
                              item.pax > 7 || item.pax === 0
                                ? (item.pax = 7)
                                : item.pax
                              isEditFlag = true
                              item.days = item.days.map((d) => ({
                                ...d,
                                totalCars:
                                  d.totalCars === 0 || d.totalCars
                                    ? d.totalCars
                                    : Math.ceil(d.priceFor / item.pax),
                              }))
                              calcTemplatePriceHandler()
                            "
                              class="form-control"/>
                        </div>
                      </div>
                      <!-- <div class="form-control-group form-control-group--labeled"><span
										class="form-control-label" :style="{width: '6rem'}">Total cars</span>
										<div class="form-control-wrap">
											<input type="number" placeholder="0" disabled v-model.number="item.totalCars" @input="isEditFlag = true" class="form-control" />
										</div>
									</div> -->
                      <label
                          class="form-control-checkbox"
                          @click.prevent="
                          isEditFlag = true
                          item.extraCar = !item.extraCar
                          !item.extraCar === false
                            ? (item.carsSelectItem = 1)
                            : (item.carsSelectItem = 0)
                          calcTemplatePriceHandler()
                        ">
                        <input
                            type="checkbox"
                            :checked="item.extraCar"
                            @click.prevent/><span
                          class="form-control-checkbox__box">
                          <svg width="1em" height="1em" class="icon icon-check">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg
                          ></span>

                        <span
                            class="form-control__name-help"
                            :style="{width: '12rem'}">
                          <span class="form-control-checkbox__name"
                          >Add extra car rental day(s) for safari</span
                          >
                          <span
                              class="form-control__name-help-content"
                              :style="{bottom: '40px'}"
                          >Если вам необходимо, чтобы машина приехала в парк
                            до прилета клиентов или же предстоит длительный
                            обратный трансфер без клиентов - не забудьте указать
                            дополнительные дни аренды внедорожника.</span
                          >
                        </span>
                      </label>
                      <div
                          :style="{
                          opacity: item.extraCar ? 1 : 0.6,
                          cursor: item.extraCar ? 'pointer' : 'default',
                          pointerEvents: item.extraCar ? 'auto' : 'none',
                        }"
                          :class="[
                          'select-wrapper',
                          {'is-active': item.carsSelect},
                        ]"
                          @click="
                          isEditFlag = true
                          item.days.forEach((day) => {
                            day.transitSelectOpen = false
                          })
                          data.program = data.program.map((day, i) =>
                            i === index
                              ? {
                                  ...day,
                                  carsSelect: !day.carsSelect,
                                  islandSelect: false,
                                  climbSelect: false,
                                  tourLeaderSelect: false,
                                  activitySelect: false,
                                  mountainSelect: false,
                                  airstripSelect: false,
                                  typeSelect: false,
                                  priceForSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                              : {
                                  ...day,
                                  carsSelect: false,
                                  mountainSelect: false,
                                  tourLeaderSelect: false,
                                  climbSelect: false,
                                  islandSelect: false,
                                  activitySelect: false,
                                  airstripSelect: false,
                                  typeSelect: false,
                                  priceForSelect: false,
                                  days: day.days.map((d) => ({
                                    ...d,
                                    parkSelect: false,
                                  })),
                                }
                          )
                        ">
                        <div
                            class="select-trigger"
                            :style="{width: '7.5rem', marginLeft: '10px'}">
                          <span class="select-trigger__name">{{
                              item.carsSelectItem
                            }}</span
                          ><span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div
                            class="select-body"
                            :style="{width: '7.5rem', left: '1rem'}">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="carI in Array(4)
                                .fill(true)
                                .map((_, carI) => carI)"
                                :key="carI"
                                :class="[
                                'select-option',
                                {'is-selected': carI === item.carsSelectItem},
                              ]"
                                @click="
                                item.carsSelectItem = carI
                                calcTemplatePriceHandler()
                              ">
                              <span class="select-option__name">{{
                                  carI
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                        class="tour-program-table__btn-group"
                        v-if="
                        item.type.data !== 'CLIMBING' &&
                        item.type.data !== 'SAFARI' &&
                        item.type.data !== 'ISLAND' &&
                        item.type.data !== 'ISLAND_COMPACTED'
                      ">
                      <button
                          type="button"
                          :data-popover="'Hotel' + getHotelNamesList(item.hotelsData)"
                          @click="
                          hotelPopup = item
                          hotelPopupData.hotelsData = JSON.parse(
                            JSON.stringify(item.hotelsData)
                          )
                          getHotelsHandler(null)
                        "
                          :disabled="!(item.type && item.type.name)"
                          :class="[
                          'btn btn--green btn--sm-squared btn--popover',
                          {'btn--popover-disabled': !item.hotelsData.length},
                        ]">
                        <svg width="1em" height="1em" class="icon icon-house">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-house"></use>
                        </svg>
                      </button>
                      <button
                          type="button"
                          data-popover="Activity"
                          @click="
                          activityPopup = item
                          activityPopupData.activitiesData = JSON.parse(
                            JSON.stringify(item.activitiesData)
                          )
                        "
                          :disabled="!(item.type && item.type.name)"
                          :class="[
                          'btn btn--green btn--sm-squared btn--popover',
                          {error: item.dayTripError},
                          {
                            'btn--popover-disabled':
                              !item.activitiesData.length,
                          },
                        ]">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-parachute">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-parachute"></use>
                        </svg>
                      </button>
                      <!-- BTN flights-->
                      <button
                          type="button"
                          data-popover="Flight"
                          @click="
                          flightsPopup = item
                          flightsPopupData.flightsData = JSON.parse(
                            JSON.stringify(item.flightsData)
                          )
                          isActiveFlightTab = 'REGULAR'
                        "
                          :disabled="!(item.type && item.type.name)"
                          :class="[
                          'btn btn--green btn--sm-squared btn--popover',
                          {'btn--popover-disabled': !item.flightsData.length},
                        ]">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-airplane">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                        </svg>
                      </button>
                      <button
                          type="button"
                          data-popover="Transfers"
                          @click="
                          transfersPopup = item
                          transfersPopupData.transfersData = JSON.parse(
                            JSON.stringify(item.transfersData)
                          )
                        "
                          :disabled="!(item.type && item.type.name)"
                          :class="[
                          'btn btn--green btn--sm-squared btn--popover',
                          {'btn--popover-disabled': !item.transfersData.length},
                        ]">
                        <svg width="1em" height="1em" class="icon icon-taxi">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-taxi"></use>
                        </svg>
                      </button>
                      <button
                          @click="onNotesButtonClick(item)"
                          type="button"
                          data-popover="Notes"
                          :class="[
                          'btn btn--green btn--sm-squared btn--popover',
                          {'btn--popover-disabled': !item.notes},
                        ]">
                        <svg width="1em" height="1em" class="icon icon-taxi">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-notes"></use>
                        </svg>
                      </button>
                    </div>

                    <div
                        class="tour-program-table__btn-group"
                        v-if="item.type.data === 'ISLAND_COMPACTED'">
                      <button
                          type="button"
                          :data-popover="'Hotel' + getHotelNamesList(item.hotelsData)"
                          @click="
                          hotelPopup = item
                          hotelPopupData.hotelsData = JSON.parse(
                            JSON.stringify(item.hotelsData)
                          )
                          getHotelsHandler(null)
                        "
                          :disabled="!(item.type && item.type.name)"
                          :class="[
                          'btn btn--green btn--sm-squared btn--popover',
                          {'btn--popover-disabled': !item.hotelsData.length},
                        ]">
                        <svg width="1em" height="1em" class="icon icon-house">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-house"></use>
                        </svg>
                      </button>
                      <button
                          @click="onNotesButtonClick(item)"
                          type="button"
                          data-popover="Notes"
                          :class="[
                          'btn btn--green btn--sm-squared btn--popover',
                          {'btn--popover-disabled': !item.notes},
                        ]">
                        <svg width="1em" height="1em" class="icon icon-taxi">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-notes"></use>
                        </svg>
                      </button>
                    </div>

                    <!-- ISLAND options-include start-->
                    <!--                    <div-->
                    <!--                        v-if="item.type.data === 'ISLAND'"-->
                    <!--                        class="options-include" style="margin-top: 0">-->
                    <!--                      <label-->
                    <!--                          class="form-control-checkbox form-control__name-help"-->
                    <!--                          @click.prevent="item.showDetails = !item.showDetails, calcTemplatePriceHandler()">-->
                    <!--                        <input-->
                    <!--                            type="checkbox"-->
                    <!--                            :checked="item.showDetails" />-->
                    <!--                        <span class="form-control-checkbox__box">-->
                    <!--                              <svg-->
                    <!--                                  width="1em"-->
                    <!--                                  height="1em"-->
                    <!--                                  class="icon icon-check">-->
                    <!--                                <use-->
                    <!--                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>-->
                    <!--                              </svg>-->
                    <!--                            </span>-->
                    <!--                        <span class="form-control-checkbox__name"-->
                    <!--                        >Show details</span-->
                    <!--                        >-->
                    <!--                        <span-->
                    <!--                            class="form-control__name-help-content"-->
                    <!--                            :style="{bottom: '28px', left: '-30px'}"-->
                    <!--                        >Если вам нужно указать стоимость восхождения без-->
                    <!--                              учёта стандартного трансфера и размещения в в-->
                    <!--                              отеле, уберите эту галочку и нажмите на-->
                    <!--                              Recalculate the price</span-->
                    <!--                        >-->
                    <!--                      </label>-->
                    <!--                    </div>-->
                    <!-- ISLAND options-include end-->

                    <!-- ISLAND_COMPACTED options-include start-->
                    <!--                    <div-->
                    <!--                        v-if="item.type.data === 'ISLAND_COMPACTED'"-->
                    <!--                        class="options-include" style="margin-top: 0">-->
                    <!--                      <label-->
                    <!--                          class="form-control-checkbox form-control__name-help"-->
                    <!--                          @click.prevent="item.showDetails = !item.showDetails, calcTemplatePriceHandler()">-->
                    <!--                        <input-->
                    <!--                            type="checkbox"-->
                    <!--                            :checked="item.showDetails"/>-->
                    <!--                        <span class="form-control-checkbox__box">-->
                    <!--                              <svg-->
                    <!--                                  width="1em"-->
                    <!--                                  height="1em"-->
                    <!--                                  class="icon icon-check">-->
                    <!--                                <use-->
                    <!--                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>-->
                    <!--                              </svg>-->
                    <!--                            </span>-->
                    <!--                        <span class="form-control-checkbox__name"-->
                    <!--                        >Show details</span-->
                    <!--                        >-->
                    <!--                        <span-->
                    <!--                            class="form-control__name-help-content"-->
                    <!--                            :style="{bottom: '28px', left: '-30px'}"-->
                    <!--                        >Если вам нужно указать стоимость восхождения без-->
                    <!--                              учёта стандартного трансфера и размещения в в-->
                    <!--                              отеле, уберите эту галочку и нажмите на-->
                    <!--                              Recalculate the price</span-->
                    <!--                        >-->
                    <!--                      </label>-->
                    <!--                    </div>-->
                    <!-- ISLAND_COMPACTED options-include end-->

                    <div
                        class="form-control-group group-25"
                        v-if="
                        item.type.data === 'ARRIVAL' ||
                        item.type.data === 'DEPARTURE'
                      ">
                      <label class="form-control-checkbox">
                        <input
                            :disabled="fromNationalPark"
                            type="checkbox"
                            v-model="item.vipService"/>
                        <span class="form-control-checkbox__box">
                          <svg width="1em" height="1em" class="icon icon-check">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg
                          ></span>
                        <span class="form-control__name-help">
                          <span class="form-control-checkbox__name"
                          >VIP Service</span
                          >
                          <span class="form-control__name-help-content"
                          >Подробнее читайте в нашем <a href="#">FAQ</a></span
                          >
                        </span>
                      </label>
                    </div>

                    <!-- ---- <div class="tour-program-table__text-info" v-if="item.type.data === 'ARRIVAL'"><span
									class="tour-program-table__text-info__item"><b>Hotels: </b> Aishi Machame Lodge (3
									Rooms)</span><span class="tour-program-table__text-info__item"><b>Activity: </b>
									Waterfall</span><span
									class="tour-program-table__text-info__item"><b>Transfer: </b> Kilimanjaro Airport - Aishi Machame (3 pax)</span>
								</div> -->
                  </div>
                  <!--Program DAY start-->
                  <div v-if="item.type.data === 'SAFARI' && item.duration">
                    <div
                        class="tour-program-table__row-day tour-program-table__row--labeled tour-program-table__line tour-program-table__line-item"
                        v-for="(day, indexDay) in item.days"
                        :key="indexDay"
                        :ref="'daysItem'"
                        :class="{dragged: day.drag}"
                        :style="{
                        top: day.drag ? mouseDay.top + 'px' : 'unset',
                            marginBottom: day.pre
                            ? indexDay === data.program[index].days.length - 1
                                ? dragHeight + 50 + 'px'
                                : dragHeight + 'px'
                            : '0px',
                            marginTop: day.post ? dragHeight + 30 + 'px' : '0px',
                      }"
                        @mouseup="
                        () => {
                          if (day.drag) {
                            day.drag = false
                            dragCurrentDay(index, indexDay)
                            }
                          }
                        "
                        @mouseleave="day.drag = false"
                        @mousemove="
                        day.drag
                          ? (() => {
                              mouseFindDay($event)
                              dragCurrentDayFly(index, indexDay)
                            })()
                          : false
                      "
                        :data-indexDay="indexDay">
                      <div class="tour-program-table__day">
                        <div
                            class="tour-program-table__day__dot tour-program-table__day__dot--orange"></div>
                        <span class="tour-program-table__day__num"
                        >Day {{ day.day }}</span
                        ><span class="tour-program-table__day__date">{{
                          day.date
                        }}</span>
                      </div>
                      <div class="form-control-group">
                        <v-select
                            class="select-wrapper new-select safari-park-select"
                            :value="day.park && day.park.id ? day.park : null"
                            :options="dataSelects.parks"
                            label="nameForSystem"
                            :clearable="false"
                            placeholder="Search park"
                            @open="
                            data.program = data.program.map((dayItem, idx) =>
                              dayItem.type.data === 'SAFARI'
                                ? {
                                    ...dayItem,
                                    carsSelect: false,
                                    islandSelect: false,
                                    mountainSelect: false,
                                    climbSelect: false,
                                    tourLeaderSelect: false,
                                    activitySelect: false,
                                    airstripSelect: false,
                                    typeSelect: false,
                                    priceForSelect: false,
                                    days: dayItem.days.map((d, i) => ({
                                      ...d,
                                      parkSelect: i === indexDay && index === idx,
                                    })),
                                  }
                                : {
                                    ...dayItem,
                                    carsSelect: false,
                                    islandSelect: false,
                                    mountainSelect: false,
                                    climbSelect: false,
                                    tourLeaderSelect: false,
                                    activitySelect: false,
                                    airstripSelect: false,
                                    typeSelect: false,
                                    priceForSelect: false,
                                  }
                            )
                          "
                            @close="day.parkSelect = false"
                            @input="
                            day.park = {...$event}
                            isEditFlag = true
                            calcTemplatePriceHandler()
                          ">
                          <template #open-indicator>
                            <svg width="1em" height="1em" class="icon icon-chevron">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg>
                          </template>
                          <template #selected-option="park">
                            <div class="selected">{{ park.nameForSystem }}</div>
                          </template>
                        </v-select>
                      </div>
                      <div class="tour-program-table__btn-group">
                        <button
                            type="button"
                            :data-popover="'Hotel' + getHotelNamesList(day.hotelsData)"
                            @click="
                            hotelPopup = day
                            hotelPopupData.hotelsData = JSON.parse(
                              JSON.stringify(day.hotelsData)
                            )
                            getHotelsHandler(null)
                          "
                            :disabled="!(item.type && item.type.name)"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {'btn--popover-disabled': !day.hotelsData.length},
                          ]">
                          <svg width="1em" height="1em" class="icon icon-house">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-house"></use>
                          </svg>
                        </button>
                        <button
                            type="button"
                            data-popover="Activity"
                            @click="
                            day.type = item.type
                            activityPopup = day
                            activityPopupData.activitiesData = JSON.parse(
                              JSON.stringify(day.activitiesData)
                            )
                          "
                            :disabled="!(item.type && item.type.name)"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {
                              'btn--popover-disabled':
                                !day.activitiesData.length,
                            },
                          ]">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-parachute">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-parachute"></use>
                          </svg>
                        </button>
                        <button
                            type="button"
                            data-popover="Flight"
                            @click="
                            flightsPopup = day
                            flightsPopupData.flightsData = JSON.parse(
                              JSON.stringify(day.flightsData)
                            )
                            isActiveFlightTab = 'REGULAR'
                          "
                            :disabled="!(item.type && item.type.name)"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {'btn--popover-disabled': !day.flightsData.length},
                          ]">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-airplane">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                          </svg>
                        </button>
                        <button
                            type="button"
                            data-popover="Transfers"
                            @click="
                            day.type = item.type
                            transfersPopup = day
                            transfersPopupData.transfersData = JSON.parse(
                              JSON.stringify(day.transfersData)
                            )
                          "
                            :disabled="!(item.type && item.type.name)"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {
                              'btn--popover-disabled':
                                !day.transfersData.length,
                            },
                          ]">
                          <svg width="1em" height="1em" class="icon icon-taxi">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-taxi"></use>
                          </svg>
                        </button>
                        <button
                            type="button"
                            data-popover="Safari Members"
                            @click="
                            day.participantsIds = day.participantsIds
                              ? participants.map((p) => ({
                                  ...p,
                                  active: day.participantsIds.find(
                                    (par) => par.id === p.id
                                  )
                                    ? day.participantsIds
                                        .filter((par) => par.active)
                                        .map((par) => par.id)
                                        .includes(p.id)
                                    : true,
                                }))
                              : [
                                  ...participants.map((item) => ({
                                    ...item,
                                    active: true,
                                  })),
                                ]
                            participantsPopup = day
                          "
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {'btn--popover-disabled': !day.participantsSave},
                          ]">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-adult"
                              :style="{fontSize: '2rem'}">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                          </svg>
                        </button>
                        <button
                            @click="onNotesButtonClick(day)"
                            type="button"
                            data-popover="Notes"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {'btn--popover-disabled': !day.notes},
                          ]">
                          <svg width="1em" height="1em" class="icon icon-taxi">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-notes"></use>
                          </svg>
                        </button>
                        <div
                            class="form-control__name-help"
                            :style="{width: '12rem'}">
                          <div
                              class="form-control-group form-control-group--labeled"
                              :style="{margin: '0 0 0 10px'}">
                            <span
                                class="form-control-label"
                                :style="{width: '6rem'}"
                            >Total cars</span
                            >
                            <div class="form-control-wrap">
                              <input
                                  type="number"
                                  placeholder="1"
                                  v-model.number="day.totalCars"
                                  @input="onInputTotalCars(day)"
                                  @change="calcTemplatePriceHandler"
                                  class="form-control"/>
                            </div>
                            <span
                                class="form-control__name-help-content"
                                :style="{bottom: '45px'}"
                            >Если вам нужно настроить сафари как Game Package
                              от отеля и машина уже включена в стоимость
                              размещения, то укажите Total Cars = 0 в каждом
                              где, где НЕ нужно считать машину.</span
                            >
                          </div>
                        </div>
                        <div
                            class="form-control-group"
                            :style="{
                            margin: '0 10px 0 10px',
                            'padding-right': '5px',
                          }">
                          <span
                              class="form-control__name-help"
                              :style="{width: '12rem'}">
                            <button
                                type="button"
                                class="btn btn--green btn--sm-squared"
                                :class="{
                                'btn--popover-disabled':
                                  !day.transitPark ||
                                  Object.keys(day.transitPark).length === 0,
                              }"
                                @click="transitParkToggleHandler(day)">
                              <img
                                  src="/images/dual-location.svg"
                                  alt=""
                                  class="icon"
                                  :style="{width: '16px', height: '18px'}"/>
                            </button>
                            <span
                                class="form-control__name-help-content"
                                :style="{bottom: '40px'}"
                            >If enabled, transfers through Ngorongoro will be
                              calculated automatically</span
                            >
                          </span>
                        </div>
                      </div>
                      <div v-if="item.days.length > 1" class="tour-day-table__replace">
                        <button
                            type="button"
                            class="tour-day-table__replace-btn"
                            @mousedown="
                                mouseFindDay($event, index, indexDay)
                                day.drag = true
                              ">
                          <svg width="1em" height="1em" class="icon icon-move">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-move"></use>
                          </svg>
                        </button>
                        <button
                            type="button"
                            class="tour-day-table__remove-btn"
                            @click="
                              removeCurrentDayTour(index, indexDay)"
                        >
                          <svg width="1em" height="1em" class="icon icon-close">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>

                    </div>
                  </div>
                  <!--Program DAY end-->


                  <div v-if="item.type.data === 'ISLAND' && item.duration">
                    <div
                        class="tour-program-table__line"
                        v-for="(day, indexIsland) in item.days"
                        :key="indexIsland">
                      <div class="tour-program-table__day">
                        <div class="tour-program-table__day">
                          <div
                              class="tour-program-table__day__dot tour-program-table__day__dot--red"></div>
                          <span class="tour-program-table__day__num"
                          >Day {{ day.day }}</span
                          ><span class="tour-program-table__day__date">{{
                            day.date
                          }}</span>
                        </div>
                      </div>
                      <div
                          class="tour-program-table__btn-group tour-program-table__btn-group--to-right">
                        <button
                            type="button"
                            :data-popover="'Hotel' + getHotelNamesList(day.hotelsData)"
                            @click="
                            hotelPopup = day
                            hotelPopupData.hotelsData = JSON.parse(
                              JSON.stringify(day.hotelsData)
                            )
                            getHotelsHandler(item.island)
                          "
                            :disabled="!(item.type && item.type.name)"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {'btn--popover-disabled': !day.hotelsData.length},
                          ]">
                          <svg width="1em" height="1em" class="icon icon-house">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-house"></use>
                          </svg>
                        </button>
                        <button
                            type="button"
                            data-popover="Activity"
                            @click="
                            day.type = item.type
                            activityPopup = day
                            activityPopupData.activitiesData = JSON.parse(
                              JSON.stringify(day.activitiesData)
                            )
                          "
                            :disabled="!(item.type && item.type.name)"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {
                              'btn--popover-disabled':
                                !day.activitiesData.length,
                            },
                          ]">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-parachute">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-parachute"></use>
                          </svg>
                        </button>
                        <button
                            type="button"
                            data-popover="Flight"
                            @click="
                            flightsPopup = day
                            flightsPopupData.flightsData = JSON.parse(
                              JSON.stringify(day.flightsData)
                            )
                            isActiveFlightTab = 'REGULAR'
                          "
                            :disabled="!(item.type && item.type.name)"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {'btn--popover-disabled': !day.flightsData.length},
                          ]">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-airplane">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                          </svg>
                        </button>
                        <button
                            type="button"
                            data-popover="Transfers"
                            @click="
                            day.type = item.type
                            transfersPopup = day
                            transfersPopupData.transfersData = JSON.parse(
                              JSON.stringify(day.transfersData)
                            )
                          "
                            :disabled="!(item.type && item.type.name)"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {
                              'btn--popover-disabled':
                                !day.transfersData.length,
                            },
                          ]">
                          <svg width="1em" height="1em" class="icon icon-taxi">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-taxi"></use>
                          </svg>
                        </button>
                        <button
                            @click="onNotesButtonClick(day)"
                            type="button"
                            data-popover="Notes"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {'btn--popover-disabled': !day.notes},
                          ]">
                          <svg width="1em" height="1em" class="icon icon-taxi">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-notes"></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div v-if="item.type.data === 'ISLAND_COMPACTED' && item.duration">
                    <div
                        class="tour-program-table__line"
                        v-for="(day, indexIsland) in item.days"
                        :key="indexIsland">
                      <div class="tour-program-table__day">
                        <div class="tour-program-table__day">
                          <div
                              class="tour-program-table__day__dot tour-program-table__day__dot--red"></div>
                          <span class="tour-program-table__day__num"
                          >Day {{ day.day }}</span
                          ><span class="tour-program-table__day__date">{{
                            day.date
                          }}</span>
                        </div>
                      </div>
                      <div
                          class="tour-program-table__btn-group tour-program-table__btn-group--to-right">
                        <button
                            type="button"
                            data-popover="Flight"
                            @click="
                            flightsPopup = day
                            flightsPopupData.flightsData = JSON.parse(
                              JSON.stringify(day.flightsData)
                            )
                            isActiveFlightTab = 'REGULAR'
                          "
                            :disabled="!(item.type && item.type.name)"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {'btn--popover-disabled': !day.flightsData.length},
                          ]">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-airplane">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                          </svg>
                        </button>
                        <button
                            type="button"
                            data-popover="Transfers"
                            @click="
                            day.type = item.type
                            transfersPopup = day
                            transfersPopupData.transfersData = JSON.parse(
                              JSON.stringify(day.transfersData)
                            )
                          "
                            :disabled="!(item.type && item.type.name)"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {
                              'btn--popover-disabled':
                                !day.transfersData.length,
                            },
                          ]">
                          <svg width="1em" height="1em" class="icon icon-taxi">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-taxi"></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                      class="tour-program-table__columns"
                      v-if="item.type.data === 'CLIMBING' && item.climb">
                    <div class="tour-program-table__column">
                      <div
                          class="tour-program-table__line"
                          v-for="(itemClimbDay, indexClimb) in Array(
                          item.climb.durationDays || item.climb.days
                        )"
                          :key="indexClimb">
                        <div class="tour-program-table__day">
                          <div class="tour-program-table__day">
                            <div
                                class="tour-program-table__day__dot tour-program-table__day__dot--green"></div>
                            <span class="tour-program-table__day__num"
                            >Day
                              {{
                                data.program
                                    .slice(0, index)
                                    .reduce(
                                        (acc, day) => acc + +day.duration,
                                        0
                                    ) +
                                1 +
                                indexClimb
                              }}</span
                            >
                            <span class="tour-program-table__day__date">{{
                                tourStart
                                    ? dateCalc(
                                        +new Date(tourStart).getTime() +
                                        (data.program
                                                .slice(0, index)
                                                .reduce(
                                                    (acc, day) => acc + +day.duration,
                                                    0
                                                ) +
                                            indexClimb) *
                                        24 *
                                        60 *
                                        60 *
                                        1000
                                    )
                                    : ''
                              }}</span>
                          </div>
                        </div>
                        <div class="tour-program-table__day-descr">
                          <span
                          >{{ item.climb.name || item.climb.route }}
                            {{ item.climb.durationDays || item.climb.days }}
                            days | Day {{ indexClimb + 1 }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div
                        class="tour-program-table__column tour-program-table__column_2">
                      <div class="tour-program-table__column_2_new">
                        <div
                            class="form-control-group form-control-group_price-for form-control__help form-control__help-offset"
                            v-if="item.type.data === 'CLIMBING'">
                          <span class="form-control-group_price-for__label"
                          >Price for:</span
                          >
                          <div
                              :class="[
                              'select-wrapper select-wrapper--xs',
                              {'is-active': item.priceForSelect},
                            ]"
                              @click="
                              isEditFlag = true
                              data.program = data.program.map((day, i) =>
                                i === index
                                  ? {
                                      ...day,
                                      priceForSelect: !day.priceForSelect,
                                      climbSelect: false,
                                      tourLeaderSelect: false,
                                      activitySelect: false,
                                      mountainSelect: false,
                                      airstripSelect: false,
                                      typeSelect: false,
                                      islandSelect: false,
                                      carsSelect: false,
                                      days: day.days.map((d) => ({
                                        ...d,
                                        parkSelect: false,
                                      })),
                                    }
                                  : {
                                      ...day,
                                      priceForSelect: false,
                                      mountainSelect: false,
                                      tourLeaderSelect: false,
                                      climbSelect: false,
                                      activitySelect: false,
                                      airstripSelect: false,
                                      typeSelect: false,
                                      islandSelect: false,
                                      carsSelect: false,
                                      days: day.days.map((d) => ({
                                        ...d,
                                        parkSelect: false,
                                      })),
                                    }
                              )
                            "
                              :style="{
                              opacity: !participants.length ? 0.6 : 1,
                              cursor: !participants.length
                                ? 'default'
                                : 'pointer',
                              pointerEvents: !participants.length
                                ? 'none'
                                : 'auto',
                            }">
                            <div
                                class="select-trigger"
                                :style="{width: '8rem'}">
                              <span class="select-trigger__name">{{
                                  item.priceFor ? item.priceFor : ''
                                }}</span
                              ><span class="select-trigger__icon">
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-chevron">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                                ></span>
                            </div>
                            <div class="select-body">
                              <div class="select-inner js-scrollbar">
                                <div
                                    v-for="price in climbingPrice(
                                    item.type.subData,
                                    item
                                  )"
                                    :key="price"
                                    :class="[
                                    'select-option',
                                    {'is-selected': price === item.priceFor},
                                  ]"
                                    @click="
                                    item.priceFor = price
                                    calcTemplatePriceHandler()
                                  ">
                                  <span class="select-option__name">{{
                                      price
                                    }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <span class="form-control__help-icon">
                            <span class="form-control__help-content"
                            >Укажите для какого размера группы посчитать цену
                              за восхождение. Если у вас один человек в
                              групповое восхождение, по-умолчанию укажите 3.
                              Чек-бокс турлидер необходимо поставить, чтобы в
                              группе один из участников посчитался по цене
                              тур-лидера.</span
                            >
                            <img
                                src="/images/useful/svg/help-icon.svg"
                                alt=""/>
                          </span>
                        </div>
                        <div
                            class="form-control-group"
                            v-if="
                            item.type.data === 'CLIMBING' &&
                            item.type.subData !== 'JOIN'
                          ">
                          <label
                              class="form-control-checkbox"
                              @click.prevent="
                              item.tourLeader = !item.tourLeader
                              item.tourLeaderPer = null
                              isEditFlag = true
                              calcTemplatePriceHandler()
                            ">
                            <input
                                type="checkbox"
                                :checked="item.tourLeader"
                                @click.prevent/><span
                              class="form-control-checkbox__box">
                              <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-check">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                          ><span class="form-control-checkbox__name"
                          >Tour Leader</span
                          >
                          </label>
                        </div>
                        <div
                            class="form-control-group form-control-group-client"
                            :style="{marginLeft: '10px', height: '36px'}"
                            v-if="
                            item.type.data === 'CLIMBING' &&
                            item.type.subData !== 'JOIN'
                          ">
                          <div
                              :class="[
                              'select-wrapper',
                              {'is-active': item.tourLeaderSelect},
                            ]"
                              :style="{
                              opacity: !item.tourLeader ? 0.6 : 1,
                              cursor: !item.tourLeader ? 'default' : 'pointer',
                              pointerEvents: !item.tourLeader ? 'none' : 'auto',
                            }"
                              @click="
                              isEditFlag = true
                              data.program = data.program.map((day, i) =>
                                i === index
                                  ? {
                                      ...day,
                                      tourLeaderSelect: !day.tourLeaderSelect,
                                      climbSelect: false,
                                      activitySelect: false,
                                      mountainSelect: false,
                                      airstripSelect: false,
                                      typeSelect: false,
                                      islandSelect: false,
                                      carsSelect: false,
                                      days: day.days.map((d) => ({
                                        ...d,
                                        parkSelect: false,
                                      })),
                                    }
                                  : {
                                      ...day,
                                      tourLeaderSelect: false,
                                      priceForSelect: false,
                                      mountainSelect: false,
                                      climbSelect: false,
                                      activitySelect: false,
                                      airstripSelect: false,
                                      typeSelect: false,
                                      islandSelect: false,
                                      carsSelect: false,
                                      days: day.days.map((d) => ({
                                        ...d,
                                        parkSelect: false,
                                      })),
                                    }
                              )
                            ">
                            <div class="form-control-group-client-icon">
                              <svg
                                  width="1em"
                                  height="1em"
                                  :class="
                                  'icon icon-' +
                                  (item.tourLeaderPer
                                    ? item.tourLeaderPer.type
                                    : 'adult')
                                ">
                                <use
                                    :xlink:href="
                                    '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                                    (item.tourLeaderPer
                                      ? item.tourLeaderPer.type
                                      : 'adult')
                                  "></use>
                              </svg>
                            </div>
                            <div class="select-trigger">
                              <span class="select-trigger__name">{{
                                  item.tourLeaderPer &&
                                  participants.find(
                                      (par) => par.id === item.tourLeaderPer.id
                                  )
                                      ? participants.find(
                                          (par) => par.id === item.tourLeaderPer.id
                                      ).name
                                      : ''
                                }}</span>
                              <span class="select-trigger__icon">
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-chevron">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                                </svg>
                              </span>
                            </div>
                            <div class="select-body">
                              <div
                                  v-if="
                                  item.tourLeaderPer &&
                                  item.tourLeaderPer.name &&
                                  item.tourLeaderPer.name.length > 0
                                "
                                  :class="[
                                  'select-option',
                                  {'is-selected': true},
                                ]"
                                  @click="
                                  item.tourLeaderPer = {name: '', id: ''}
                                ">
                                --
                              </div>
                              <div
                                  v-for="(
                                  client, clientIndex
                                ) in participants.filter(
                                  (client) => client.ageType === 'adult'
                                )"
                                  :key="clientIndex"
                                  :class="[
                                  'select-option',
                                  {
                                    'is-selected':
                                      item.tourLeaderPer &&
                                      item.tourLeaderPer.name === client.name,
                                  },
                                ]"
                                  @click="
                                  item.tourLeaderPer = {
                                    name: client.name,
                                    id: client.id,
                                    type: client.ageType,
                                  }
                                ">
                                <span class="select-option__name">{{
                                    client.name
                                  }}</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- <div :class="['select-wrapper', {'is-active' : clientOption.isOpen}, { 'is-error' : clientOption.error}]" @click="clientOption.error = false;item.clients = item.clients.map((c, ci) => ({...c, isOpen: clientOptionIndex === ci ? !c.isOpen : false}));">
										<div class="form-control-group-client-icon">
											<svg width="1em" height="1em" :class="'icon icon-' + (clientOption.type || 'adult') ">
											<use :xlink:href="'/images/useful/svg/theme/symbol-defs.svg#icon-' + (clientOption.type || 'adult')"></use>
											</svg>
										</div>
										<div class="select-trigger"><span class="select-trigger__name">{{participants.find(par => par.id === clientOption.id) ? participants.find(par => par.id === clientOption.id).name : ''}}</span><span class="select-trigger__icon">
											<svg width="1em" height="1em" class="icon icon-chevron ">
												<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
											</svg></span></div>
										<div class="select-body">
											<div v-if="clientOption.name.length > 0" :class="['select-option', {'is-selected' : true}]" @click="clientOption.name = '';clientOption.id = ''">
												--
											</div>
											<div
												v-for="(client, clientIndex) in participants" :key="clientIndex"
												:class="['select-option', {'is-selected' : clientOption.name === client.name}]" @click="clientOption.name = client.name || 'Adult ' + (clientIndex + 1);clientOption.id = client.id;clientOption.type = client.ageType"><span class="select-option__name">{{client.name || 'Adult ' + (clientIndex + 1)}}</span>
											</div>
										</div>
										</div> -->
                      </div>
                      <div
                          class=""
                          :style="{height: '100%', paddingTop: '1rem'}">
                        <div class="elem-flex flex-center">
                          <div class="tour-program-label-2">
                            Additional Options
                          </div>
                          <button
                              type="button"
                              @click="
                              item.participantsIds = item.participantsIds
                                ? participants.map((p) => ({
                                    ...p,
                                    active: item.participantsIds
                                      .filter((par) => par.active)
                                      .map((par) => par.id)
                                      .includes(p.id),
                                    choosed: false,
                                  }))
                                : [
                                    ...participants.map((p) => ({
                                      ...p,
                                      active: true,
                                      choosed: false,
                                    })),
                                  ]
                              additionalPopup = item
                              additionalPopupData.additionalOptions =
                                JSON.parse(
                                  JSON.stringify(item.additionalOptions)
                                )
                            "
                              class="btn btn--rounded2 btn--green btn-vs btn-add">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-plus-o-white">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                            </svg>
                            <span>Add</span>
                          </button>
                        </div>
                        <div
                            class="options-no-additional"
                            v-if="!item.additionalOptions.length">
                          No additional options
                        </div>

                        <div
                            class="options-table"
                            v-if="totalPrice && item.additionalOptions.length">
                          <div
                              class="options-table__tr"
                              v-for="(
                              option, additionalOptionsIndex
                            ) in item.additionalOptions"
                              :key="additionalOptionsIndex">
                            <div class="options-table__td">
                              <span>{{ option.name }}</span>
                            </div>
                            <div class="options-table__td">
                              <span class="options-table__price"
                                    v-if="dataSelects.additionalOptions.find((item) => item.id === option.id) && dataSelects.additionalOptions.find((item) => item.id === option.id).costType === 'PER_CLIMB'"
                              >{{ option.pax }} x
                                {{
                                  +(+option.price / +option.pax).toFixed(2)
                                }}$</span>

                              <span
                                  v-if="dataSelects.additionalOptions.find((item) => item.id === option.id) && dataSelects.additionalOptions.find((item) => item.id === option.id).costType === 'PER_DAY'">
                                <span class="options-table__price">
                                  {{ option.pax }} x
                                {{ item.type.subData === "JOIN" ? item.climb.days : item.climb.durationDays }}d x
                                {{
                                    +(+option.price / +option.pax).toFixed(2)
                                  }}$
                                </span>
                              </span>
                            </div>
                            <div class="options-table__td"
                                 v-if="dataSelects.additionalOptions.find((item) => item.id === option.id) && dataSelects.additionalOptions.find((item) => item.id === option.id).costType === 'PER_CLIMB'">
                              {{ option.price }}$
                            </div>
                            <div class="options-table__td"
                                 v-if="dataSelects.additionalOptions.find((item) => item.id === option.id) && dataSelects.additionalOptions.find((item) => item.id === option.id).costType === 'PER_DAY'">
                              {{
                                +option.price * (item.type.subData === "JOIN" ? +item.climb.days : item.climb.durationDays)
                              }}$
                            </div>
                          </div>
                        </div>

                        <!--options-include start-->
                        <div
                            v-if="item.type.data === 'CLIMBING'"
                            class="options-include">
                          <label
                              class="form-control-checkbox form-control__name-help"
                              @click.prevent="
                              item.includeHotelsAndTransfers =
                                !item.includeHotelsAndTransfers
                              updateClientsHandlerIncludeHotelAndTransfer()
                            ">
                            <input
                                type="checkbox"
                                :checked="item.includeHotelsAndTransfers"/>
                            <span class="form-control-checkbox__box">
                              <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-check">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                              </svg>
                            </span>
                            <span class="form-control-checkbox__name"
                            >Hotels & transfers included</span
                            >
                            <span
                                class="form-control__name-help-content"
                                :style="{bottom: '28px', left: '-36px'}"
                            >
                              If you add a custom hotel or transfer, tick this box to remove both standard hotels and transfers from the Kilimanjaro climb price.<br><br>
                              Then mark all hotels and transfers as paid options, even if you customise only one of them, so both are included in the total.<br><br>
                              Use this when guests stay in Arusha or choose upgraded hotels in Moshi.
                            </span
                            >
                          </label>
                        </div>
                        <!--options-include end-->

                      </div>
                      <div class="tour-program-table__btn-group">
                        <button
                            type="button"
                            :data-popover="'Hotel' + getHotelNamesList(item.hotelsData)"
                            @click="
                            hotelPopup = item
                            hotelPopupData.hotelsData = JSON.parse(
                              JSON.stringify(item.hotelsData)
                            )
                            getHotelsHandler(null)
                          "
                            :disabled="!(item.type && item.type.name)"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {'btn--popover-disabled': !item.hotelsData.length},
                          ]">
                          <svg width="1em" height="1em" class="icon icon-house">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-house"></use>
                          </svg>
                        </button>
                        <button
                            type="button"
                            data-popover="Flight"
                            @click="
                            flightsPopup = item
                            flightsPopupData.flightsData = JSON.parse(
                              JSON.stringify(item.flightsData)
                            )
                            isActiveFlightTab = 'REGULAR'
                          "
                            :disabled="!(item.type && item.type.name)"
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {'btn--popover-disabled': !item.flightsData.length},
                          ]">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-airplane">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                          </svg>
                        </button>
                        <button
                            type="button"
                            data-popover="Transfers"
                            :disabled="!(item.type && item.type.name)"
                            @click="
                            transfersPopup = item
                            transfersPopup.firstDay = false
                            transfersPopupData.transfersData = JSON.parse(
                              JSON.stringify(
                                item.transfersData.filter(
                                  (t) => t.firstDay === false
                                )
                              )
                            )
                          "
                            :class="[
                            'btn btn--green btn--sm-squared btn--popover',
                            {
                              'btn--popover-disabled':
                                !item.transfersData.filter((t) => !t.firstDay)
                                  .length,
                            },
                          ]">
                          <svg width="1em" height="1em" class="icon icon-taxi">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-taxi"></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Program LIST end-->

              <button
                  type="button"
                  class="btn btn--rounded btn--add"
                  @click="
                  duration = +duration + 1
                  changeNumDays()
                  isEditFlag = true
                ">
                <svg
                    :style="{color: '#639A05'}"
                    width="1em"
                    height="1em"
                    class="icon icon-plus-o-white">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                </svg>
                <span>Add day</span>
              </button>

            </div>
          </div>
          <!--Program end-->
          <div
              class="make-story-collapses"
              v-if="data.id"
              v-show="tab === 1"
              :style="{paddingTop: '0px'}">
            <div class="container-lg">
              <div
                  :class="[
                  'make-story__collapse js-collapse',
                  {'is-collapsed': collapse.folio},
                ]"
                  :style="{marginBottom: '2rem', paddingTop: '0px'}"
                  id="folio-sect">
                <div
                    class="make-story__collapse__title form-control__help make-story__collapse_block"
                    :style="{maxWidth: '100%', paddingRight: '6rem'}">
                  <div class="make-story__collapse_bl">
                    <div class="make-story__collapse__title__icon">
                      <svg width="1em" height="1em" class="icon icon-house">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-house"></use>
                      </svg>
                    </div>
                    <span class="make-story__collapse__title__text"
                    >Client Folio</span
                    >
                  </div>
                  <a
                      class="print-ic"
                      :style="{cursor: 'pointer'}"
                      @click="
                      printMode = 'print-clients'
                      print('print-clients')
                    ">
                    <i class="icon-loader" v-if="printLoad">
                      <svg width="1em" height="1em" class="icon spinner">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-loader"></use>
                      </svg>
                    </i>
                    <svg
                        class="icon icon-collapse">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-print"></use>
                    </svg>
                    <span>Print</span>
                  </a>
                </div>
                <div
                    class="make-story__collapse__inner js-collapse-inner"
                    id="folio-to-print">
                  <simplebar
                      data-simplebar-auto-hide="true"
                      class="section-table-wrap">
                    <div class="section-table section-table--folio">
                      <div class="section-table__head">
                        <div class="col col-folio__name">Name</div>
                        <div class="col col-folio__birth">Date of birth</div>
                        <div class="col col-folio__dietary">Dietary</div>
                        <div class="col col-folio__allergies">Allergies</div>
                        <div class="col col-folio__total">Total Amount</div>
                      </div>
                      <div class="section-table__body">
                        <div v-for="(item, index) in participants" :key="index">
                          <div class="section-table__row">
                            <div class="col col-folio__name">
                              {{ index + 1 }}. {{ item.name }}
                            </div>
                            <svg
                                width="1em"
                                height="1em"
                                :class="'icon icon-' + item.gender"
                                :style="{
                                minWidth:
                                  item.gender === 'male' ? '12px' : '15px',
                                height:
                                  item.gender === 'male' ? '12px' : '15px',
                                marginRight: '20px',
                              }">
                              <use
                                  :xlink:href="
                                  '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                                  item.gender
                                "></use>
                            </svg>
                            <div
                                class="col col-folio__birth"
                                :style="{display: 'flex'}">
                              {{ item.dateOfBirth }}
                              <div
                                  class="col-folio__citizenship-icon"
                                  :style="{
                                  marginLeft: '4px',
                                  transform: 'translateY(-4px)',
                                }"
                                  v-if="
                                  item.dateOfBirth &&
                                  tourStart &&
                                  tourFinish &&
                                  +new Date(item.dateOfBirth).setFullYear(
                                    2021
                                  ) >= +new Date(tourStart).setFullYear(2021) &&
                                  +new Date(item.dateOfBirth).setFullYear(
                                    2021
                                  ) <= +new Date(tourFinish).setFullYear(2021)
                                ">
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-cake">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-cake"></use>
                                </svg>
                              </div>
                            </div>
                            <div class="col col-folio__dietary">
                              {{
                                item.dietarySave
                                    ? item.dietaryRequirements.foodPreferences
                                    : '-'
                              }}
                              <img
                                  v-if="
                                  item.dietaryRequirements.foodPreferences ===
                                    'Vegan' ||
                                  item.dietaryRequirements.foodPreferences ===
                                    'Vegetarian'
                                "
                                  src="/images/vegan.svg"
                                  :style="{marginLeft: '10px'}"/>
                            </div>
                            <div class="col col-folio__allergies">
                              {{
                                item.dietarySave
                                    ? item.dietaryRequirements.allergies.join(
                                        ', '
                                    )
                                    : '-'
                              }}
                            </div>
                            <div
                                class="col col-folio__total"
                                v-if="totalPrice && totalPrice.clientFolio">
                              {{
                                totalPrice.clientFolio.find(
                                    (client) => item.id === client.id
                                )
                                    ? totalPrice.clientFolio.find(
                                        (client) => item.id === client.id
                                    ).totalAmount
                                    : 0
                              }}{{
                                getCurrencySign(totalPrice.breakdownCost.currency)
                              }}
                            </div>
                          </div>
                          <div
                              class="section-table__row-bottom"
                              v-if="
                              item.insurance.companyName &&
                              item.insurance.policyNumber &&
                              item.insurance.validFrom &&
                              item.insurance.validUpTo &&
                              item.insurance.validFrom <
                                item.insurance.validUpTo
                            ">
                            <span>Insurance details:</span>
                            {{ item.insurance.companyName }} |
                            {{ item.insurance.policyNumber }} | Valid from
                            {{ item.insurance.validFrom }} to
                            {{ item.insurance.validUpTo }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </simplebar>
                </div>
              </div>
              <div
                  id="hotel-sect"
                  :class="[
                  'make-story__collapse js-collapse',
                  {'is-collapsed': collapse.hotels},
                ]">
                <div
                    class="make-story__collapse__title form-control__help make-story__collapse_block">
                  <div class="make-story__collapse_bl">
                    <div class="make-story__collapse__title__icon">
                      <svg width="1em" height="1em" class="icon icon-house">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-house"></use>
                      </svg>
                    </div>
                    <span class="make-story__collapse__title__text"
                    >Hotels</span
                    >
                    <!-- <button type="button"
										data-opened="Hide" data-closed="Show"
										:class="['btn', 'btn--collapse', 'js-collapse-trigger', { 'is-active': collapse.hotels }]"
										@click="collapse.hotels = !collapse.hotels"
										>
										<div class="btn--collapse__icon">
										<svg width="1em" height="1em" class="icon icon-collapse ">
											<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
										</svg>
										</div>
									</button> -->
                  </div>
                  <a
                      class="print-ic"
                      :style="{cursor: 'pointer'}"
                      @click="
                      printMode = 'print-hotels'
                      print('print-hotels')
                    ">
                    <i class="icon-loader" v-if="printLoad">
                      <svg width="1em" height="1em" class="icon spinner">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-loader"></use>
                      </svg>
                    </i>
                    <svg
                        class="icon icon-collapse">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-print"></use>
                    </svg>
                    <span>Print</span>
                  </a>
                </div>
                <div class="make-story__collapse__inner js-collapse-inner">
                  <div
                      class="section-table-wrap"
                      v-if="
                      filteredHotelsData
                        .map((item) => item.hotelsData)
                        .flat()
                        .filter((item) => !item.free).length
                    "
                      id="hotels-to-print">
                    <div
                        class="section-table section-table--hotels section-table--3">
                      <div class="section-table__head">
                        <div
                            class="col col-day-2"
                            :style="{paddingTop: '10px', paddingBottom: '0px'}">
                          <span>Night</span>
                        </div>
                        <div class="col col-hotel-2">
                          <span>Hotel Name</span>
                        </div>
                        <div class="col col-meal col-meal-2">
                          <span>Meal</span>
                        </div>
                        <div class="col col-room-2"><span>Room</span></div>
                        <div class="col col-qty-2"><span>Qty</span></div>
                        <div class="col col-persons col-persons-2"></div>
                        <div class="col col-room-type-2">
                          <span>Room Type</span>
                        </div>
                      </div>
                      <div class="section-table__body">
                        <div
                            class="section-table__row"
                            v-for="(item, index) in filteredHotelsData"
                            :key="index"
                            v-if="
                            item.hotelsData.filter((itemH) => !itemH.free)
                              .length
                          ">
                          <div class="col col-day-2">
                            <b v-if="!item.dayTo">NIGHT {{ item.day }}</b>
                            <b v-else>NIGHT {{ item.day }} - {{ item.dayTo }}</b>
                            <span class="date-el">{{ item.date }}</span>
                          </div>
                          <div class="section-table__row-wrapper">
                            <div
                                class="section-table__row-wrap"
                                v-for="(hotel, hotelI) in item.hotelsData.filter(
                                (itemH) => !itemH.free
                              )"
                                :key="hotelI">
                              <div class="col col-hotel-2">
                                <span>{{ hotel.name }}</span>
                              </div>
                              <div class="col col-meal col-meal-2">
                                <span>{{ hotel.meal }}</span>
                              </div>
                              <div class="col col-room-2">
                                <span>{{ hotel.room }}</span>
                              </div>
                              <div class="col col-qty-2">
                                <span>{{ 1 }}</span>
                              </div>
                              <div class="col col-persons col-persons-2">
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-adult"
                                    v-for="(icon, i) in Array(
                                    hotel.accommodations.data.find(
                                      (d) => d.type === 'A'
                                    )
                                      ? hotel.accommodations.data.find(
                                          (d) => d.type === 'A'
                                        ).count
                                      : 0
                                  )"
                                    :key="i + 'A'">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-teenager"
                                    v-for="(icon, i) in Array(
                                    hotel.accommodations.data.find(
                                      (d) => d.type === 'T'
                                    )
                                      ? hotel.accommodations.data.find(
                                          (d) => d.type === 'T'
                                        ).count
                                      : 0
                                  )"
                                    :key="i + 'T'">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-child"
                                    v-for="(icon, i) in Array(
                                    hotel.accommodations.data.find(
                                      (d) => d.type === 'C'
                                    )
                                      ? hotel.accommodations.data.find(
                                          (d) => d.type === 'C'
                                        ).count
                                      : 0
                                  )"
                                    :key="i + 'C'">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </div>
                              <div class="col col-room-type-2">
                                <span>{{ hotel.roomType }}</span>
                              </div>
                              <div class="col col-names_2">
                                <span class="col-names_2__label">Guests:</span
                                ><span>{{
                                  hotel.clients.length > 1
                                      ? participants
                                          .filter((par) =>
                                              hotel.clients
                                                  .map((client) => client.id)
                                                  .includes(par.id)
                                          )
                                          .map((client) => client.name)
                                          .join(', ')
                                      : participants
                                          .filter((par) =>
                                              hotel.clients
                                                  .map((client) => client.id)
                                                  .includes(par.id)
                                          )
                                          .map((client) => client.name)
                                          .join()
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                      class="section-table-wrap"
                      v-if="
                      filteredHotelsData
                        .map((item) => item.hotelsData)
                        .flat()
                        .filter((item) => item.free || item.bookedByGuest).length
                    "
                      :style="{marginTop: '-10px'}">
                    <div
                        class="section-table section-table--free section-table--hotels section-table--3">
                      <span
                          class="section-table--free__title"
                          :style="{height: '20px'}"
                      >Free of charge, incl on package<img
                          src="/images/icons/free.svg"
                          alt=""
                      /></span>
                      <div class="section-table__body">
                        <div
                            class="section-table__row"
                            v-for="(item, index) in filteredHotelsData"
                            :key="index"
                            v-if="
                            item.hotelsData.filter((itemH) => itemH.free || itemH.bookedByGuest).length
                          ">
                          <div class="col col-day-2">
                            <b>NIGHT {{ item.day }}</b>
                            <span class="date-el">{{ item.date }}</span>
                          </div>
                          <div class="section-table__row-wrapper">
                            <div
                                class="section-table__row-wrap"
                                v-for="(hotel, hotelI) in item.hotelsData.filter(
                                (itemH) => itemH.free || itemH.bookedByGuest
                              )"
                                :key="hotelI">
                              <div class="col col-hotel-2">
                                <span>{{ hotel.name }}</span>
                              </div>
                              <div class="col col-meal col-meal-2">
                                <span>{{ hotel.meal }}</span>
                              </div>
                              <div class="col col-room-2">
                                <span>{{ hotel.room }}</span>
                              </div>
                              <div class="col col-qty-2">
                                <span>{{ 1 }}</span>
                              </div>
                              <div class="col col-persons col-persons-2">
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-adult"
                                    v-for="(icon, i) in Array(
                                    hotel.accommodations.data.find(
                                      (d) => d.type === 'A'
                                    )
                                      ? hotel.accommodations.data.find(
                                          (d) => d.type === 'A'
                                        ).count
                                      : 0
                                  )"
                                    :key="i + 'A'">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                                </svg>
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-teenager"
                                    v-for="(icon, i) in Array(
                                    hotel.accommodations.data.find(
                                      (d) => d.type === 'T'
                                    )
                                      ? hotel.accommodations.data.find(
                                          (d) => d.type === 'T'
                                        ).count
                                      : 0
                                  )"
                                    :key="i + 'T'">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                                </svg>
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-child"
                                    v-for="(icon, i) in Array(
                                    hotel.accommodations.data.find(
                                      (d) => d.type === 'C'
                                    )
                                      ? hotel.accommodations.data.find(
                                          (d) => d.type === 'C'
                                        ).count
                                      : 0
                                  )"
                                    :key="i + 'C'">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                                </svg>
                              </div>
                              <div class="col col-room-type-2">
                                <span>{{ hotel.roomType }}</span>
                              </div>
                              <div class="col col-names_2">
                                <span class="col-names_2__label">Guests:</span
                                ><span>{{
                                  hotel.clients.length > 1
                                      ? participants
                                          .filter((par) =>
                                              hotel.clients
                                                  .map((client) => client.id)
                                                  .includes(par.id)
                                          )
                                          .map((client) => client.name)
                                          .join(', ')
                                      : participants
                                          .filter((par) =>
                                              hotel.clients
                                                  .map((client) => client.id)
                                                  .includes(par.id)
                                          )
                                          .map((client) => client.name)
                                          .join()
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span
                      :style="{
                      paddingTop: '2rem',
                      marginLeft: '1rem',
                      fontSize: '12px',
                      display: 'flex',
                    }"
                      v-if="
                      !data.program
                        .filter(
                          (item) =>
                            item.type.data === 'SAFARI' ||
                            item.type.data === 'ISLAND' ||
                            item.hotelsData.length
                        )
                        .map((item) =>
                          item.type.data === 'SAFARI' ||
                          item.type.data === 'ISLAND'
                            ? item.days
                                .filter((day) => day.hotelsData.length)
                                .map((day) => ({
                                  hotelsData: day.hotelsData,
                                  day: day.day,
                                  date: day.date,
                                }))
                            : [
                                {
                                  hotelsData: item.hotelsData,
                                  day: item.day,
                                  date: item.date,
                                },
                              ]
                        )
                        .flat()
                        .map((item) => ({...item.hotelsData}))
                        .map((item) => item[0]).length
                    "
                  >Hotels not added</span
                  >
                </div>
              </div>
              <div
                  :class="[
                  'make-story__collapse js-collapse',
                  {'is-collapsed': collapse.activities},
                ]"
                  id="activities-sect">
                <div class="make-story__collapse__title form-control__help">
                  <div class="make-story__collapse__title__icon">
                    <svg width="1em" height="1em" class="icon icon-parachute">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-parachute"></use>
                    </svg>
                  </div>
                  <span class="make-story__collapse__title__text"
                  >Activities</span
                  >
                  <!-- <button type="button" data-opened="Hide" data-closed="Show"
								:class="['btn', 'btn--collapse', 'js-collapse-trigger', { 'is-active': collapse.activities }]"
								@click="collapse.activities = !collapse.activities">
								<div class="btn--collapse__icon">
								<svg width="1em" height="1em" class="icon icon-collapse ">
									<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
								</svg>
								</div>
							</button> -->
                </div>
                <div class="make-story__collapse__inner js-collapse-inner">
                  <div
                      class="section-table-wrap"
                      v-if="
                      data.program
                        .filter(
                          (item) =>
                            item.type.data === 'SAFARI' ||
                            item.type.data === 'ISLAND' ||
                            item.activitiesData.length
                        )
                        .map((item) =>
                          item.type.data === 'SAFARI' ||
                          item.type.data === 'ISLAND'
                            ? item.days
                                .filter((day) => day.activitiesData.length)
                                .map((day) => ({
                                  activitiesData: day.activitiesData,
                                  day: day.day,
                                  date: day.date,
                                }))
                            : {
                                activitiesData: item.activitiesData,
                                day: item.day,
                                date: item.date,
                              }
                        )
                        .flat()
                        .map((item) =>
                          item.activitiesData.map((data) => ({
                            ...data,
                            day: item.day,
                            date: item.date,
                          }))
                        )
                        .flat().length
                    ">
                    <div
                        class="section-table section-table--3 section-table--activities-2">
                      <div class="section-table__body">
                        <div
                            class="section-table__row"
                            v-for="(item, index) in data.program
                            .filter(
                              (item) =>
                                item.type.data === 'SAFARI' ||
                                item.type.data === 'ISLAND' ||
                                item.activitiesData.length
                            )
                            .map((item) =>
                              item.type.data === 'SAFARI' ||
                              item.type.data === 'ISLAND'
                                ? item.days
                                    .filter((day) => day.activitiesData.length)
                                    .map((day) => ({
                                      activitiesData: day.activitiesData,
                                      day: day.day,
                                      date: day.date,
                                    }))
                                : {
                                    activitiesData: item.activitiesData,
                                    day: item.day,
                                    date: item.date,
                                  }
                            )
                            .flat()
                            .map((item) =>
                              item.activitiesData.map((data) => ({
                                ...data,
                                day: item.day,
                                date: item.date,
                              }))
                            )
                            .flat()"
                            :key="index">
                          <div class="col col-day-2">
                            <b>DAY {{ item.day }}</b>
                            <span class="date-el">{{ item.date }}</span>
                          </div>
                          <div class="section-table__row-wrapper">
                            <div class="section-table__row-wrap">
                              <div class="col col-activity col-activity-2">
                                <span>{{ item.name }}</span>
                              </div>
                              <div
                                  class="col col-activity-persons col-activity-persons_2">
                                <span
                                    v-if="
                                    item.paxList.filter(
                                      (pax) => pax.ageType === 'adult'
                                    ).length
                                  "
                                >Adult:
                                  <span>{{
                                      item.paxList.filter(
                                          (pax) => pax.ageType === 'adult'
                                      ).length
                                    }}</span></span
                                >
                                <span
                                    v-if="
                                    item.paxList.filter(
                                      (pax) => pax.ageType === 'teenager'
                                    ).length
                                  "
                                >Teenager:
                                  <span>{{
                                      item.paxList.filter(
                                          (pax) => pax.ageType === 'teenager'
                                      ).length
                                    }}</span></span
                                >
                                <span
                                    v-if="
                                    item.paxList.filter(
                                      (pax) => pax.ageType === 'child'
                                    ).length
                                  "
                                >Child:
                                  <span>{{
                                      item.paxList.filter(
                                          (pax) => pax.ageType === 'child'
                                      ).length
                                    }}</span></span
                                >
                              </div>
                              <div
                                  class="col col-pick-up-time col-pick-up-time_2">
                                <span
                                >{{
                                    item.time
                                        ? 'Pick up time:'
                                        : 'To be confirmed'
                                  }}
                                  <span>{{
                                      item.time
                                          ? item.time.slice(0, 2) +
                                          ':' +
                                          item.time.slice(2, 5)
                                          : ''
                                    }}</span></span
                                >
                              </div>
                              <div
                                  class="col col-from col-from_2"
                                  v-if="
                                  item.day > 1 &&
                                  ((data.program.find(
                                    (d) => d.day === item.day - 1
                                  ) &&
                                    data.program.find(
                                      (d) => d.day === item.day - 1
                                    ).hotelsData &&
                                    data.program.find(
                                      (d) => d.day === item.day - 1
                                    ).hotelsData.length) ||
                                    (data.program.find(
                                      (d) => d.day === item.day - 1
                                    ) &&
                                      data.program.find(
                                        (d) => d.day === item.day - 1
                                      ).days &&
                                      data.program.find(
                                        (d) => d.day === item.day - 1
                                      ).days[0] &&
                                      data.program.find(
                                        (d) => d.day === item.day - 1
                                      ).days[0].hotelsData &&
                                      data.program.find(
                                        (d) => d.day === item.day - 1
                                      ).days[0].hotelsData.length))
                                ">
                                <span
                                >From:
                                  <span>{{
                                      data.program.find(
                                          (d) => d.day === item.day - 1
                                      ).hotelsData.length
                                          ? data.program.find(
                                              (d) => d.day === item.day - 1
                                          ).hotelsData[0].name
                                          : data.program.find(
                                              (d) => d.day === item.day - 1
                                          ).days[0].hotelsData[0].name
                                    }}</span></span
                                >
                              </div>
                              <div class="col col-bottom col-names_2">
                                <span
                                ><b>Participants:</b>
                                  {{
                                    participants
                                        .filter((par) =>
                                            item.clients
                                                .map((client) => client.id)
                                                .includes(par.id)
                                        )
                                        .map((client) => client.name)
                                        .join(', ')
                                  }}</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span
                      :style="{
                      paddingTop: '2rem',
                      marginLeft: '1rem',
                      fontSize: '12px',
                      display: 'flex',
                    }"
                      v-if="
                      !data.program
                        .filter(
                          (item) =>
                            item.type.data === 'SAFARI' ||
                            item.type.data === 'ISLAND' ||
                            item.activitiesData.length
                        )
                        .map((item) =>
                          item.type.data === 'SAFARI' ||
                          item.type.data === 'ISLAND'
                            ? item.days
                                .filter((day) => day.activitiesData.length)
                                .map((day) => ({
                                  activitiesData: day.activitiesData,
                                  day: day.day,
                                  date: day.date,
                                }))
                            : [
                                {
                                  activitiesData: item.activitiesData,
                                  day: item.day,
                                  date: item.date,
                                },
                              ]
                        )
                        .flat()
                        .map((item) => ({...item.activitiesData}))
                        .map((item) => item[0]).length
                    "
                  >Activities not added</span
                  >
                </div>
              </div>
              <div
                  :class="[
                  'make-story__collapse js-collapse',
                  {'is-collapsed': collapse.flights},
                ]"
                  id="flights-sect"
                  :style="{overflow: 'visible'}">
                <div class="make-story__collapse__title form-control__help">
                  <div class="make-story__collapse__title__icon">
                    <svg width="1em" height="1em" class="icon icon-airplane">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                    </svg>
                  </div>
                  <span class="make-story__collapse__title__text">Flights</span>
                  <!-- <button type="button"  data-opened="Hide" data-closed="Show"
								:class="['btn', 'btn--collapse', 'js-collapse-trigger', { 'is-active': collapse.flights }]"
								@click="collapse.flights = !collapse.flights">
								<div class="btn--collapse__icon">
								<svg width="1em" height="1em" class="icon icon-collapse ">
									<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
								</svg>
								</div>
							</button> -->
                  <!-- <span class="form-control__help-icon">
								<span class="form-control__help-content">Подробнее читайте в нашем <a >FAQ</a></span>
								<img src="/images/useful/svg/help-icon.svg" alt="">
							</span> -->
                </div>
                <div class="make-story__collapse__inner js-collapse-inner">
                  <div
                      class="section-table-wrap"
                      v-if="
                      data.program
                        .filter(
                          (item) =>
                            item.type.data === 'SAFARI' ||
                            item.type.data === 'ISLAND' ||
                            item.flightsData.length
                        )
                        .map((item) =>
                          item.type.data === 'SAFARI' ||
                          item.type.data === 'ISLAND'
                            ? item.days
                                .filter((day) => day.flightsData.length)
                                .map((day) => ({
                                  flightsData: day.flightsData,
                                  day: day.day,
                                  date: day.date,
                                }))
                            : {
                                flightsData: item.flightsData,
                                day: item.day,
                                date: item.date,
                              }
                        )
                        .flat()
                        .map((item) =>
                          item.flightsData.map((data) => ({
                            ...data,
                            day: item.day,
                            date: item.date,
                          }))
                        )
                        .flat().length
                    ">
                    <div class="section-table section-table--flights">
                      <div class="section-table__body">
                        <div
                            class="section-table__row"
                            v-for="(item, index) in data.program
                            .filter(
                              (item) =>
                                item.type.data === 'SAFARI' ||
                                item.type.data === 'ISLAND' ||
                                item.flightsData.length
                            )
                            .map((item) =>
                              item.type.data === 'SAFARI' ||
                              item.type.data === 'ISLAND'
                                ? item.days
                                    .filter((day) => day.flightsData.length)
                                    .map((day) => ({
                                      flightsData: day.flightsData,
                                      day: day.day,
                                      date: day.date,
                                    }))
                                : {
                                    flightsData: item.flightsData,
                                    day: item.day,
                                    date: item.date,
                                  }
                            )
                            .flat()
                            .map((item) =>
                              item.flightsData.map((data) => ({
                                ...data,
                                day: item.day,
                                date: item.date,
                              }))
                            )
                            .flat()"
                            :key="index">
                          <div class="col col-flight-day">
                            <div class="col-flight-day__icon">
                              <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-airplane">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                              </svg>
                            </div>
                            <span
                            ><b>DAY {{ item.day }}</b> {{ item.date }}</span
                            >
                          </div>
                          <!--                          <div class="col col-flight-time">-->
                          <!--                            <div class="col-flight-time__side">-->
                          <!--                              <span class="col-flight-time__item">{{-->
                          <!--                                item.depTime.substring(0, 2) +-->
                          <!--                                ':' +-->
                          <!--                                item.depTime.substring(item.depTime.length - 2)-->
                          <!--                              }}</span-->
                          <!--                              ><span class="col-flight-time__destination">{{-->
                          <!--                                item.dep-->
                          <!--                              }}</span>-->
                          <!--                            </div>-->
                          <!--                            <div class="col-flight-time__arrow">-->
                          <!--                              <svg-->
                          <!--                                width="1em"-->
                          <!--                                height="1em"-->
                          <!--                                class="icon icon-arrow">-->
                          <!--                                <use-->
                          <!--                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow"></use>-->
                          <!--                              </svg>-->
                          <!--                            </div>-->
                          <!--                            <div class="col-flight-time__side">-->
                          <!--                              <span class="col-flight-time__item">{{-->
                          <!--                                item.arrTime.substring(0, 2) +-->
                          <!--                                ':' +-->
                          <!--                                item.arrTime.substring(item.arrTime.length - 2)-->
                          <!--                              }}</span-->
                          <!--                              ><span class="col-flight-time__destination">{{-->
                          <!--                                item.arr-->
                          <!--                              }}</span>-->
                          <!--                            </div>-->
                          <!--                          </div>-->
                          <div class="col col-airlines">
                            <span>Airlines:</span><b>{{ item.airline }}</b>
                          </div>
                          <div class="col col-activity-status-2">
                            <span
                            >{{ item.timeActivity ? 'After' : 'Before' }} the
                              activity</span
                            >
                          </div>
                          <div
                              v-if="item.type === 'REGULAR'"
                              class="col col-flight-persons">
                            <span class="col-flight-persons__item"
                            >Total Pax:
                              <b
                              >{{
                                  item.clients.filter(
                                      (client) => client.type === 'Adult 15kg'
                                  ).length || ''
                                }}
                                {{
                                  item.clients.filter(
                                      (client) => client.type === 'Adult 15kg'
                                  ).length
                                      ? 'Adult 15kg, '
                                      : ''
                                }}
                                {{
                                  item.clients.filter(
                                      (client) => client.type === 'Adult 30kg'
                                  ).length || ''
                                }}
                                {{
                                  item.clients.filter(
                                      (client) => client.type === 'Adult 30kg'
                                  ).length
                                      ? 'Adult 30kg, '
                                      : ''
                                }}
                                {{
                                  item.clients.filter(
                                      (client) => client.type === 'Teenager 15kg'
                                  ).length || ''
                                }}
                                {{
                                  item.clients.filter(
                                      (client) => client.type === 'Teenager 15kg'
                                  ).length
                                      ? 'Teenager 15kg, '
                                      : ''
                                }}
                                {{
                                  item.clients.filter(
                                      (client) => client.type === 'Teenager 30kg'
                                  ).length || ''
                                }}
                                {{
                                  item.clients.filter(
                                      (client) => client.type === 'Teenager 30kg'
                                  ).length
                                      ? 'Teenager 30kg, '
                                      : ''
                                }}
                                {{
                                  item.clients.filter(
                                      (client) => client.type === 'Child 15kg'
                                  ).length || ''
                                }}
                                {{
                                  item.clients.filter(
                                      (client) => client.type === 'Child 15kg'
                                  ).length
                                      ? 'Child 15kg, '
                                      : ''
                                }}
                                {{
                                  item.clients.filter(
                                      (client) => client.type === 'Child 30kg'
                                  ).length || ''
                                }}
                                {{
                                  item.clients.filter(
                                      (client) => client.type === 'Child 30kg'
                                  ).length
                                      ? 'Child 30kg, '
                                      : ''
                                }}
                              </b></span
                            >
                          </div>
                          <div class="col col-flight-passengers">
                            <span
                            ><b>Passengers: </b
                            >{{
                                participants
                                    .filter((par) =>
                                        item.clients
                                            .map((client) => client.id)
                                            .includes(par.id)
                                    )
                                    .map((client) => client.name)
                                    .join(', ')
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span
                      :style="{
                      paddingTop: '2rem',
                      marginLeft: '1rem',
                      fontSize: '12px',
                      display: 'flex',
                    }"
                      v-if="
                      !data.program
                        .filter(
                          (item) =>
                            item.type.data === 'SAFARI' ||
                            item.type.data === 'ISLAND' ||
                            item.flightsData.length
                        )
                        .map((item) =>
                          item.type.data === 'SAFARI' ||
                          item.type.data === 'ISLAND'
                            ? item.days
                                .filter((day) => day.flightsData.length)
                                .map((day) => ({
                                  flightsData: day.flightsData,
                                  day: day.day,
                                  date: day.date,
                                }))
                            : [
                                {
                                  flightsData: item.flightsData,
                                  day: item.day,
                                  date: item.date,
                                },
                              ]
                        )
                        .flat()
                        .map((item) => ({...item.flightsData}))
                        .map((item) => item[0]).length
                    "
                  >Filghts not added</span
                  >
                </div>
              </div>
              <div
                  :class="[
                  'make-story__collapse js-collapse',
                  {'is-collapsed': collapse.transfers},
                ]"
                  id="transfer-sect"
                  :style="{overflow: 'visible'}">
                <div class="make-story__collapse__title form-control__help">
                  <div class="make-story__collapse__title__icon">
                    <svg width="1em" height="1em" class="icon icon-taxi">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-taxi2"></use>
                    </svg>
                  </div>
                  <span class="make-story__collapse__title__text"
                  >Transfers</span
                  >
                  <!-- <button type="button" data-opened="Hide" data-closed="Show"
								:class="['btn', 'btn--collapse', 'js-collapse-trigger', { 'is-active': collapse.transfers }]"
								@click="collapse.transfers = !collapse.transfers">
								<div class="btn--collapse__icon">
								<svg width="1em" height="1em" class="icon icon-collapse ">
									<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
								</svg>
								</div>
							</button> -->
                  <!-- <span class="form-control__help-icon">
								<span class="form-control__help-content">Подробнее читайте в нашем <a >FAQ</a></span>
								<img src="/images/useful/svg/help-icon.svg" alt="">
							</span> -->
                </div>
                <div class="make-story__collapse__inner js-collapse-inner">
                  <div
                      class="section-table-wrap"
                      v-if="
                      data.program
                        .filter(
                          (item) =>
                            item.type.data === 'SAFARI' ||
                            item.type.data === 'ISLAND' ||
                            item.transfersData.length
                        )
                        .map((item) =>
                          item.type.data === 'SAFARI' ||
                          item.type.data === 'ISLAND'
                            ? item.days
                                .filter((day) => day.transfersData.length)
                                .map((day) => ({
                                  transfersData: day.transfersData,
                                  day: day.day,
                                  date: day.date,
                                }))
                            : [
                                {
                                  transfersData: item.transfersData,
                                  day: item.day,
                                  date: item.date,
                                },
                              ]
                        )
                        .flat()
                        .map((item) => item.transfersData)
                        .flat()
                        .filter((item) => !item.free).length
                    ">
                    <div
                        class="section-table section-table--3 section-table--activities-2 transfer-wrap">
                      <div class="section-table__body">
                        <div
                            class="section-table__row"
                            v-for="(item, index) in getSomeTransfers"
                            :key="index">
                          <div class="col col-day-2">
                            <b>DAY {{ item.day }}</b>
                            <span class="date-el">{{ item.date }}</span>
                          </div>
                          <div class="section-table__row-wrapper">
                            <div class="section-table__row-wrap">
                              <div class="col col-activity">
                                <span>{{ item.from }} - {{ item.to }}</span>
                              </div>
                              <div class="col col-activity-persons">
                                <span
                                >Pax: <b>{{ item.pax }}</b></span
                                >
                              </div>
                              <div class="col col-pick-up-time">
                                <span
                                >{{
                                    item.time.length === 5
                                        ? 'Pick up time:'
                                        : 'To be confirmed'
                                  }}
                                  <b>{{
                                      item.time.length < 4 ? '' : item.time
                                    }}</b></span
                                >
                              </div>
                              <div class="col col-bottom col-names_2">
                                <span>{{
                                    participants
                                        .filter((par) =>
                                            item.clients
                                                .map((client) => client.id)
                                                .includes(par.id)
                                        )
                                        .map((client) => client.name)
                                        .join(', ')
                                  }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                      class="section-table section-table--3 section-table--activities-2 transfer-wrap section-table--free"
                      v-if="
                      data.program
                        .filter(
                          (item) =>
                            item.type.data === 'SAFARI' ||
                            item.type.data === 'ISLAND' ||
                            item.transfersData.length
                        )
                        .map((item) =>
                          item.type.data === 'SAFARI' ||
                          item.type.data === 'ISLAND'
                            ? item.days
                                .filter((day) => day.transfersData.length)
                                .map((day) => ({
                                  transfersData: day.transfersData,
                                  day: day.day,
                                  date: day.date,
                                }))
                            : [
                                {
                                  transfersData: item.transfersData,
                                  day: item.day,
                                  date: item.date,
                                },
                              ]
                        )
                        .flat()
                        .map((item) => item.transfersData)
                        .flat()
                        .filter((item) => item.free).length
                    "
                      :style="{
                      marginTop:
                        data.program
                          .filter(
                            (item) =>
                              item.type.data === 'SAFARI' ||
                              item.type.data === 'ISLAND' ||
                              item.transfersData.length
                          )
                          .map((item) =>
                            item.type.data === 'SAFARI' ||
                            item.type.data === 'ISLAND'
                              ? item.days
                                  .filter((day) => day.transfersData.length)
                                  .map((day) => ({
                                    transfersData: day.transfersData,
                                    day: day.day,
                                    date: day.date,
                                  }))
                              : [
                                  {
                                    transfersData: item.transfersData,
                                    day: item.day,
                                    date: item.date,
                                  },
                                ]
                          )
                          .flat()
                          .map((item) => item.transfersData)
                          .flat()
                          .filter((item) => !item.free).length === 0
                          ? '10px'
                          : '-4px',
                    }">
                    <span
                        class="section-table--free__title"
                        :style="{height: '20px'}"
                    >Free of charge, incl on package<img
                        src="/images/icons/free.svg"
                        alt=""
                    /></span>
                    <div class="section-table__body">
                      <div
                          class="section-table__row"
                          v-for="(item, index) in data.program
                          .filter(
                            (item) =>
                              item.type.data === 'SAFARI' ||
                              item.type.data === 'ISLAND' ||
                              item.transfersData.length
                          )
                          .map((item) =>
                            item.type.data === 'SAFARI' ||
                            item.type.data === 'ISLAND'
                              ? item.days
                                  .filter((day) => day.transfersData.length)
                                  .map((day) => ({
                                    transfersData: day.transfersData,
                                    day: day.day,
                                    date: day.date,
                                  }))
                              : [
                                  {
                                    transfersData: item.transfersData,
                                    day: item.day,
                                    date: item.date,
                                  },
                                ]
                          )
                          .flat()
                          .map((item) => item.transfersData)
                          .flat()
                          .filter((item) => item.free)"
                          :key="index">
                        <div class="col col-day-2">
                          <b>DAY {{ item.day }}</b>
                          <span class="date-el">{{ item.date }}</span>
                        </div>
                        <div class="section-table__row-wrapper">
                          <div class="section-table__row-wrap">
                            <div class="col col-activity">
                              <span>{{ item.from }} - {{ item.to }}</span>
                            </div>
                            <div class="col col-activity-persons">
                              <span
                              >Pax: <b>{{ item.pax }}</b></span
                              >
                            </div>
                            <div class="col col-pick-up-time">
                              <span
                              >{{
                                  item.time.length === 5
                                      ? 'Pick up time:'
                                      : 'To be confirmed'
                                }}
                                <b>{{
                                    item.time.length < 4 ? '' : item.time
                                  }}</b></span
                              >
                            </div>
                            <div class="col col-bottom col-names_2">
                              <span>{{
                                  participants
                                      .filter((par) =>
                                          item.clients
                                              .map((client) => client.id)
                                              .includes(par.id)
                                      )
                                      .map((client) => client.name)
                                      .join(', ')
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span
                      :style="{
                      paddingTop: '2rem',
                      marginLeft: '1rem',
                      fontSize: '12px',
                      display: 'flex',
                    }"
                      v-if="
                      !data.program
                        .filter(
                          (item) =>
                            item.type.data === 'SAFARI' ||
                            item.type.data === 'ISLAND' ||
                            item.transfersData.length
                        )
                        .map((item) =>
                          item.type.data === 'SAFARI' ||
                          item.type.data === 'ISLAND'
                            ? item.days
                                .filter((day) => day.transfersData.length)
                                .map((day) => ({
                                  transfersData: day.transfersData,
                                  day: day.day,
                                  date: day.date,
                                }))
                            : [
                                {
                                  transfersData: item.transfersData,
                                  day: item.day,
                                  date: item.date,
                                },
                              ]
                        )
                        .flat()
                        .map((item) => ({...item.transfersData}))
                        .map((item) => item[0]).length
                    "
                  >Transfers not added</span
                  >
                </div>
              </div>
            </div>
          </div>

          <section
              class="breakdown-cost"
              id="breakdown-sect"
              v-if="data.id && totalPrice"
              :style="{paddingTop: '0px'}">
            <div class="container-lg">
              <div
                  :class="[
                  'make-story__collapse js-collapse',
                  {'is-collapsed': collapse.cost},
                ]"
                  v-show="tab === 2"
                  v-if="totalPrice">
                <div
                    class="make-story__collapse__title page-title form-control__help">
                  <h2>Full Breakdown Cost</h2>
                  <!-- <button type="button" data-opened="Hide" data-closed="Show"
							:class="['btn', 'btn--collapse', 'js-collapse-trigger', { 'is-active': collapse.cost }]"
							@click="collapse.cost = !collapse.cost">
							<div class="btn--collapse__icon">
							<svg width="1em" height="1em" class="icon icon-collapse ">
								<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
							</svg>
							</div>
						</button> -->
                  <a
                      class="btn btn--green btn_print"
                      @click="
                      printMode = 'print-cost'
                      print('print-cost')
                    ">
                    <svg
                        class="icon icon-collapse">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-print"></use>
                    </svg>
                    <span>Print</span>
                  </a>
                </div>

                <div
                    class="make-story__collapse__inner js-collapse-inner"
                    id="cost-to-print">
                  <div class="breakdown-cost__info">
                    <div class="breakdown-cost__info__title">
                      <span
                      >TOTAL DAYS PROGRAMM:
                        <b>{{ totalPrice.breakdownCost.totalDays }}</b></span
                      >
                    </div>
                    <div class="breakdown-cost__info__range">
                      <p v-if="tourStart">
                        Start: <b>{{ totalPrice.breakdownCost.startDate }}</b>
                        <span class="breakdown-cost__info__range__divider"
                        >/</span
                        >
                        End:
                        <b>{{ totalPrice.breakdownCost.endDate }}</b>
                      </p>
                    </div>
                  </div>
                  <div class="form-control-group make-story__checkbox-2">
                    <label for="chk_41" class="form-control-checkbox">
                      <input
                          id="chk_41"
                          type="checkbox"
                          v-model="showNames"/><span
                        class="form-control-checkbox__box">
                        <svg width="1em" height="1em" class="icon icon-check">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                    ><span class="form-control-checkbox__name"
                    >Show clients names</span
                    >
                    </label>
                    <label for="chk_42" class="form-control-checkbox">
                      <input
                          id="chk_42"
                          type="checkbox"
                          @change="onChangeComission"
                          v-model="commisionInclude"/><span
                        class="form-control-checkbox__box">
                        <svg width="1em" height="1em" class="icon icon-check">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                    ><span class="form-control-checkbox__name"
                    >Show breakdown incl our margin</span
                    >
                    </label>
                    <label for="chk_43" class="form-control-checkbox">
                      <input id="chk_43" type="checkbox" v-model="show0"/><span
                        class="form-control-checkbox__box">
                        <svg width="1em" height="1em" class="icon icon-check">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                    ><span class="form-control-checkbox__name">Show.000</span>
                    </label>
                  </div>
                  <div class="breakdown-cost__table">
                    <div class="breakdown-cost__table__head">
                      <div class="col col-pax"><span>Pax</span></div>
                      <div class="col col-price"><span>Price</span></div>
                    </div>
                    <div
                        class="breakdown-cost__table__row"
                        v-if="
                        (totalPrice.breakdownCost.transferCost &&
                          totalPrice.breakdownCost.transferCost.transfers
                            .length) ||
                        (totalPrice.breakdownCost.transferCost &&
                          totalPrice.breakdownCost.transferCost.errors.length)
                      ">
                      <div class="breakdown-cost__table__row__title">
                        <div
                            class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--blue">
                          <svg width="1em" height="1em" class="icon icon-car">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-car"></use>
                          </svg>
                        </div>
                        <span>Transfers Cost</span>
                      </div>
                      <div
                          class="breakdown-cost__table__line breakdown-cost__table__line-parent">
                        <div
                            class="breakdown-cost__table__line__item"
                            v-for="(item, index) in totalPrice.breakdownCost
                            .transferCost.transfers"
                            :key="index">
                          <div class="breakdown-cost__table__line__item__name">
                            {{ item.name }}
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, i) in item.participants"
                                :key="i"
                                v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(totalPrice.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{ item.pax }} Pax</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0 ? item.price : removeFractional(item.price)
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                          <span
                              class="breakdown-cost__table__line__item__warning form-control__help-icon__warning"
                              v-if="item.warning">
                            <svg
                                class="icon icon-important important-icon">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                            </svg>
                          </span>
                        </div>
                      </div>
                      <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Transfer Total:</span
                        >
                        <span class="breakdown-cost__item-total-value"
                        >{{
                            show0
                                ? totalPrice.breakdownCost.transferCost
                                    .totalAmount
                                : removeFractional(
                                    totalPrice.breakdownCost.transferCost
                                        .totalAmount
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                      <div
                          class="note-info"
                          v-if="
                          totalPrice.breakdownCost.transferCost.errors.length
                        ">
                        <svg
                            class="icon icon-important important-icon">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                        </svg>
                        <div class="note-info__text">
                          {{
                            totalPrice.breakdownCost.transferCost.errors.join(
                                ', '
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__row"
                        v-if="totalPrice.breakdownCost.safariCost">
                      <div
                          class="breakdown-cost__table__row__title form-control__help">
                        <div
                            class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--orange">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-safari">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-safari"></use>
                          </svg>
                        </div>
                        <span>Safari Cost</span>
                        <span class="form-control__help-icon">
                          <span class="form-control__help-content"
                          >Подробнее читайте в нашем <a>FAQ</a></span
                          >
                          <img src="/images/useful/svg/help-icon.svg" alt=""/>
                        </span>
                      </div>
                      <div
                          class="breakdown-cost__table__line"
                          v-if="
                          totalPrice.breakdownCost.safariCost.parkFees.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Park Fees</span
                        >
                        <div
                            class="breakdown-cost__table__line__item"
                            v-for="(item, index) in totalPrice.breakdownCost
                            .safariCost.parkFees"
                            :key="index">
                          <div class="breakdown-cost__table__line__item__name">
                            {{ item.name }} ({{ item.days }} Day{{
                              item.days > 1 ? 's' : ''
                            }})
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, idx) in item.participants"
                                :key="idx"
                                v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(totalPrice.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{ item.pax }} Pax</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0 ? item.price : removeFractional(item.price)
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}
                            <span
                                class="form-control__help-icon"
                                v-if="item.warning">
                              <span class="form-control__help-content"
                              >This price substantially differs from regular
                                values, please check it manually.</span
                              >
                              <svg
                                  class="icon icon-important important-icon">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                              </svg>
                            </span>
                          </span>
                        </div>
                      </div>

                      <div
                          class="breakdown-cost__table__line"
                          v-if="
                          totalPrice.breakdownCost.safariCost.activities.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Safari Activities</span
                        >
                        <div
                            class="breakdown-cost__table__line__item"
                            v-for="(item, index) in totalPrice.breakdownCost
                            .safariCost.activities"
                            :key="index">
                          <div class="breakdown-cost__table__line__item__name">
                            {{ item.name }}
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, idx) in item.participants"
                                :key="idx"
                                v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(totalPrice.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{ item.pax }} Pax</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0 ? item.price : removeFractional(item.price)
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                        </div>
                      </div>

                      <div
                          class="breakdown-cost__table__line"
                          v-if="
                          totalPrice.breakdownCost.safariCost.hotels.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Hotels</span
                        >
                        <div
                            v-for="(item, index) in totalPrice.breakdownCost
                            .safariCost.hotels"
                            :key="index">
                          <div class="breakdown-cost__table__line__item">
                            <span
                                class="breakdown-cost__table__line__item__name"
                            >{{ item.name }} ({{ item.nights }} night{{
                                item.nights === 1 ? '' : 's'
                              }})</span
                            >
                          </div>
                          <div
                              class="breakdown-cost__table__line__subitem"
                              v-for="(room, i) in item.rooms"
                              :key="i">
                            <div
                                class="breakdown-cost__table__line__subitem__name">
                              {{ room.name }}
                              <div
                                  class="breakdown-cost__table__line__subsubitem"
                                  v-for="(client, idx) in room.participants"
                                  :key="idx"
                                  v-if="showNames">
                                <span
                                    class="breakdown-cost__table__line__subsubitem__name"
                                ><span>{{ client.info }}</span>
                                </span>
                                <span
                                    class="breakdown-cost__table__line__subsubitem__name-price"
                                >{{
                                    show0
                                        ? client.totalCost
                                        : removeFractional(client.totalCost)
                                  }}{{
                                    getCurrencySign(totalPrice.breakdownCost.currency)
                                  }}</span
                                >
                              </div>
                            </div>
                            <span class="breakdown-cost__table__line__item__pax"
                            >{{ room.roomCount }} Room</span
                            ><span
                              class="breakdown-cost__table__line__item__price"
                          >{{
                              show0
                                  ? room.price
                                  : removeFractional(room.price)
                            }}{{
                              getCurrencySign(totalPrice.breakdownCost.currency)
                            }}<span
                                class="form-control__help-icon"
                                v-if="room.warning">
                                <span class="form-control__help-content"
                                >This price substantially differs from regular
                                  values, please check it manually.</span
                                ><svg
                                class="icon icon-important important-icon">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use></svg></span
                            ></span>
                          </div>
                        </div>
                      </div>

                      <div
                          class="breakdown-cost__table__line"
                          v-if="totalPrice.breakdownCost.safariCost.carRental">
                        <span class="breakdown-cost__table__line__title"
                        >Transfers</span
                        >
                        <div class="breakdown-cost__table__line__item">
                          <div class="breakdown-cost__table__line__item__name">
                            Rent safari car
                            <!-- <div class="breakdown-cost__table__line__subsubitem" v-for="(item, index) in totalPrice.breakdownCost.safariCost.carRental.participants" :key="index" v-if="showNames"><span
								class="breakdown-cost__table__line__subsubitem__name">{{item}}</span>
								</div> -->
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{
                              totalPrice.breakdownCost.safariCost.carRental.pax
                            }}
                            Pax</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0
                                ? totalPrice.breakdownCost.safariCost.carRental
                                    .price
                                : removeFractional(
                                    totalPrice.breakdownCost.safariCost
                                        .carRental.price
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                        </div>
                      </div>
                      <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Safari Total:</span
                        >
                        <span class="breakdown-cost__item-total-value"
                        >{{
                            show0
                                ? totalPrice.breakdownCost.safariCost.totalAmount
                                : removeFractional(
                                    totalPrice.breakdownCost.safariCost
                                        .totalAmount
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                      <div
                          class="note-info"
                          v-if="
                          totalPrice.breakdownCost.safariCost.errors.length
                        ">
                        <svg
                            class="icon icon-important important-icon">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                        </svg>
                        <div class="note-info__text">
                          {{
                            totalPrice.breakdownCost.safariCost.errors.join(
                                ', '
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__row"
                        v-if="totalPrice.breakdownCost.climbingCost">
                      <div
                          class="breakdown-cost__table__row__title form-control__help">
                        <div
                            class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--green">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-climbing">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-climbing"></use>
                          </svg>
                        </div>
                        <span>Climbing Cost </span>
                        <span class="form-control__help-icon">
                          <span class="form-control__help-content"
                          >Подробнее читайте в нашем <a>FAQ</a></span
                          >
                          <img src="/images/useful/svg/help-icon.svg" alt=""/>
                        </span>
                      </div>
                      <div
                          class="breakdown-cost__table__line"
                          v-for="(item, index) in totalPrice.breakdownCost
                          .climbingCost.routes"
                          :key="index">
                        <span class="breakdown-cost__table__line__title"
                        >Climbing
                          {{ item.tourLeader ? ' (Tour Leader)' : '' }}</span
                        >
                        <div class="breakdown-cost__table__line__item">
                          <div class="breakdown-cost__table__line__item__name">
                            {{ item.mountName }} via {{ item.routeName }} Route
                            {{ item.days }} days
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, idx) in item.participants"
                                :key="idx"
                                v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(totalPrice.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{ item.pax }} Pax</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0 ? item.price : removeFractional(item.price)
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                        </div>
                      </div>

                      <div
                          class="breakdown-cost__table__line"
                          v-if="
                          totalPrice.breakdownCost.climbingCost
                            .additionalOptions.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Additional options</span
                        >

                        <div
                            class="breakdown-cost__table__line__item"
                            v-for="(item, index) in totalPrice.breakdownCost
                            .climbingCost.additionalOptions"
                            :key="index">
                          <div class="breakdown-cost__table__line__item__name">
                            {{ item.name }}
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, idx) in item.participants"
                                :key="idx"
                                v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(totalPrice.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{ item.pax }} Pax</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0 ? item.price : removeFractional(item.price)
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                        </div>
                      </div>

                      <div
                          class="breakdown-cost__table__line"
                          v-if="
                          totalPrice.breakdownCost.climbingCost.hotels.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Accomodation</span
                        >
                        <div
                            v-for="(item, index) in totalPrice.breakdownCost
                            .climbingCost.hotels"
                            :key="index">
                          <div class="breakdown-cost__table__line__item">
                            <span
                                class="breakdown-cost__table__line__item__name"
                            >{{ item.name }} ({{ item.nights }} night{{
                                item.nights === 1 ? '' : 's'
                              }})</span
                            >
                          </div>
                          <div
                              class="breakdown-cost__table__line__subitem"
                              v-for="(room, i) in item.rooms"
                              :key="i">
                            <div
                                class="breakdown-cost__table__line__subitem__name">
                              {{ room.name }}
                              <div
                                  class="breakdown-cost__table__line__subsubitem"
                                  v-for="(client, idx) in room.participants"
                                  :key="idx"
                                  v-if="showNames">
                                <span
                                    class="breakdown-cost__table__line__subsubitem__name"
                                ><span>{{ client.info }}</span>
                                </span>
                                <span
                                    class="breakdown-cost__table__line__subsubitem__name-price"
                                >{{
                                    show0
                                        ? client.totalCost
                                        : removeFractional(client.totalCost)
                                  }}{{
                                    getCurrencySign(totalPrice.breakdownCost.currency)
                                  }}</span
                                >
                              </div>
                            </div>
                            <span class="breakdown-cost__table__line__item__pax"
                            >{{ room.roomCount }} Room</span
                            ><span
                              class="breakdown-cost__table__line__item__price"
                          >{{
                              show0
                                  ? room.price
                                  : removeFractional(room.price)
                            }}{{
                              getCurrencySign(totalPrice.breakdownCost.currency)
                            }}<span
                                class="form-control__help-icon"
                                v-if="room.warning">
                                <span class="form-control__help-content"
                                >This price substantially differs from regular
                                  values, please check it manually.</span
                                ><svg
                                class="icon icon-important important-icon">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use></svg></span
                            ></span>
                          </div>
                        </div>
                      </div>

                      <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Climbing Total:</span
                        >
                        <span class="breakdown-cost__item-total-value"
                        >{{
                            show0
                                ? totalPrice.breakdownCost.climbingCost
                                    .totalAmount
                                : removeFractional(
                                    totalPrice.breakdownCost.climbingCost
                                        .totalAmount
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                      <div
                          class="note-info"
                          v-if="
                          totalPrice.breakdownCost.climbingCost.errors.length
                        ">
                        <svg
                            class="icon icon-important important-icon">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                        </svg>
                        <div class="note-info__text">
                          {{
                            totalPrice.breakdownCost.climbingCost.errors.join(
                                ', '
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__row"
                        v-if="
                        totalPrice.breakdownCost.islandCost &&
                        (totalPrice.breakdownCost.islandCost.activities
                          .length ||
                          totalPrice.breakdownCost.islandCost.transfers
                            .length ||
                          totalPrice.breakdownCost.islandCost.hotels.length ||
                          totalPrice.breakdownCost.islandCost.errors.length)
                      ">
                      <div class="breakdown-cost__table__row__title">
                        <div
                            class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--red">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-zanzibar">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-zanzibar"></use>
                          </svg>
                        </div>
                        <span>Island Cost</span>
                      </div>

                      <div
                          class="breakdown-cost__table__line"
                          v-for="(item, index) in totalPrice.breakdownCost
                          .islandCost.activities"
                          :key="index">
                        <div class="breakdown-cost__table__line__item">
                          <div class="breakdown-cost__table__line__item__name">
                            {{ item.name }}
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, i) in item.participants"
                                :key="i"
                                v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(totalPrice.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{ item.pax }} Pax</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0 ? item.price : removeFractional(item.price)
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                        </div>
                      </div>

                      <div
                          class="breakdown-cost__table__line"
                          v-if="
                          totalPrice.breakdownCost.islandCost.transfers.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Transfer</span
                        >
                        <div
                            class="breakdown-cost__table__line__item"
                            v-for="(item, index) in totalPrice.breakdownCost
                            .islandCost.transfers"
                            :key="index">
                          <div class="breakdown-cost__table__line__item__name">
                            {{ item.name }}
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, i) in item.participants"
                                :key="i"
                                v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(totalPrice.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{ item.pax }} Pax</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0 ? item.price : removeFractional(item.price)
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                        </div>
                      </div>

                      <div
                          class="breakdown-cost__table__line"
                          v-if="
                          totalPrice.breakdownCost.islandCost.hotels.length
                        ">
                        <span class="breakdown-cost__table__line__title"
                        >Hotels</span
                        >
                        <div
                            v-for="(item, index) in totalPrice.breakdownCost
                            .islandCost.hotels"
                            :key="index">
                          <div class="breakdown-cost__table__line__item">
                            <span
                                class="breakdown-cost__table__line__item__name"
                            >{{ item.name }} ({{ item.nights }} night{{
                                item.nights === 1 ? '' : 's'
                              }})</span
                            >
                          </div>
                          <div
                              class="breakdown-cost__table__line__subitem"
                              v-for="(room, i) in item.rooms"
                              :key="i">
                            <div
                                class="breakdown-cost__table__line__subitem__name">
                              {{ room.name }}
                              <div
                                  class="breakdown-cost__table__line__subsubitem"
                                  v-for="(client, idx) in room.participants"
                                  :key="idx"
                                  v-if="showNames">
                                <span
                                    class="breakdown-cost__table__line__subsubitem__name"
                                ><span>{{ client.info }}</span>
                                </span>
                                <span
                                    class="breakdown-cost__table__line__subsubitem__name-price"
                                >{{
                                    show0
                                        ? client.totalCost
                                        : removeFractional(client.totalCost)
                                  }}{{
                                    getCurrencySign(totalPrice.breakdownCost.currency)
                                  }}</span
                                >
                              </div>
                            </div>
                            <span class="breakdown-cost__table__line__item__pax"
                            >{{ room.roomCount }} Room</span
                            ><span
                              class="breakdown-cost__table__line__item__price"
                          >{{
                              show0
                                  ? room.price
                                  : removeFractional(room.price)
                            }}{{
                              getCurrencySign(totalPrice.breakdownCost.currency)
                            }}
                            <!--                            <span-->
                            <!--                                class="form-control__help-icon form-control__special-offer">-->
                            <!--											<span class="form-control__help-content">-->
                            <!--											<p>Special Offer: <span>Early Bird</span></p>-->
                            <!--											<p>Hotel booked 30 days in advance, provide 15% discount</p>-->
                            <!--											</span>-->
                            <!--											<img src="/images/icons/special-tag.svg" alt="">-->
                            <!--										</span>-->
                            <!-- <span class="form-control__help-icon" v-if="room.warning"> 	<span class="form-control__help-content">This price substantially differs from regular values, please check it manually.</span><svg  width="1.6rem" height="1.6rem" class="icon icon-important important-icon">
										<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
										</svg></span>
										 -->
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Island Total:</span
                        >
                        <span class="breakdown-cost__item-total-value"
                        >{{
                            show0
                                ? totalPrice.breakdownCost.islandCost.totalAmount
                                : removeFractional(
                                    totalPrice.breakdownCost.islandCost
                                        .totalAmount
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>

                      <div
                          class="note-info"
                          v-if="
                          totalPrice.breakdownCost.islandCost.errors.length
                        ">
                        <svg
                            class="icon icon-important important-icon">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                        </svg>
                        <div class="note-info__text">
                          {{
                            totalPrice.breakdownCost.islandCost.errors.join(
                                ', '
                            )
                          }}
                        </div>
                      </div>
                    </div>

                    <!--Flight tickets start-->
                    <div
                        class="breakdown-cost__table__row"
                        v-if="
                        totalPrice.breakdownCost.flightTickets.tickets.length ||
                        totalPrice.breakdownCost.flightTickets.errors.length
                      ">
                      <div class="breakdown-cost__table__row__title">
                        <div
                            class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--blue">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-airplane">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                          </svg>
                        </div>
                        <span>Flight tickets</span>
                      </div>
                      <div
                          class="breakdown-cost__table__line"
                          v-for="(item, index) in totalPrice.breakdownCost
                          .flightTickets.tickets"
                          :key="index">
                        <div class="breakdown-cost__table__line__item">
                          <div class="breakdown-cost__table__line__item__name">
                            {{ item.name }}
                            <div class="breakdown-cost__table__line__info">
                              <span
                                  class="breakdown-cost__table__line__item__box"
                              >Airlines: <i>{{ item.airline }}</i>
                              </span>
                              <span
                                  class="breakdown-cost__table__line__item__box"
                              >Dept Time:
                                <i>{{
                                    item.depTime.substring(0, 2) +
                                    ':' +
                                    item.depTime.substring(
                                        item.depTime.length - 2
                                    )
                                  }}</i></span
                              >
                            </div>
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, idx) in item.participants"
                                :key="idx"
                                v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(totalPrice.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>

                          <span class="breakdown-cost__table__line__item__pax">
                            <span v-if="item.passengers.adult15"
                            >Adult 15kg ({{
                                item.passengers.adult15.pax
                              }})</span
                            >
                            <span v-if="item.passengers.adult30"
                            >Adult 30kg ({{
                                item.passengers.adult30.pax
                              }})</span
                            >
                            <span v-if="item.passengers.child15"
                            >Child 15kg ({{
                                item.passengers.child15.pax
                              }})</span
                            >
                            <span v-if="item.passengers.child30"
                            >Child 15kg ({{
                                item.passengers.child30.pax
                              }})</span
                            >
                          </span>
                          <span
                              v-if="item.type === 'REGULAR'"
                              class="breakdown-cost__table__line__item__price">
                            <span v-if="item.passengers.adult15"
                            >{{
                                show0
                                    ? item.passengers.adult15.price
                                    : removeFractional(
                                        item.passengers.adult15.price
                                    )
                              }}{{
                                getCurrencySign(totalPrice.breakdownCost.currency)
                              }}</span
                            >
                            <span v-if="item.passengers.adult30"
                            >{{
                                show0
                                    ? item.passengers.adult30.price
                                    : removeFractional(
                                        item.passengers.adult30.price
                                    )
                              }}{{
                                getCurrencySign(totalPrice.breakdownCost.currency)
                              }}</span
                            >
                            <span v-if="item.passengers.child15"
                            >{{
                                show0
                                    ? item.passengers.child15.price
                                    : removeFractional(
                                        item.passengers.child15.price
                                    )
                              }}{{
                                getCurrencySign(totalPrice.breakdownCost.currency)
                              }}</span
                            >
                            <span v-if="item.passengers.child30"
                            >{{
                                show0
                                    ? item.passengers.child30.price
                                    : removeFractional(
                                        item.passengers.child30.price
                                    )
                              }}{{
                                getCurrencySign(totalPrice.breakdownCost.currency)
                              }}</span
                            >
                          </span>
                          <span v-if="item.type === 'PRIVATE'">
                            {{ item.participants[0].totalCost }}{{
                              getCurrencySign(totalPrice.breakdownCost.currency)
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Flights Tickets Total:</span
                        >
                        <span class="breakdown-cost__item-total-value"
                        >{{
                            show0
                                ? totalPrice.breakdownCost.flightTickets
                                    .totalAmount
                                : removeFractional(
                                    totalPrice.breakdownCost.flightTickets
                                        .totalAmount
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                      <div
                          class="note-info"
                          v-if="
                          totalPrice.breakdownCost.flightTickets.errors.length
                        ">
                        <svg
                            class="icon icon-important important-icon">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                        </svg>
                        <div class="note-info__text">
                          {{
                            totalPrice.breakdownCost.flightTickets.errors.join(
                                ', '
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <!--Flight tickets end-->

                    <div
                        class="breakdown-cost__table__row"
                        v-if="
                        totalPrice.breakdownCost.airportVipServices &&
                        (totalPrice.breakdownCost.airportVipServices.vipServices
                          .length ||
                          totalPrice.breakdownCost.airportVipServices.errors
                            .length)
                      ">
                      <div
                          class="breakdown-cost__table__row__title form-control__help">
                        <div
                            class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--dark-blue">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-airport">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airport"></use>
                          </svg>
                        </div>
                        <span>Airport Services</span>
                      </div>
                      <div
                          v-for="(item, index) in totalPrice.breakdownCost
                          .airportVipServices.vipServices"
                          :key="index"
                          class="breakdown-cost__table__line">
                        <div class="breakdown-cost__table__line__item">
                          <div class="breakdown-cost__table__line__item__name">
                            {{ item.name }}
                            <div
                                v-if="showNames"
                                v-for="(client, i) in item.participants"
                                :key="i"
                                class="breakdown-cost__table__line__subsubitem">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name">
                                <span>{{ client.info }}</span>
                              </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(totalPrice.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__price"
                          >{{
                              show0 ? item.price : removeFractional(item.price)
                            }}{{
                              getCurrencySign(totalPrice.breakdownCost.currency)
                            }}</span
                          >
                        </div>
                      </div>
                      <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Airport Services Total:</span
                        >
                        <span class="breakdown-cost__item-total-value"
                        >{{
                            show0
                                ? totalPrice.breakdownCost.airportVipServices
                                    .totalAmount
                                : removeFractional(
                                    totalPrice.breakdownCost.airportVipServices
                                        .totalAmount
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                      <div
                          class="note-info"
                          v-if="
                          totalPrice.breakdownCost.airportVipServices.errors
                            .length
                        ">
                        <svg
                            class="icon icon-important important-icon">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                        </svg>
                        <div class="note-info__text">
                          {{
                            totalPrice.breakdownCost.airportVipServices.errors.join(
                                ', '
                            )
                          }}
                        </div>
                      </div>
                    </div>

                    <div
                        class="breakdown-cost__table__row breakdown-cost__table__row-no-line"
                        v-if="
                        (totalPrice.breakdownCost.dayTripsCost &&
                          totalPrice.breakdownCost.dayTripsCost.totalAmount) ||
                        totalPrice.breakdownCost.dayTripsCost.errors.length
                      ">
                      <div
                          class="breakdown-cost__table__row__title form-control__help">
                        <div
                            class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--green-2">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-parachute">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-parachute"></use>
                          </svg>
                        </div>
                        <span>Day Trips Cost</span>
                      </div>
                      <div
                          class="breakdown-cost__table__line"
                          v-for="(item, index) in totalPrice.breakdownCost
                          .dayTripsCost.activities"
                          :key="index">
                        <div class="breakdown-cost__table__line__item">
                          <div class="breakdown-cost__table__line__item__name">
                            {{ item.name }}
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, i) in item.participants"
                                :key="i"
                                v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(totalPrice.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{ item.pax }} Pax</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0 ? item.price : removeFractional(item.price)
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                        </div>
                      </div>
                      <!-- <div class="breakdown-cost__table__line" v-if="totalPrice.breakdownCost.dayTripsCost.hotels.length"><span
								class="breakdown-cost__table__line__title">Hotels</span>
								<div v-for="(item, index) in totalPrice.breakdownCost.dayTripsCost.hotels" :key="index">
									<div class="breakdown-cost__table__line__item"><span
									class="breakdown-cost__table__line__item__name">{{item.name}} ({{item.nights}} nights)</span></div>
									<div class="breakdown-cost__table__line__subitem" v-for="(room, i) in item.rooms" :key="i"><div
										class="breakdown-cost__table__line__subitem__name">{{room.name}}
										<div class="breakdown-cost__table__line__subsubitem" v-for="(client, idx) in room.participants " :key="idx"><span
										class="breakdown-cost__table__line__subsubitem__name">{{client}}</span>
										</div></div><span
										class="breakdown-cost__table__line__item__pax">{{room.roomCount}} Room</span><span
										class="breakdown-cost__table__line__item__price">{{room.price}}$</span></div>
								</div>
							</div> -->
                      <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Day Trips Total:</span
                        >
                        <span class="breakdown-cost__item-total-value"
                        >{{
                            show0
                                ? totalPrice.breakdownCost.dayTripsCost
                                    .totalAmount
                                : removeFractional(
                                    totalPrice.breakdownCost.dayTripsCost
                                        .totalAmount
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                      <div
                          class="note-info"
                          v-if="
                          totalPrice.breakdownCost.dayTripsCost.errors.length
                        ">
                        <svg
                            class="icon icon-important important-icon">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                        </svg>
                        <div class="note-info__text">
                          {{
                            totalPrice.breakdownCost.dayTripsCost.errors.join(
                                ', '
                            )
                          }}
                        </div>
                      </div>
                    </div>

                    <div
                        class="breakdown-cost__table__row breakdown-cost__table__row-no-line"
                        v-if="
                        (totalPrice.breakdownCost.extraAccommodationCost &&
                          totalPrice.breakdownCost.extraAccommodationCost.hotels
                            .length) ||
                        totalPrice.breakdownCost.extraAccommodationCost.errors
                          .length
                      ">
                      <div
                          class="breakdown-cost__table__row__title form-control__help">
                        <div
                            class="breakdown-cost__table__row__icon breakdown-cost__table__row__icon--dark-blue">
                          <svg width="1em" height="1em" class="icon icon-house">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-house"></use>
                          </svg>
                        </div>
                        <span>Extra Accommodation</span>
                      </div>
                      <div
                          class="breakdown-cost__table__line"
                          v-for="(item, index) in totalPrice.breakdownCost
                          .extraAccommodationCost.hotels"
                          :key="index">
                        <div class="breakdown-cost__table__line__item">
                          <span class="breakdown-cost__table__line__item__name"
                          >{{ item.name }} ({{ item.nights }} night{{
                              item.nights === 1 ? '' : 's'
                            }})</span
                          >
                        </div>
                        <div
                            class="breakdown-cost__table__line__subitem"
                            v-for="(room, idx) in item.rooms"
                            :key="idx">
                          <div
                              class="breakdown-cost__table__line__subitem__name">
                            {{ room.name }}
                            <div
                                class="breakdown-cost__table__line__subsubitem"
                                v-for="(client, i) in room.participants"
                                :key="i"
                                v-if="showNames">
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name"
                              ><span>{{ client.info }}</span>
                              </span>
                              <span
                                  class="breakdown-cost__table__line__subsubitem__name-price"
                              >{{
                                  show0
                                      ? client.totalCost
                                      : removeFractional(client.totalCost)
                                }}{{
                                  getCurrencySign(totalPrice.breakdownCost.currency)
                                }}</span
                              >
                            </div>
                          </div>
                          <span class="breakdown-cost__table__line__item__pax"
                          >{{ room.roomCount }} Room</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0 ? room.price : removeFractional(room.price)
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}<span
                              class="form-control__help-icon"
                              v-if="room.warning">
                              <span class="form-control__help-content"
                              >This price substantially differs from regular
                                values, please check it manually.</span
                              ><svg
                              class="icon icon-important important-icon">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use></svg></span
                          ></span>
                        </div>
                      </div>
                      <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Extra Accommodation Total:</span
                        >
                        <span class="breakdown-cost__item-total-value"
                        >{{
                            show0
                                ? totalPrice.breakdownCost.extraAccommodationCost
                                    .totalAmount
                                : removeFractional(
                                    totalPrice.breakdownCost
                                        .extraAccommodationCost.totalAmount
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                      <div
                          class="note-info"
                          v-if="
                          totalPrice.breakdownCost.extraAccommodationCost.errors
                            .length
                        ">
                        <svg
                            class="icon icon-important important-icon">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                        </svg>
                        <div class="note-info__text">
                          {{
                            totalPrice.breakdownCost.extraAccommodationCost.errors.join(
                                ', '
                            )
                          }}
                        </div>
                      </div>
                    </div>

                    <div
                        class="breakdown-cost__table__row"
                        v-if="
                        totalPrice.breakdownCost.other &&
                        (totalPrice.breakdownCost.other.costs.length ||
                          totalPrice.breakdownCost.other.errors.length)
                      ">
                      <div class="breakdown-cost__table__row__title">
                        <div class="breakdown-cost__table__row__icon">
                          <svg width="1em" height="1em" class="icon icon-other">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-other"></use>
                          </svg>
                        </div>
                        <span>Other</span>
                      </div>
                      <div class="breakdown-cost__table__line">
                        <div
                            class="breakdown-cost__table__line__info"
                            v-for="(item, index) in totalPrice.breakdownCost.other
                            .costs"
                            :key="index">
                          <span
                              class="breakdown-cost__table__line__item__name"
                          >{{ item.name }}</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0 ? item.price : removeFractional(item.price)
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                        </div>
                      </div>
                      <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Other Total:</span
                        >
                        <span class="breakdown-cost__item-total-value"
                        >{{
                            show0
                                ? totalPrice.breakdownCost.other.totalAmount
                                : removeFractional(
                                    totalPrice.breakdownCost.other.totalAmount
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__row"
                        v-if="
                        totalPrice.breakdownCost.additionalServices &&
                        (totalPrice.breakdownCost.additionalServices.services.length)
                      ">
                      <div class="breakdown-cost__table__row__title">
                        <div class="breakdown-cost__table__row__icon">
                          <svg width="1em" height="1em" class="icon icon-additional-options">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-additional-options"></use>
                          </svg>
                        </div>
                        <span>Additional Services</span>
                      </div>
                      <div class="breakdown-cost__table__line">
                        <div
                            class="breakdown-cost__table__line__info"
                            v-for="(service, index) in totalPrice.breakdownCost.additionalServices
                            .services"
                            :key="index">
                          <span
                              class="breakdown-cost__table__line__item__name"
                          >{{ service.description }}</span
                          ><span
                            class="breakdown-cost__table__line__item__price"
                        >{{
                            show0 ? service.participant.totalCost : removeFractional(service.participant.totalCost)
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                        </div>
                      </div>
                      <div class="breakdown-cost__item-total">
                        <span class="breakdown-cost__item-total-label"
                        >Additional Services Total:</span
                        >
                        <span class="breakdown-cost__item-total-value"
                        >{{
                            show0
                                ? totalPrice.breakdownCost.additionalServices.totalAmount
                                : removeFractional(
                                    totalPrice.breakdownCost.additionalServices.totalAmount
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="breakdown-cost__table-total">
                    GRAND TOTAL:<span
                      class="breakdown-cost__table-total-val"
                  >{{
                      totalPrice.breakdownCost.summary.grandTotal
                    }}{{
                      getCurrencySign(totalPrice.breakdownCost.currency)
                    }}</span
                  >
                  </div>
                </div>
              </div>

              <div ref="additionalServices" v-show="tab !== 3" class="new-title new-title--m-top new-title--m-bottom">
                Additional Services
              </div>
              <div v-show="tab !== 3" class="additional-block">
                <div
                    v-if="additionalServices.length"
                    class="additional-block__top">
                  <div class="additional-block__row">
                    <span class="additional-block__label">Participant</span>
                    <span class="additional-block__label"
                    >Description of services</span
                    >
                    <span class="additional-block__label"
                    >Price (incl commission)</span
                    >
                  </div>
                </div>
                <draggable
                    v-if="additionalServices.length"
                    v-model="additionalServices"
                    class="additional-block__list"
                    @update="onAddDragUpdate()"
                    handle=".movethis">
                  <div
                      v-for="(service, ind) in additionalServices"
                      :key="ind"
                      class="additional-block__row">
                    <div class="additional-block__element"
                         :class="{'additional-block__select--invalid': service.errors && !service.participantId && service.errors.participantError}">
                      <v-select
                          @input="
                          onChangeAdditional(
                            service.participantId,
                            service.description,
                            service.price
                          )
                        "
                          v-model="service.participantId"
                          :reduce="(item) => item.id"
                          :options="participants"
                          :filterable="false"
                          :clearable="false"
                          :searchable="false"
                          label="name"
                          placeholder="Select the participant"
                          class="new-select">
                        <template #open-indicator>
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="8"
                              height="5"
                              viewBox="0 0 8 5"
                              fill="none">
                            <path
                                d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                                fill="#606060"/>
                          </svg>
                        </template>
                        <template #option="option">
                          <div class="select__item d-center">
                            {{ option.name }}
                          </div>
                        </template>
                        <template #selected-option="option">
                          <div class="selected d-center">{{ option.name }}</div>
                        </template>
                      </v-select>
                    </div>
                    <div class="additional-block__element">
                      <div :class="[
                            'additional-block__input',
                            {'additional-block__input--invalid': service.errors && !service.description && service.errors.descriptionError}
                        ]">
                        <input
                            @change="
                            onChangeAdditional(
                              service.participantId,
                              service.description,
                              service.price
                            )
                          "
                            v-model="service.description"
                            type="text"
                            placeholder="Description"/>
                      </div>
                    </div>
                    <div class="additional-block__element">
                      <div
                          :class="[
                            'additional-block__input',
                            'additional-block__input--decor',
                            {'additional-block__input--invalid': service.errors && (service.price === '0' || !service.price) && service.errors.priceError}
                        ]">
                        <input
                            @change="
                            onChangeAdditional(
                              service.participantId,
                              service.description,
                              service.price
                            )
                          "
                            v-model="service.price"
                            type="number"
                            placeholder="0"/>
                        <span>{{ programCurrency }}</span>
                      </div>
                    </div>
                    <div class="additional-block__element">
                      <div class="additional-block__checkbox-wrapper">
                        <label
                            class="form-control-checkbox">
                          <input
                              type="checkbox"
                              :checked="service.hideForClient"
                              @click="service.hideForClient = !service.hideForClient
                              onChangeAdditionalServicesHideCheckbox()"/>
                          <span class="form-control-checkbox__box">
                        <svg width="1em" height="1em" class="icon icon-check">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                        </svg>
                      </span>
                          <span class="form-control-checkbox__name"
                          >Hide for the client</span
                          >
                        </label>
                      </div>
                    </div>
                    <button
                        @click="onAdditionalDelete(ind)"
                        type="button"
                        class="additional-block__delete">
                      <img src="/images/disc-delete.svg" alt=""/>
                    </button>
                    <div class="movethis-wrapper">
                      <button
                          type="button"
                          class="movethis-button movethis">
                        <svg width="1em" height="1em" class="icon icon-move">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-move"></use>
                        </svg>
                      </button>
                    </div>
                  </div>
                </draggable>
                <button
                    @click="onAdditionalAdd"
                    class="additional-block__add"
                    type="button">
                  + Add Service
                </button>
              </div>

              <div
                  :class="[
                  'make-story__collapse js-collapse commissions-section',
                  {'is-collapsed': collapse.comiss},
                ]"
                  id="commissions"
                  v-show="tab === 0 || tab === 2"
                  v-if="dataSelects.advices && advicesRecomended">
                <div
                    class="make-story__collapse__title page-title form-control__help">
                  <h2>Our Commissions</h2>
                  <button
                      type="button"
                      data-opened="Hide"
                      data-closed="Show"
                      :class="[
                      'btn',
                      'btn--collapse',
                      'js-collapse-trigger',
                      {'is-active': collapse.comiss},
                    ]"
                      @click="collapse.comiss = !collapse.comiss">
                    <div class="btn--collapse__icon">
                      <svg width="1em" height="1em" class="icon icon-collapse">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                      </svg>
                    </div>
                  </button>
                </div>
                <div class="commissions-header">
                  <div>Profit</div>
                </div>
                <div class="make-story__collapse__inner js-collapse-inner">
                  <div class="make-story__scroll" v-if="totalPrice">
                    <div
                        class="breakdown-cost__table__commision"
                        v-if="
                        totalPrice.breakdownCost.climbingCost &&
                        totalPrice.breakdownCost.climbingCost.routes.length
                      ">
                      <div
                          class="breakdown-cost__table__commision__icon breakdown-cost__table__commision__icon-percent">
                        <img src="/images/useful/svg/hot.svg" alt=""/>
                      </div>
                      <div class="breakdown-cost__table__commision__name">
                        <span
                        >Climb Discount ({{
                            dataSelects.advices.discounts.climb || 0
                          }}%)</span
                        >
                      </div>
                      <div class="breakdown-cost__table__commision__action">
                        <button
                            type="button"
                            class="btn btn--edit"
                            @click="
                            commissionPopup = 'discounts.climb'
                            commissionPopupValue =
                              dataSelects.advices.discounts.climb
                          ">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                      </div>
                      <div class="breakdown-cost__table__commision__info">
                        <span
                        >Advised for {{ advicesRecomended.month }}:
                          {{ advicesRecomended.discounts.climb }}%</span
                        >
                      </div>
                      <div class="breakdown-cost__table__commision__price">
                        <span>
                          {{
                            show0
                                ? totalPrice.breakdownCost.discounts.climb
                                : removeFractional(
                                    totalPrice.breakdownCost.discounts.climb
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}
                        </span>
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__commision"
                        v-if="
                        totalPrice.breakdownCost.climbingCost &&
                        totalPrice.breakdownCost.climbingCost.additionalOptions
                          .length
                      ">
                      <div
                          class="breakdown-cost__table__commision__icon breakdown-cost__table__commision__icon-percent">
                        <img src="/images/useful/svg/hot.svg" alt=""/>
                      </div>
                      <div class="breakdown-cost__table__commision__name">
                        <span
                        >Climb Additional Discount ({{
                            dataSelects.advices.discounts
                                .climbAdditionalOptions
                          }}%)</span
                        >
                      </div>
                      <div class="breakdown-cost__table__commision__action">
                        <button
                            type="button"
                            class="btn btn--edit"
                            @click="
                            commissionPopup = 'discounts.climbAdditionalOptions'
                            commissionPopupValue =
                              dataSelects.advices.discounts
                                .climbAdditionalOptions
                          ">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                      </div>
                      <div class="breakdown-cost__table__commision__info">
                        <span
                        >Advised for {{ advicesRecomended.month }}:
                          {{
                            advicesRecomended.discounts.climbAdditionalOptions
                          }}%</span
                        >
                      </div>
                      <div class="breakdown-cost__table__commision__price">
                        <span
                        >{{
                            show0
                                ? totalPrice.breakdownCost.discounts
                                    .climbAdditionalOptions
                                : removeFractional(
                                    totalPrice.breakdownCost.discounts
                                        .climbAdditionalOptions
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__commision"
                        v-if="
                        totalPrice.breakdownCost.dayTripsCost &&
                        totalPrice.breakdownCost.dayTripsCost.totalAmount
                      ">
                      <div
                          class="breakdown-cost__table__commision__icon breakdown-cost__table__commision__icon-percent">
                        <img src="/images/useful/svg/hot.svg" alt=""/>
                      </div>
                      <div class="breakdown-cost__table__commision__name">
                        <span
                        >Day Trips Discount ({{
                            dataSelects.advices.discounts.dayTrips
                          }}%)</span
                        >
                      </div>
                      <div
                          class="breakdown-cost__table__commision__action"
                          @click="
                          commissionPopup = 'discounts.dayTrips'
                          commissionPopupValue =
                            dataSelects.advices.discounts.dayTrips
                        ">
                        <button type="button" class="btn btn--edit">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                      </div>
                      <div class="breakdown-cost__table__commision__info">
                        <span
                        >Advised for {{ advicesRecomended.month }}:
                          {{ advicesRecomended.discounts.dayTrips }}%</span
                        >
                      </div>
                      <div class="breakdown-cost__table__commision__price">
                        <span
                        >{{
                            totalPrice.breakdownCost.discounts.dayTrips
                                ? '-'
                                : ''
                          }}{{
                            show0
                                ? totalPrice.breakdownCost.discounts.dayTrips
                                : removeFractional(
                                    totalPrice.breakdownCost.discounts.dayTrips
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__commision"
                        v-if="
                        totalPrice.breakdownCost.safariCost &&
                        totalPrice.breakdownCost.safariCost.totalAmount
                      ">
                      <div class="breakdown-cost__table__commision__icon">
                        <span>{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span>
                      </div>
                      <div class="breakdown-cost__table__commision__name">
                        <span>
                          Safari Commission ({{ getSafariCommission(totalPrice) }}%)
                        </span>
                      </div>
                      <div class="breakdown-cost__table__commision__action">
                        <span v-tooltip="{content: 'Commission calculated automatically based on safari duration', offset: 5}"
                              class="form-control__name-help"
                              style="display: inline-block; cursor: pointer;"
                        >
                          <img src="/images/useful/svg/help-icon.svg" alt="" />
                        </span>
                      </div>
                      <div class="breakdown-cost__table__commision__info">
                        <span
                        >Advised for {{ advicesRecomended.month }}:
                          {{ advicesRecomended.commissions.safari }}%</span
                        >
                      </div>
                      <div class="breakdown-cost__table__commision__price">
                        <span
                        >
                          {{getSafariCommission(totalPrice) ? '+' : '' }}{{
                            show0
                                ? totalPrice.breakdownCost.commissions.safari
                                : removeFractional(totalPrice.breakdownCost.commissions.safari)
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__commision"
                        v-if="
                        totalPrice.breakdownCost.islandCost &&
                        totalPrice.breakdownCost.islandCost.totalAmount
                      ">
                      <div class="breakdown-cost__table__commision__icon">
                        <span>{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span>
                      </div>
                      <div class="breakdown-cost__table__commision__name">
                        <span
                        >Islands Commission ({{
                            dataSelects.advices.commissions.island
                          }}%)</span
                        >
                      </div>
                      <div
                          class="breakdown-cost__table__commision__action"
                          @click="
                          commissionPopup = 'commissions.island'
                          commissionPopupValue =
                            dataSelects.advices.commissions.island
                        ">
                        <button type="button" class="btn btn--edit">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                      </div>
                      <div class="breakdown-cost__table__commision__info">
                        <span
                        >Advised for {{ advicesRecomended.month }}:
                          {{ advicesRecomended.commissions.island }}%</span
                        >
                      </div>
                      <div class="breakdown-cost__table__commision__price">
                        <span
                        >{{
                            totalPrice.breakdownCost.commissions.island
                                ? '+'
                                : ''
                          }}{{
                            show0
                                ? totalPrice.breakdownCost.commissions.island
                                : removeFractional(
                                    totalPrice.breakdownCost.commissions.island
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__commision"
                        v-if="
                        totalPrice.breakdownCost.transferCost &&
                        totalPrice.breakdownCost.transferCost.totalAmount
                      ">
                      <div class="breakdown-cost__table__commision__icon">
                        <span>{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span>
                      </div>
                      <div class="breakdown-cost__table__commision__name">
                        <span
                        >Transfers Commission ({{
                            dataSelects.advices.commissions.transfer
                          }}%)</span
                        >
                      </div>
                      <div
                          class="breakdown-cost__table__commision__action"
                          @click="
                          commissionPopup = 'commissions.transfer'
                          commissionPopupValue =
                            dataSelects.advices.commissions.transfer
                        ">
                        <button type="button" class="btn btn--edit">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                      </div>
                      <div class="breakdown-cost__table__commision__info">
                        <span
                        >Advised for {{ advicesRecomended.month }}:
                          {{ advicesRecomended.commissions.transfer }}%</span
                        >
                      </div>
                      <div class="breakdown-cost__table__commision__price">
                        <span
                        >{{
                            totalPrice.breakdownCost.commissions.transfer
                                ? '+'
                                : ''
                          }}{{
                            show0
                                ? totalPrice.breakdownCost.commissions.transfer
                                : removeFractional(
                                    totalPrice.breakdownCost.commissions.transfer
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                    <!--                    <div-->
                    <!--                        class="breakdown-cost__table__commision"-->
                    <!--                        v-if="data.program.find(d => d.activitiesData.length) || data.program.filter(d => d.days && d.days.length).map(d => d.days).flat().find(d => d.activitiesData.length)"-->
                    <!--                    >-->
                    <div
                        class="breakdown-cost__table__commision"
                        v-if="showActivityComission">
                      <div class="breakdown-cost__table__commision__icon">
                        <span>{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span>
                      </div>
                      <div class="breakdown-cost__table__commision__name">
                        <span
                        >Activity Commission ({{
                            dataSelects.advices.commissions.activity
                          }}%)</span
                        >
                      </div>
                      <div
                          class="breakdown-cost__table__commision__action"
                          @click="
                          commissionPopup = 'commissions.activity'
                          commissionPopupValue =
                            dataSelects.advices.commissions.activity
                        ">
                        <button type="button" class="btn btn--edit">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                      </div>
                      <div class="breakdown-cost__table__commision__info">
                        <span
                        >Advised for {{ advicesRecomended.month }}:
                          {{ advicesRecomended.commissions.activity }}%</span
                        >
                      </div>
                      <div class="breakdown-cost__table__commision__price">
                        <span
                        >{{
                            totalPrice.breakdownCost.commissions.activity
                                ? '+'
                                : ''
                          }}{{
                            show0
                                ? totalPrice.breakdownCost.commissions.activity
                                : removeFractional(
                                    totalPrice.breakdownCost.commissions.activity
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__commision"
                        v-if="
                        totalPrice.breakdownCost.flightTickets &&
                        totalPrice.breakdownCost.flightTickets.totalAmount
                      ">
                      <div class="breakdown-cost__table__commision__icon">
                        <span>{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span>
                      </div>
                      <div class="breakdown-cost__table__commision__name">
                        <span
                        >Flights Commission ({{
                            dataSelects.advices.commissions.flights
                          }}%)</span
                        >
                      </div>
                      <div
                          class="breakdown-cost__table__commision__action"
                          @click="
                          commissionPopup = 'commissions.flights'
                          commissionPopupValue =
                            dataSelects.advices.commissions.flights
                        ">
                        <button type="button" class="btn btn--edit">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                      </div>
                      <div class="breakdown-cost__table__commision__info">
                        <span
                        >Advised for {{ advicesRecomended.month }}:
                          {{ advicesRecomended.commissions.flights }}%</span
                        >
                      </div>
                      <div class="breakdown-cost__table__commision__price">
                        <span
                        >{{
                            totalPrice.breakdownCost.commissions.flights
                                ? '+'
                                : ''
                          }}{{
                            show0
                                ? totalPrice.breakdownCost.commissions.flights
                                : removeFractional(
                                    totalPrice.breakdownCost.commissions.flights
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__commision"
                        v-if="
                        totalPrice.breakdownCost.other &&
                        totalPrice.breakdownCost.other.totalAmount
                      ">
                      <div class="breakdown-cost__table__commision__icon">
                        <span>{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span>
                      </div>
                      <div class="breakdown-cost__table__commision__name">
                        <span
                        >Other Commission ({{
                            dataSelects.advices.commissions.other
                          }}%)</span
                        >
                      </div>
                      <div
                          class="breakdown-cost__table__commision__action"
                          @click="
                          commissionPopup = 'commissions.other'
                          commissionPopupValue =
                            dataSelects.advices.commissions.other
                        ">
                        <button type="button" class="btn btn--edit">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                      </div>
                      <div class="breakdown-cost__table__commision__info">
                        <span
                        >Advised for {{ advicesRecomended.month }}:
                          {{ advicesRecomended.commissions.other }}%</span
                        >
                      </div>
                      <div class="breakdown-cost__table__commision__price">
                        <span
                        >{{
                            totalPrice.breakdownCost.commissions.other
                                ? '+'
                                : ''
                          }}{{
                            show0
                                ? totalPrice.breakdownCost.commissions.other
                                : removeFractional(
                                    totalPrice.breakdownCost.commissions.other
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__commision"
                        v-if="
                        totalPrice.breakdownCost.extraAccommodationCost &&
                        totalPrice.breakdownCost.extraAccommodationCost
                          .totalAmount
                      ">
                      <div class="breakdown-cost__table__commision__icon">
                        <span>{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span>
                      </div>
                      <div class="breakdown-cost__table__commision__name">
                        <span
                        >Extra Accommodation ({{
                            dataSelects.advices.commissions.extraAccommodation
                          }}%)</span
                        >
                      </div>
                      <div
                          class="breakdown-cost__table__commision__action"
                          @click="
                          commissionPopup = 'commissions.extraAccommodation'
                          commissionPopupValue =
                            dataSelects.advices.commissions.extraAccommodation
                        ">
                        <button type="button" class="btn btn--edit">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                      </div>
                      <div class="breakdown-cost__table__commision__info">
                        <span>
                          Advised for {{ advicesRecomended.month }}:
                          {{
                            advicesRecomended.commissions.extraAccommodation
                          }}%
                        </span>
                      </div>
                      <div class="breakdown-cost__table__commision__price">
                        <span
                        >{{
                            totalPrice.breakdownCost.commissions
                                .extraAccommodation
                                ? '+'
                                : ''
                          }}{{
                            show0
                                ? totalPrice.breakdownCost.commissions
                                    .extraAccommodation
                                : removeFractional(
                                    totalPrice.breakdownCost.commissions
                                        .extraAccommodation
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                    <div
                        class="breakdown-cost__table__commision"
                        v-if="
                        totalPrice.breakdownCost.airportVipServices &&
                        totalPrice.breakdownCost.airportVipServices.vipServices
                          .length
                      ">
                      <div class="breakdown-cost__table__commision__icon">
                        <span>{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span>
                      </div>
                      <div class="breakdown-cost__table__commision__name">
                        <span
                        >Airport VIP Services ({{
                            dataSelects.advices.commissions.airportVipServices
                          }}%)</span
                        >
                      </div>
                      <div
                          class="breakdown-cost__table__commision__action"
                          @click="
                          commissionPopup = 'commissions.airportVipServices'
                          commissionPopupValue =
                            dataSelects.advices.commissions.airportVipServices
                        ">
                        <button type="button" class="btn btn--edit">
                          <svg width="1em" height="1em" class="icon icon-edit">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                      </div>
                      <div class="breakdown-cost__table__commision__info">
                        <span>
                          Advised for {{ advicesRecomended.month }}:
                          {{
                            advicesRecomended.commissions.airportVipServices
                          }}%
                        </span>
                      </div>
                      <div class="breakdown-cost__table__commision__price">
                        <span
                        >{{
                            totalPrice.breakdownCost.commissions
                                .airportVipServices
                                ? '+'
                                : ''
                          }}{{
                            show0
                                ? totalPrice.breakdownCost.commissions
                                    .airportVipServices
                                : removeFractional(
                                    totalPrice.breakdownCost.commissions
                                        .airportVipServices
                                )
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div v-show="tab !== 3" class="new-title new-title--m-top new-title--m-bottom" ref="discounts">
                <img
                    class="make-story__collapse__title__icon"
                    src="/images/discounts-icon.svg"
                    alt=""/>
                Discounts
              </div>
              <div v-show="tab !== 3" class="discount-block">
                <div
                    v-if="participantPersonalDiscounts.length"
                    class="discount-block__top">
                  <span>Participant</span>
                  <span>Discount</span>
                  <span>Description</span>
                </div>
                <div
                    v-for="(disc, index) in participantPersonalDiscounts"
                    :key="index"
                    class="discount-block__item">
                  <div class="discount-block__select">
                    <v-select
                        v-model="disc.participantId"
                        :options="filteredParticipantDiscounts"
                        :filterable="false"
                        :clearable="false"
                        :searchable="false"
                        label="name"
                        placeholder="Select the participant"
                        class="new-select">
                      <template #open-indicator>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="5"
                            viewBox="0 0 8 5"
                            fill="none">
                          <path
                              d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                              fill="#606060"/>
                        </svg>
                      </template>
                      <template #option="option">
                        <div class="select__item d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template #selected-option="option">
                        <div class="selected d-center">{{ option.name }}</div>
                      </template>
                    </v-select>
                  </div>
                  <div class="discount-block__input">
                    <input
                        @keydown="onDiscountValueInput($event)"
                        v-model="disc.discount"
                        type="number"/>
                  </div>
                  <div class="discount-block__radios">
                    <label class="discount-block__radio">
                      <input
                          v-model="disc.discountType"
                          type="radio"
                          :name="`disc_type_${index}`"
                          value="AMOUNT"/>
                      <span class="discount-block__radio-mark">{{
                        getCurrencySign(getSelectedCurrency)
                        }}</span>
                    </label>
                    <label class="discount-block__radio">
                      <input
                          v-model="disc.discountType"
                          type="radio"
                          :name="`disc_type_${index}`"
                          value="PERCENT"/>
                      <span class="discount-block__radio-mark">%</span>
                    </label>
                  </div>
                  <div :class="[
                            'discount-block__input',
                            'discount-block__input--description',
                            {'additional-block__input--invalid': disc.errors && disc.errors.descriptionError && !disc.description}
                        ]">
                    <input
                        v-model="disc.description"
                        type="text"
                        placeholder="Description"/>
                  </div>
                  <div class="discount-block__checkbox">
                    <label
                        class="form-control-checkbox">
                      <input
                          type="checkbox"
                          :checked="disc.hideForClient"
                          @click="disc.hideForClient = !disc.hideForClient"/>
                      <span class="form-control-checkbox__box">
                        <svg width="1em" height="1em" class="icon icon-check">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                        </svg>
                      </span>
                      <span class="form-control-checkbox__name"
                      >Hide for the client</span
                      >
                    </label>
                  </div>
                  <button
                      @click="onDiscountDelete(index)"
                      type="button"
                      class="discount-block__delete">
                    <img src="/images/disc-delete.svg" alt=""/>
                  </button>
                </div>
                <button
                    @click="onDiscountAdd"
                    class="discount-block__add"
                    type="button">
                  + Add Discount
                </button>
                <button
                    @click="calcTemplatePriceHandler()"
                    style="margin-left: 35px"
                    class="btn btn--blue"
                    type="button">
                  Apply Discount
                </button>
              </div>

              <div
                  id="total-sect"
                  v-show="tab === 0 || tab === 2"
                  :class="[
                  'make-story__collapse summary-section',
                  {'is-collapsed': collapse.summary},
                ]"
                  v-if="totalPrice">
                <div
                    class="make-story__collapse__title page-title form-control__help">
                  <h2>Summary</h2>
                  <!-- <button type="button" data-opened="Hide" data-closed="Show"
							:class="['btn', 'btn--collapse', 'js-collapse-trigger', { 'is-active': collapse.summary }]"
							@click="collapse.summary = !collapse.summary">
							<div class="btn--collapse__icon">
							<svg width="1em" height="1em" class="icon icon-collapse ">
								<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
							</svg>
							</div>
						</button> -->
                </div>

                <div
                    class="make-story__collapse__inner"
                    v-if="totalPrice">
                  <div class="breakdown-cost__summary__line-head">
                    <div class="breakdown-cost__summary__line__item">
                      <div class="breakdown-cost__summary__line__descr">
                        <div class="breakdown-cost__summary__line__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-calendar">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                          </svg>
                        </div>
                        <span
                        >TOTAL DAYS:<span class="count-day"
                        >{{
                            totalPrice.breakdownCost.summary.totalDays
                          }}
                            Days</span
                        ></span
                        >
                      </div>
                      <div class="breakdown-cost__summary__line__val">
                        <span class="total-desc total-desc_top"
                        ><span class="breakdown-cost__summary__total__descr"
                        >GRAND TOTAL:</span
                        ><span class="breakdown-cost__summary__total__val"
                        >{{
                            totalPrice.breakdownCost.summary.grandTotal
                          }}{{
                            getCurrencySign(totalPrice.breakdownCost.currency)
                          }}</span
                        ></span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="breakdown-cost__summary-notification" v-if="totalPrice.exchangeRateData && (totalPrice.breakdownCost.currency === 'GBP' || totalPrice.breakdownCost.currency === 'EUR')">
                    <div class="breakdown-cost__summary-notification__top">
                      <div class="breakdown-cost__summary-notification__icons">
                        <svg width="20px" height="20px" class="icon-pound" v-if="totalPrice.breakdownCost.currency === 'GBP'">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#pound-icon"></use>
                        </svg>
                        <svg width="20px" height="20px" class="icon-euro" v-if="totalPrice.breakdownCost.currency === 'EUR'">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#euro-icon"></use>
                        </svg>
                        <svg width="20px" height="20px" class="icon-dollar">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#dollar-icon"></use>
                        </svg>
                      </div>
                      <span><strong>CURRENT RATE:</strong>
                        {{`1 ${totalPrice.exchangeRateData.base} = ${totalPrice.exchangeRateData.rates['USD']}$`}}
                      </span>
                      <span class="form-control__help-icon">
                            <span class="form-control__help-content">
                              Please note that when calculating the program cost in EUR or GBP,
                              the original cost in USD increases by 2%, as we include an additional
                              amount for currency exchange - all tour program payments are made by us
                              in USD and overall we only use USD.
                            </span>
                            <img
                                src="/images/useful/svg/help-icon.svg"
                                alt=""/>
                      </span>
                    </div>
                    <div class="breakdown-cost__summary-notification__bottom">
                      Date and time of rate update: {{new Date(totalPrice.exchangeRateData.timestamp * 1000).toLocaleString()}}
                    </div>
                  </div>
                  <div class="breakdown-cost__summary">
                    <div class="breakdown-cost__summary__line-item">
                      <div class="breakdown-cost__summary__line__descr">
                        <div class="breakdown-cost__summary__line__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-location">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-location"></use>
                          </svg>
                        </div>
                        <span>National Parks:</span>
                      </div>
                      <div class="breakdown-cost__summary__line__val">
                        <span>{{
                            totalPrice.breakdownCost.summary.nationalParks
                                .concat(
                                    data.program
                                        .filter((item) => item.type.data === 'CLIMBING')
                                        .map((item) =>
                                            item.mountain === 'Meru'
                                                ? 'Mount Meru'
                                                : item.mountain === 'Kilimanjaro'
                                                    ? 'Mount Kilimanjaro'
                                                    : ''
                                        )
                                )
                                .join(', ')
                          }}</span>
                      </div>
                    </div>
                    <div class="breakdown-cost__summary__total">
                      <div
                          class="breakdown-cost__summary__total__line breakdown-cost__summary__total__line_head">
                        <span class="breakdown-cost__summary__total__descr"
                        >Participant</span
                        >
                        <span class="breakdown-cost__summary__total__holder">
                          <span
                              v-if="discountInSorteredParticipantPresent"
                              class="breakdown-cost__summary__total__val breakdown-cost__summary__total__val--disc"
                          >Discount</span
                          >
                          <span class="breakdown-cost__summary__total__val"
                          >Total Amount</span
                          >
                        </span>
                      </div>
                      <div
                          class="breakdown-cost__summary__total__line"
                          v-for="(item, index) in sorteredParticipants"
                          :key="index">
                        <span class="breakdown-cost__summary__total__descr">
                          {{ item.info }}
                        </span>
                        <span
                            class="breakdown-cost__summary__total__holder breakdown-cost__summary__total__holder--gap">
                          <span
                              v-if="item.personalDiscount"
                              class="breakdown-cost__summary__total__val breakdown-cost__summary__total__val--disc"
                          >{{
                              item.personalDiscount
                            }}{{
                              getCurrencySign(totalPrice.breakdownCost.currency)
                            }}</span
                          >
                          <span class="breakdown-cost__summary__total__val"
                          >{{
                              item.totalAmount
                            }}{{
                              getCurrencySign(totalPrice.breakdownCost.currency)
                            }}</span
                          >
                        </span>
                      </div>
                    </div>
                    <div class="breakdown-cost__summary__total__main">
                      <span class="total-desc"
                      ><span class="breakdown-cost__summary__total__descr"
                      >GRAND TOTAL:</span
                      ><span class="breakdown-cost__summary__total__val"
                      >{{
                          totalPrice.breakdownCost.summary.grandTotal
                        }}{{
                          getCurrencySign(totalPrice.breakdownCost.currency)
                        }}</span
                      ></span
                      >
                    </div>
                    <div
                        class="breakdown-cost__summary__total__main breakdown-cost__summary__total__main_2">
                      <div class="breakdown-cost__summary__text-swich">
                        Allow the client to pay for the tour via Stripe, turn it
                        ON only when all hotels have confirmed your pre-booking.
                      </div>
                      <div class="switch">
                        <label class="switch-label"
                        ><input type="checkbox" v-model="allowStripe"/>
                          <span class="switch-inp"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="menu-aside" v-if="tab !== 3">
                <a
                    :class="['menu-aside__link', {active: tab === 0}]"
                    @click="
                    tab = 0
                    scrollTop()
                  ">
                  <svg width="1em" height="1em" class="icon icon-itinerary">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-itinerary"></use>
                  </svg>
                  <span>Itinerary</span>
                </a>
                <a
                    :class="[
                    'menu-aside__link',
                    {active: tab === 1},
                    {disabled: data.id ? false : true},
                  ]"
                    @click="
                    tab = 1
                    scrollTop()
                  ">
                  <svg width="1em" height="1em" class="icon icon-details">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-details"></use>
                  </svg>
                  <span>Quick Details</span>
                </a>
                <a
                    :class="[
                    'menu-aside__link',
                    {active: tab === 2},
                    {disabled: data.id ? false : true},
                  ]"
                    @click="
                    tab = 2
                    scrollTop()
                  ">
                  <svg width="1em" height="1em" class="icon icon-cost">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-cost"></use>
                  </svg>
                  <span>Cost</span>
                </a>
                <!--fixed menu Invoices start-->
                <a
                    :class="[
                    'menu-aside__link',
                    {active: tab === 3},
                    {disabled: data.id ? false : true},
                  ]"
                    @click="
                    tab = 3
                    scrollTop()
                  "
                >
                  <svg width="1em" height="1em" class="icon icon-invoices">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-invoices"></use>
                  </svg>
                  <span>Invoices</span>
                </a>
                <!--fixed menu Invoices end-->
                <button
                    type="submit"
                    @click="
                    isEdit &&
                    ($route.fullPath.includes('client') ||
                      $route.fullPath.includes('new'))
                      ? updateClientsHandler()
                      : createClientsHandler(false, false)
                  "
                    class="btn btn--green btn_save">
                  <svg width="1em" height="1em" class="icon icon-save">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-save"></use>
                  </svg>
                  <span>Save <span class="btn_save-bottom">ctrl+s</span></span>
                </button>
              </div>
            </div>
          </section>
          <div v-if="isEdit && tab !== 3" class="make-story-form__footer">
            <div class="container-lg">
              <div class="make-story-form__footer__inner">
                <button
                    type="submit"
                    class="btn btn--blue"
                    @click="
                    safariDriverPopup = true
                    isEditFlag = true
                  ">
                  <svg width="1em" height="1em" class="icon icon-car2">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-car2"></use>
                  </svg>
                  <span>Make Itinerary for Safari Driver</span>
                </button>
                <button
                    @click="recalculationPopup = true"
                    class="btn btn--blue">
                  <svg width="1em" height="1em" class="icon icon-recalc">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recalc"></use>
                  </svg>
                  <span>Recalculate the Price</span>
                </button>
                <button
                    type="submit"
                    v-if="isEdit"
                    class="btn btn--blue"
                    @click="openLink('https://tz.altezza.travel/itinerary/' + data.link)">
                  <img src="/images/link.svg" :style="{marginRight: '10px'}"/>
                  <span>Link w/o prices</span>
                </button>
                <button
                    type="submit"
                    v-if="isEdit"
                    class="btn btn--blue"
                    @click="openLink('/itinerary/' + data.link)">
                  <img src="/images/link.svg" :style="{marginRight: '10px'}"/>
                  <span>Get a link</span>
                </button>
                <button
                    type="submit"
                    class="btn btn--blue"
                    @click="
                    isEdit && $route.fullPath.includes('template')
                      ? updateTemplateHandler()
                      : createTemplateHandler(false)
                  ">
                  <span
                  >{{
                      isEdit && $route.fullPath.includes('template')
                          ? 'Update'
                          : 'Save'
                    }}
                    as Template</span
                  >
                </button>
                <button
                    type="submit"
                    class="btn btn--green"
                    @click="
                    isEdit &&
                    ($route.fullPath.includes('client') ||
                      $route.fullPath.includes('new'))
                      ? updateClientsHandler()
                      : createClientsHandler(false, true)
                  ">
                  <span>{{
                      isEdit &&
                      ($route.fullPath.includes('client') ||
                          $route.fullPath.includes('new'))
                          ? 'Update Group Info'
                          : 'Save as Client'
                    }}</span>
                </button>
              </div>
            </div>
          </div>
        </form>

        <!--id="invoices" START-->
        <section id="invoices" v-show="tab === 3">
          <div class="container-lg">
            <div class="invoices">
              <div class="story-templates__table-wrap">
                <div
                    class="story-templates__table invoices-templates__table">
                  <div class="story-templates__table__head">
                    <div class="col col-invoice-num">Invoice #</div>
                    <div class="col col-invoice-bank">Bank</div>
                    <div class="col col-invoice-payer">Payer</div>
                    <div class="col col-invoice-amount">Invoice Amount</div>
                    <div class="col col-invoice-paid фсешму">Amount Paid</div>
                    <div class="col col-invoice-deadline">Deadline</div>
                    <div class="col col-invoice-status">Status</div>
                    <div class="col col-invoice-date">Date of Payment</div>
                    <div class="col col-invoice-info"></div>
                    <div class="col col-invoice-options"></div>
                  </div>
                  <template v-if="allInvoices.length > 0">
                    <div class="story-templates__table__row--invoice" v-for="invoice in allInvoices" :key="invoice.id">
                      <div class="col col-invoice-num">
                        <router-link :to="{ name: 'changeInvoice', params: { id: invoice.id }}">
                          {{ invoice.invoiceNumber }}
                        </router-link>
                      </div>
                      <div class="col col-invoice-bank">
                      <span>
                        {{ findCurrentBankInvoice(invoice.bankId) }}
                      </span>
                      </div>
                      <div class="col col-invoice-payer">
                        <span>{{ invoice.payer.operatorId ? findCurrentPartnersInvoice(invoice.payer.operatorId) : invoice.payer.participant }}</span>
                      </div>
                      <div class="col col-invoice-amount"
                           @click="findCurrentTotalAmountInvoices(invoice), isLoad = true">
                        {{ numberWithCommas(invoice.totalAmountPayable) }}
                        {{ getCurrencySign(invoice.currencyType) }}
                      </div>
                      <div
                          class="col col-invoice-paid"
                          @click="openModalAmountPaid(invoice)"
                          :class="[
                          {'modal--active': invoice.status === 'PARTIALLY'},
                          {'active': (invoice.status === 'PARTIALLY' && (+invoice.totalAmount > +invoice.amountPaid))}
                        ]">
                        <template v-if="invoice.amountPaid">
                          {{ numberWithCommas(invoice.amountPaid) }}
                          {{ getCurrencySign(invoice.currencyType) }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </div>
                      <div
                          class="col col-invoice-deadline"
                          :class="{'active': invoice.status === 'SENT' && parseDate(invoice.deadline) < now}">
                        {{ parseDateToString(invoice.deadline) }}
                      </div>
                      <div class="col col-invoice-status">
                        <v-select
                            v-if="
                          (user.scope.includes('ADMIN') && (invoice.status === 'PAID')) ||
                          (user.scope.includes('ADMIN') && (invoice.status === 'PARTIALLY')) ||
                          (invoice.status === 'REFUND') ||
                          (invoice.status === 'SENT') ||
                          (invoice.status === 'CANCEL')
                          "

                            @input="selectedOption(invoice)"
                            v-model="invoice.status"
                            :options="dataSelects.statusInvoices"
                            :reduce="(item) => item.type"
                            :filterable="false"
                            :clearable="false"
                            :searchable="false"
                            label="name"
                            placeholder="Select status"
                            class="new-select"
                            :disabled="!user.scope.includes('ADMIN') && user.scope.includes('SALES') && invoice.authFormCompleted"
                        >
                          <template #open-indicator>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="8"
                                height="5"
                                viewBox="0 0 8 5"
                                fill="none">
                              <path
                                  d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                                  fill="#606060"/>
                            </svg>
                          </template>
                          <template #option="option">
                            <div class="select__item d-center">
                              <div v-if="option.type === 'PAID' || option.type === 'PARTIALLY'"
                                   class="select-trigger__circle select-trigger__circle-paid"></div>
                              <div v-if="option.type === 'REFUND'"
                                   class="select-trigger__circle select-trigger__circle-refund"></div>
                              <div v-if="option.type === 'SENT'"
                                   class="select-trigger__circle select-trigger__circle-sent"></div>
                              <div v-if="option.type === 'CANCEL'"
                                   class="select-trigger__circle select-trigger__circle-cancel"></div>
                              {{ option.name }}
                            </div>
                          </template>
                          <template #selected-option="option">
                            <div class="selected d-center">
                              <div v-if="option.type === 'PAID' || option.type === 'PARTIALLY'"
                                   class="select-trigger__circle select-trigger__circle-paid"></div>
                              <div v-if="option.type === 'REFUND'"
                                   class="select-trigger__circle select-trigger__circle-refund"></div>
                              <div v-if="option.type === 'SENT'"
                                   class="select-trigger__circle select-trigger__circle-sent"></div>
                              <div v-if="option.type === 'CANCEL'"
                                   class="select-trigger__circle select-trigger__circle-cancel"></div>
                              {{ option.name }}
                            </div>
                          </template>
                        </v-select>
                        <div class="invoice-status__disable" v-else>
                          <div class="select-trigger__circle select-trigger__circle-paid"></div>
                          <span v-if="invoice.status === 'PAID'">Paid</span>
                          <span v-if="invoice.status === 'PARTIALLY'">Partially Paid(Not for use)</span>
                        </div>
                      </div>
                      <div class="col col-invoice-date">

                        <template v-if="invoice.dateOfPayment">
                          {{ parseDateToString(invoice.dateOfPayment) }}
                        </template>
                        <template v-else>
                          -
                        </template>
                      </div>

                      <div class="col col-invoice-info">
                        <a href="#" class="col-invoice-info__link">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-info-invoices">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-info-invoices"></use>
                          </svg>
                        </a>
                        <div class="col-invoice-info__body">
                          <div class="body__header">
                            <div class="body__header-date">
                              <span>Payment Method:</span>
                              <span>{{ invoice.paymentMethod ? invoice.paymentMethod : '' }}</span>
                            </div>
                            <div class="body__header-date">
                              <span>Date of Payment:</span>
                              <span>{{ invoice.dateOfPayment ? parseDateToString(invoice.dateOfPayment) : '' }}</span>
                            </div>
                          </div>
                          <div v-if="invoice.note.length > 0" class="body">
                            <div class="body__logo">
                              <svg
                                  class="icon icon-info-invoices">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-info-invoices"></use>
                              </svg>
                              <span>Note</span>
                            </div>

                            <span>{{ invoice.note }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="col col-invoice-options">
                        <button
                            type="button"
                            class="story-templates__table__dropdown-trigger"
                            :style="{position: 'relative'}"
                            @click="openMenu(invoice.id)"
                        >
                          <svg width="1em" height="1em" class="icon icon-more">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-more"></use>
                          </svg>
                          <div class="col-invoice-options--active"
                               :class="{'edit-popup edit-popup--short': invoice.id === invoice.id}"
                               v-if="invoice.menu"
                               :style="{zIndex: 100, right: '-6px'}"
                          >
                            <div class="form-control-group">
                              <ul class="col-invoice-options__links">
                                <li>
                                  <router-link :to="{ name: 'changeInvoice', params: { id: invoice.id }}">
                                    <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-edit-invoices">
                                      <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit-invoices"></use>
                                    </svg>
                                    <span class="li-name">Edit</span>
                                  </router-link>
                                </li>
                                <li @click="openLink('/invoice/shared/' + invoice.link)">
                                                        <span class="form-control-action__icon icon--blue">
                                                          <svg width="1em" height="1em" class="icon icon-link">
                                                            <use
                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-link">
                                                              </use>
                                                          </svg>
                                                        </span>
                                  <span class="li-name">Get A Link</span>
                                </li>
                                <li>
                                  <router-link :to="{ name: 'createDublicateInvoice', params: { id: invoice.id }}">
                                    <span class="form-control-action__icon icon--orange">
                                      <svg
                                          width="1em"
                                          height="1em"
                                          class="icon icon-copy">
                                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                                      </svg>
                                    </span>
                                    <span class="li-name">Copy</span>
                                  </router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="invoices_item-no">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M16.3752 13.124C16.7204 13.124 17.0002 12.8442 17.0002 12.499C17.0002 12.1538 16.7204 11.874 16.3752 11.874H16.3748C16.0296 11.874 15.75 12.1538 15.75 12.499C15.75 12.8442 16.0301 13.124 16.3752 13.124Z"
                            fill="#77B017"/>
                        <path
                            d="M19.5002 13.124C19.8454 13.124 20.1252 12.8442 20.1252 12.499C20.1252 12.1538 19.8454 11.874 19.5002 11.874H19.4998C19.1546 11.874 18.875 12.1538 18.875 12.499C18.875 12.8442 19.1551 13.124 19.5002 13.124Z"
                            fill="#77B017"/>
                        <path
                            d="M22.6252 13.124C22.9704 13.124 23.2502 12.8442 23.2502 12.499C23.2502 12.1538 22.9704 11.874 22.6252 11.874H22.6248C22.2796 11.874 22 12.1538 22 12.499C22 12.8442 22.2801 13.124 22.6252 13.124Z"
                            fill="#77B017"/>
                        <path
                            d="M30.5016 19.6976C30.4297 19.4463 30.3201 19.211 30.1795 18.998C31.3718 17.043 32 14.8053 32 12.4995C32 5.60727 26.3927 0 19.5005 0C16.2142 0 13.2201 1.27476 10.9866 3.3558C10.5161 2.90594 9.88256 2.64333 9.21709 2.64333C9.14072 2.64333 9.06453 2.6467 8.98879 2.65345C8.30869 1.78443 7.25142 1.25945 6.13634 1.25945C4.35029 1.25945 2.86254 2.56083 2.57174 4.26533C1.52022 4.38982 0.702065 5.28672 0.702065 6.37111C0.702065 7.54038 1.6489 8.49165 2.81279 8.49165H7.6599C7.23273 9.75029 7.00099 11.0983 7.00099 12.4995C7.00099 15.0523 7.77021 17.4287 9.08903 19.4093L0.804936 27.3482C0.801748 27.3513 0.798561 27.3544 0.795436 27.3575C-0.265145 28.4181 -0.265145 30.1439 0.795436 31.2045C1.32573 31.7348 2.02232 32 2.71892 32C3.41552 32 4.11211 31.7348 4.6424 31.2045C4.64553 31.2014 4.64865 31.1982 4.65172 31.195L12.5903 22.9107C14.5711 24.2296 16.9476 24.9989 19.5005 24.9989C21.4614 24.9989 23.3366 24.5583 25.0764 23.689H29.9688C31.0888 23.689 32 22.7778 32 21.6579C32 20.7221 31.364 19.9322 30.5016 19.6976ZM2.81285 7.24164C2.34625 7.24164 1.95208 6.84297 1.95208 6.37105C1.95208 5.89101 2.34262 5.50046 2.82267 5.50046H3.14521C3.49039 5.50046 3.77019 5.22066 3.77019 4.87549C3.77019 3.57079 4.83165 2.50933 6.13634 2.50933C6.97506 2.50933 7.73403 2.93925 8.16657 3.65948C8.31107 3.90003 8.59812 4.01484 8.86854 3.94015C8.98147 3.90903 9.09872 3.89322 9.21709 3.89322C9.55439 3.89322 9.87569 4.02534 10.1157 4.25195C9.32984 5.1451 8.66918 6.15087 8.16132 7.2417H2.81285V7.24164ZM3.75431 30.325C3.18071 30.894 2.25113 30.8925 1.67934 30.3207C1.10749 29.7489 1.10605 28.8193 1.67503 28.2457L7.33767 22.819L9.18084 24.6622L3.75431 30.325ZM10.0457 23.7595L8.24026 21.9539L9.83919 20.4216C10.3606 21.0564 10.9433 21.639 11.578 22.1605L10.0457 23.7595ZM8.25101 12.4994C8.25101 6.29643 13.2975 1.24989 19.5005 1.24989C25.7035 1.24989 30.7501 6.29643 30.7501 12.4994C30.7501 14.4934 30.2285 16.4303 29.2363 18.1391C28.8783 17.9485 28.4714 17.8406 28.0425 17.8406C28.0132 17.8406 27.9839 17.8411 27.9548 17.8421C28.9674 16.2446 29.5001 14.4086 29.5001 12.4995C29.5001 6.98571 25.0143 2.4999 19.5005 2.4999C17.8801 2.4999 16.2699 2.89726 14.8439 3.64904C14.5386 3.81003 14.4215 4.18802 14.5824 4.49338C14.7434 4.79868 15.1214 4.91567 15.4268 4.75481C16.6737 4.09727 18.0824 3.74978 19.5005 3.74978C24.325 3.74978 28.2501 7.67487 28.2501 12.4994C28.2501 14.1273 27.8077 15.6942 26.9656 17.0661C26.3793 16.6762 25.6826 16.4568 24.9618 16.4568C23.1757 16.4568 21.6879 17.7583 21.3972 19.4627C20.4509 19.5747 19.6937 20.3122 19.5515 21.2491C19.5352 21.2491 19.5182 21.2491 19.5005 21.2491C14.676 21.2491 10.7509 17.324 10.7509 12.4994C10.7509 11.0812 11.0983 9.6726 11.7556 8.42597C11.9166 8.1206 11.7996 7.74262 11.4942 7.58163C11.1889 7.42063 10.8109 7.53769 10.6499 7.84299C9.89825 9.26868 9.50089 10.8789 9.50089 12.4994C9.50089 18.0132 13.9866 22.499 19.5005 22.499C19.5927 22.499 19.6691 22.4988 19.7411 22.4975C20.0147 23.0591 20.5283 23.4821 21.1467 23.6309C20.6067 23.7095 20.0575 23.749 19.5005 23.749C13.2975 23.749 8.25101 18.7024 8.25101 12.4994ZM29.9689 22.4391H21.6382C21.1716 22.4391 20.7774 22.0404 20.7774 21.5685C20.7774 21.0884 21.168 20.6979 21.648 20.6979H21.9706C22.3157 20.6979 22.5955 20.4181 22.5955 20.0729C22.5955 18.7682 23.657 17.7068 24.9617 17.7068C25.8005 17.7068 26.5594 18.1367 26.9919 18.8569C27.1364 19.0975 27.4234 19.2123 27.6939 19.1375C27.8069 19.1063 27.9241 19.0906 28.0424 19.0906C28.7227 19.0906 29.295 19.621 29.3456 20.2982C29.3699 20.6244 29.6417 20.8766 29.9688 20.8766C30.3996 20.8766 30.75 21.2271 30.75 21.6579C30.75 22.0887 30.3996 22.4391 29.9689 22.4391Z"
                            fill="#77B017"/>
                        <path
                            d="M12.8713 6.49561C13.2165 6.49561 13.4963 6.21579 13.4963 5.87061C13.4963 5.52542 13.2165 5.24561 12.8713 5.24561H12.8708C12.5257 5.24561 12.2461 5.52542 12.2461 5.87061C12.2461 6.21579 12.5261 6.49561 12.8713 6.49561Z"
                            fill="#77B017"/>
                      </svg>
                      <span class="title">No Results</span>
                      <span class="desc">There’s no invoices yet</span>
                    </div>
                  </template>

                </div>
              </div>
              <div class="invoices-bottom">
                <ul class="invoices-bottom__info">
                  <li>
                    <span>Program Total Amount:</span>$
                    {{ numberWithCommas(String(amountSummariesInvoice.programCostUSD)) }}
                  </li>
                  <li>
                    <span>Amount Paid:</span>$
                    {{ numberWithCommas(String(amountSummariesInvoice.amountPaidUSD)) }}
                  </li>
                  <li>
                    <span>Remain Balance:</span>$
                    {{ numberWithCommas(String(amountSummariesInvoice.remainBalanceUSD)) }}
                  </li>
                </ul>
                <div class="invoices-bottom__note">
                  <span class="invoices-bottom__note-title">
                    <svg width="1em" height="1em" class="icon icon-alert">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-alert"></use>
                    </svg>
                    Note
                  </span>
                  <p>
                    Please keep in mind that you are responsible for confirming
                    the payment for the tour. Please check in with the
                    operations department to ensure that the client paid the
                    remaining balance for the tour in full upon arrival in
                    Tanzania, and the payment is checked on the invoice
                    spreadsheet.
                  </p>
                </div>
                <router-link
                    v-if="data.contract"
                    :to="{ name: 'createdInvoice', params: { id: data.id }}"
                    class="btn btn--green">
                  <span>Create New Invoice</span>
                </router-link>
                <button
                    v-else
                    type="button"
                    class="btn btn--green"
                    disabled>
                  <span>Create New Invoice</span>
                </button>
              </div>
            </div>
          </div>
        </section>
        <!--id="invoices" END-->

      </div>
    </main>

    <at-modal-invoice-amount-paid v-if="IsModalInvoiceAmountPaid" :invoice="currentInvoiceModal"
                                  @closeModalInvoiceAmountPaidOptions="closeModalInvoiceAmountPaid"/>

    <at-modal-invoice-status-paid
        v-if="isModalInvoicePaid"
        :invoice="currentInvoiceModal"
        :has-client-contract="Boolean(data.contract)"
        :is-admin="isAdmin"
        @closeModalInvoiceStatusPaidOptions="closeModalInvoiceStatusPaid"
    />

    <at-modal-invoice-status-cancel v-if="false"/>

    <at-modal-invoice-status-partially-paid
        v-if="isModalInvoicePartiallyPaid"
        :invoice="currentInvoiceModal"
        :has-client-contract="Boolean(data.contract)"
        :is-admin="isAdmin"
        @closeModalInvoiceStatusPartiallyPaidOptions="closeModalInvoiceStatusPartiallyPaid"
    />

    <at-modal-invoice-total-amount
        v-if="isLoad && isModalInvoiceTotalAmount"
        :currentInvoice="currentInvoice"
        @closeModalInvoiceTotalAmountParams="closeModalInvoiceTotalAmount"
    />

    <div class="modal-wrapper" v-if="isLoad && commissionPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--commision">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div
                  class="breakdown-cost__table__commision__icon breakdown-cost__table__commision__icon-percent"
                  v-if="commissionPopup.includes('discounts')">
                <img src="/images/useful/svg/hot.svg" alt=""/>
              </div>
              <div
                  class="edit-popup__title__icon edit-popup__title__icon-bg"
                  v-else>
                $
              </div>
              <span
                  :style="{
                  marginTop: commissionPopup.includes('discounts')
                    ? '6px'
                    : '0px',
                }"
              >Edit Our
                {{
                  commissionPopup.includes('discounts')
                      ? 'Discount'
                      : 'Commission'
                }}</span
              >
            </div>
            <div class="edit-popup__close" @click="commissionPopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>

          <form action="javascript:void(0)" class="edit-popup--commision__form">
            <div class="form-control-group">
              <input
                  type="number"
                  class="form-control"
                  v-model.number="commissionPopupValue"
                  @input="
                  commissionPopupValue = $event.target.value.replace(
                    /[^0-9]/g,
                    ''
                  )
                  commissionPopupValue = commissionPopup.includes('commission')
                    ? commissionPopupValue > 50
                      ? 50
                      : commissionPopupValue
                    : commissionPopupValue > 20
                    ? 20
                    : commissionPopupValue
                "/>
              <div class="form-control-icon form-control-icon_percent">%</div>
            </div>
            <button
                type="button"
                class="btn btn--green"
                @click="
                changeComissions()
                commissionPopupValue = ''
                commissionPopup = false
                isEditFlag = true
              ">
              <span>Save</span>
            </button>
          </form>
        </div>
      </div>
    </div>
    <div
        class="modal-wrapper"
        v-if="
        isLoad &&
        participants.find((item) => item.insurancePopup) &&
        insurancePopup
      ">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--insurance">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon edit-popup__title__icon--mod">
                <svg width="1em" height="1em" class="icon icon-insurance">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-insurance"></use>
                </svg>
              </div>
              <span
              >Insurance
                <span
                >|
                  {{
                    participants.find((item) => item.insurancePopup).name
                  }}</span
                ></span
              >
            </div>
            <div
                class="edit-popup__close"
                @click="
                $emit('deleteModalHandler', {
                  entity: 'Data',
                  name: 'this',
                  handler: () => {
                    participants.find(
                      (item) => item.insurancePopup
                    ).insurance.validFrom = $refs['insuranceFrom'].value = 0
                    participants.find(
                      (item) => item.insurancePopup
                    ).insurance.validUpTo = $refs['insuranceTo'].value = 0
                    participants.find(
                      (item) => item.insurancePopup
                    ).insurance.policyNumber = ''
                    participants.find(
                      (item) => item.insurancePopup
                    ).insurance.companyName = ''
                    participants.find(
                      (item) => item.insurancePopup
                    ).insurancePopup = false
                    insurancePopup = false
                  },
                  id: null,
                })
                isEditFlag = true
              ">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>

          <form action="javascript:void(0)" class="edit-popup-insurance">
            <div class="edit-popup-insurance__add">
              <div class="edit-popup-insurance__el edit-popup-insurance__name">
                <div
                    :class="[
                    'form-control-group',
                    {'is-error': insuranseErrors.company},
                  ]">
                  <span class="form-control-label">Company name</span>
                  <div class="form-control-wrap">
                    <input
                        type="text"
                        Placeholder="Insurance company name"
                        class="form-control"
                        @focus="
                        isEditFlag = true
                        insuranseErrors.company = false
                      "
                        v-model="
                        participants.find((item) => item.insurancePopup)
                          .insurance.companyName
                      "/>
                  </div>
                </div>
              </div>
              <div
                  class="edit-popup-insurance__el edit-popup-insurance__number">
                <div
                    :class="[
                    'form-control-group',
                    {'is-error': insuranseErrors.policy},
                  ]">
                  <span class="form-control-label">Policy number</span>
                  <div class="form-control-wrap">
                    <input
                        type="text"
                        v-model="
                        participants.find((item) => item.insurancePopup)
                          .insurance.policyNumber
                      "
                        @focus="
                        isEditFlag = true
                        insuranseErrors.policy = false
                      "
                        placeholder="--- --- --- ---"
                        class="form-control maskField"/>
                  </div>
                </div>
              </div>
              <div
                  class="edit-popup-insurance__el form-control-datepicker form-control-datepicker_divider">
                <div class="form-control-group">
                  <span class="form-control-label">Valid from</span>
                  <div
                      :class="[
                      'form-control-wrap',
                      {'is-error': insuranseErrors.from},
                    ]">
                    <input
                        type="text"
                        Placeholder="Date From"
                        :ref="'insuranceFrom'"
                        @click="
                        insuranseErrors = {from: false, to: false}
                        isEditFlag = true
                      "
                        readonly
                        @blur="
                        participants.find(
                          (item) => item.insurancePopup
                        ).insurance.validFrom = $event.target.value
                      "
                        class="form-control js-datepicker-single not-input"/>
                    <div class="form-control-icon">
                      <svg width="1em" height="1em" class="icon icon-calendar">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="form-control-group">
                  <span class="form-control-label">Valid up to</span>
                  <div
                      :class="[
                      'form-control-wrap',
                      {'is-error': insuranseErrors.to},
                    ]">
                    <input
                        type="text"
                        Placeholder="Date To"
                        :ref="'insuranceTo'"
                        readonly
                        @click="
                        insuranseErrors = {from: false, to: false}
                        isEditFlag = true
                      "
                        @blur="
                        participants.find(
                          (item) => item.insurancePopup
                        ).insurance.validUpTo = $event.target.value
                      "
                        class="form-control js-datepicker-single not-input"/>
                    <div class="form-control-icon">
                      <svg width="1em" height="1em" class="icon icon-calendar">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                      </svg>
                    </div>
                  </div>
                </div>
                <span class="divider-datepicker">-</span>
              </div>
            </div>
            <div class="options-additional__btns">
              <button
                  type="button"
                  class="btn btn--silver btn_options"
                  @click="
                  $emit('deleteModalHandler', {
                    entity: 'Data',
                    name: 'this',
                    handler: () => {
                      participants.find(
                        (item) => item.insurancePopup
                      ).insurance.validFrom = $refs['insuranceFrom'].value = 0
                      participants.find(
                        (item) => item.insurancePopup
                      ).insurance.validUpTo = $refs['insuranceTo'].value = 0
                      participants.find(
                        (item) => item.insurancePopup
                      ).insurance.policyNumber = ''
                      participants.find(
                        (item) => item.insurancePopup
                      ).insurance.companyName = ''
                    },
                    id: null,
                  })
                  isEditFlag = true
                ">
                <span>Reset</span>
              </button>
              <button
                  type="submit"
                  class="btn btn--green btn--shadowed btn_options"
                  @click="
                  checkInsuranceErrors()
                    ? false
                    : (() => {
                        participants.find(
                          (item) => item.insurancePopup
                        ).insurance.validFrom = $refs['insuranceFrom'].value
                        participants.find(
                          (item) => item.insurancePopup
                        ).insurance.validUpTo = $refs['insuranceTo'].value
                        participants.find(
                          (item) => item.insurancePopup
                        ).insurancePopup = false
                        insurancePopup = false
                      })()
                  isEditFlag = true
                ">
                <span>Save</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div
        class="modal-wrapper"
        v-if="
        isLoad && participants.find((item) => item.dietaryPopup) && dietaryPopup
      ">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--dietary">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon edit-popup__title__icon--mod">
                <svg width="1em" height="1em" class="icon icon-insurance">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-dietary"></use>
                </svg>
              </div>
              <span
              >Dietary Requirements
                <span
                >|
                  {{
                    participants.find((item) => item.dietaryPopup).name
                  }}</span
                ></span
              >
            </div>
            <div
                class="edit-popup__close"
                @click="
                participants.find(
                  (item) => item.dietaryPopup
                ).dietaryPopup = false
                dietaryPopup = false
              ">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>

          <form action="javascript:void(0)" class="edit-popup-dietary">
            <div class="edit-popup-dietary__add">
              <div class="edit-popup-dietary__el edit-popup-dietary__name">
                <div class="form-control-group">
                  <span class="form-control-label">Food preferences</span>
                  <div
                      :class="[
                      'select-wrapper',
                      {
                        'is-active': participants.find(
                          (item) => item.dietaryPopup
                        ).foodPreferencesSelect,
                      },
                    ]"
                      @click="
                      isEditFlag = true
                      participants.find(
                        (item) => item.dietaryPopup
                      ).foodPreferencesSelect = !participants.find(
                        (item) => item.dietaryPopup
                      ).foodPreferencesSelect
                    ">
                    <div class="select-trigger">
                      <span class="select-trigger__name">{{
                          participants.find((item) => item.dietaryPopup)
                              .dietaryRequirements.foodPreferences || ''
                        }}</span
                      ><span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                        ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner js-scrollbar">
                        <div
                            v-for="food in dataSelects.foodPreferences"
                            :key="food.name"
                            :class="[
                            'select-option',
                            {
                              'is-selected':
                                food.name ===
                                participants.find((item) => item.dietaryPopup)
                                  .dietaryRequirements.foodPreferences,
                            },
                          ]"
                            @click="
                            participants.find(
                              (item) => item.dietaryPopup
                            ).dietaryRequirements.foodPreferences = food.name
                          ">
                          <span class="select-option__name">{{
                              food.name
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="edit-popup-dietary__allergies">
                  <div class="form-control-group">
                    <span class="form-control-label">Allergies</span>
                    <div class="val-sel-wrap">
                      <div
                          class="val-sel"
                          v-for="(all, index) in participants.find(
                          (item) => item.dietaryPopup
                        ).dietaryRequirements.allergies"
                          :key="index">
                        <span>{{ all }}</span
                        ><i
                          class="val-sel__remove"
                          @click="
                            isEditFlag = true
                            participants.find(
                              (item) => item.dietaryPopup
                            ).dietaryRequirements.allergies = participants
                              .find((item) => item.dietaryPopup)
                              .dietaryRequirements.allergies.filter(
                                (item, i) => !(i === index)
                              )
                          ">
                        <svg width="1em" height="1em" class="icon icon-close">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                        </svg>
                      </i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="edit-popup-dietary__el edit-popup-dietary__alg">
                <div class="form-control-group">
                  <span class="form-control-label">Allergies</span>
                  <div
                      class="form-control-wrap"
                      :style="{marginBottom: '1rem'}">
                    <div
                        :class="[
                        'select-wrapper select-wrapper--xl',
                        {
                          'is-active': participants.find(
                            (item) => item.dietaryPopup
                          ).alergiesSelect,
                        },
                      ]"
                        @click="
                        participants.find(
                          (item) => item.dietaryPopup
                        ).alergiesSelect = !participants.find(
                          (item) => item.dietaryPopup
                        ).alergiesSelect
                      ">
                      <div class="select-trigger">
                        <span class="select-trigger__name">{{ 'Select' }}</span
                        ><span class="select-trigger__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                      </div>
                      <div class="select-body">
                        <div class="select-inner js-scrollbar">
                          <div
                              v-for="(
                              item, index
                            ) in dataSelects.allergiesDefaults.filter(
                              (item) =>
                                !participants
                                  .find((item) => item.dietaryPopup)
                                  .dietaryRequirements.allergies.includes(item)
                            )"
                              :key="index"
                              :class="['select-option']"
                              @click="
                              isEditFlag = true
                              participants.find(
                                (item) => item.dietaryPopup
                              ).dietaryRequirements.allergies = participants
                                .find((item) => item.dietaryPopup)
                                .dietaryRequirements.allergies.concat(item)
                                .filter((all) =>
                                  item === 'No allergies'
                                    ? all === 'No allergies'
                                    : !(all === 'No allergies')
                                )
                            ">
                            <span class="select-option__name">{{ item }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-control-wrap">
                    <div class="form-control_autocomplete opened">
                      <input
                          type="text"
                          placeholder="Typing..."
                          @keydown.enter="
                          isEditFlag = true
                          $event.target.value.length > 0 &&
                          !participants
                            .find((item) => item.dietaryPopup)
                            .dietaryRequirements.allergies.includes(
                              $event.target.value
                            )
                            ? (participants.find(
                                (item) => item.dietaryPopup
                              ).dietaryRequirements.allergies = participants
                                .find((item) => item.dietaryPopup)
                                .dietaryRequirements.allergies.concat(
                                  $event.target.value
                                ))
                            : ''
                          $event.target.value = ''
                        "
                          class="form-control"/>
                      <div class="drop-auto">
                        <span
                            class="val-select"
                            v-for="(all, i) in participants.find(
                            (item) => item.dietaryPopup
                          ).dietaryRequirements.allergies"
                            :key="i"
                        >{{ all }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="options-additional__btns">
              <button
                  type="button"
                  class="btn btn--silver btn_options"
                  @click="
                  $emit('deleteModalHandler', {
                    entity: 'Data',
                    name: 'this',
                    handler: () => {
                      participants.find(
                        (item) => item.dietaryPopup
                      ).dietaryRequirements.foodPreferences = 'Regular'
                      participants.find(
                        (item) => item.dietaryPopup
                      ).dietaryRequirements.allergies = []
                    },
                    id: null,
                  })
                ">
                <span>Reset</span>
              </button>
              <button
                  type="button"
                  class="btn btn--green btn--shadowed btn_options"
                  @click="
                  participants.find(
                    (item) => item.dietaryPopup
                  ).dietaryRequirementsSaved = true
                  participants.find(
                    (item) => item.dietaryPopup
                  ).dietarySave = true
                  participants.find(
                    (item) => item.dietaryPopup
                  ).dietaryPopup = false
                  dietaryPopup = false
                ">
                <span>Save</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div
        class="modal-wrapper"
        v-if="
        isLoad && participants.find((item) => item.weddingPopup) && weddingPopup
      ">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--wedding">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon edit-popup__title__icon--mod">
                <svg width="1em" height="1em" class="icon icon-ring">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-ring"></use>
                </svg>
              </div>
              <span>Honeymooners</span>
            </div>
            <div
                class="edit-popup__close"
                @click="
                participants.find(
                  (item) => item.weddingPopup
                ).weddingPopup = false
                weddingPopup = false
              ">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="form-control-groups form-control-groups_1">
              <div class="form-control-group form-control-group_7">
                <span class="form-control-label">Wedding date:</span>
                <div class="form-control-group">
                  <div class="form-control-wrap">
                    <input
                        type="text"
                        placeholder="Date"
                        :value="
                        participants.find((item) => item.weddingPopup)
                          .weddingDate
                      "
                        @blur="
                        participants.find(
                          (item) => item.weddingPopup
                        ).weddingDate = $event.target.value
                      "
                        class="form-control js-datepicker-single"/>
                    <div class="form-control-icon">
                      <svg width="1em" height="1em" class="icon icon-calendar">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-control-group form-control-group_8">
                <span class="form-control-label">Couple with</span>
                <div
                    :class="[
                    'select-wrapper',
                    {
                      'is-active': participants.find(
                        (item) => item.weddingPopup
                      ).weddingPopupOpen,
                    },
                  ]"
                    @click="
                    participants.find(
                      (item) => item.weddingPopup
                    ).weddingPopupOpen = !participants.find(
                      (item) => item.weddingPopup
                    ).weddingPopupOpen
                  ">
                  <div class="select-trigger">
                    <span class="select-trigger__name">{{
                        participants.find(
                            (p) =>
                                p.id ===
                                participants.find((item) => item.weddingPopup)
                                    .coupleId
                        )
                            ? participants.find(
                                (p) =>
                                    p.id ===
                                    participants.find((item) => item.weddingPopup)
                                        .coupleId
                            ).name
                            : 'Name Surname'
                      }}</span
                    ><span class="select-trigger__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                      ></span>
                  </div>
                  <div class="select-body">
                    <div class="select-inner js-scrollbar">
                      <div
                          class="select-option"
                          v-for="(par, index) in participants
                          .filter((par) => par.ageType === 'adult')
                          .filter(
                            (par) =>
                              par.gender !==
                              participants.find((item) => item.weddingPopup)
                                .gender
                          )"
                          :key="index">
                        <span
                            class="select-option__name"
                            @click="
                            participants.find(
                              (item) => item.weddingPopup
                            ).coupleId = par.id
                            participants = participants.map((p) =>
                              p.id === par.id
                                ? {
                                    ...p,
                                    coupleId: participants.find(
                                      (item) => item.weddingPopup
                                    ).id,
                                    weddingDate: participants.find(
                                      (item) => item.weddingPopup
                                    ).weddingDate,
                                  }
                                : p
                            )
                          "
                        >{{ par.name }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup--choose-hotel__submit">
              <button
                  type="reset"
                  class="btn btn--silver"
                  @click="
                  participants = participants.map((item) =>
                    item.weddingPopup ||
                    item.id ===
                      participants.find((p) => p.weddingPopup).coupleId
                      ? {...item, coupleId: null, weddingDate: null}
                      : item
                  )
                  participants.find(
                    (item) => item.weddingPopup
                  ).weddingPopup = false
                  weddingPopup = false
                ">
                <span>Reset</span>
              </button>
              <button
                  type="submit"
                  class="btn btn--green"
                  @click="
                  participants = participants.map((p) =>
                    participants.find((item) => item.weddingPopup).coupleId !=
                      null &&
                    p.id ===
                      participants.find((item) => item.weddingPopup).coupleId
                      ? {
                          ...p,
                          weddingDate: participants.find(
                            (item) => item.weddingPopup
                          ).weddingDate,
                        }
                      : p
                  )
                  participants.find(
                    (item) => item.weddingPopup
                  ).weddingPopup = false
                  weddingPopup = false
                ">
                <span>Ok</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && changeDaysPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup info-popup info-popup_actions">
          <div class="edit-popup__header">
            <div class="info-title">
              <div class="info-title__icon">
                <svg width="3rem" height="3rem">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#info-actions-icon"></use>
                </svg>
              </div>
              <span class="info-title__heading">Warning</span>
            </div>
            <div class="edit-popup__close" @click="changeDaysPopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="info-popup__text">
            <p>
              You want to delete the last {{ countDeleteDays }} days from the
              itinerary, it’s will be impossible to restore it
            </p>
          </div>
          <div class="info-popup__btns">
            <button
                type="button"
                class="btn btn--silver"
                @click="
                removeDays()
                isEditFlag = true
                changeDaysPopup = false
              ">
              <span>Yes, delete it</span>
            </button>
            <button
                type="button"
                class="btn btn--green btn--shadowed"
                @click="
                isEditFlag = true
                changeDaysPopup = false
              ">
              <span>No, wait</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && flightsPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner" :style="{alignItems: 'flex-start'}">
        <div class="edit-popup edit-popup--add-flight">
          <div class="edit-popup__header edit-popup__header-flight">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon edit-popup__title__icon--mod">
                <svg
                    width=".8em"
                    height="1em"
                    class="icon icon-airplane"
                    :style="{width: '.8em'}">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                </svg>
              </div>
              <span>Add Domestic Flight</span>
            </div>
            <div class="edit-popup__close" @click="flightsPopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="edit-popup__flight-tabs">
            <div
                class="flight-tab"
                :class="isActiveFlightTab === 'REGULAR' ? 'is-active' : ''"
                @click="
              isActiveFlightTab = 'REGULAR'
                flightsPopupData.paxList = []
                    dataSelects.pointsDep = dataSelects.pointsDep.map(
                      (item) => ({...item, active: false})
                    )
                    dataSelects.pointsArr = dataSelects.pointsArr.map(
                      (item) => ({...item, active: false})
                    )
                    dataSelects.airlines = dataSelects.airlines.map((item) => ({
                      ...item,
                      active: false,
                    }))
                    dataSelects.flightsTimes = []
                    flightsPopupData.type = null
                    flightsPopupData.pax = null
                    flightsPopupData.lug = ''
                    dataSelects.flightsNetPricePrivate = null
                    dataSelects.flightsTimesPrivateStart = '--:--'
                    dataSelects.flightsTimesPrivateEnd = '--:--'
                    flightDepSelectInput = ''
                    flightArrSelectInput = ''
                    dataSelects.selectedFlight = {
                        comments: '',
                        frequency: [],
                        minPax: 0,
                      }
              ">
              Regular
            </div>
            <div
                class="flight-tab"
                :class="isActiveFlightTab === 'PRIVATE' ? 'is-active' : ''"
                @click="
                isActiveFlightTab = 'PRIVATE'
                flightsPopupData.paxList = []
                    dataSelects.pointsDep = dataSelects.pointsDep.map(
                      (item) => ({...item, active: false})
                    )
                    dataSelects.pointsArr = dataSelects.pointsArr.map(
                      (item) => ({...item, active: false})
                    )
                    dataSelects.airlines = dataSelects.airlines.map((item) => ({
                      ...item,
                      active: false,
                    }))
                    dataSelects.flightsTimes = []
                    flightsPopupData.type = null
                    flightsPopupData.pax = null
                    flightsPopupData.lug = ''
                    dataSelects.flightsNetPricePrivate = null
                    dataSelects.flightsTimesPrivateStart = '--:--'
                    dataSelects.flightsTimesPrivateEnd = '--:--'
                    flightDepSelectInput = ''
               ">
              Private
            </div>
          </div>

          <form>
            <template
                v-if="isActiveFlightTab === 'REGULAR'"
                action="javascript:void(0)"
                class="edit-popup--add-flight__form">
              <div class="edit-popup--add-flight__add">
                <div class="edit-popup--add-flight__add__col">
                  <div class="form-select-group">
                    <div class="form-control-group">
                      <span class="form-control-label">Departure:</span>
                      <div
                          :class="[
                          'select-wrapper',
                          {'is-active': selects.flightsPopup.dep},
                        ]"
                          @click="
                          isEditFlag = true
                          changeSelectsFlights('dep')
                        ">
                        <div class="select-label"><span>From</span></div>
                        <div class="select-trigger">
                          <input
                              type="text"
                              class="select-trigger__name"
                              placeholder="Select"
                              :style="{border: 'none'}"
                              v-model="flightDepSelectInput"
                              @click="selects.flightsPopup.dep = false"/>
                          <!--                        <span-->
                          <!--                          class="select-trigger__name">{{-->
                          <!--                          dataSelects.pointsDep.find(item => item.active) ? dataSelects.pointsDep.find(item => item.active).names.EN : 'Select'-->
                          <!--                        }}</span>-->
                          <span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="item in flightDepSelectOptions"
                                :key="item.id + Math.random()"
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ) &&
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ).names.EN === item.names.EN,
                                },
                              ]"
                                @click="onDepartureChecked(item)">
                              <span class="select-option__name">{{
                                  item.names.EN || ''
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-select-group__divider">
                      <svg width="1em" height="1em" class="icon icon-arrow">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow"></use>
                      </svg>
                    </div>
                    <div class="form-control-group">
                      <span class="form-control-label">Arrival:</span>
                      <div
                          :class="[
                          'select-wrapper',
                          {'is-active': selects.flightsPopup.arr},
                        ]"
                          @click="
                          changeSelectsFlights('arr')
                          isEditFlag = true
                        "
                          :style="{
                          opacity:
                            !dataSelects.pointsDep.find(
                              (item) => item.active
                            ) ||
                            !dataSelects.pointsArr.filter((item) =>
                              dataSelects.flights
                                .filter(
                                  (flight) =>
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ) &&
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ).id === flight.origin
                                )
                                .map((flight) => flight.destination)
                                .includes(item.id)
                            ).length
                              ? 0.6
                              : 1,
                          cursor:
                            !dataSelects.pointsDep.find(
                              (item) => item.active
                            ) ||
                            !dataSelects.pointsArr.filter((item) =>
                              dataSelects.flights
                                .filter(
                                  (flight) =>
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ) &&
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ).id === flight.origin
                                )
                                .map((flight) => flight.destination)
                                .includes(item.id)
                            ).length
                              ? 'default'
                              : 'pointer',
                          pointerEvents:
                            !dataSelects.pointsDep.find(
                              (item) => item.active
                            ) ||
                            !dataSelects.pointsArr.filter((item) =>
                              dataSelects.flights
                                .filter(
                                  (flight) =>
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ) &&
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ).id === flight.origin
                                )
                                .map((flight) => flight.destination)
                                .includes(item.id)
                            ).length
                              ? 'none'
                              : 'auto',
                        }">
                        <div class="select-label"><span>To</span></div>
                        <div class="select-trigger">
                          <input
                              type="text"
                              class="select-trigger__name"
                              placeholder="Select"
                              :style="{border: 'none'}"
                              v-model="flightArrSelectInput"
                              @click="selects.flightsPopup.arr = false"
                          >
                          <!--                          <span class="select-trigger__name">{{-->
                          <!--                            dataSelects.pointsArr.find((item) => item.active)-->
                          <!--                              ? dataSelects.pointsArr.find(-->
                          <!--                                  (item) => item.active-->
                          <!--                                ).names.EN-->
                          <!--                              : 'Select'-->
                          <!--                          }}</span>-->
                          <span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="item in flightArrSelectOptions
                                .filter((item) =>
                                  dataSelects.flights
                                    .filter(
                                      (flight) =>
                                        dataSelects.pointsDep.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.pointsDep.find(
                                          (item) => item.active
                                        ).id === flight.origin
                                    )
                                    .map((flight) => flight.destination)
                                    .includes(item.id)
                                )
                                .map((point, _, arr) => ({
                                  ...point,
                                  active: arr.length === 1,
                                }))"

                                :key="item.id + Math.random()"
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    dataSelects.pointsArr.find(
                                      (item) => item.active
                                    ) &&
                                    dataSelects.pointsArr.find(
                                      (item) => item.active
                                    ).names.EN === item.names.EN,
                                },
                              ]"
                                @click="onArrivalChecked(item)">
                              <span class="select-option__name">{{
                                  item.names.EN || ''
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="edit-popup--add-flight__add__col">
                  <div class="form-control-group">
                    <span class="form-control-label">Airlines</span>
                    <div
                        :class="[
                        'select-wrapper',
                        {'is-active': selects.flightsPopup.air},
                      ]"
                        @click="
                        changeSelectsFlights('air')
                        isEditFlag = true
                      "
                        :style="{
                        opacity:
                          !dataSelects.pointsDep.find((item) => item.active) ||
                          !dataSelects.pointsArr.find((item) => item.active) ||
                          !dataSelects.airlines.filter((item) =>
                            dataSelects.flights
                              .filter(
                                (flight) =>
                                  dataSelects.pointsDep.find(
                                    (item) => item.active
                                  ) &&
                                  dataSelects.pointsDep.find(
                                    (item) => item.active
                                  ).id === flight.origin &&
                                  dataSelects.pointsArr.find(
                                    (item) => item.active
                                  ) &&
                                  dataSelects.pointsArr.find(
                                    (item) => item.active
                                  ).id === flight.destination
                              )
                              .map((flight) => flight.companyId)
                              .includes(item.id)
                          ).length
                            ? 0.6
                            : 1,
                        cursor:
                          !dataSelects.pointsDep.find((item) => item.active) ||
                          !dataSelects.pointsArr.find((item) => item.active) ||
                          !dataSelects.airlines.filter((item) =>
                            dataSelects.flights
                              .filter(
                                (flight) =>
                                  dataSelects.pointsDep.find(
                                    (item) => item.active
                                  ) &&
                                  dataSelects.pointsDep.find(
                                    (item) => item.active
                                  ).id === flight.origin &&
                                  dataSelects.pointsArr.find(
                                    (item) => item.active
                                  ) &&
                                  dataSelects.pointsArr.find(
                                    (item) => item.active
                                  ).id === flight.destination
                              )
                              .map((flight) => flight.companyId)
                              .includes(item.id)
                          ).length
                            ? 'default'
                            : 'pointer',
                        pointerEvents: !dataSelects.airlines.filter((item) =>
                          dataSelects.flights
                            .filter(
                              (flight) =>
                                dataSelects.pointsDep.find(
                                  (item) => item.active
                                ) &&
                                dataSelects.pointsDep.find(
                                  (item) => item.active
                                ).id === flight.origin &&
                                dataSelects.pointsArr.find(
                                  (item) => item.active
                                ) &&
                                dataSelects.pointsArr.find(
                                  (item) => item.active
                                ).id === flight.destination
                            )
                            .map((flight) => flight.companyId)
                            .includes(item.id)
                        ).length
                          ? 'none'
                          : 'auto',
                      }">
                      <div class="select-trigger">
                        <span class="select-trigger__name">{{
                            dataSelects.airlines.find((item) => item.active)
                                ? dataSelects.airlines.find((item) => item.active)
                                    .name
                                : 'Select'
                          }}</span
                        ><span class="select-trigger__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                      </div>
                      <div class="select-body">
                        <div class="select-inner js-scrollbar">
                          <div
                              v-for="item in dataSelects.airlines.filter((item) =>
                              dataSelects.flights
                                .filter(
                                  (flight) =>
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ) &&
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ).id === flight.origin &&
                                    dataSelects.pointsArr.find(
                                      (item) => item.active
                                    ) &&
                                    dataSelects.pointsArr.find(
                                      (item) => item.active
                                    ).id === flight.destination
                                )
                                .map((flight) => flight.companyId)
                                .includes(item.id)
                            )"
                              :key="item.id + Math.random()"
                              :class="[
                              'select-option',
                              {
                                'is-selected':
                                  dataSelects.airlines.find(
                                    (item) => item.active
                                  ) &&
                                  dataSelects.airlines.find(
                                    (item) => item.active
                                  ).name === item.name,
                              },
                            ]"
                              @click="
                              dataSelects.airlines = dataSelects.airlines.map(
                                (point) => ({
                                  ...point,
                                  active: point.id === item.id,
                                })
                              );
                              dataSelects.flights.filter(
                                (flight) =>
                                  dataSelects.pointsDep.find((pt) => pt.active)
                                    .id === flight.origin &&
                                  dataSelects.pointsArr.find((pt) => pt.active)
                                    .id === flight.destination &&
                                  item.id === flight.companyId
                              ).length === 1
                                ? (dataSelects.flightsTimes = [
                                    {
                                      name: dataSelects.flights.find(
                                        (flight) =>
                                          dataSelects.pointsDep.find(
                                            (pt) => pt.active
                                          ).id === flight.origin &&
                                          dataSelects.pointsArr.find(
                                            (pt) => pt.active
                                          ).id === flight.destination &&
                                          item.id === flight.companyId
                                      ).departureTime,
                                      active: true,
                                    },
                                  ])
                                : (dataSelects.flightsTimes =
                                    dataSelects.flights
                                      .filter(
                                        (flight) =>
                                          dataSelects.pointsDep.find(
                                            (item) => item.active
                                          ) &&
                                          dataSelects.pointsDep.find(
                                            (item) => item.active
                                          ).id === flight.origin &&
                                          dataSelects.pointsArr.find(
                                            (item) => item.active
                                          ) &&
                                          dataSelects.pointsArr.find(
                                            (item) => item.active
                                          ).id === flight.destination &&
                                          dataSelects.airlines.find(
                                            (item) => item.active
                                          ) &&
                                          dataSelects.airlines.find(
                                            (item) => item.active
                                          ).id === flight.companyId
                                      )
                                      .map((flight, index) => ({
                                        name: flight.departureTime,
                                        active: index === 0,
                                      })));
                                      fillSelectedFlight();
                            ">
                            <span class="select-option__name">{{
                                item.name
                              }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="edit-popup--add-flight__add__col">
                  <div class="form-select-group">
                    <div class="form-control-group">
                      <span class="form-control-label">Departure Time:</span>
                      <div
                          :class="[
                          'select-wrapper select-wrapper--xs',
                          {'is-active': selects.flightsPopup.depTime},
                        ]"
                          @click="
                          changeSelectsFlights('depTime')
                          isEditFlag = true
                        "
                          :style="{
                          opacity: !dataSelects.airlines.find(
                            (item) => item.active
                          )
                            ? 0.6
                            : 1,
                          cursor: !dataSelects.airlines.find(
                            (item) => item.active
                          )
                            ? 'default'
                            : 'pointer',
                          pointerEvents: !dataSelects.airlines.find(
                            (item) => item.active
                          )
                            ? 'none'
                            : 'auto',
                        }">
                        <div class="select-trigger">
                          <span class="select-trigger__name">{{
                              dataSelects.flightsTimes.find((item) => item.active)
                                  ? dataSelects.flightsTimes
                                      .find((item) => item.active)
                                      .name.substring(0, 2) +
                                  ':' +
                                  dataSelects.flightsTimes
                                      .find((item) => item.active)
                                      .name.substring(
                                      dataSelects.flightsTimes.find(
                                          (item) => item.active
                                      ).name.length - 2
                                  )
                                  : 'Select'
                            }}</span
                          ><span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="(item, index) in dataSelects.flightsTimes"
                                :key="index"
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    dataSelects.flightsTimes.find(
                                      (item) => item.active
                                    ) &&
                                    dataSelects.flightsTimes.find(
                                      (item) => item.active
                                    ).name === item.name,
                                },
                              ]"
                                @click="
                                dataSelects.flightsTimes =
                                  dataSelects.flightsTimes.map((point, i) => ({
                                    ...point,
                                    active: index === i,
                                  }))
                                  fillSelectedFlight();
                              ">
                              <span class="select-option__name"
                              >{{ item.name.substring(0, 2) }}:{{
                                  item.name.substring(item.name.length - 2)
                                }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                        class="form-select-group__divider form-select-group__divider--mod">
                      <svg width="1em" height="1em" class="icon icon-arrow">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow"></use>
                      </svg>
                    </div>
                    <div class="form-control-group">
                      <span class="form-control-label">Arrival Time:</span>
                      <div class="form-control-wrap">
                        <input
                            type="text"
                            mask="29:59"
                            Placeholder="--:--"
                            :value="
                            dataSelects.flights.find(
                              (flight) =>
                                dataSelects.pointsDep.find(
                                  (item) => item.active
                                ) &&
                                dataSelects.pointsDep.find(
                                  (item) => item.active
                                ).id === flight.origin &&
                                dataSelects.pointsArr.find(
                                  (item) => item.active
                                ) &&
                                dataSelects.pointsArr.find(
                                  (item) => item.active
                                ).id === flight.destination &&
                                dataSelects.airlines.find(
                                  (item) => item.active
                                ) &&
                                dataSelects.airlines.find((item) => item.active)
                                  .id === flight.companyId &&
                                dataSelects.flightsTimes.find(
                                  (item) => item.active
                                ) &&
                                dataSelects.flightsTimes.find(
                                  (item) => item.active
                                ).name === flight.departureTime
                            )
                              ? dataSelects.flights
                                  .find(
                                    (flight) =>
                                      dataSelects.pointsDep.find(
                                        (item) => item.active
                                      ) &&
                                      dataSelects.pointsDep.find(
                                        (item) => item.active
                                      ).id === flight.origin &&
                                      dataSelects.pointsArr.find(
                                        (item) => item.active
                                      ) &&
                                      dataSelects.pointsArr.find(
                                        (item) => item.active
                                      ).id === flight.destination &&
                                      dataSelects.airlines.find(
                                        (item) => item.active
                                      ) &&
                                      dataSelects.airlines.find(
                                        (item) => item.active
                                      ).id === flight.companyId &&
                                      dataSelects.flightsTimes.find(
                                        (item) => item.active
                                      ) &&
                                      dataSelects.flightsTimes.find(
                                        (item) => item.active
                                      ).name === flight.departureTime
                                  )
                                  .arrivalTime.substring(0, 2) +
                                ':' +
                                dataSelects.flights
                                  .find(
                                    (flight) =>
                                      dataSelects.pointsDep.find(
                                        (item) => item.active
                                      ) &&
                                      dataSelects.pointsDep.find(
                                        (item) => item.active
                                      ).id === flight.origin &&
                                      dataSelects.pointsArr.find(
                                        (item) => item.active
                                      ) &&
                                      dataSelects.pointsArr.find(
                                        (item) => item.active
                                      ).id === flight.destination &&
                                      dataSelects.airlines.find(
                                        (item) => item.active
                                      ) &&
                                      dataSelects.airlines.find(
                                        (item) => item.active
                                      ).id === flight.companyId &&
                                      dataSelects.flightsTimes.find(
                                        (item) => item.active
                                      ) &&
                                      dataSelects.flightsTimes.find(
                                        (item) => item.active
                                      ).name === flight.departureTime
                                  )
                                  .arrivalTime.substring(
                                    dataSelects.flights.find(
                                      (flight) =>
                                        dataSelects.pointsDep.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.pointsDep.find(
                                          (item) => item.active
                                        ).id === flight.origin &&
                                        dataSelects.pointsArr.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.pointsArr.find(
                                          (item) => item.active
                                        ).id === flight.destination &&
                                        dataSelects.airlines.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.airlines.find(
                                          (item) => item.active
                                        ).id === flight.companyId &&
                                        dataSelects.flightsTimes.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.flightsTimes.find(
                                          (item) => item.active
                                        ).name === flight.departureTime
                                    ).arrivalTime.length - 2
                                  )
                              : ''
                          "
                            readonly=""
                            class="form-control form-control-time maskField"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="edit-popup--add-flight__add__col">
                  <div
                      class="form-control-group form-control-group--persons form-control-group--residence">
                    <span class="form-control-label">Type:</span>

                    <div class="form-control-group--persons__col">
                      <div class="form-control-group--persons__col__info">
                        <svg
                            width="1em"
                            height="1em"
                            :class="
                            'icon icon-' +
                            (flightsPopupData.type
                              ? flightsPopupData.type.name.toLowerCase()
                              : 'adult')
                          ">
                          <use
                              :xlink:href="
                              '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                              (flightsPopupData.type
                                ? flightsPopupData.type.name.toLowerCase()
                                : 'adult')
                            "></use>
                        </svg>
                      </div>
                      <div
                          :class="[
                          'select-wrapper',
                          {'is-active': selects.flightsPopup.type},
                        ]"
                          @click="changeSelectsFlights('type')">
                        <div class="select-trigger">
                          <span class="select-trigger__name">{{
                              flightsPopupData.type
                                  ? flightsPopupData.type.name
                                  : 'Select'
                            }}</span
                          ><span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-if="
                                participants.find(
                                  (par) => par.ageType === 'adult'
                                )
                              "
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    flightsPopupData.type &&
                                    flightsPopupData.type.name === 'Adult',
                                },
                              ]"
                                @click="
                                flightsPopupData.type = {
                                  name: 'Adult',
                                  icon: 'adult',
                                }
                              ">
                              <span class="select-option__name">Adult</span>
                            </div>
                            <div
                                v-if="
                                participants.find(
                                  (par) => par.ageType === 'teenager'
                                )
                              "
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    flightsPopupData.type &&
                                    flightsPopupData.type.name === 'Teenager',
                                },
                              ]"
                                @click="
                                flightsPopupData.type = {
                                  name: 'Teenager',
                                  icon: 'teenager',
                                }
                              ">
                              <span class="select-option__name">Teenager</span>
                            </div>
                            <div
                                v-if="
                                participants.find(
                                  (par) => par.ageType === 'child'
                                )
                              "
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    flightsPopupData.type &&
                                    flightsPopupData.type.name === 'Child',
                                },
                              ]"
                                @click="
                                flightsPopupData.type = {
                                  name: 'Child',
                                  icon: 'child',
                                }
                              ">
                              <span class="select-option__name">Child</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="edit-popup--add-flight__add__col">
                  <div class="form-control-group form-control-group--luggage">
                    <span class="form-control-label">Luggage:</span>
                    <div
                        :class="[
                        'select-wrapper',
                        {'is-active': selects.flightsPopup.lug},
                      ]"
                        @click="changeSelectsFlights('lug')">
                      <div class="select-trigger">
                        <span class="select-trigger__name">{{
                            flightsPopupData.lug || '-kg'
                          }}</span
                        ><span class="select-trigger__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                      </div>
                      <div class="select-body">
                        <div class="select-inner js-scrollbar">
                          <div
                              :class="[
                              'select-option',
                              {'is-selected': flightsPopupData.lug === '15kg'},
                            ]"
                              @click="flightsPopupData.lug = '15kg'">
                            <span class="select-option__name">15kg</span>
                          </div>
                          <div
                              :class="[
                              'select-option',
                              {'is-selected': flightsPopupData.lug === '30kg'},
                            ]"
                              @click="flightsPopupData.lug = '30kg'">
                            <span class="select-option__name">30kg</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="edit-popup--add-flight__add__col">
                  <div class="form-control-group form-control-group--pax">
                    <span class="form-control-label">Pax:</span>
                    <div
                        :class="[
                        'select-wrapper',
                        {
                          'is-active':
                            selects.flightsPopup.pax && flightsPopupData.type,
                        },
                      ]"
                        @click="changeSelectsFlights('pax')"
                        :style="{
                        opacity:
                          !participants.length ||
                          !(
                            participants.length -
                            flightsPopupData.paxList.length
                          )
                            ? 0.6
                            : 1,
                        cursor:
                          !participants.length ||
                          !(
                            participants.length -
                            flightsPopupData.paxList.length
                          )
                            ? 'default'
                            : 'pointer',
                        pointerEvents:
                          !participants.length ||
                          !(
                            participants.length -
                            flightsPopupData.paxList.length
                          )
                            ? 'none'
                            : 'auto',
                      }">
                      <div class="select-trigger">
                        <span class="select-trigger__name">{{
                            flightsPopupData.pax || '-'
                          }}</span
                        ><span class="select-trigger__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                      </div>
                      <div
                          class="select-body"
                          v-if="flightsPopupData.type != null">
                        <div class="select-inner js-scrollbar">
                          <div
                              v-for="pax in Array(
                              flightsPopupData.paxList
                                ? participants.filter(
                                    (par) =>
                                      par.ageType === flightsPopupData.type.icon
                                  ).length -
                                    flightsPopupData.paxList.filter(
                                      (par) =>
                                        par.icon === flightsPopupData.type.icon
                                    ).length
                                : participants.filter(
                                    (par) =>
                                      par.ageType === flightsPopupData.type.icon
                                  ).length
                            )
                              .fill(true)
                              .map((_, i) => i + 1)"
                              :key="pax"
                              :class="[
                              'select-option',
                              {'is-selected': pax === flightsPopupData.pax},
                            ]"
                              @click="flightsPopupData.pax = pax">
                            <span class="select-option__name">{{ pax }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                        type="button"
                        class="btn btn--rounded btn--add"
                        :class="{
                        'btn--disabled':
                          !flightsPopupData.type ||
                          !flightsPopupData.lug ||
                          !flightsPopupData.pax ||
                          flightsPopupData.paxList.length ===
                            participants.length,
                      }"
                        :disabled="
                        !flightsPopupData.type ||
                        !flightsPopupData.lug ||
                        !flightsPopupData.pax ||
                        flightsPopupData.paxList.length === participants.length
                      "
                        @click="
                        flightsPopupData.paxList =
                          flightsPopupData.paxList.concat(
                            Array(+flightsPopupData.pax).fill({
                              ...flightsPopupData.type,
                              lug: flightsPopupData.lug,
                            })
                          )
                        flightsPopupData.type = null
                        flightsPopupData.lug = null
                        flightsPopupData.pax = null
                      ">
                      <svg
                          width="1em"
                          height="1em"
                          class="icon icon-plus-o-white"
                          :style="{color: '#77B017'}">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                      </svg>
                      <span>Add</span>
                    </button>
                  </div>
                </div>

                <div class="edit-popup--add-flight__pax">
                  <div class="edit-popup--add-flight__pax-info">
                    <span>Total Pax:</span>
                    <p
                        v-if="
                        flightsPopupData.paxList.filter(
                          (item) => item.icon === 'adult' && item.lug === '15kg'
                        ).length
                      ">
                      <svg width="1em" height="1em" class="icon icon-adult">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                      </svg>
                      {{
                        flightsPopupData.paxList.filter(
                            (item) => item.icon === 'adult' && item.lug === '15kg'
                        ).length
                      }}
                      Adult{{
                        flightsPopupData.paxList.filter(
                            (item) => item.icon === 'adult' && item.lug === '15kg'
                        ).length > 1
                            ? 's'
                            : ''
                      }}
                      15kg
                    </p>
                    <p
                        v-if="
                        flightsPopupData.paxList.filter(
                          (item) => item.icon === 'adult' && item.lug === '30kg'
                        ).length
                      ">
                      <svg width="1em" height="1em" class="icon icon-adult">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                      </svg>
                      {{
                        flightsPopupData.paxList.filter(
                            (item) => item.icon === 'adult' && item.lug === '30kg'
                        ).length
                      }}
                      Adult{{
                        flightsPopupData.paxList.filter(
                            (item) => item.icon === 'adult' && item.lug === '30kg'
                        ).length > 1
                            ? 's'
                            : ''
                      }}
                      30kg
                    </p>
                    <p
                        v-if="
                        flightsPopupData.paxList.filter(
                          (item) =>
                            item.icon === 'teenager' && item.lug === '15kg'
                        ).length
                      ">
                      <svg width="1em" height="1em" class="icon icon-teenager">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                      </svg>
                      {{
                        flightsPopupData.paxList.filter(
                            (item) =>
                                item.icon === 'teenager' && item.lug === '15kg'
                        ).length
                      }}
                      Teenager{{
                        flightsPopupData.paxList.filter(
                            (item) =>
                                item.icon === 'teenager' && item.lug === '15kg'
                        ).length > 1
                            ? 's'
                            : ''
                      }}
                      15kg
                    </p>
                    <p
                        v-if="
                        flightsPopupData.paxList.filter(
                          (item) =>
                            item.icon === 'teenager' && item.lug === '30kg'
                        ).length
                      ">
                      <svg width="1em" height="1em" class="icon icon-teenager">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                      </svg>
                      {{
                        flightsPopupData.paxList.filter(
                            (item) =>
                                item.icon === 'teenager' && item.lug === '30kg'
                        ).length
                      }}
                      Teenager{{
                        flightsPopupData.paxList.filter(
                            (item) =>
                                item.icon === 'teenager' && item.lug === '30kg'
                        ).length > 1
                            ? 's'
                            : ''
                      }}
                      30kg
                    </p>
                    <p
                        v-if="
                        flightsPopupData.paxList.filter(
                          (item) => item.icon === 'child' && item.lug === '15kg'
                        ).length
                      ">
                      <svg width="1em" height="1em" class="icon icon-child">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                      </svg>
                      {{
                        flightsPopupData.paxList.filter(
                            (item) => item.icon === 'child' && item.lug === '15kg'
                        ).length
                      }}
                      Child{{
                        flightsPopupData.paxList.filter(
                            (item) => item.icon === 'child' && item.lug === '15kg'
                        ).length > 1
                            ? 'ren'
                            : ''
                      }}
                      15kg
                    </p>
                    <p
                        v-if="
                        flightsPopupData.paxList.filter(
                          (item) => item.icon === 'child' && item.lug === '30kg'
                        ).length
                      ">
                      <svg width="1em" height="1em" class="icon icon-child">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                      </svg>
                      {{
                        flightsPopupData.paxList.filter(
                            (item) => item.icon === 'child' && item.lug === '30kg'
                        ).length
                      }}
                      Child{{
                        flightsPopupData.paxList.filter(
                            (item) => item.icon === 'child' && item.lug === '30kg'
                        ).length > 1
                            ? 'ren'
                            : ''
                      }}
                      30kg
                    </p>
                  </div>
                  <div
                      class="edit-popup--add-flight__pax-remove"
                      @click="flightsPopupData.paxList = []">
                    <button type="button" class="btn btn--remove">
                      <svg width="1em" height="1em" class="icon icon-close">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                      </svg>
                    </button>
                    <span>Clear pax</span>
                  </div>
                </div>
                <div class="edit-popup--add-flight__add__radio">
                  <div class="form-control-group form-control-group--radio">
                    <label
                        class="form-control-radio"
                        @click="flightsPopupData.timeActivity = false">
                      <input
                          type="radio"
                          name="activity_radio"
                          :checked="!flightsPopupData.timeActivity"/><span
                        class="form-control-radio__box"></span
                    ><span class="form-control-radio__name"
                    >Before the Activity</span
                    >
                    </label>
                    <label
                        class="form-control-radio"
                        @click="flightsPopupData.timeActivity = true">
                      <input
                          type="radio"
                          name="activity_radio"
                          :checked="flightsPopupData.timeActivity"/><span
                        class="form-control-radio__box"></span
                    ><span class="form-control-radio__name"
                    >After the Activity</span
                    >
                    </label>
                  </div>
                </div>
                <div class="edit-popup--add-flight__add__submit">
                  <button
                      type="button"
                      class="btn btn--rounded2 btn--green btn--add"
                      :disabled="
                      !dataSelects.pointsDep.find((item) => item.active) ||
                      !dataSelects.pointsArr.find((item) => item.active) ||
                      !dataSelects.airlines.find((item) => item.active) ||
                      !dataSelects.flightsTimes.find((item) => item.active) ||
                      !flightsPopupData.paxList.length
                    "
                      @click="
                      flightsPopupData.flightsData.find(
                        (itemData) =>
                          itemData.comId ===
                            dataSelects.airlines.find((item) => item.active)
                              .id &&
                          itemData.depId ===
                            dataSelects.pointsDep.find((item) => item.active)
                              .id &&
                          itemData.arrId ===
                            dataSelects.pointsArr.find((item) => item.active)
                              .id &&
                          itemData.timeActivity ===
                            flightsPopupData.timeActivity &&
                          itemData.depTime ===
                            (dataSelects.flightsTimes.find(
                              (item) => item.active
                            )
                              ? dataSelects.flightsTimes
                                  .find((item) => item.active)
                                  .name.slice(0, 2) +
                                ':' +
                                dataSelects.flightsTimes
                                  .find((item) => item.active)
                                  .name.slice(2, 5)
                              : '')
                      )
                        ? (flightsPopupData.flightsData =
                            flightsPopupData.flightsData.map((itemData) =>
                              itemData.comId ===
                                dataSelects.airlines.find((item) => item.active)
                                  .id &&
                              itemData.depId ===
                                dataSelects.pointsDep.find(
                                  (item) => item.active
                                ).id &&
                              itemData.arrId ===
                                dataSelects.pointsArr.find(
                                  (item) => item.active
                                ).id &&
                              itemData.timeActivity ===
                                flightsPopupData.timeActivity &&
                              itemData.depTime ===
                                (dataSelects.flightsTimes.find(
                                  (item) => item.active
                                )
                                  ? dataSelects.flightsTimes
                                      .find((item) => item.active)
                                      .name.slice(0, 2) +
                                    ':' +
                                    dataSelects.flightsTimes
                                      .find((item) => item.active)
                                      .name.slice(2, 5)
                                  : '')
                                ? {
                                    ...itemData,
                                    paxList: itemData.paxList.concat(
                                      flightsPopupData.paxList
                                    ),
                                    clients: itemData.clients.concat(
                                      flightsPopupData.paxList.map((item) => ({
                                        ...item,
                                        name: '',
                                        isOpen: false,
                                        ageType: item.name.toLowerCase(),
                                        type: item.name + ' ' + item.lug,
                                        id: '',
                                      }))
                                    ),
                                  }
                                : itemData
                            ))
                        : (flightsPopupData.flightsData =
                            flightsPopupData.flightsData.concat({
                              airline: dataSelects.airlines.find(
                                (item) => item.active
                              ).name,
                              day: flightsPopup.day,
                              type: isActiveFlightTab,
                              date: flightsPopup.date,
                              timeActivity: flightsPopupData.timeActivity,
                              dep: dataSelects.pointsDep.find(
                                (item) => item.active
                              ).names.EN,
                              arr: dataSelects.pointsArr.find(
                                (item) => item.active
                              ).names.EN,
                              depId: dataSelects.pointsDep.find(
                                (item) => item.active
                              ).id,
                              arrId: dataSelects.pointsArr.find(
                                (item) => item.active
                              ).id,
                              comId: dataSelects.airlines.find(
                                (item) => item.active
                              ).id,
                              depTime: dataSelects.flightsTimes.find(
                                (item) => item.active
                              )
                                ? dataSelects.flightsTimes
                                    .find((item) => item.active)
                                    .name.slice(0, 2) +
                                  ':' +
                                  dataSelects.flightsTimes
                                    .find((item) => item.active)
                                    .name.slice(2, 5)
                                : '',
                              arrTime: dataSelects.flights.find(
                                (flight) =>
                                  dataSelects.pointsDep.find(
                                    (item) => item.active
                                  ) &&
                                  dataSelects.pointsDep.find(
                                    (item) => item.active
                                  ).id === flight.origin &&
                                  dataSelects.pointsArr.find(
                                    (item) => item.active
                                  ) &&
                                  dataSelects.pointsArr.find(
                                    (item) => item.active
                                  ).id === flight.destination &&
                                  dataSelects.airlines.find(
                                    (item) => item.active
                                  ) &&
                                  dataSelects.airlines.find(
                                    (item) => item.active
                                  ).id === flight.companyId &&
                                  dataSelects.flightsTimes.find(
                                    (item) => item.active
                                  ) &&
                                  dataSelects.flightsTimes.find(
                                    (item) => item.active
                                  ).name === flight.departureTime
                              )
                                ? dataSelects.flights
                                    .find(
                                      (flight) =>
                                        dataSelects.pointsDep.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.pointsDep.find(
                                          (item) => item.active
                                        ).id === flight.origin &&
                                        dataSelects.pointsArr.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.pointsArr.find(
                                          (item) => item.active
                                        ).id === flight.destination &&
                                        dataSelects.airlines.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.airlines.find(
                                          (item) => item.active
                                        ).id === flight.companyId &&
                                        dataSelects.flightsTimes.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.flightsTimes.find(
                                          (item) => item.active
                                        ).name === flight.departureTime
                                    )
                                    .arrivalTime.slice(0, 2) +
                                  ':' +
                                  dataSelects.flights
                                    .find(
                                      (flight) =>
                                        dataSelects.pointsDep.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.pointsDep.find(
                                          (item) => item.active
                                        ).id === flight.origin &&
                                        dataSelects.pointsArr.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.pointsArr.find(
                                          (item) => item.active
                                        ).id === flight.destination &&
                                        dataSelects.airlines.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.airlines.find(
                                          (item) => item.active
                                        ).id === flight.companyId &&
                                        dataSelects.flightsTimes.find(
                                          (item) => item.active
                                        ) &&
                                        dataSelects.flightsTimes.find(
                                          (item) => item.active
                                        ).name === flight.departureTime
                                    )
                                    .arrivalTime.slice(2, 5)
                                : '',
                              clients: flightsPopupData.paxList.map(
                                (item, index) => ({
                                  ...item,
                                  name:
                                    participants.length <= 2
                                      ? participants[index].name
                                      : '',
                                  isOpen: false,
                                  ageType: item.name.toLowerCase(),
                                  type: item.name + ' ' + item.lug,
                                  id:
                                    participants.length <= 2
                                      ? participants[index].id
                                      : '',
                                })
                              ),
                              paxList: flightsPopupData.paxList,
                              flightId: dataSelects.flights.find(
                                (flight) =>
                                  flight.origin ===
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ).id &&
                                  flight.destination ===
                                    dataSelects.pointsArr.find(
                                      (item) => item.active
                                    ).id &&
                                  flight.departureTime ===
                                    dataSelects.flightsTimes.find(
                                      (item) => item.active
                                    ).name &&
                                  flight.companyId ===
                                    dataSelects.airlines.find(
                                      (item) => item.active
                                    ).id
                              ).id,
                            }))
                      flightsPopupData.paxList = []
                      isEditFlag = true
                    ">
                    <svg
                        width="1em"
                        height="1em"
                        class="icon icon-plus-o-white">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                    </svg>
                    <span>Add flight</span>
                  </button>
                </div>
                <div class="flights__additional-info">
                  <div>
                    <div class="flights__additional-info__name" v-if="dataSelects.selectedFlight.minPax > 0">
                      <div class="flights__additional-info--bold">MIN PAX:</div>
                      <div>{{ dataSelects.selectedFlight.minPax }}</div>
                      <div class="flights__additional-info__icon" v-if="dataSelects.selectedFlight.minPax > 1">
                        <svg width="1em" height="1em" class="icon icon-fire">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fire"></use>
                        </svg>
                      </div>
                    </div>
                    <div class="flights__additional-info__name flights__additional-info__name--second"
                         v-if="dataSelects.selectedFlight.frequency.length">
                      <div class="flights__additional-info--bold">FREQUENCY:</div>
                      <div>{{ dataSelects.selectedFlight.frequency.join(', ') }}</div>
                    </div>
                  </div>
                  <div>
                    <div class="flights__additional-info__name" v-if="dataSelects.selectedFlight.comments">
                      <div class="flights__additional-info--bold">COMMENT:</div>
                      <div>{{ dataSelects.selectedFlight.comments }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <!--edit-popup--add-flight__form end-->
            <!--edit-popup--add-flight__form PRIVATE start-->
            <template
                v-if="isActiveFlightTab === 'PRIVATE'"
                action="javascript:void(0)"
                class="edit-popup--add-flight__form">
              <div class="edit-popup--add-flight__add">
                <!--Departure: PRIVATE start -->
                <div class="edit-popup--add-flight__add__col">
                  <div class="form-select-group">
                    <div class="form-control-group">
                      <span class="form-control-label">Departure:</span>
                      <div
                          :class="[
                          'select-wrapper',
                          {'is-active': selects.flightsPopup.dep},
                        ]"
                          @click="
                          isEditFlag = true
                          changeSelectsFlights('dep')
                        ">
                        <div class="select-label"><span>From</span></div>
                        <div class="select-trigger">
                          <input
                              type="text"
                              class="select-trigger__name"
                              placeholder="Select"
                              :style="{border: 'none'}"
                              v-model="flightDepSelectInput"
                              @click="selects.flightsPopup.dep = false"/>
                          <!--                        <span-->
                          <!--                          class="select-trigger__name">{{-->
                          <!--                          dataSelects.pointsDep.find(item => item.active) ? dataSelects.pointsDep.find(item => item.active).names.EN : 'Select'-->
                          <!--                        }}</span>-->
                          <span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="item in flightDepSelectOptions"
                                :key="item.id + Math.random()"
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ) &&
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ).names.EN === item.names.EN,
                                },
                              ]"
                                @click="onDepartureChecked(item)">
                              <span class="select-option__name">{{
                                  item.names.EN || ''
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-select-group__divider">
                      <svg width="1em" height="1em" class="icon icon-arrow">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow"></use>
                      </svg>
                    </div>
                    <div class="form-control-group">
                      <span class="form-control-label">Arrival:</span>
                      <div
                          :class="[
                          'select-wrapper',
                          {'is-active': selects.flightsPopup.arr},
                        ]"
                          @click="
                          changeSelectsFlights('arr')
                          isEditFlag = true
                        "
                      >
                        <div class="select-label"><span>To</span></div>
                        <div class="select-trigger">
                          <input
                              type="text"
                              class="select-trigger__name"
                              placeholder="Select"
                              :style="{border: 'none'}"
                              v-model="flightArrSelectInput"
                              @click="selects.flightsPopup.arr = false"
                          >
                          <!--                          <span class="select-trigger__name">{{-->
                          <!--                            dataSelects.pointsArr.find((item) => item.active)-->
                          <!--                              ? dataSelects.pointsArr.find(-->
                          <!--                                  (item) => item.active-->
                          <!--                                ).names.EN-->
                          <!--                              : 'Select'-->
                          <!--                          }}</span>-->
                          <span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-for="item in flightArrSelectOptions
                                "
                                :key="item.id + Math.random()"
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    dataSelects.pointsArr.find(
                                      (item) => item.active
                                    ) &&
                                    dataSelects.pointsArr.find(
                                      (item) => item.active
                                    ).names.EN === item.names.EN,
                                },
                              ]"
                                @click="onArrivalChecked(item)">
                              <span class="select-option__name">{{
                                  item.names.EN || ''
                                }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Departure: PRIVATE end -->

                <!--Airlines: PRIVATE start -->
                <div class="edit-popup--add-flight__add__col">
                  <div class="form-control-group">
                    <span class="form-control-label">Airlines</span>
                    <div
                        :class="[
                        'select-wrapper',
                        {'is-active': selects.flightsPopup.air},
                      ]"
                        @click="
                        changeSelectsFlights('air')
                        isEditFlag = true
                      "
                    >
                      <div class="select-trigger">
                        <span class="select-trigger__name">{{
                            dataSelects.airlines.find((item) => item.active)
                                ? dataSelects.airlines.find((item) => item.active)
                                    .name
                                : 'Select'
                          }}</span
                        ><span class="select-trigger__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                      </div>
                      <div class="select-body">
                        <div class="select-inner js-scrollbar">
                          <div
                              v-for="item in dataSelects.airlines"
                              :key="item.id + Math.random()"
                              :class="[
                              'select-option',
                              {
                                'is-selected':
                                  dataSelects.airlines.find(
                                    (item) => item.active
                                  ) &&
                                  dataSelects.airlines.find(
                                    (item) => item.active
                                  ).name === item.name,
                              },
                            ]"
                              @click="
                              dataSelects.airlines = dataSelects.airlines.map(
                                (point) => ({
                                  ...point,
                                  active: point.id === item.id,
                                })
                              )
                              dataSelects.flights.filter(
                                (flight) =>
                                  dataSelects.pointsDep.find((pt) => pt.active)
                                    .id === flight.origin &&
                                  dataSelects.pointsArr.find((pt) => pt.active)
                                    .id === flight.destination &&
                                  item.id === flight.companyId
                              ).length === 1
                                ? (dataSelects.flightsTimes = [
                                    {
                                      name: dataSelects.flights.find(
                                        (flight) =>
                                          dataSelects.pointsDep.find(
                                            (pt) => pt.active
                                          ).id === flight.origin &&
                                          dataSelects.pointsArr.find(
                                            (pt) => pt.active
                                          ).id === flight.destination &&
                                          item.id === flight.companyId
                                      ).departureTime,
                                      active: true,
                                    },
                                  ])
                                : (dataSelects.flightsTimes =
                                    dataSelects.flights
                                      .filter(
                                        (flight) =>
                                          dataSelects.pointsDep.find(
                                            (item) => item.active
                                          ) &&
                                          dataSelects.pointsDep.find(
                                            (item) => item.active
                                          ).id === flight.origin &&
                                          dataSelects.pointsArr.find(
                                            (item) => item.active
                                          ) &&
                                          dataSelects.pointsArr.find(
                                            (item) => item.active
                                          ).id === flight.destination &&
                                          dataSelects.airlines.find(
                                            (item) => item.active
                                          ) &&
                                          dataSelects.airlines.find(
                                            (item) => item.active
                                          ).id === flight.companyId
                                      )
                                      .map((flight) => ({
                                        name: flight.departureTime,
                                        active: false,
                                      })))
                            ">
                            <span class="select-option__name">{{
                                item.name
                              }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Airlines: PRIVATE end -->

                <!--Departure Time:: PRIVATE start -->
                <div
                    class="edit-popup--add-flight__add__col edit-popup--add-flight__add__col">
                  <div class="form-select-group form-select-group-time">
                    <div class="form-control-group">
                      <span class="form-control-label">Departure Time:</span>
                      <div
                          :class="[
                          'select-wrapper select-wrapper--xs',
                          {'is-active': selects.flightsPopup.depTime},
                        ]"
                          @click="
                          changeSelectsFlights('depTime')
                          isEditFlag = true
                        "
                          :style="{
                          opacity: !dataSelects.airlines.find(
                            (item) => item.active
                          )
                            ? 0.6
                            : 1,
                          cursor: !dataSelects.airlines.find(
                            (item) => item.active
                          )
                            ? 'default'
                            : 'pointer',
                          pointerEvents: !dataSelects.airlines.find(
                            (item) => item.active
                          )
                            ? 'none'
                            : 'auto',
                        }">
                        <div class="select-trigger select-trigger_time">
                          <the-mask
                              type="text"
                              :disabled="activityPopupData.confirmed"
                              class="form-control form-control-time maskField"
                              @input="isEditFlag = true"
                              mask="##:##"
                              :masked="true"
                              v-model="dataSelects.flightsTimesPrivateStart"
                              placeholder="--:--"/>
                        </div>
                      </div>
                    </div>
                    <div
                        class="form-select-group__divider form-select-group__divider-time form-select-group__divider--mod">
                      <svg width="1em" height="1em" class="icon icon-arrow">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow"></use>
                      </svg>
                    </div>
                    <div class="form-control-group">
                      <span class="form-control-label">Arrival Time:</span>
                      <div
                          :class="[
                          'select-wrapper select-wrapper--xs',
                          {'is-active': selects.flightsPopup.depTime},
                        ]"
                          @click="
                          changeSelectsFlights('depTime')
                          isEditFlag = true
                        "
                          :style="{
                          opacity: !dataSelects.airlines.find(
                            (item) => item.active
                          )
                            ? 0.6
                            : 1,
                          cursor: !dataSelects.airlines.find(
                            (item) => item.active
                          )
                            ? 'default'
                            : 'pointer',
                          pointerEvents: !dataSelects.airlines.find(
                            (item) => item.active
                          )
                            ? 'none'
                            : 'auto',
                        }">
                        <div class="select-trigger select-trigger_time">
                          <the-mask
                              type="text"
                              :disabled="activityPopupData.confirmed"
                              class="form-control form-control-time maskField"
                              @input="isEditFlag = true"
                              :mask="'##:##'"
                              :masked="true"
                              v-model="dataSelects.flightsTimesPrivateEnd"
                              placeholder="--:--"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Departure Time:: PRIVATE end -->

                <!--Net Price:: PRIVATE start -->
                <div class="edit-popup--add-flight__add__col">
                  <div class="form-control-group form-control-group--price">
                    <span class="form-control-label">Net Price:</span>
                    <div class="select-wrapper">
                      <div class="select-trigger">
                        <input
                            type="number"
                            min="0"
                            max="1000000"
                            placeholder="0"
                            v-model.number="dataSelects.flightsNetPricePrivate"
                            @input="isEditFlag = true"
                            class="form-control"/>
                        <span class="select-trigger__icon">USD</span>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Net Price:: PRIVATE end -->

                <div class="edit-popup--add-flight__add__col">
                  <div
                      class="form-control-group form-control-group--persons form-control-group--residence">
                    <span class="form-control-label">Type:</span>

                    <div class="form-control-group--persons__col">
                      <div class="form-control-group--persons__col__info">
                        <svg
                            width="1em"
                            height="1em"
                            :class="
                            'icon icon-' +
                            (flightsPopupData.type
                              ? flightsPopupData.type.name.toLowerCase()
                              : 'adult')
                          ">
                          <use
                              :xlink:href="
                              '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                              (flightsPopupData.type
                                ? flightsPopupData.type.name.toLowerCase()
                                : 'adult')
                            "></use>
                        </svg>
                      </div>
                      <div
                          :class="[
                          'select-wrapper',
                          {'is-active': selects.flightsPopup.type},
                        ]"
                          @click="changeSelectsFlights('type')">
                        <div class="select-trigger">
                          <span class="select-trigger__name">{{
                              flightsPopupData.type
                                  ? flightsPopupData.type.name
                                  : 'Select'
                            }}</span
                          ><span class="select-trigger__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                            ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner js-scrollbar">
                            <div
                                v-if="
                                participants.find(
                                  (par) => par.ageType === 'adult'
                                )
                              "
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    flightsPopupData.type &&
                                    flightsPopupData.type.name === 'Adult',
                                },
                              ]"
                                @click="
                                flightsPopupData.type = {
                                  name: 'Adult',
                                  icon: 'adult',
                                }
                              ">
                              <span class="select-option__name">Adult</span>
                            </div>
                            <div
                                v-if="
                                participants.find(
                                  (par) => par.ageType === 'teenager'
                                )
                              "
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    flightsPopupData.type &&
                                    flightsPopupData.type.name === 'Teenager',
                                },
                              ]"
                                @click="
                                flightsPopupData.type = {
                                  name: 'Teenager',
                                  icon: 'teenager',
                                }
                              ">
                              <span class="select-option__name">Teenager</span>
                            </div>
                            <div
                                v-if="
                                participants.find(
                                  (par) => par.ageType === 'child'
                                )
                              "
                                :class="[
                                'select-option',
                                {
                                  'is-selected':
                                    flightsPopupData.type &&
                                    flightsPopupData.type.name === 'Child',
                                },
                              ]"
                                @click="
                                flightsPopupData.type = {
                                  name: 'Child',
                                  icon: 'child',
                                }
                              ">
                              <span class="select-option__name">Child</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!--Pax:: PRIVATE start -->
                <div class="edit-popup--add-flight__add__col">
                  <div class="form-control-group form-control-group--pax">
                    <span class="form-control-label">Pax:</span>
                    <div
                        :class="[
                        'select-wrapper',
                        {
                          'is-active':
                            selects.flightsPopup.pax && flightsPopupData.type,
                        },
                      ]"
                        @click="changeSelectsFlights('pax')"
                        :style="{
                        opacity:
                          !participants.length ||
                          !(
                            participants.length -
                            flightsPopupData.paxList.length
                          )
                            ? 0.6
                            : 1,
                        cursor:
                          !participants.length ||
                          !(
                            participants.length -
                            flightsPopupData.paxList.length
                          )
                            ? 'default'
                            : 'pointer',
                        pointerEvents:
                          !participants.length ||
                          !(
                            participants.length -
                            flightsPopupData.paxList.length
                          )
                            ? 'none'
                            : 'auto',
                      }">
                      <div class="select-trigger">
                        <span class="select-trigger__name">{{
                            flightsPopupData.pax || '-'
                          }}</span
                        ><span class="select-trigger__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                      </div>
                      <div
                          class="select-body"
                          v-if="flightsPopupData.type != null">
                        <div class="select-inner js-scrollbar">
                          <div
                              v-for="pax in Array(
                              flightsPopupData.paxList
                                ? participants.filter(
                                    (par) =>
                                      par.ageType === flightsPopupData.type.icon
                                  ).length -
                                    flightsPopupData.paxList.filter(
                                      (par) =>
                                        par.icon === flightsPopupData.type.icon
                                    ).length
                                : participants.filter(
                                    (par) =>
                                      par.ageType === flightsPopupData.type.icon
                                  ).length
                            )
                              .fill(true)
                              .map((_, i) => i + 1)"
                              :key="pax"
                              :class="[
                              'select-option',
                              {'is-selected': pax === flightsPopupData.pax},
                            ]"
                              @click="flightsPopupData.pax = pax">
                            <span class="select-option__name">{{ pax }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                        type="button"
                        class="btn btn--rounded btn--add"
                        :class="{
                        'btn--disabled':
                          !flightsPopupData.type ||
                          !flightsPopupData.pax ||
                          flightsPopupData.paxList.length ===
                            participants.length,
                      }"
                        :disabled="
                        !flightsPopupData.type ||
                        !flightsPopupData.pax ||
                        flightsPopupData.paxList.length === participants.length
                      "
                        @click="
                        flightsPopupData.paxList =
                          flightsPopupData.paxList.concat(
                            Array(+flightsPopupData.pax).fill({
                              ...flightsPopupData.type,
                            })
                          )
                        flightsPopupData.type = null
                        flightsPopupData.pax = null
                      "
                    >
                      <svg
                          width="1em"
                          height="1em"
                          class="icon icon-plus-o-white"
                          :style="{color: '#77B017'}">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                      </svg>
                      <span>Add</span>
                    </button>
                  </div>
                </div>
                <!--Pax:: PRIVATE end -->

                <div class="edit-popup--add-flight__add__radio">
                  <div class="form-control-group form-control-group--radio">
                    <label
                        class="form-control-radio"
                        @click="flightsPopupData.timeActivity = false">
                      <input
                          type="radio"
                          name="activity_radio"
                          :checked="!flightsPopupData.timeActivity"/><span
                        class="form-control-radio__box"></span
                    ><span class="form-control-radio__name"
                    >Before the Activity</span
                    >
                    </label>
                    <label
                        class="form-control-radio"
                        @click="flightsPopupData.timeActivity = true">
                      <input
                          type="radio"
                          name="activity_radio"
                          :checked="flightsPopupData.timeActivity"/><span
                        class="form-control-radio__box"></span
                    ><span class="form-control-radio__name"
                    >After the Activity</span
                    >
                    </label>
                  </div>
                </div>
                <div class="edit-popup--add-flight__add__submit">
                  <button
                      type="button"
                      class="btn btn--rounded2 btn--green btn--add"
                      :disabled="
                      !dataSelects.pointsDep.find((item) => item.active) ||
                      !dataSelects.pointsArr.find((item) => item.active) ||
                      !dataSelects.airlines.find((item) => item.active) ||
                      !flightsPopupData.paxList.length
                    "
                      @click="
                      flightsPopupData.flightsData.find(
                        (itemData) =>
                          itemData.comId ===
                            dataSelects.airlines.find((item) => item.active)
                              .id &&
                          itemData.depId ===
                            dataSelects.pointsDep.find((item) => item.active)
                              .id &&
                          itemData.arrId ===
                            dataSelects.pointsArr.find((item) => item.active).id
                      )
                        ? (flightsPopupData.flightsData =
                            flightsPopupData.flightsData.map((itemData) =>
                              itemData.comId ===
                                dataSelects.airlines.find((item) => item.active)
                                  .id &&
                              itemData.depId ===
                                dataSelects.pointsDep.find(
                                  (item) => item.active
                                ).id &&
                              itemData.arrId ===
                                dataSelects.pointsArr.find(
                                  (item) => item.active
                                ).id &&
                              itemData.timeActivity ===
                                flightsPopupData.timeActivity &&
                              itemData.depTime ===
                                (dataSelects.flightsTimes.find(
                                  (item) => item.active
                                )
                                  ? dataSelects.flightsTimes
                                      .find((item) => item.active)
                                      .name.slice(0, 2) +
                                    ':' +
                                    dataSelects.flightsTimes
                                      .find((item) => item.active)
                                      .name.slice(2, 5)
                                  : '')
                                ? {
                                    ...itemData,
                                    paxList: itemData.paxList.concat(
                                      flightsPopupData.paxList
                                    ),

                                    clients: itemData.clients.concat(
                                      flightsPopupData.paxList.map((item) => ({
                                        ...item,
                                        name: '',
                                        isOpen: false,
                                        ageType: item.name.toLowerCase(),
                                        type: item.name + ' ' + item.lug,
                                        id: '',
                                      }))
                                    ),
                                  }
                                : itemData
                            ))
                        : (flightsPopupData.flightsData =
                            flightsPopupData.flightsData.concat({
                              airline: dataSelects.airlines.find(
                                (item) => item.active
                              ).name,
                              day: flightsPopup.day,
                              flightsNetPricePrivate:
                                dataSelects.flightsNetPricePrivate,
                              flightsTimesPrivateStart:
                                dataSelects.flightsTimesPrivateStart,
                              flightsTimesPrivateEnd:
                                dataSelects.flightsTimesPrivateEnd,
                              type: isActiveFlightTab,
                              date: flightsPopup.date,
                              timeActivity: flightsPopupData.timeActivity,
                              dep: dataSelects.pointsDep.find(
                                (item) => item.active
                              ).names.EN,
                              arr: dataSelects.pointsArr.find(
                                (item) => item.active
                              ).names.EN,
                              depId: dataSelects.pointsDep.find(
                                (item) => item.active
                              ).id,
                              arrId: dataSelects.pointsArr.find(
                                (item) => item.active
                              ).id,
                              comId: dataSelects.airlines.find(
                                (item) => item.active
                              ).id,
                              clients: flightsPopupData.paxList.map(
                                (item, index) => ({
                                  ...item,
                                  name:
                                    participants.length <= 2
                                      ? participants[index].name
                                      : '',
                                  isOpen: false,
                                  ageType: item.name.toLowerCase(),
                                  type: item.name + ' ' + item.lug,
                                  id:
                                    participants.length <= 2
                                      ? participants[index].id
                                      : '',
                                })
                              ),
                              paxList: flightsPopupData.paxList,
                              flightId: dataSelects.flights.find(
                                (flight) =>
                                  flight.origin ===
                                    dataSelects.pointsDep.find(
                                      (item) => item.active
                                    ).id &&
                                  flight.destination ===
                                    dataSelects.pointsArr.find(
                                      (item) => item.active
                                    ).id &&
                                  flight.companyId ===
                                    dataSelects.airlines.find(
                                      (item) => item.active
                                    ).id
                              ),
                            }))
                      flightsPopupData.paxList = []

                      isEditFlag = true
                    ">
                    <svg
                        width="1em"
                        height="1em"
                        class="icon icon-plus-o-white">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                    </svg>
                    <span>Add flight</span>
                  </button>
                </div>
              </div>
            </template>
            <!--edit-popup--add-flight__form PRIVATE end-->

            <div class="edit-popup--add-flight__table">
              <div class="edit-popup__title">
                <span>Domestic Flights</span>
              </div>
              <div
                  class="section-table-wrap"
                  v-for="(item, index) in flightsPopupData.flightsData"
                  :key="index">
                <div class="section-table section-table--flights">
                  <div class="section-table__body">
                    <div class="section-table__row">
                      <div class="col col-flight-day">
                        <div class="col-flight-day__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-airplane">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-airplane"></use>
                          </svg>
                        </div>
                        <span
                        ><b>DAY {{ flightsPopup.day }}</b>
                          {{ flightsPopup.date }}</span
                        >
                      </div>

                      <div class="col col-flight-time">
                        <div class="col-flight-time__side">
                          <span
                              v-if="item.type === 'REGULAR'"
                              class="col-flight-time__item"
                          >{{ item.depTime.substring(0, 2) }}:{{
                              item.depTime.substring(item.depTime.length - 2)
                            }}</span
                          >
                          <span
                              v-if="item.type === 'PRIVATE'"
                              class="col-flight-time__item"
                          >{{ item.flightsTimesPrivateStart }}</span
                          ><span class="col-flight-time__destination">{{
                            item.dep
                          }}</span>
                        </div>
                        <div class="col-flight-time__arrow">
                          <svg width="1em" height="1em" class="icon icon-arrow">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arrow"></use>
                          </svg>
                        </div>
                        <div class="col-flight-time__side">
                          <span
                              v-if="item.type === 'REGULAR'"
                              class="col-flight-time__item"
                          >{{ item.arrTime.substring(0, 2) }}:{{
                              item.arrTime.substring(item.arrTime.length - 2)
                            }}</span
                          >
                          <span
                              v-if="item.type === 'PRIVATE'"
                              class="col-flight-time__item"
                          >{{ item.flightsTimesPrivateEnd }}</span
                          ><span class="col-flight-time__destination">{{
                            item.arr
                          }}</span>
                        </div>
                      </div>
                      <div class="col col-airlines">
                        <span>Airlines:</span><b>{{ item.airline }}</b>
                      </div>

                      <div class="col col-activity-status">
                        <span
                        >{{ item.timeActivity ? 'After' : 'Before' }} the
                          activity</span
                        >
                      </div>

                      <div class="col col-action">
                        <button
                            type="button"
                            class="btn btn--remove"
                            @click="
                            $emit('deleteModalHandler', {
                              entity: 'Flight',
                              name: 'this',
                              handler: () =>
                                (flightsPopupData.flightsData =
                                  flightsPopupData.flightsData.filter(
                                    (_, i) => !(i === index)
                                  )),
                              id: null,
                            })
                          ">
                          <svg width="1em" height="1em" class="icon icon-close">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>

                      <div
                          v-if="item.type === 'REGULAR'"
                          class="section-table--flights__pax">
                        <p>
                          <span>Total pax:</span>
                          {{
                            item.clients.filter(
                                (client) => client.type === 'Adult 15kg'
                            ).length || ''
                          }}
                          {{
                            item.clients.filter(
                                (client) => client.type === 'Adult 15kg'
                            ).length
                                ? `Adult${
                                    item.clients.filter(
                                        (client) => client.type === 'Adult 15kg'
                                    ).length > 1
                                        ? 's'
                                        : ''
                                } 15kg`
                                : ''
                          }}{{
                            item.clients.filter(
                                (client) => client.type !== 'Adult 15kg'
                            ).length > 0 &&
                            item.clients.filter(
                                (client) => client.type === 'Adult 15kg'
                            ).length
                                ? ','
                                : ''
                          }}
                          {{
                            item.clients.filter(
                                (client) => client.type === 'Adult 30kg'
                            ).length || ''
                          }}
                          {{
                            item.clients.filter(
                                (client) => client.type === 'Adult 30kg'
                            ).length
                                ? `Adult${
                                    item.clients.filter(
                                        (client) => client.type === 'Adult 30kg'
                                    ).length > 1
                                        ? 's'
                                        : ''
                                } 30kg`
                                : ''
                          }}{{
                            item.clients.filter(
                                (client) =>
                                    client.type !== 'Adult 15kg' &&
                                    client.type !== 'Adult 30kg'
                            ).length > 0 &&
                            item.clients.filter(
                                (client) => client.type === 'Adult 30kg'
                            ).length
                                ? ','
                                : ''
                          }}
                          {{
                            item.clients.filter(
                                (client) => client.type === 'Teenager 15kg'
                            ).length || ''
                          }}
                          {{
                            item.clients.filter(
                                (client) => client.type === 'Teenager 15kg'
                            ).length
                                ? `Teenager${
                                    item.clients.filter(
                                        (client) => client.type === 'Teenager 15kg'
                                    ).length > 1
                                        ? 's'
                                        : ''
                                } 15kg`
                                : ''
                          }}{{
                            item.clients.filter(
                                (client) =>
                                    client.type !== 'Adult 15kg' &&
                                    client.type !== 'Adult 30kg' &&
                                    client.type !== 'Teenager 15kg'
                            ).length > 0 &&
                            item.clients.filter(
                                (client) => client.type === 'Teenager 15kg'
                            ).length
                                ? ','
                                : ''
                          }}
                          {{
                            item.clients.filter(
                                (client) => client.type === 'Teenager 30kg'
                            ).length || ''
                          }}
                          {{
                            item.clients.filter(
                                (client) => client.type === 'Teenager 30kg'
                            ).length
                                ? `Teenager${
                                    item.clients.filter(
                                        (client) => client.type === 'Teenager 30kg'
                                    ).length > 1
                                        ? 's'
                                        : ''
                                } 30kg`
                                : ''
                          }}{{
                            item.clients.filter(
                                (client) =>
                                    client.type !== 'Adult 15kg' &&
                                    client.type !== 'Adult 30kg' &&
                                    client.type !== 'Teenager 15kg' &&
                                    client.type !== 'Teenager 30kg'
                            ).length > 0 &&
                            item.clients.filter(
                                (client) => client.type === 'Teenager 30kg'
                            ).length
                                ? ','
                                : ''
                          }}
                          {{
                            item.clients.filter(
                                (client) => client.type === 'Child 15kg'
                            ).length || ''
                          }}
                          {{
                            item.clients.filter(
                                (client) => client.type === 'Child 15kg'
                            ).length
                                ? `Child${
                                    item.clients.filter(
                                        (client) => client.type === 'Child 15kg'
                                    ).length > 1
                                        ? 'ren'
                                        : ''
                                } 15kg`
                                : ''
                          }}{{
                            item.clients.filter(
                                (client) =>
                                    client.type !== 'Adult 15kg' &&
                                    client.type !== 'Adult 30kg' &&
                                    client.type !== 'Teenager 15kg' &&
                                    client.type !== 'Teenager 30kg' &&
                                    client.type !== 'Child 15kg'
                            ).length > 0 &&
                            item.clients.filter(
                                (client) => client.type === 'Child 15kg'
                            ).length
                                ? ','
                                : ''
                          }}
                          {{
                            item.clients.filter(
                                (client) => client.type === 'Child 30kg'
                            ).length || ''
                          }}
                          {{
                            item.clients.filter(
                                (client) => client.type === 'Child 30kg'
                            ).length
                                ? `Child${
                                    item.clients.filter(
                                        (client) => client.type === 'Child 30kg'
                                    ).length > 1
                                        ? 'ren'
                                        : ''
                                } 30kg`
                                : ''
                          }}
                        </p>
                      </div>

                      <div class="col col-selects">
                        <span class="col-selects__title">Passengers:</span>
                        <div
                            class="form-control-group form-control-group-client"
                            v-for="(
                            clientOption, clientOptionIndex
                          ) in item.clients"
                            :key="clientOptionIndex">
                          <div
                              :class="[
                              'select-wrapper',
                              {'is-active': clientOption.isOpen},
                              {'is-error': clientOption.error},
                            ]"
                              @click="
                              clientOption.error = false
                              item.clients = item.clients.map((c, ci) => ({
                                ...c,
                                isOpen:
                                  clientOptionIndex === ci ? !c.isOpen : false,
                              }))
                            ">
                            <div class="form-control-group-client-icon">
                              <svg
                                  width="1em"
                                  height="1em"
                                  :class="
                                  'icon icon-' +
                                  (clientOption.ageType === 'teenager'
                                    ? 'teenager'
                                    : clientOption.ageType === 'child'
                                    ? 'child'
                                    : 'adult')
                                ">
                                <use
                                    :xlink:href="
                                    '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                                    (clientOption.ageType === 'teenager'
                                      ? 'teenager'
                                      : clientOption.ageType === 'child'
                                      ? 'child'
                                      : 'adult')
                                  "></use>
                              </svg>
                            </div>
                            <div class="select-trigger">
                              <span class="select-trigger__name">{{
                                  clientOption.name
                                }}</span
                              ><span class="select-trigger__icon">
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-chevron">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                                ></span>
                            </div>
                            <div class="select-body">
                              <div
                                  v-if="clientOption.name.length > 0"
                                  :class="[
                                  'select-option',
                                  {'is-selected': true},
                                ]"
                                  @click="
                                  clientOption.name = ''
                                  clientOption.id = ''
                                ">
                                --
                              </div>
                              <div
                                  v-for="(client, clientIndex) in participants
                                  .filter(
                                    (par) =>
                                      par.ageType ===
                                      (clientOption.ageType === 'teenager'
                                        ? 'teenager'
                                        : clientOption.ageType === 'child'
                                        ? 'child'
                                        : 'adult')
                                  )
                                  .filter(
                                    (par) =>
                                      !flightsPopupData.flightsData
                                        .map((data) => data.clients)
                                        .flat()
                                        .map((client) => client.id)
                                        .includes(par.id)
                                  )"
                                  :key="clientIndex"
                                  :class="[
                                  'select-option',
                                  {
                                    'is-selected':
                                      clientOption.name === client.name,
                                  },
                                ]"
                                  @click="
                                  clientOption.name =
                                    client.name || 'Adult ' + (clientIndex + 1)
                                  clientOption.id = client.id
                                ">
                                <span class="select-option__name">{{
                                    client.name || 'Adult ' + (clientIndex + 1)
                                  }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup--add-flight__submit">
              <button
                  type="reset"
                  class="btn btn--silver"
                  @click="
                  $emit('deleteModalHandler', {
                    entity: 'Data',
                    name: 'this',
                    handler: () => {
                      flightsPopupData.flightsData = []
                      flightDepSelectInput = ''
                      flightArrSelectInput = ''
                      dataSelects.selectedFlight = {
                        comments: '',
                        frequency: [],
                        minPax: 0,
                      }
                      dataSelects.pointsDep = dataSelects.pointsDep.map(
                        (pt) => ({...pt, active: false})
                      )
                      dataSelects.pointsArr = dataSelects.pointsArr.map(
                        (pt) => ({...pt, active: false})
                      )
                      dataSelects.airlines = dataSelects.airlines.map(
                        (air) => ({...air, active: false})
                      )
                      dataSelects.flightsTimes = []
                    },
                    id: null,
                  })
                ">
                <span>Reset</span>
              </button>
              <button
                  type="submit"
                  class="btn btn--green"
                  @click="
                  () => {
                    if (checkFlightsErrors()) {
                      return false
                    }
                    flightsPopup.flightsData = JSON.parse(
                      JSON.stringify(flightsPopupData.flightsData)
                    )
                    flightsPopup = false
                    flightsPopupData.paxList = []
                    dataSelects.pointsDep = dataSelects.pointsDep.map(
                      (item) => ({...item, active: false})
                    )
                    dataSelects.pointsArr = dataSelects.pointsArr.map(
                      (item) => ({...item, active: false})
                    )
                    dataSelects.airlines = dataSelects.airlines.map((item) => ({
                      ...item,
                      active: false,
                    }))
                    dataSelects.flightsTimes = []
                    flightsPopupData.type = null
                    flightsPopupData.pax = null
                    flightsPopupData.lug = ''
                    dataSelects.flightsNetPricePrivate = null
                    dataSelects.flightsTimesPrivateStart = '--:--'
                    dataSelects.flightsTimesPrivateEnd = '--:--'
                    flightDepSelectInput = ''
                  }
                ">
                <span>Save</span>
              </button>
            </div>
          </form>

          <!--edit-popup--add-flight__form REGULAR start-->
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && activityPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner" :style="{alignItems: 'flex-start'}">
        <div class="edit-popup edit-popup--activity">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon edit-popup__title__icon--mod">
                <svg width="1em" height="1em" class="icon icon-parachute">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-parachute"></use>
                </svg>
              </div>
              <span>Add Activity</span>
            </div>
            <div class="edit-popup__close" @click="activityPopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup--activity__form">
            <div class="edit-popup--activity__add">
              <div
                  class="edit-popup--activity__add__col edit-popup--activity__add__col_a">
                <div class="form-control-group">
                  <span class="form-control-label">Choose Activity</span>
                  <div
                      :class="[
                      'select-wrapper select-wrapper--md',
                      {'is-active': selects.activityPopup.activity},
                    ]"
                      @click="changeSelectsActivities('activity')">
                    <div class="select-trigger">
                      <span class="select-trigger__name">{{
                          activityPopupData.activity
                              ? activityPopupData.activity.name
                              : 'Select'
                        }}</span
                      ><span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                        ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner js-scrollbar">
                        <div
                            v-for="item in dataSelects.activities"
                            :key="item.id"
                            :class="[
                            'select-option',
                            {
                              'is-selected':
                                activityPopupData.activity &&
                                item.id === activityPopupData.activity.id,
                            },
                          ]"
                            @click="activityPopupData.activity = item">
                          <span class="select-option__name">{{
                              item.name
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                  class="edit-popup--activity__add__col edit-popup--activity__add__col_a">
                <div class="form-control-group">
                  <span class="form-control-label">Pick Up Time</span>
                  <div class="form-control-wrap">
                    <the-mask
                        type="text"
                        :disabled="activityPopupData.confirmed"
                        class="form-control form-control-time maskField"
                        @input="
                        activityPopupData.time =
                          +activityPopupData.time.slice(0, 2) > 23
                            ? 23
                            : activityPopupData.time
                        activityPopupData.time.length === 4
                          ? (activityPopupData.time =
                              +activityPopupData.time.slice(2, 5) > 59
                                ? activityPopupData.time.slice(0, 2) + '59'
                                : activityPopupData.time)
                          : false
                      "
                        :mask="'##:##'"
                        :tokens="{'#': {pattern: /[0-9]/}}"
                        v-model="activityPopupData.time"
                        placeholder="--:--"/>
                  </div>
                </div>
              </div>
              <div class="edit-popup--activity__add__col">
                <label
                    for="chk_120__free"
                    class="form-control-checkbox form-control-checkbox-pickup_2">
                  <input
                      id="chk_120__free"
                      type="checkbox"
                      v-model="activityPopupData.confirmed"
                      @change="activityPopupData.time = ''"/><span
                    class="form-control-checkbox__box">
                    <svg width="1em" height="1em" class="icon icon-check">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                ><span class="form-control-checkbox__name"
                >Pick Up Time to be confirmed</span
                >
                  {{ activityPopupData.confirmed }}

                </label>
              </div>
              <div class="col-selects selects-row selects-row_1">
                <div
                    class="col-offset"
                    v-for="(item, i) in activityPopupData.paxList"
                    :key="i">
                  <div
                      class="form-control-group form-control-group-client"
                      :style="{height: '36px'}">
                    <div
                        :class="['select-wrapper', {'is-active': item.open}]"
                        @click="
                        changeSelectsActivities()
                        activityPopupData.paxList =
                          activityPopupData.paxList.map((pli, plii) => ({
                            ...pli,
                            open: i === plii ? !pli.open : false,
                          }))
                      ">
                      <div class="form-control-group-client-icon">
                        <svg
                            width="1em"
                            height="1em"
                            :class="
                            'icon icon-' +
                            (item.ageType === 'teenager'
                              ? 'teenager'
                              : item.ageType === 'child'
                              ? 'child'
                              : 'adult')
                          ">
                          <use
                              :xlink:href="
                              '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                              (item.ageType === 'teenager'
                                ? 'teenager'
                                : item.ageType === 'child'
                                ? 'child'
                                : 'adult')
                            "></use>
                        </svg>
                      </div>
                      <div class="select-trigger">
                        <span class="select-trigger__name">{{
                            item.id ? item.name : ''
                          }}</span
                        ><span class="select-trigger__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                      </div>
                      <div class="select-body">
                        <div class="select-inner js-scrollbar">
                          <div
                              class="select-option"
                              v-for="(p, idx) in participants.filter(
                              (p) =>
                                !activityPopupData.paxList
                                  .map((pli) => pli.id)
                                  .includes(p.id)
                            )"
                              :key="idx"
                              @click="
                              item.id = p.id
                              item.name = p.name
                              item.ageType = p.ageType
                            ">
                            <span class="select-option__name">{{
                                p.name
                              }}</span>
                          </div>
                          <div
                              class="select-option"
                              v-if="item.id"
                              @click="
                              item.id = null
                              item.name = ''
                              item.ageType = null
                            ">
                            <span class="select-option__name">--</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="edit-popup--activity__add-submit" :style="{display: 'flex', gap: '8px'}">
                <button
                    type="button"
                    class="btn btn--rounded2 btn--add btn--green"
                    :disabled="
                    !activityPopupData.activity ||
                    (!activityPopupData.time && !activityPopupData.confirmed)
                  "
                    @click="
                    activityPopupData.activitiesData.find(
                      (item) =>
                        item.name === activityPopupData.activity.name &&
                        item.time === activityPopupData.time &&
                        item.activityId === activityPopupData.activity.id
                    )
                      ? (activityPopupData.activitiesData =
                          activityPopupData.activitiesData.map((itemData) => {
                            if (
                              itemData.name ===
                                activityPopupData.activity.name &&
                              itemData.time === activityPopupData.time &&
                              itemData.activityId ===
                                activityPopupData.activity.id
                            ) {
                              return {
                                ...itemData,
                                clients:
                                  activityPopupData.paxList.filter((p) => p.id)
                                    .length === 0 && participants.length <= 2
                                    ? itemData.clients.concat(
                                        participants.map((pax) => ({
                                          id: pax.id,
                                          name: pax.name,
                                          ageType: pax.ageType,
                                          isOpen: false,
                                          type: pax.name.toLowerCase(),
                                        }))
                                      )
                                    : itemData.clients.concat(
                                        activityPopupData.paxList
                                          .filter((p) => p.id)
                                          .map((pax) => ({
                                            id: pax.id,
                                            name: pax.name,
                                            ageType: pax.ageType,
                                            isOpen: false,
                                            type: pax.name.toLowerCase(),
                                          }))
                                      ),
                              }
                            }
                            return itemData
                          }))
                      : (activityPopupData.activitiesData =
                          activityPopupData.activitiesData.concat({
                            name: activityPopupData.activity.name,
                            time: activityPopupData.time,
                            confirmed: activityPopupData.confirmed ? activityPopupData.confirmed : false,
                            clients:
                              activityPopupData.paxList.filter((p) => p.id)
                                .length === 0 && participants.length <= 2
                                ? participants.map((pax) => ({
                                    id: pax.id,
                                    name: pax.name,
                                    ageType: pax.ageType,
                                    isOpen: false,
                                    type: pax.name.toLowerCase(),
                                  }))
                                : activityPopupData.paxList
                                    .filter((p) => p.id)
                                    .map((pax) => ({
                                      id: pax.id,
                                      name: pax.name,
                                      isOpen: false,
                                      ageType: pax.ageType,
                                      type: pax.name.toLowerCase(),
                                    })),
                            activityId: activityPopupData.activity.id,
                            day: activityPopup.day,
                            date: activityPopup.date,
                            paxList: activityPopupData.paxList,
                          }))

                    activityPopupData.activity = null
                    activityPopupData.confirmed = false
                    isEditFlag = true
                    activityPopupData.time = '0900'
                    activityPopupData.type = null
                    activityPopupData.pax = null
                    if (participants.length <= 2) {
                      if (participants.length === 1) {
                        activityPopupData.paxList = Array({
                          id: participants[0].id,
                          name: participants[0].name,
                          ageType: participants[0].ageType,
                          open: false,
                        })
                      } else if (participants.length === 2) {
                        activityPopupData.paxList = Array(
                          {
                            id: participants[0].id,
                            name: participants[0].name,
                            ageType: participants[0].ageType,
                            open: false,
                          },
                          {
                            id: participants[1].id,
                            name: participants[1].name,
                            ageType: participants[1].ageType,
                            open: false,
                          }
                        )
                      }
                    } else {
                      activityPopupData.paxList = Array(
                        participants.length
                      ).fill({open: false})
                    }
                  ">
                  <svg width="1em" height="1em" class="icon icon-plus-o-white">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                  </svg>
                  <span>Add Activity</span>
                </button>

                <div :style="{paddingBottom: '0px', marginBottom: '0px'}">
                  <button
                      :disabled="participants.length === 0"
                      @click="onAutocompleteActivityClick"
                      type="button"
                      data-popover="Autocomplete participants"
                      class="btn btn--rounded2 btn--orange">
                    <span>Quick Allocation</span>
                  </button>
                </div>
              </div>
            </div>
            <div
                class="edit-popup--activity__table edit-popup--activity__table_main">
              <div class="edit-popup__title"><span>Activities</span></div>
              <div class="section-table-wrap">
                <div class="section-table section-table--activities">
                  <div class="section-table__body">
                    <div
                        class="section-table__row"
                        v-for="(item, index) in activityPopupData.activitiesData"
                        :key="index">
                      <div class="col col-day">
                        <div class="col-day__label">
                          <span
                          ><b>DAY {{ activityPopup.day }}</b>
                            {{ activityPopup.date }}</span
                          >
                        </div>
                      </div>
                      <div class="col col-activity">
                        <span>{{ item.name }}</span>
                      </div>

                      <div class="col col-pick-up-time">
                        <span
                        >{{
                            item.time ? 'Pick up time:' : 'To be confirmed'
                          }}
                          <b>{{
                              item.time
                                  ? item.time.slice(0, 2) +
                                  ':' +
                                  item.time.slice(2, 5)
                                  : ''
                            }}</b></span
                        >
                      </div>
                      <div class="col col-action">
                        <button
                            type="button"
                            class="btn btn--remove"
                            @click="
                            $emit('deleteModalHandler', {
                              entity: 'Activity',
                              name: 'this',
                              handler: () =>
                                (activityPopupData.activitiesData =
                                  activityPopupData.activitiesData.filter(
                                    (_, i) => !(i === index)
                                  )),
                              id: null,
                            })
                          ">
                          <svg width="1em" height="1em" class="icon icon-close">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>
                      <div class="section-table--flights__pax">
                        <p>
                          <span>Pax:</span>
                          {{
                            item.clients.filter(
                                (item) => item.ageType === 'adult'
                            ).length
                                ? item.clients.filter(
                                (item) => item.ageType === 'adult'
                            ).length + ' Adult'
                                : ''
                          }}{{
                            item.clients.filter(
                                (item) => item.ageType === 'adult'
                            ).length > 1
                                ? 's'
                                : ''
                          }}{{
                            item.clients.filter(
                                (item) => item.ageType === 'adult'
                            ).length &&
                            (item.clients.filter(
                                    (item) => item.ageType === 'teenager'
                                ).length ||
                                item.clients.filter(
                                    (item) => item.ageType === 'child'
                                ).length)
                                ? ', '
                                : ''
                          }}
                          {{
                            item.clients.filter(
                                (item) => item.ageType === 'teenager'
                            ).length
                                ? item.clients.filter(
                                (item) => item.ageType === 'teenager'
                            ).length + ' Teenager'
                                : ''
                          }}{{
                            item.clients.filter(
                                (item) => item.ageType === 'teenager'
                            ).length > 1
                                ? 's'
                                : ''
                          }}{{
                            item.clients.filter(
                                (item) => item.ageType === 'teenager'
                            ).length &&
                            item.clients.filter(
                                (item) => item.ageType === 'child'
                            ).length
                                ? ', '
                                : ''
                          }}
                          {{
                            item.clients.filter(
                                (item) => item.ageType === 'child'
                            ).length
                                ? item.clients.filter(
                                (item) => item.ageType === 'child'
                            ).length + ' Child'
                                : ''
                          }}{{
                            item.clients.filter(
                                (item) => item.ageType === 'child'
                            ).length > 1
                                ? 'ren'
                                : ''
                          }}
                        </p>
                      </div>
                      <div class="col col-selects">
                        <div
                            class="form-control-group form-control-group-client"
                            :style="{marginBottom: '.6rem'}"
                            v-for="(
                            clientOption, clientOptionIndex
                          ) in item.clients"
                            :key="clientOptionIndex">
                          <div
                              :class="[
                              'select-wrapper',
                              {'is-active': clientOption.isOpen},
                              {'is-error': clientOption.error},
                            ]"
                              @click="
                              clientOption.error = false
                              item.clients = item.clients.map((c, ci) => ({
                                ...c,
                                isOpen:
                                  clientOptionIndex === ci ? !c.isOpen : false,
                              }))
                            ">
                            <div class="form-control-group-client-icon">
                              <svg
                                  width="1em"
                                  height="1em"
                                  :class="
                                  'icon icon-' +
                                  (clientOption.ageType === 'teenager'
                                    ? 'teenager'
                                    : clientOption.ageType === 'child'
                                    ? 'child'
                                    : 'adult')
                                ">
                                <use
                                    :xlink:href="
                                    '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                                    (clientOption.ageType === 'teenager'
                                      ? 'teenager'
                                      : clientOption.ageType === 'child'
                                      ? 'child'
                                      : 'adult')
                                  "></use>
                              </svg>
                            </div>
                            <div class="select-trigger">
                              <span class="select-trigger__name">{{
                                  clientOption.name
                                }}</span
                              ><span class="select-trigger__icon">
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-chevron">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                                ></span>
                            </div>
                            <div class="select-body">
                              <div
                                  v-if="clientOption.name.length > 0"
                                  :class="[
                                  'select-option',
                                  {'is-selected': true},
                                ]"
                                  @click="
                                  clientOption.name = ''
                                  clientOption.id = ''
                                ">
                                --
                              </div>
                              <div
                                  v-for="(
                                  client, clientIndex
                                ) in participants.filter(
                                  (par) =>
                                    !item.clients
                                      .map((client) => client.id)
                                      .includes(par.id)
                                )"
                                  :key="clientIndex"
                                  :class="[
                                  'select-option',
                                  {
                                    'is-selected':
                                      clientOption.name === client.name,
                                  },
                                ]"
                                  @click="
                                  clientOption.name =
                                    client.name || 'Adult ' + (clientIndex + 1)
                                  clientOption.id = client.id
                                  clientOption.ageType = client.ageType
                                ">
                                <span class="select-option__name">{{
                                    client.name || 'Adult ' + (clientIndex + 1)
                                  }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup--activity__submit">
              <button
                  type="reset"
                  class="btn btn--silver"
                  @click="
                  $emit('deleteModalHandler', {
                    entity: 'Data',
                    name: 'this',
                    handler: () => {
                      activityPopupData.activitiesData = []
                    },
                    id: null,
                  })
                ">
                <span>Reset</span>
              </button>
              <button
                  type="submit"
                  class="btn btn--green"
                  @click="
                  () => {
                    if (checkActivitiesErrors()) {
                      return false
                    }
                    activityPopup.activitiesData = JSON.parse(
                      JSON.stringify(activityPopupData.activitiesData)
                    )
                    activityPopup = false
                  }
                ">
                <span>Save</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && transfersPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner" :style="{alignItems: 'flex-start'}">
        <div class="edit-popup edit-popup--taxi">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div
                  class="edit-popup__title__icon edit-popup__title__icon--mod"
                  :style="{backgroundColor: '#77B017'}">
                <svg width="1em" height="1em" class="icon icon-taxi">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-taxi"></use>
                </svg>
              </div>
              <span>Transfers</span>
            </div>
            <div class="edit-popup__close" @click="transfersPopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup--activity__form">
            <div
                class="edit-popup--activity__add edit-popup--activity__add_transfer">
              <div class="edit-popup--activity__add__col" style="height: 88px">
                <div class="form-control-group">
                  <span class="form-control-label">Departure</span>
                  <div
                      :class="[
                      'select-wrapper',
                      {'is-active': selects.transfersPopup.from},
                    ]"
                      @click="changeSelectsTransfers('from')">
                    <div class="select-trigger">
                      <input
                          type="text"
                          class="select-trigger__name"
                          placeholder="Select"
                          :style="{border: 'none'}"
                          v-model="transferFromSelectInput"
                          @click="selects.transfersPopup.from = false"/>
                      <!--                      <span-->
                      <!--                        class="select-trigger__name"-->
                      <!--                      >-->
                      <!--                        {{ dataSelects.pointsTransferFrom.find(item => item.active) ? dataSelects.pointsTransferFrom.find(item => item.active).title : 'Select'}}-->
                      <!--                      </span>-->
                      <span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                        ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner js-scrollbar">
                        <div
                            v-for="item in tranferFromSelectOptions"
                            :key="item.id + Math.random()"
                            :class="[
                            'select-option',
                            {
                              'is-selected':
                                dataSelects.pointsTransferFrom.find(
                                  (item) => item.active
                                ) &&
                                dataSelects.pointsTransferFrom.find(
                                  (item) => item.active
                                ).title === item.title,
                            },
                          ]"
                            @click="
                            dataSelects.pointsTransferFrom =
                              dataSelects.pointsTransferFrom.map((point) => ({
                                ...point,
                                active: point.id === item.id,
                              }))
                            transferFromSelectInput =
                              dataSelects.pointsTransferFrom.find(
                                (item) => item.active
                              ).title
                            searchPrice(dataSelects)
                          ">
                          <span class="select-option__name">{{
                              item.title
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                      style="
                      color: #606060;
                      margin-top: 10px;
                      margin-bottom: 10px;
                    "
                      v-if="dataSelects.pointsTransferFrom.find((x) => x.active)">
                    {{
                      dataSelects.pointsTransferFrom.find((x) => x.active).path
                          .territory
                    }}
                    >
                    {{
                      dataSelects.pointsTransferFrom.find((x) => x.active).path
                          .location
                    }}
                    >
                    {{
                      dataSelects.pointsTransferFrom.find((x) => x.active).path
                          .area
                    }}
                  </div>
                </div>
              </div>
              <div
                  class="edit-popup--activity__add__col dep-arr-chevron"
                  style="height: 68px">
                <div class="form-control-group-divider">
                  <svg
                      width="1em"
                      height="1em"
                      class="icon icon-chevron-double">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron-double"></use>
                  </svg>
                </div>
              </div>
              <div class="edit-popup--activity__add__col" style="height: 88px">
                <div class="form-control-group">
                  <span class="form-control-label">Arrival</span>
                  <div
                      :class="[
                      'select-wrapper',
                      {'is-active': selects.transfersPopup.to},
                    ]"
                      @click="changeSelectsTransfers('to')">
                    <div class="select-trigger">
                      <input
                          type="text"
                          class="select-trigger__name"
                          placeholder="Select"
                          :style="{border: 'none'}"
                          v-model="transferToSelectInput"
                          @click="selects.transfersPopup.to = false"/>
                      <!--                      <span-->
                      <!--                        class="select-trigger__name">{{-->
                      <!--                        dataSelects.pointsTransferTo.find(item => item.active) ? dataSelects.pointsTransferTo.find(item => item.active).title : 'Select'-->
                      <!--                      }}</span>-->
                      <span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                        ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner js-scrollbar">
                        <div
                            v-for="item in tranferToSelectOptions"
                            :key="item.id + Math.random()"
                            :class="[
                            'select-option',
                            {
                              'is-selected':
                                dataSelects.pointsTransferTo.find(
                                  (item) => item.active
                                ) &&
                                dataSelects.pointsTransferTo.find(
                                  (item) => item.active
                                ).title === item.title,
                            },
                          ]"
                            @click="
                            dataSelects.pointsTransferTo =
                              dataSelects.pointsTransferTo.map((point) => ({
                                ...point,
                                active: point.id === item.id,
                              }))
                            transferToSelectInput =
                              dataSelects.pointsTransferTo.find(
                                (item) => item.active
                              ).title
                            searchPrice(dataSelects)
                          ">
                          <span class="select-option__name">{{
                              item.title
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                      style="
                      color: #606060;
                      margin-top: 10px;
                      margin-bottom: 10px;
                    "
                      v-if="dataSelects.pointsTransferTo.find((x) => x.active)">
                    {{
                      dataSelects.pointsTransferTo.find((x) => x.active).path
                          .territory
                    }}
                    >
                    {{
                      dataSelects.pointsTransferTo.find((x) => x.active).path
                          .location
                    }}
                    >
                    {{
                      dataSelects.pointsTransferTo.find((x) => x.active).path
                          .area
                    }}
                  </div>
                </div>
              </div>
              <div
                  class="edit-popup--activity__add__col"
                  style="height: 64px"
                  v-if="
                  transfersPopupData.error == null &&
                  transfersPopupData.price != null
                ">
                <label
                    for="chk_310__alternative"
                    class="form-control-checkbox form-control-checkbox-pickup">
                  <input
                      id="chk_310__alternative"
                      type="checkbox"
                      v-model="transfersPopupData.alternative"/>
                  <span class="form-control-checkbox__box">
                    <svg width="1em" height="1em" class="icon icon-check">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                    </svg>
                  </span>
                  <span class="form-control-checkbox__name"
                  >Alternative Price</span
                  >
                </label>
              </div>
              <div
                  class="edit-popup--activity__add__col"
                  style="height: 64px"
                  v-if="transfersPopupData.error != null">
                <label
                    for="chk_310__alternative"
                    class="form-control-checkbox form-control-checkbox-pickup">
                  <span
                      class="form-control-checkbox__name"
                      style="color: #e85c20"
                  >{{ transfersPopupData.error }}</span
                  >
                </label>
              </div>
              <div
                  class="edit-popup--activity__add__col"
                  style="height: 74px"
                  v-if="
                  transfersPopupData.alternative &&
                  transfersPopupData.price != null
                ">
                <div class="form-control-group">
                  <span class="form-control-label">&nbsp;</span>
                  <div
                      :class="[
                      'select-wrapper',
                      {'is-active': selects.transfersPopup.price},
                    ]"
                      @click="changeSelectsTransfers('price')"
                      :style="{
                      opacity: 1,
                      cursor: 'pointer',
                      pointerEvents: 'auto',
                    }">
                    <div class="select-trigger" style="width: 26em">
                      <span class="select-trigger__name">
                        {{ transfersPopupData.price.departure }}
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-chevron-double"
                            style="
                            margin-left: 10px;
                            margin-right: 10px;
                            margin-top: -2px;
                          ">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron-route"></use>
                        </svg>
                        {{ transfersPopupData.price.arrival }}
                      </span>
                      <span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                        ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner js-scrollbar" v-if="true">
                        <div
                            v-for="item in this.dataSelects.transfersAll"
                            :key="item.id + Math.random()"
                            :class="['select-option', {'is-selected': true}]"
                            @click="transfersPopupData.price = item">
                          <span
                              class="select-trigger__name"
                              style="font-size: 1rem; width: calc(100% - 1rem)">
                            {{ item.departure }}
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-chevron-double"
                                style="
                                margin-left: 10px;
                                margin-right: 10px;
                                margin-top: -2px;
                              ">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron-route"></use>
                            </svg>
                            {{ item.arrival }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                  class="edit-popup--activity__add__col edit-popup--activity__add__col-time"
                  :style="{marginLeft: '0px', height: '88px'}">
                <div class="form-control-group">
                  <span class="form-control-label">Pick Up Time</span>
                  <div
                      :class="[
                      'form-control-wrap',
                      {'is-error': transfersPopupData.timeError},
                    ]">
                    <the-mask
                        type="text"
                        v-model="transfersPopupData.time"
                        :disabled="transfersPopupData.confirmed"
                        @input="
                        transfersPopupData.time =
                          +transfersPopupData.time.slice(0, 2) > 23
                            ? 23
                            : transfersPopupData.time
                        transfersPopupData.time.length === 4
                          ? (transfersPopupData.time =
                              +transfersPopupData.time.slice(2, 5) > 59
                                ? transfersPopupData.time.slice(0, 2) + '59'
                                : transfersPopupData.time)
                          : false
                      "
                        class="form-control form-control-time"
                        :mask="'##:##'"
                        placeholder="--:--"/>
                  </div>
                </div>
              </div>
              <div class="edit-popup--activity__add__col" style="height: 88px">
                <div class="form-control-group">
                  <span class="form-control-label">Pax:</span>
                  <div
                      :class="[
                      'select-wrapper select-wrapper--xs',
                      {'is-active': selects.transfersPopup.pax},
                    ]"
                      @click="changeSelectsTransfers('pax')"
                      :style="{
                      opacity: !participants.length ? 0.6 : 1,
                      cursor: !participants.length ? 'default' : 'pointer',
                      pointerEvents: !participants.length ? 'none' : 'auto',
                    }">
                    <div class="select-trigger">
                      <span class="select-trigger__name">{{
                          transfersPopupData.pax || '-'
                        }}</span
                      ><span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                        ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner js-scrollbar">
                        <div
                            v-for="pax in Array(participants.length)
                            .fill(true)
                            .map((_, i) => i + 1)"
                            :key="pax"
                            :class="[
                            'select-option',
                            {'is-selected': pax === transfersPopupData.pax},
                          ]"
                            @click="onTransferPaxClick(pax)">
                          <span class="select-option__name">{{ pax }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tour-program-table__btn-group">
                <button
                    :disabled="participants.length !== transfersPopupData.pax"
                    @click="onAutocompletePaxClick"
                    type="button"
                    data-popover="Autocomplete participants"
                    class="btn btn--green btn--sm-squared btn--popover dark">
                  <svg width="1em" height="1em" class="icon icon-autocomplete">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-autocomplete"></use>
                  </svg>
                </button>
              </div>
              <div :style="{width: '100%'}"></div>
              <div class="edit-popup--activity__add__col" style="height: 44px">
                <label
                    for="chk_110__free"
                    class="form-control-checkbox form-control-checkbox-free form-control-checkbox-free--left">
                  <input
                      id="chk_110__free"
                      type="checkbox"
                      v-model="transfersPopupData.confirmed"
                      @change="transfersPopupData.time = ''"/><span
                    class="form-control-checkbox__box">
                    <svg width="1em" height="1em" class="icon icon-check">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                ><span class="form-control-checkbox__name"
                >Pick Up Time to be confirmed</span
                >
                </label>
              </div>
              <div class="edit-popup--activity__add__col" style="height: 44px">
                <label
                    for="chk_1__free"
                    class="form-control-checkbox form-control-checkbox-free">
                  <input
                      id="chk_1__free"
                      type="checkbox"
                      v-model="transfersPopupData.free"/><span
                    class="form-control-checkbox__box">
                    <svg width="1em" height="1em" class="icon icon-check">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                ><span class="form-control-checkbox__name form-control__help"
                >Free of charge, incl on package<span
                    class="form-control__help-icon">
                      <span class="form-control__help-content"
                      >Если трансфер включен в стоимость восхождения или же вы
                        хотите сделать трансфер бесплатным - поставьте галочку.
                        Стоимость данной поездки будет равна нулю.</span
                      >
                      <img
                          src="/images/useful/svg/help-icon.svg"
                          alt=""/> </span
                ></span>
                </label>
              </div>
              <div class="edit-popup__add-transfer">
                <div class="form-control-group form-control-group--radio">
                  <label
                      class="form-control-radio"
                  >
                    <input
                        type="radio"
                        name="transfer_activity_radio"
                        v-model="transfersPopupData.timeActivity"
                        :value="true"
                    />
                    <span
                        class="form-control-radio__box"></span
                    ><span class="form-control-radio__name"
                  >Before the Activity</span
                  >
                  </label>
                  <label
                      class="form-control-radio"
                  >
                    <input
                        type="radio"
                        name="transfer_activity_radio"
                        v-model="transfersPopupData.timeActivity"
                        :value="false"
                    /><span
                      class="form-control-radio__box"></span
                  ><span class="form-control-radio__name"
                  >After the Activity</span
                  >
                  </label>
                </div>
              </div>
              <div
                  class="col-selects selects-row selects-row_1 fix-transfer-participants">
                <div
                    class="col-offset"
                    v-for="(item, i) in transfersPopupData.participants"
                    :key="i">
                  <div
                      class="form-control-group form-control-group-client"
                      :style="{height: '36px'}">
                    <div
                        :class="['select-wrapper', {'is-active': item.open}]"
                        @click="
                        changeSelectsTransfers()
                        transfersPopupData.participants =
                          transfersPopupData.participants.map((pli, plii) => ({
                            ...pli,
                            open: i === plii ? !pli.open : false,
                          }))
                      ">
                      <div class="form-control-group-client-icon">
                        <svg
                            width="1em"
                            height="1em"
                            :class="
                            'icon icon-' +
                            (item.ageType === 'teenager'
                              ? 'teenager'
                              : item.ageType === 'child'
                              ? 'child'
                              : 'adult')
                          ">
                          <use
                              :xlink:href="
                              '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                              (item.ageType === 'teenager'
                                ? 'teenager'
                                : item.ageType === 'child'
                                ? 'child'
                                : 'adult')
                            "></use>
                        </svg>
                      </div>
                      <div class="select-trigger">
                        <span class="select-trigger__name">{{
                            item.id ? item.name : ''
                          }}</span
                        ><span class="select-trigger__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                      </div>
                      <div class="select-body">
                        <div class="select-inner js-scrollbar">
                          <div
                              class="select-option"
                              v-for="(p, idx) in participants.filter(
                              (p) =>
                                !transfersPopupData.participants
                                  .map((pli) => pli.id)
                                  .includes(p.id)
                            )"
                              :key="idx"
                              @click="
                              item.id = p.id
                              item.name = p.name
                              item.ageType = p.ageType
                            ">
                            <span class="select-option__name">{{
                                p.name
                              }}</span>
                          </div>
                          <div
                              class="select-option"
                              v-if="item.id"
                              @click="
                              item.id = null
                              item.name = ''
                              item.ageType = null
                            ">
                            <span class="select-option__name">--</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="edit-popup--activity__add__submit">
                <button
                    type="button"
                    class="btn btn--rounded2 btn--green btn--add"
                    :disabled="
                    !dataSelects.pointsTransferFrom.find(
                      (item) => item.active
                    ) ||
                    transfersPopupData.price == null ||
                    !dataSelects.pointsTransferTo.find((item) => item.active) ||
                    !transfersPopupData.pax ||
                    (!transfersPopupData.time &&
                      !transfersPopupData.confirmed) ||
                    (transfersPopupData.time.length < 4 &&
                      !transfersPopupData.confirmed)
                  "
                    @click="
                    () => {
                      let price = null
                      if (
                        +transfersPopupData.pax > 0 &&
                        +transfersPopupData.pax <= 3
                      ) {
                        price = transfersPopupData.price.pax1_3
                      } else if (
                        +transfersPopupData.pax > 3 &&
                        +transfersPopupData.pax <= 6
                      ) {
                        price = transfersPopupData.price.pax4_6
                      } else {
                        price = transfersPopupData.price.pax7_10
                      }

                      transfersPopupData.transfersData =
                        transfersPopupData.transfersData.concat({
                          firstDay: transfersPopup.firstDay,
                          free: transfersPopupData.free,
                          confirmed: transfersPopupData.confirmed,
                          date: transfersPopup.date
                            ? dateCalcStart(
                                +new Date(
                                  +('20' + transfersPopup.date.split('/')[2]),
                                  +transfersPopup.date.split('/')[1] - 1,
                                  +transfersPopup.date.split('/')[0]
                                ).getTime()
                              )
                            : '',
                          day: transfersPopup.day,
                          pax: transfersPopupData.pax,
                          time:
                            transfersPopupData.time.slice(0, 2) +
                            ':' +
                            transfersPopupData.time.slice(2, 5),
                          from: dataSelects.pointsTransferFrom.find(
                            (item) => item.active
                          )
                            ? dataSelects.pointsTransferFrom.find(
                                (item) => item.active
                              ).title
                            : '',
                          fromId: dataSelects.pointsTransferFrom.find(
                            (item) => item.active
                          )
                            ? dataSelects.pointsTransferFrom.find(
                                (item) => item.active
                              ).id
                            : '',
                          to: dataSelects.pointsTransferTo.find(
                            (item) => item.active
                          )
                            ? dataSelects.pointsTransferTo.find(
                                (item) => item.active
                              ).title
                            : '',
                          toId: dataSelects.pointsTransferTo.find(
                            (item) => item.active
                          )
                            ? dataSelects.pointsTransferTo.find(
                                (item) => item.active
                              ).id
                            : '',
                          clients:
                            participants.length === 2 &&
                            transfersPopupData.pax === 2
                              ? participants.map((p) => ({
                                  name: p.name,
                                  id: p.id,
                                  ageType: p.ageType,
                                }))
                              : participants.length === 1 &&
                                transfersPopupData.pax === 1
                              ? participants.map((p) => ({
                                  name: p.name,
                                  id: p.id,
                                  ageType: p.ageType,
                                }))
                              : transfersPopupData.participants,
                          price: price,
                          transferId: transfersPopupData.price.id,
                          timeActivity: transfersPopupData.timeActivity,
                        })
                      isEditFlag = true
                    }
                  ">
                  <svg width="1em" height="1em" class="icon icon-plus-o-white">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                  </svg>
                  <span>Add Transfer</span>
                </button>
              </div>
            </div>
            <div class="edit-popup--activity__table">
              <div
                  class="edit-popup__title edit-popup__title--between"
                  :style="{marginBottom: '2rem'}">
                <span>Transfers</span>
                <div
                    v-if="transfersPopupData.transfersData.length < 1"
                    class="edit-popup--activity__alert edit-popup--activity__alert--no-m">
                  <div class="edit-popup--activity__alert-block">
                    <svg width="1em" height="1em" class="icon icon-alert">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-alert"></use>
                    </svg>
                    <span>No transfers added. Please add a transfer before saving</span>
                  </div>
                </div>
              </div>
              <div
                  v-for="(item, index) in transfersPopupData.transfersData.filter(
                  (item) => item.firstDay === transfersPopup.firstDay
                )"
                  :key="index"
                  class="section-table-wrap">
                <div
                    :class="[
                    'section-table section-table--activities',
                    {'section-table--free': item.free},
                  ]"
                    :style="{
                    marginBottom: '0px',
                    marginTop: '0px',
                    width: '100%',
                  }">
                  <span
                      class="section-table--free__title"
                      :style="{height: '20px', marginTop: '20px'}"
                      v-if="item.free"
                  >Free of charge, incl on package
                    <img src="/images/icons/free.svg" alt=""
                    /></span>
                  <div class="section-table__body">
                    <div
                        class="section-table__row"
                        :style="{marginBottom: '5px'}">
                      <div class="col col-day">
                        <div class="col-day__label">
                          <span
                          ><b
                          >DAY
                              {{
                              item.firstDay
                                  ? transfersPopup.day
                                  : transfersPopup.climb
                                      ? transfersPopup.day +
                                      (transfersPopup.climb.durationDays ||
                                          transfersPopup.climb.duration) -
                                      1
                                      : transfersPopup.day
                            }}</b
                          >
                            {{ transfersPopup.date }}</span
                          >
                        </div>
                      </div>
                      <div class="col col-activity">
                        <span>{{ item.from }} - {{ item.to }}</span>
                      </div>
                      <div class="col col-activity-persons">
                        <span
                        >Pax: <b>{{ item.pax }}</b></span
                        >
                      </div>
                      <div
                          class="col col-pick-up-time"
                          :style="{
                          whiteSpace: 'unset',
                          marginLeft: 'unset',
                          position: 'static',
                          paddingLeft: '0px',
                          marginRight: '0px',
                        }">
                        <span
                        >{{
                            item.time.length === 5
                                ? 'Pick up time:'
                                : 'To be confirmed'
                          }}
                          <b>{{
                              item.time.length < 5 ? '' : item.time
                            }}</b></span
                        >
                      </div>
                      <div
                          class="col col-pick-up-time"
                          :style="{
                          marginLeft: 'unset',
                          marginRight: '0',
                          paddingLeft: '12px',
                        }">
                        <span
                        >{{ item.timeActivity ? 'Before' : 'After' }} the
                          activity</span
                        >
                      </div>
                      <div class="col col-action" :style="{marginLeft: 'auto'}">
                        <button
                            type="button"
                            class="btn btn--remove"
                            @click="
                            $emit('deleteModalHandler', {
                              entity: 'Transfer',
                              name: 'this',
                              handler: () =>
                                (transfersPopupData.transfersData =
                                  transfersPopupData.transfersData.filter(
                                    (_, i) => !(i === index)
                                  )),
                              id: null,
                            })
                          ">
                          <svg width="1em" height="1em" class="icon icon-close">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>

                      <div
                          class="col col-selects"
                          :style="{
                          borderTop: '1px solid #e3e3e3',
                          paddingTop: '6px',
                          marginTop: '6px',
                        }">
                        <div
                            class="form-control-group form-control-group-client"
                            v-for="(
                            clientOption, clientOptionIndex
                          ) in item.clients"
                            :key="clientOptionIndex">
                          <div
                              :class="[
                              'select-wrapper',
                              {'is-active': clientOption.isOpen},
                              {'is-error': clientOption.error},
                            ]"
                              @click="
                              clientOption.error = false
                              item.clients = item.clients.map((c, ci) => ({
                                ...c,
                                isOpen:
                                  clientOptionIndex === ci ? !c.isOpen : false,
                              }))
                            ">
                            <div class="form-control-group-client-icon">
                              <svg
                                  width="1em"
                                  height="1em"
                                  :class="
                                  'icon icon-' +
                                  (clientOption.ageType || 'adult')
                                ">
                                <use
                                    :xlink:href="
                                    '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                                    (clientOption.ageType || 'adult')
                                  "></use>
                              </svg>
                            </div>
                            <div class="select-trigger">
                              <span class="select-trigger__name">{{
                                  clientOption.name
                                }}</span
                              ><span class="select-trigger__icon">
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-chevron">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                                ></span>
                            </div>
                            <div class="select-body">
                              <div
                                  v-if="clientOption.name.length > 0"
                                  :class="[
                                  'select-option',
                                  {'is-selected': true},
                                ]"
                                  @click="
                                  clientOption.name = ''
                                  clientOption.id = ''
                                ">
                                --
                              </div>
                              <div
                                  v-for="(
                                  client, clientIndex
                                ) in participants.filter(
                                  (par) =>
                                    !transfersPopupData.transfersData
                                      .filter(
                                        (data) =>
                                          data.firstDay ===
                                          transfersPopup.firstDay
                                      )
                                      .map((data) => data.clients)
                                      .flat()
                                      .map((client) => client.id)
                                      .includes(par.id)
                                )"
                                  :key="clientIndex"
                                  :class="[
                                  'select-option',
                                  {
                                    'is-selected':
                                      clientOption.name === client.name,
                                  },
                                ]"
                                  @click="
                                  clientOption.name =
                                    client.name || 'Adult ' + (clientIndex + 1)
                                  clientOption.id = client.id
                                  clientOption.ageType = client.ageType
                                ">
                                <span class="select-option__name">{{
                                    client.name || 'Adult ' + (clientIndex + 1)
                                  }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
                v-if="transfersPopupData.transfersData.length > 0"
                class="edit-popup--activity__alert">
              <div class="edit-popup--activity__alert-block">
                <svg width="1em" height="1em" class="icon icon-alert">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-alert"></use>
                </svg>
                <span
                >Please double check if you’ve added all the transfers before
                  saving</span
                >
              </div>
            </div>
            <div class="edit-popup--activity__submit">
              <button
                  type="reset"
                  class="btn btn--silver"
                  @click="
                  $emit('deleteModalHandler', {
                    entity: 'Data',
                    name: 'this',
                    handler: resetTransferPopup,
                    id: null,
                  })
                ">
                <span>Reset</span>
              </button>
              <button
                  type="submit"
                  class="btn btn--green"
                  @click="
                  () => {
                    if (checkTransfersErrors()) {
                      return false
                    }
                    transfersPopupData.pax = null
                    transfersPopupData.free = false
                    transfersPopupData.time = ''
                    transfersPopupData.alternative = ''
                    transfersPopupData.participants = []
                    dataSelects.pointsTransferFrom =
                      dataSelects.pointsTransferFrom.map((transfer) => ({
                        ...transfer,
                        active: false,
                      }))
                    dataSelects.pointsTransferTo =
                      dataSelects.pointsTransferTo.map((transfer) => ({
                        ...transfer,
                        active: false,
                      }))
                    transfersPopup.transfersData = transfersPopup.transfersData
                      .filter((t) => t.firstDay === !transfersPopup.firstDay)
                      .concat(
                        ...JSON.parse(
                          JSON.stringify(transfersPopupData.transfersData)
                        )
                      )
                    transfersPopup = false
                    transferToSelectInput = ''
                    transferFromSelectInput = ''
                  }
                ">
                <span>Save</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && hotelPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner" :style="{alignItems: 'flex-start'}">
        <div class="edit-popup edit-popup--choose-hotel">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon edit-popup__title__icon--mod">
                <svg width="1em" height="1em" class="icon icon-house">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-house"></use>
                </svg>
              </div>
              <span>Choose hotel</span>
            </div>

            <div class="edit-popup__close" @click="hotelPopup = false; clearSelectedHotelInModal();">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form
              action="javascript:void(0)"
              class="edit-popup--choose-hotel__form">
            <div class="edit-popup--choose-hotel__add">
              <div class="edit-popup--choose-hotel__add__col">
                <div class="form-control-group">
                  <span
                      v-if="
                      hotelsClosedMinNights.closed.length &&
                      isHotelClosedThisDay
                    "
                      class="form-control__help-icon form-control__help-hotel">
                    <span class="form-control__help-content">
                      <p><span>Hotel closed during</span></p>
                      <p>
                        {{
                          parseDateToString(
                              hotelsClosedMinNights.closed[0].dateFrom
                          )
                        }}
                        -
                        {{
                          parseDateToString(
                              hotelsClosedMinNights.closed[0].dateTo
                          )
                        }}
                      </p>
                    </span>
                    <img src="/images/icons/hotel-closed.svg" alt=""/>
                  </span>
                  <span
                      v-if="
                      ((hotelsClosedMinNights.minNights.length &&
                        isHotelMinNightThisDay) ||
                        hotelNotes) &&
                      !isHotelClosedThisDay
                    "
                      class="form-control__help-icon form-control__help-hotel form-control__help-minimum">
                    <span class="form-control__help-content">
                      <template
                          v-if="
                          hotelsClosedMinNights.minNights.length &&
                          isHotelMinNightThisDay
                        ">
                        <p>
                          <span
                          >Minimum Nights Stay -
                            {{
                              hotelsClosedMinNights.minNights[0].minNights
                            }}</span
                          >
                        </p>
                        <p>
                          Valid from
                          {{
                            parseDateToString(
                                hotelsClosedMinNights.minNights[0].dateFrom
                            )
                          }}
                          - to
                          {{
                            parseDateToString(
                                hotelsClosedMinNights.minNights[0].dateTo
                            )
                          }}
                        </p>
                      </template>
                      <span v-if="hotelNotes">
                        Notes: <span v-html="hotelNotes"></span>
                      </span>
                    </span>
                    <img src="/images/icons/minimum-nights.svg" alt=""/>
                  </span>
                  <div style="display: flex;">
                    <span class="form-control-label">Hotel Name</span>
                    <span class="hotel-alert__help-icon"
                          v-if="hotelSelectOptions.find((hotel) => hotel.names['EN'] === hotelSelectInput) && hotelSelectOptions.find((hotel) => hotel.names['EN'] === hotelSelectInput).concessionWarning">
                    <span class="hotel-alert__help-content">Concession fees are not included
                    </span>
                    <svg
                        class="icon hotel-location__alert-icon important-icon">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-important"></use>
                </svg>
                  </span>
                  </div>

                  <div
                      :class="[
                      'select-wrapper select-wrapper--xl hotel-select-wrapper',
                      {'is-active': selects.hotelPopup.hotel},
                    ]"
                      @click="changeSelectsHotels('hotel')"
                      :style="{
                      opacity:
                        dataSelects.accommodations.find(
                          (item) => item.active
                        ) ||
                        !dataSelects.hotels.length ||
                        hotelPopupData.hotelsData.length
                          ? 0.6
                          : 1,
                      cursor:
                        dataSelects.accommodations.find(
                          (item) => item.active
                        ) ||
                        !dataSelects.hotels.length ||
                        hotelPopupData.hotelsData.length
                          ? 'default'
                          : 'pointer',
                      pointerEvents:
                        dataSelects.accommodations.find(
                          (item) => item.active
                        ) ||
                        !dataSelects.hotels.length ||
                        hotelPopupData.hotelsData.length
                          ? 'none'
                          : 'auto',
                    }">
                    <div class="select-trigger hotel-select-trigger">
                      <svg
                          v-if="isSelectedHotelDisplayed && hotelPopupData.hotel.preferredPartnerLevel"
                          width="21"
                          height="15"
                          class="hotel-preferred-partner-icon hotel-preferred-partner-icon--trigger"
                          aria-hidden="true">
                        <use
                            :xlink:href="`/images/useful/svg/theme/symbol-defs.svg#preferred-icon-${hotelPopupData.hotel.preferredPartnerLevel.toLowerCase()}`"></use>
                      </svg>
                      <div class="hotel-select-trigger__input-wrapper">
                        <input
                            type="text"
                            class="select-trigger__name"
                            :class="{
                              'hotel-select-trigger__name--with-preferred-partner':
                                isSelectedHotelDisplayed && hotelPopupData.hotel.preferredPartnerLevel,
                              'hotel-select-trigger__name--with-badge':
                                isSelectedHotelDisplayed &&
                                (hotelPopupData.hotel.bestPrice === true ||
                                  hotelPopupData.hotel.lowPriority === true),
                              'hotel-select-trigger__name--with-two-badges':
                                isSelectedHotelDisplayed &&
                                hotelPopupData.hotel.bestPrice === true &&
                                hotelPopupData.hotel.lowPriority === true,
                            }"
                            v-model="hotelSelectInput"
                            :style="{border: 'none', outline: 'none'}"
                            @click="selects.hotelPopup.hotel = false"/>
                        <div
                            v-if="isSelectedHotelDisplayed &&
                              (hotelPopupData.hotel.bestPrice === true ||
                                hotelPopupData.hotel.lowPriority === true)"
                            :class="[
                              'hotel-select-trigger__badge-positioner',
                              {
                                'hotel-select-trigger__badge-positioner--with-preferred-partner':
                                  isSelectedHotelDisplayed && hotelPopupData.hotel.preferredPartnerLevel,
                              },
                            ]"
                            aria-hidden="true">
                          <span class="hotel-select-trigger__text-measure">{{ hotelSelectInput }}</span>
                          <img
                              v-if="hotelPopupData.hotel.bestPrice === true"
                              class="hotel-best-price-badge hotel-best-price-badge--trigger"
                              src="/images/useful/svg/hotel-best-price.svg"
                              alt="">
                          <img
                              v-if="hotelPopupData.hotel.lowPriority === true"
                              class="hotel-low-priority-badge hotel-low-priority-badge--trigger"
                              src="/images/useful/svg/hotel-low-priority.svg"
                              alt="">
                        </div>
                      </div>
                      <span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                        </svg>
                      </span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner js-scrollbar">
                        <div
                            v-for="item in hotelSelectOptions"
                            :key="item.id"
                            :class="[
                            'select-option',
                            'hotel-select-option',
                            {
                              'is-selected':
                                hotelPopupData.hotel &&
                                item.id === hotelPopupData.hotel.id,
                            },
                          ]"
                            @click="
                            hotelSelectInput = item.names.EN
                            getHotelsMinNightAndClosedDays(item.id)
                            hotelPopupData.hotel = item
                            getHotelData(item.id)
                            hotelPopupData.price = ''
                            hotelPopupData.meal = null
                            hotelPopupData.room = null
                            dataSelects.accommodations = []
                          ">
                          <svg
                              v-if="item.preferredPartnerLevel"
                              width="21"
                              height="15"
                              class="hotel-preferred-partner-icon hotel-preferred-partner-icon--option"
                              aria-hidden="true">
                            <use
                                :xlink:href="`/images/useful/svg/theme/symbol-defs.svg#preferred-icon-${item.preferredPartnerLevel.toLowerCase()}`"></use>
                          </svg>
                          <span class="select-option__name">{{
                              item.names.EN
                            }}</span>
                          <img
                              v-if="item.bestPrice === true"
                              class="hotel-best-price-badge hotel-best-price-badge--option"
                              src="/images/useful/svg/hotel-best-price.svg"
                              alt="Best Price">
                          <img
                              v-if="item.lowPriority === true"
                              class="hotel-low-priority-badge hotel-low-priority-badge--option"
                              src="/images/useful/svg/hotel-low-priority.svg"
                              alt="Low Priority">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                  class="edit-popup--choose-hotel__add__col edit-popup--choose-hotel__add__col-meal">
                <div class="form-control-group">
                  <span class="form-control-label">Meal Plan</span>
                  <div
                      :class="[
                      'select-wrapper select-wrapper--xs hotel-meal-plan-select',
                      {'is-active': selects.hotelPopup.meal},
                    ]"
                      @click="changeSelectsHotels('meal')"
                      :style="{
                      opacity:
                        !dataSelects.meal.mealPlanTypes.length ||
                        hotelPopup.hotelsData.length
                          ? 0.6
                          : 1,
                      cursor:
                        !dataSelects.meal.mealPlanTypes.length ||
                        hotelPopup.hotelsData.length
                          ? 'default'
                          : 'pointer',
                      pointerEvents:
                        !dataSelects.meal.mealPlanTypes.length ||
                        hotelPopup.hotelsData.length
                          ? 'none'
                          : 'auto',
                    }">
                    <div class="select-trigger">
                      <span class="select-trigger__name">{{
                          hotelPopupData.meal ? hotelPopupData.meal : '--'
                        }}</span>
                      <span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                        </svg>
                      </span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner js-scrollbar">
                        <div
                            v-for="(item, index) in dataSelects.meal
                            .mealPlanTypes"
                            :key="index"
                            :class="[
                            'select-option',
                            {
                              'is-selected':
                                hotelPopupData.meal &&
                                item.type === hotelPopupData.meal.type,
                            },
                          ]"
                            @click="
                            hotelPopupData.meal = item
                            hotelPopupData.price = ''
                          ">
                          <span class="select-option__name">{{ item }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="edit-popup--choose-hotel__add__col">
                <div class="form-select-group">
                  <div class="form-control-group">
                    <div
                        :class="[
                        'select-wrapper hotel-room-type-select',
                        {'is-active': selects.hotelPopup.room},
                      ]"
                        @click="changeSelectsHotels('room')"
                        :style="{
                        opacity: !dataSelects.room.length ? 0.6 : 1,
                        cursor: !dataSelects.room.length
                          ? 'default'
                          : 'pointer',
                        pointerEvents: !dataSelects.room.length
                          ? 'none'
                          : 'auto',
                      }">
                      <div class="select-label"><span>Room Type</span></div>
                      <div class="select-trigger">
                        <input
                            type="text"
                            class="select-trigger__name"
                            v-model="hotelSelectInputRoom"
                            :style="{border: 'none', outline: 'none'}"
                            @click="selects.hotelPopup.room = false"/>
                        <span class="select-trigger__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                          </svg>
                        </span>
                      </div>
                      <div class="select-body">
                        <div class="select-inner js-scrollbar">
                          <div
                              v-for="(item, index) in hotelSelectRoomOptions"
                              :key="index"
                              :class="[
                              'select-option',
                              {
                                'is-selected':
                                  hotelPopupData.room &&
                                  item.id === hotelPopupData.room.id,
                              },
                            ]"
                              @click="
                              hotelSelectInputRoom = item.names.EN
                              hotelPopupData.room = item
                              getRoomAccommodationsHandler(item.accommodations)
                            ">
                            <span class="select-option__name">{{
                                item.names.EN
                              }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="edit-popup--choose-hotel__wrapper">
                <div
                    class="edit-popup--choose-hotel__add__col"
                    v-for="(item, index) in dataSelects.accommodations"
                    :key="index">
                  <div class="form-control-group">
                    <label
                        class="form-control-checkbox-person"
                        @click.prevent="
                        dataSelects.accommodations =
                          dataSelects.accommodations.map((room, i) => ({
                            ...room,
                            active: i === index ? !room.active : false,
                          }))
                        calcHotelPrice(hotelPopup.day)
                      ">
                      <input
                          type="checkbox"
                          :checked="item.active"
                          @click.prevent/>
                      <div class="form-control-checkbox-person__box">
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-adult"
                            v-for="(icon, i) in Array(
                            item.data.find((d) => d.type === 'A')
                              ? item.data.find((d) => d.type === 'A').count
                              : 0
                          )"
                            :key="i + 'A'">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                        </svg>
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-teenager"
                            v-for="(icon, i) in Array(
                            item.data.find((d) => d.type === 'T')
                              ? item.data.find((d) => d.type === 'T').count
                              : 0
                          )"
                            :key="i + 'T'">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                        </svg>
                        <svg
                            width="1em"
                            height="1em"
                            class="icon icon-child"
                            v-for="(icon, i) in Array(
                            item.data.find((d) => d.type === 'C')
                              ? item.data.find((d) => d.type === 'C').count
                              : 0
                          )"
                            :key="i + 'C'">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                        </svg>
                        <span class="form-control-checkbox-person__icon">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-check-rounded">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check-rounded"></use>
                          </svg>
                        </span>
                      </div>
                    </label>
                  </div>
                </div>
                <div
                    class="edit-popup--choose-hotel__add__col edit-popup--choose-hotel__add__col-sto">
                  <span
                      class="edit-popup--choose-hotel-sto form-control__help"
                      :class="{
                      'edit-popup--choose-hotel-sto--margin':
                        hotelPopupData.price &&
                        hotelPopupData.price.split(' ')[0] === '0',
                      'edit-popup--choose-hotel-sto--red':
                        hotelPopupData.price &&
                        hotelPopupData.price.split(' ')[0] === '0',
                    }">
                    <span>STO Rate:</span>
                    {{ hotelPopupData.price }}
                    <span
                        v-show="
                        hotelPopupData.price &&
                        hotelPopupData.price.split(' ')[0] === '0'
                      "
                        class="form-control__help-icon">
                      <span
                          class="form-control__help-content"
                          style="color: #7a7a7a"
                      >Для данного отеля в выбранный сезон не установлено
                        цены. Обратитесь к администратору системы и проверьте
                        документ контрактных цен.</span
                      >
                      <img src="/images/useful/svg/help-red-icon.svg" alt=""/>
                    </span>
                  </span>
                  <div
                      :class="[
                      'select-wrapper select-wrapper--xl select-wrapper--hotels',
                      {'is-active': selects.hotelPopup.alternative},
                    ]">
                    <div class="select-trigger select-trigger--hotels">
                      <button
                          type="button"
                          class="btn btn--green btn--sm-squared"
                          @click="
                          changeSelectsHotels('alternative')
                          selects.hotelPopup.alternative
                            ? getAlternativeHotelsHandler()
                            : false
                        "
                          :style="{
                          opacity:
                            !hotelPopupData.hotel ||
                            !hotelPopupData.hotel.names.EN ||
                            !hotelPopupData.meal ||
                            !hotelPopupData.room ||
                            !dataSelects.accommodations.find(
                              (item) => item.active
                            )
                              ? 0.6
                              : 1,
                          cursor:
                            !hotelPopupData.hotel ||
                            !hotelPopupData.hotel.names.EN ||
                            !hotelPopupData.meal ||
                            !hotelPopupData.room ||
                            !dataSelects.accommodations.find(
                              (item) => item.active
                            )
                              ? 'default'
                              : 'pointer',
                          pointerEvents:
                            !hotelPopupData.hotel ||
                            !hotelPopupData.hotel.names.EN ||
                            !hotelPopupData.meal ||
                            !hotelPopupData.room ||
                            !dataSelects.accommodations.find(
                              (item) => item.active
                            )
                              ? 'none'
                              : 'auto',
                        }">
                        <svg width="1em" height="1em" class="icon icon-hotels">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-hotels"></use>
                        </svg>
                      </button>
                    </div>
                    <label
                        for="chk_2__free"
                        class="form-control-checkbox form-control-checkbox-free">
                      <input
                          id="chk_2__free"
                          type="checkbox"
                          v-model="hotelPopupData.free"/>
                      <span class="form-control-checkbox__box">
                        <svg width="1em" height="1em" class="icon icon-check">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                        </svg>
                      </span>
                      <span
                          class="form-control-checkbox__name form-control__help">
                        Free of charge, incl on package
                        <span class="form-control__help-icon">
                          <span class="form-control__help-content"
                          >Если ночь в отеле включена в стоимость восхождения
                            или же вы хотите сделать данную ночь бесплатной -
                            поставьте галочку. Стоимость проживания будет равна
                            нулю.
                          </span>
                          <img src="/images/useful/svg/help-icon.svg" alt=""/>
                        </span>
                      </span>
                    </label>
                    <label
                        class="form-control-checkbox form-control-checkbox--booked-by-guest">
                      <input
                          type="checkbox"
                          v-model="hotelPopupData.bookedByGuest"/>
                      <span class="form-control-checkbox__box">
                        <svg width="1em" height="1em" class="icon icon-check">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                        </svg>
                      </span>
                      <span class="form-control-checkbox__name"
                      >Booked by guest</span
                      >
                    </label>
                    <div class="select-body">
                      <span class="select-body__title"
                      >Alternative options in the same area:</span
                      >
                      <div class="select-inner js-scrollbar">
                        <div
                            class="select-option hotel-select-option"
                            v-for="item in dataSelects.alternativeHotels"
                            :key="item.hotelId">
                          <div class="select-option__icon">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-star">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                            </svg>
                            <span>{{ item.ratio }}*</span>
                          </div>
                          <svg
                              v-if="item.preferredPartnerLevel"
                              width="21"
                              height="15"
                              class="hotel-preferred-partner-icon hotel-preferred-partner-icon--option"
                              aria-hidden="true">
                            <use
                                :xlink:href="`/images/useful/svg/theme/symbol-defs.svg#preferred-icon-${item.preferredPartnerLevel.toLowerCase()}`"></use>
                          </svg>
                          <span class="select-option__name">{{
                              item.hotelName
                            }}</span>
                          <img
                              v-if="item.bestPrice === true"
                              class="hotel-best-price-badge hotel-best-price-badge--option"
                              src="/images/useful/svg/hotel-best-price.svg"
                              alt="Best Price">
                          <img
                              v-if="item.lowPriority === true"
                              class="hotel-low-priority-badge hotel-low-priority-badge--option"
                              src="/images/useful/svg/hotel-low-priority.svg"
                              alt="Low Priority">
                          <span class="hotel-alternative-diff--option"
                          >{{ item.diff }} USD</span
                          >
                          <a
                              :style="{cursor: 'Pointer'}"
                              class="btn btn--rounded2 btn--green btn--add"
                              @click="onClickAltOptions(item)"
                          >Change</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="hotel-modal__add-info-container">
                <div class="hotel-modal__add-info-double">
                  <div v-if="selectedHotel.closest">
                    <span class="hotel-modal__add-info-label">Closest Airport / Airstrip:</span>
                    {{ selectedHotel.closest.names.EN }}
                  </div>
                  <div v-if="selectedHotel.transferTimeMin > 0">
                    <span class="hotel-modal__add-info-label">Transfer Time (Min):</span>
                    {{ selectedHotel.transferTimeMin }}
                  </div>
                </div>
                <div v-if="selectedHotel.notes">
                  <span class="hotel-modal__add-info-label">Comment:</span>
                  <span v-html="selectedHotel.notes"></span>
                </div>
              </div>
              <div
                  class="edit-popup--choose-hotel__add__col edit-popup--choose-hotel__add__col-clients">
                <div class="clients-col">
                  <div class="clients-col__header">
                    <div class="clients-col__title">Allocated guests</div>
                    <div class="clients-col__title">Program</div>
                    <div class="clients-col__title">Hotel</div>
                  </div>
                  <div
                      v-for="(client, index) in hotelPopupData.hotelsData
                      .map((data) => data.clients)
                      .flat()"
                      :key="index">
                    <div
                        v-if="client.name && dataSelects.meal.ageSettings"
                        class="form-control-group--persons__col__info">
                      <span class="form-control-group--persons__name"
                      >{{ client.name }} ({{
                          participants.find((item) => item.id === client.id).age
                        }}
                        y.o)</span
                      >
                      <div class="clients-col__program-icon">
                        <svg
                            v-if="
                            participants.find((item) => item.id === client.id)
                              .ageType === 'adult'
                          "
                            width="1em"
                            height="1em"
                            class="icon icon-adult">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                        </svg>
                        <svg
                            v-if="
                            participants.find((item) => item.id === client.id)
                              .ageType === 'teenager'
                          "
                            width="1em"
                            height="1em"
                            class="icon icon icon-teenager">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                        </svg>
                        <svg
                            v-if="
                            participants.find((item) => item.id === client.id)
                              .ageType === 'child'
                          "
                            width="1em"
                            height="1em"
                            class="icon icon icon-child">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                        </svg>
                      </div>
                      <div class="clients-col__hotel-icon">
                        <svg
                            v-if="
                            client.age >=
                            dataSelects.meal.ageSettings.adult.from
                          "
                            width="1em"
                            height="1em"
                            class="icon icon-adult">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                        </svg>
                        <svg
                            v-if="
                            client.age >=
                              dataSelects.meal.ageSettings.teenager.from &&
                            client.age <=
                              dataSelects.meal.ageSettings.teenager.to
                          "
                            width="1em"
                            height="1em"
                            class="icon icon icon-teenager">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                        </svg>
                        <svg
                            v-if="
                            client.age <= dataSelects.meal.ageSettings.child.to
                          "
                            width="1em"
                            height="1em"
                            class="icon icon icon-child">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <!--                  <div-->
                  <!--                    class="form-control-group&#45;&#45;persons__col__info"-->
                  <!--                    v-if="hotelPopupData.hotelsData.map(data => data.clients).flat().filter(client => client.type === 'A' && client.id).length"-->
                  <!--                  >-->
                  <!--                    <svg width="1em" height="1em" class="icon icon-adult">-->
                  <!--                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>-->
                  <!--                    </svg>-->
                  <!--                    <span class="form-control-group&#45;&#45;persons__name">-->
                  <!--                      {{ hotelPopupData.hotelsData.map(data => data.clients).flat().filter(client => client.type === 'A' && client.id).length }} Adults-->
                  <!--                    </span>-->
                  <!--                  </div>-->
                  <!--                  <div-->
                  <!--                    class="form-control-group&#45;&#45;persons__col__info"-->
                  <!--                    v-if="hotelPopupData.hotelsData.map(data => data.clients).flat().filter(client => client.type === 'T' && client.id).length"-->
                  <!--                  >-->
                  <!--                    <svg width="1em" height="1em" class="icon icon icon-teenager">-->
                  <!--                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>-->
                  <!--                    </svg>-->
                  <!--                    <span class="form-control-group&#45;&#45;persons__name">-->
                  <!--                      {{ hotelPopupData.hotelsData.map(data => data.clients).flat().filter(client => client.type === 'T' && client.id).length }} Teenager-->
                  <!--                    </span>-->
                  <!--                  </div>-->
                  <!--                  <div-->
                  <!--                    class="form-control-group&#45;&#45;persons__col__info"-->
                  <!--                    v-if="hotelPopupData.hotelsData.map(data => data.clients).flat().filter(client => client.type === 'C' && client.id).length"-->
                  <!--                  >-->
                  <!--                    <svg width="1em" height="1em" class="icon icon icon-child">-->
                  <!--                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>-->
                  <!--                    </svg>-->
                  <!--                    <span class="form-control-group&#45;&#45;persons__name">-->
                  <!--                      {{ hotelPopupData.hotelsData.map(data => data.clients).flat().filter(client => client.type === 'C' && client.id).length }} Child-->
                  <!--                    </span>-->
                  <!--                  </div>-->
                </div>
                <div class="clients-col">
                  <div class="clients-col__header">
                    <div
                        class="clients-col__title clients-col__title-unloceted">
                      Unallocated guests
                    </div>
                    <div class="clients-col__title">Program</div>
                    <div class="clients-col__title">Hotel</div>
                  </div>
                  <div v-for="guest in participants" :key="guest.id">
                    <div
                        v-if="
                        !hotelPopupData.hotelsData
                          .map((data) => data.clients)
                          .flat()
                          .map((client) => client.id)
                          .includes(guest.id)
                      "
                        class="form-control-group--persons__col__info">
                      <span class="form-control-group--persons__name"
                      >{{ guest.name }} ({{ guest.age }} y.o)</span
                      >
                      <div class="clients-col__program-icon">
                        <svg
                            v-if="guest.ageType === 'adult'"
                            width="1em"
                            height="1em"
                            class="icon icon-adult">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                        </svg>
                        <svg
                            v-if="guest.ageType === 'teenager'"
                            width="1em"
                            height="1em"
                            class="icon icon icon-teenager">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                        </svg>
                        <svg
                            v-if="guest.ageType === 'child'"
                            width="1em"
                            height="1em"
                            class="icon icon icon-child">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                        </svg>
                      </div>
                      <div class="clients-col__hotel-icon">
                        <template
                            v-if="
                            dataSelects.meal && dataSelects.meal.ageSettings
                          ">
                          <svg
                              v-if="
                              guest.age >=
                              dataSelects.meal.ageSettings.adult.from
                            "
                              width="1em"
                              height="1em"
                              class="icon icon-adult">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                          </svg>
                          <svg
                              v-if="
                              guest.age >=
                                dataSelects.meal.ageSettings.teenager.from &&
                              guest.age <=
                                dataSelects.meal.ageSettings.teenager.to
                            "
                              width="1em"
                              height="1em"
                              class="icon icon icon-teenager">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                          </svg>
                          <svg
                              v-if="
                              guest.age <= dataSelects.meal.ageSettings.child.to
                            "
                              width="1em"
                              height="1em"
                              class="icon icon icon-child">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                          </svg>
                        </template>
                      </div>
                    </div>
                  </div>
                  <!--                  <div-->
                  <!--                    class="form-control-group&#45;&#45;persons__col__info"-->
                  <!--                    v-if="participants.filter(par => par.ageType === 'adult').length - hotelPopupData.hotelsData.map(data => data.clients).flat().filter(client => client.type === 'A' && client.id).length"-->
                  <!--                  >-->
                  <!--                    <svg width="1em" height="1em" class="icon icon-adult">-->
                  <!--                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>-->
                  <!--                    </svg>-->
                  <!--                    <span class="form-control-group&#45;&#45;persons__name">-->
                  <!--                      {{ participants.filter(par => par.ageType === 'adult').length - hotelPopupData.hotelsData.map(data => data.clients).flat().filter(client => client.type === 'A' && client.id).length }} Adults-->
                  <!--                    </span>-->
                  <!--                  </div>-->
                  <!--                  <div-->
                  <!--                    class="form-control-group&#45;&#45;persons__col__info"-->
                  <!--                    v-if="participants.filter(par => par.ageType === 'teenager').length - hotelPopupData.hotelsData.map(data => data.clients).flat().filter(client => client.type === 'T' && client.id).length"-->
                  <!--                  >-->
                  <!--                    <svg width="1em" height="1em" class="icon icon icon-teenager">-->
                  <!--                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>-->
                  <!--                    </svg>-->
                  <!--                    <span class="form-control-group&#45;&#45;persons__name">-->
                  <!--                      {{ participants.filter(par => par.ageType === 'teenager').length - hotelPopupData.hotelsData.map(data => data.clients).flat().filter(client => client.type === 'T' && client.id).length }} Teenager-->
                  <!--                    </span>-->
                  <!--                  </div>-->
                  <!--                  <div-->
                  <!--                    class="form-control-group&#45;&#45;persons__col__info"-->
                  <!--                    v-if="participants.filter(par => par.ageType === 'child').length - hotelPopupData.hotelsData.map(data => data.clients).flat().filter(client => client.type === 'C' && client.id).length"-->
                  <!--                  >-->
                  <!--                    <svg width="1em" height="1em" class="icon icon icon-child">-->
                  <!--                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>-->
                  <!--                    </svg>-->
                  <!--                    <span class="form-control-group&#45;&#45;persons__name">-->
                  <!--                      {{ participants.filter(par => par.ageType === 'child').length - hotelPopupData.hotelsData.map(data => data.clients).flat().filter(client => client.type === 'C' && client.id).length }} Child-->
                  <!--                    </span>-->
                  <!--                  </div>-->
                </div>
              </div>
              <div class="edit-popup--choose-hotel__add__col choose-hotel__check--col">
                <HotelCheckInOutTime
                    :earlyCheckIn="hotelPopupData.earlyCheckIn"
                    :lateCheckOut="hotelPopupData.lateCheckOut"
                    :inputsData="hotelPopupData.checkInOutInputsData"
                    @updateEarlyCheckIn="hotelPopupData.earlyCheckIn = $event"
                    @updateLateCheckOut="hotelPopupData.lateCheckOut = $event"
                    @updateInputsData="hotelPopupData.checkInOutInputsData = $event"
                />
              </div>
              <div
                  class="edit-popup--choose-hotel__add__submit edit-popup--choose-hotel__add__submit_chose-btn">
                <button
                    type="button"
                    class="btn btn--rounded2 btn--add btn--green btn--add_calculator btn--add"
                    :disabled="
                    !hotelPopupData.hotel ||
                    !hotelPopupData.meal ||
                    !hotelPopupData.room ||
                    !dataSelects.accommodations.find((item) => item.active)
                  "
                    @click="addToCalculatorHotelButtonClick">
                  <svg width="1em" height="1em" class="icon icon-plus-o-white">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                  </svg>
                  <span>Add To Calculator</span>
                </button>


                <div :style="{display: 'flex', gap: '16px'}">
                  <div
                      class="chose-onother-link"
                      :style="{paddingBottom: '0px', marginBottom: '0px'}">
                    <button
                        :disabled="hotelPopupData.hotelsData.length === 0"
                        @click="onAutocompleteHotelClick"
                        type="button"
                        data-popover="Autocomplete participants"
                        class="btn btn--orange btn--shadowed">
                      <span>Quick Allocation</span>
                    </button>
                  </div>
                  <div
                      class="chose-onother-link"
                      :style="{paddingBottom: '0px', marginBottom: '0px'}">
                    <button
                        type="button"
                        :disabled="
                      !dataSelects.copyHotelsData.filter(
                        (hotel) => !(hotel.day === hotelPopup.day)
                      ).length
                    "
                        @click="copyFromDayPopup = true"
                        class="btn btn-copy btn--blue btn--shadowed btn_another">
                      <svg width="1em" height="1em" class="icon icon-copy">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                      </svg>
                      <span>Copy from another day</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
                class="edit-popup--choose-hotel__table edit-popup--choose-hotel__table--mod edit-popup--choose-hotel__table--mod_2">
              <div class="section-table-wrap" :style="{overflow: 'visible'}">
                <div class="section-table section-table--hotels">
                  <div class="section-table__head">
                    <div class="col col-day"><span>Day</span></div>
                    <div class="col col-hotel"><span>Hotel Name</span></div>
                    <div class="col col-meal"><span>Meal</span></div>
                    <div class="col col-room"><span>Room</span></div>
                    <div class="col col-check"><span>Check in</span></div>
                    <div class="col col-room-type"><span>Room Type</span></div>
                  </div>
                  <div
                      class="section-table__body"
                      v-if="
                      hotelPopupData.hotelsData.filter((item) => !item.free && !item.bookedByGuest)
                        .length
                    ">
                    <div
                        v-for="(item, index) in hotelPopupData.hotelsData"
                        v-if="!item.free"
                        class="section-table__row"
                        :key="index">
                      <div class="col col-day">
                        <div class="col-day__label">
                          <span>{{ item.day }}</span>
                        </div>
                      </div>
                      <div class="col col-hotel">
                        <span>{{ item.name }}</span>
                      </div>
                      <div class="col col-meal">
                        <span>{{ item.meal }}</span>
                      </div>
                      <div class="col col-room">
                        <span>{{ item.room }}</span>
                      </div>
                      <div class="col col-check">
                        <span>{{ item.date }}</span>
                      </div>
                      <div class="col col-room-type">
                        <span>{{ item.roomType }}</span>
                      </div>
                      <div class="col col-action">
                        <button
                            type="button"
                            class="btn btn--remove"
                            @click="
                            $emit('deleteModalHandler', {
                              entity: 'Room',
                              name: 'this',
                              handler: () =>
                                (hotelPopupData.hotelsData =
                                  hotelPopupData.hotelsData.filter(
                                    (_, i) => !(i === index)
                                  )),
                              id: null,
                            })
                          ">
                          <svg width="1em" height="1em" class="icon icon-close">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>
                      <HotelCheckInOutTimeLabel :earlyCheckIn="item.earlyCheckIn" :lateCheckOut="item.lateCheckOut"/>
                      <div
                          class="col col-selects"
                          style="margin-bottom: -0.6rem">
                        <div
                            class="form-control-group form-control-group-client"
                            style="margin-bottom: 0.6rem"
                            v-for="(
                            clientOption, clientOptionIndex
                          ) in item.clients"
                            :key="clientOptionIndex">
                          <div
                              :class="[
                              'select-wrapper',
                              {'is-active': clientOption.isOpen},
                              {'is-error': item.error},
                            ]"
                              @click="
                              item.error = false
                              item.clients = item.clients.map((c, ci) => ({
                                ...c,
                                isOpen:
                                  clientOptionIndex === ci ? !c.isOpen : false,
                              }))
                            ">
                            <div class="form-control-group-client-icon">
                              <svg
                                  width="1em"
                                  height="1em"
                                  :class="
                                  'icon icon-' +
                                  (clientOption.type === 'T'
                                    ? 'teenager'
                                    : clientOption.type === 'C'
                                    ? 'child'
                                    : 'adult')
                                ">
                                <use
                                    :xlink:href="
                                    '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                                    (clientOption.type === 'T'
                                      ? 'teenager'
                                      : clientOption.type === 'C'
                                      ? 'child'
                                      : 'adult')
                                  "></use>
                              </svg>
                            </div>
                            <div class="select-trigger">
                              <span class="select-trigger__name">{{
                                  clientOption.name
                                }}</span
                              ><span class="select-trigger__icon">
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-chevron">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                                ></span>
                            </div>
                            <div class="select-body">
                              <div
                                  v-if="clientOption.name.length > 0"
                                  :class="[
                                  'select-option',
                                  {'is-selected': true},
                                ]"
                                  @click="
                                  clientOption.name = ''
                                  clientOption.id = ''
                                  clientOption.age = ''
                                ">
                                --
                              </div>
                              <div
                                  v-for="(client, index) in participantsFiltered(
                                  clientOption
                                )"
                                  :key="index"
                                  :class="[
                                  'select-option',
                                  {
                                    'is-selected':
                                      clientOption.name === client.name,
                                  },
                                ]"
                                  @click="
                                  clientOption.name = client.name
                                  clientOption.id = client.id
                                  clientOption.age = client.age
                                  item.participantIds.push(client.id)
                                ">
                                <span class="select-option__name">{{
                                    client.name
                                  }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                      class="section-table-wrap"
                      v-if="
                      hotelPopupData.hotelsData.filter((item) => item.free || item.bookedByGuest)
                        .length
                    "
                      :style="{overflow: 'visible'}">
                    <div
                        class="section-table section-table--hotels section-table--free">
                      <span
                          class="section-table--free__title"
                          :style="{height: '20px'}"
                      >Free of charge, incl on package<img
                          src="/images/icons/free.svg"
                          alt=""
                      /></span>
                      <div class="section-table__body">
                        <div
                            v-for="(item, index) in hotelPopupData.hotelsData"
                            v-if="item.free || item.bookedByGuest"
                            class="section-table__row"
                            :key="index">
                          <div class="col col-day">
                            <div class="col-day__label">
                              <span>{{ item.day }}</span>
                            </div>
                          </div>
                          <div class="col col-hotel">
                            <span>{{ item.name }}</span>
                          </div>
                          <div class="col col-meal">
                            <span>{{ item.meal }}</span>
                          </div>
                          <div class="col col-room">
                            <span>{{ item.room }}</span>
                          </div>
                          <div class="col col-check">
                            <span>{{ item.date }}</span>
                          </div>
                          <div class="col col-room-type">
                            <span>{{ item.roomType }}</span>
                          </div>
                          <div class="col col-action">
                            <button
                                type="button"
                                class="btn btn--remove"
                                @click="
                                $emit('deleteModalHandler', {
                                  entity: 'Room',
                                  name: 'this',
                                  handler: () =>
                                    (hotelPopupData.hotelsData =
                                      hotelPopupData.hotelsData.filter(
                                        (_, i) => !(i === index)
                                      )),
                                  id: null,
                                })
                              ">
                              <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-close">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                              </svg>
                            </button>
                          </div>
                          <HotelCheckInOutTimeLabel :earlyCheckIn="item.earlyCheckIn"
                                                    :lateCheckOut="item.lateCheckOut"/>
                          <div
                              class="col col-selects"
                              style="margin-bottom: -0.6rem">
                            <div
                                class="form-control-group form-control-group-client"
                                style="margin-bottom: 0.6rem"
                                v-for="(
                                clientOption, clientOptionIndex
                              ) in item.clients"
                                :key="clientOptionIndex">
                              <div
                                  :class="[
                                  'select-wrapper',
                                  {'is-active': clientOption.isOpen},
                                  {'is-error': item.error},
                                ]"
                                  @click="
                                  item.error = false
                                  item.clients = item.clients.map((c, ci) => ({
                                    ...c,
                                    isOpen:
                                      clientOptionIndex === ci
                                        ? !c.isOpen
                                        : false,
                                  }))
                                ">
                                <div class="form-control-group-client-icon">
                                  <svg
                                      width="1em"
                                      height="1em"
                                      :class="
                                      'icon icon-' +
                                      (clientOption.type === 'T'
                                        ? 'teenager'
                                        : clientOption.type === 'C'
                                        ? 'child'
                                        : 'adult')
                                    ">
                                    <use
                                        :xlink:href="
                                        '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                                        (clientOption.type === 'T'
                                          ? 'teenager'
                                          : clientOption.type === 'C'
                                          ? 'child'
                                          : 'adult')
                                      "></use>
                                  </svg>
                                </div>
                                <div class="select-trigger">
                                  <span class="select-trigger__name">{{
                                      clientOption.name
                                    }}</span
                                  ><span class="select-trigger__icon">
                                    <svg
                                        width="1em"
                                        height="1em"
                                        class="icon icon-chevron">
                                      <use
                                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                                    ></span>
                                </div>
                                <div class="select-body">
                                  <div
                                      v-if="clientOption.name.length > 0"
                                      :class="[
                                      'select-option',
                                      {'is-selected': true},
                                    ]"
                                      @click="
                                      clientOption.name = ''
                                      clientOption.id = ''
                                      clientOption.age = ''
                                    ">
                                    --
                                  </div>
                                  <div
                                      v-for="(
                                      client, clientIndex
                                    ) in participantsFiltered(clientOption)"
                                      :key="clientIndex"
                                      :class="[
                                      'select-option',
                                      {
                                        'is-selected':
                                          clientOption.name === client.name,
                                      },
                                    ]"
                                      @click="
                                      clientOption.name =
                                        client.name ||
                                        'Adult ' + (clientIndex + 1)
                                      clientOption.id = client.id
                                      clientOption.age = client.age
                                    ">
                                    <span class="select-option__name">{{
                                        client.name ||
                                        'Adult ' + (clientIndex + 1)
                                      }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup--choose-hotel__submit">
              <button
                  type="reset"
                  class="btn btn--silver"
                  @click="
                  $emit('deleteModalHandler', {
                    entity: 'Data',
                    name: 'this',
                    handler: () => {
                      hotelPopupData.hotelsData = []
                      hotelPopupData.meal = null
                      hotelPopupData.room = null
                      hotelPopupData.free = false
                      hotelPopupData.bookedByGuest = false
                      hotelPopupData.earlyCheckIn = false
                      hotelPopupData.lateCheckOut = false
                      hotelPopupData.checkInOutInputsData.earlyCheckIn = {time: '', percent: ''}
                      hotelPopupData.checkInOutInputsData.lateCheckOut = {time: '', percent: ''}
                      hotelPopupData.hotel = {names: {EN: ''}}
                      dataSelects.accommodations = []
                      dataSelects.accommodationsType = []
                      hotelPopupData.price = ''
                      hotelSelectInput = ''
                      hotelSelectInputRoom = ''
                      hotelPopup.hotelsData = []
                      clearSelectedHotelInModal();
                    },
                    id: null,
                  })
                ">
                <span>Reset</span>
              </button>
              <button
                  type="button"
                  class="btn btn--green"
                  @click="
                  () => {
                    if (checkHotelsErrors()) {
                      return false
                    }
                    hotelPopup.hotelsData = JSON.parse(
                      JSON.stringify(hotelPopupData.hotelsData)
                    )
                    hotelPopupData.hotelsData = []
                    hotelPopup = false
                    hotelPopupData.free = false
                    hotelPopupData.bookedByGuest = false
                    hotelPopupData.earlyCheckIn = false
                    hotelPopupData.lateCheckOut = false
                    hotelPopupData.checkInOutInputsData.earlyCheckIn = {time: '', percent: ''}
                    hotelPopupData.checkInOutInputsData.lateCheckOut = {time: '', percent: ''}
                    dataSelects.meal = {mealPlanTypes: []}
                    dataSelects.room = []
                    dataSelects.accommodations = []
                    dataSelects.accommodationsType = []
                    hotelPopupData.price = ''
                    hotelPopupData.copy = false
                    hotelPopupData.meal = null
                    hotelPopupData.room = null
                    hotelPopupData.hotel = {names: {EN: ''}}
                    clearSelectedHotelInModal();
                  }
                ">
                <span>Save</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && additionalPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner" style="align-items: flex-start">
        <div class="edit-popup options-additional">
          <div class="edit-popup__header">
            <div class="info-title">
              <div class="info-title__icon">
                <svg width="1.8rem" height="2.2rem">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-tel2"></use>
                </svg>
              </div>
              <span class="info-title__heading" :style="{fontSize: '15px'}"
              >Additional Options</span
              >
            </div>
            <div class="edit-popup__close" @click="additionalPopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div>
            <form>
              <div class="options-row-top">
                <div
                    :class="[
                    'select-wrapper select-wrapper--1',
                    {'is-active': selects.additionalPopup.options},
                  ]"
                    @click="changeSelectsAdditional('options')">
                  <div class="select-trigger">
                    <span class="select-trigger__name">{{
                        additionalPopupData.option
                            ? additionalPopupData.option.title
                            : 'Select'
                      }}</span
                    ><span class="select-trigger__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                      ></span>
                  </div>
                  <div class="select-body">
                    <div class="select-inner js-scrollbar">
                      <div
                          v-for="option in dataSelects.additionalOptions.filter(
                          (route) =>
                            route.mountTitle === additionalPopup.mountain
                        )"
                          :key="option.id"
                          :class="[
                          'select-option',
                          {
                            'is-selected':
                              additionalPopupData.option &&
                              option.id === additionalPopupData.option.id,
                          },
                        ]"
                          @click="additionalPopupData.option = option">
                        <span class="select-option__name">{{
                            option.title
                          }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                    :class="[
                    'select-wrapper select-wrapper--2',
                    {'is-active': selects.additionalPopup.pax},
                  ]"
                    :style="{
                    opacity: additionalPopupData.option ? 1 : 0.6,
                    cursor: additionalPopupData.option ? 'pointer' : 'default',
                    pointerEvents: additionalPopupData.option ? 'auto' : 'none',
                  }"
                    @click="changeSelectsAdditional('pax')">
                  <div class="select-trigger select-trigger_text-default">
                    <span class="select-trigger__name">{{
                        additionalPopupData.pax || '-'
                      }}</span>
                    <span
                        class="select-trigger__text-default"
                        :style="{paddingLeft: '0px'}"
                    >PAX</span
                    >
                    <span
                        class="select-trigger__icon"
                        :style="{minWidth: '3.6rem'}">
                      <svg width="1em" height="1em" class="icon icon-chevron">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                      ></span>
                  </div>
                  <div class="select-body">
                    <div
                        class="select-inner js-scrollbar"
                        v-if="additionalPopupData.option">
                      <div
                          v-for="pax in Array(
                          additionalPopup.participantsIds.filter(
                            (p) => p.active
                          ).length < additionalPopupData.option.paxLimit
                            ? additionalPopup.participantsIds.filter(
                                (p) => p.active
                              ).length
                            : additionalPopupData.option.paxLimit
                        )
                          .fill(true)
                          .map((_, i) => i + 1)"
                          :key="pax"
                          :class="[
                          'select-option',
                          {'is-selected': pax === additionalPopupData.pax},
                        ]"
                          @click="additionalPopupData.pax = pax">
                        <span class="select-option__name">{{ pax }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <span class="text-sep-1"
                >{{
                    additionalPopupData.option
                        ? additionalPopupData.option.price
                        : ''
                  }}
                  USD</span
                >
                <button
                    type="button"
                    class="btn btn--rounded2 btn--green btn_add-2 btn--add"
                    :disabled="!additionalPopupData.pax"
                    @click="
                    additionalPopupData.additionalOptions =
                      additionalPopupData.additionalOptions.concat({
                        name: additionalPopupData.option.title,
                        pax: additionalPopupData.pax,
                        price: additionalPopupData.option.price,
                        id: additionalPopupData.option.id,
                        clients: Array(+additionalPopupData.pax).fill({
                          name: '',
                          id: '',
                          isOpen: false,
                        }),
                        costType: additionalPopupData.option.costType,
                      })
                    additionalPopupData.pax = null
                    additionalPopupData.option = null
                  ">
                  <svg width="1em" height="1em" class="icon icon-plus-o-white">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-plus-o-white"></use>
                  </svg>
                  <span>ADD</span>
                </button>
              </div>
              <div class="section-table-wrap-options">
                <div
                    class="section-table section-table--options"
                    v-for="(item, index) in additionalPopupData.additionalOptions"
                    :key="index">
                  <div class="section-table__body">
                    <div class="section-table__row">
                      <div class="col col-day">
                        <div class="col-day__label">
                          <span
                          ><b>{{ index + 1 }}</b></span
                          >
                        </div>
                      </div>
                      <div class="col col-activity">
                        <span>{{ item.name }}</span>
                      </div>
                      <div class="col col-activity-persons">
                        <span
                        >Pax: <b>{{ item.pax }}</b></span
                        >
                      </div>
                      <div class="col col-cost-type">
                        <span>
                          {{
                            item.costType === 'PER_CLIMB' ? 'Cost per Climb' : item.costType === 'PER_DAY' ? 'Cost per Day' : ''
                          }}
                        </span>
                      </div>
                      <div class="col col-pick-up-price">
                        <span>{{ item.price }}$</span>
                      </div>
                      <div class="col col-action">
                        <button
                            type="button"
                            class="btn btn--remove"
                            @click="
                            $emit('deleteModalHandler', {
                              entity: 'Option',
                              name: 'this',
                              handler: () =>
                                (additionalPopupData.additionalOptions =
                                  additionalPopupData.additionalOptions.filter(
                                    (_, i) => !(i === index)
                                  )),
                              id: null,
                            })
                          ">
                          <svg width="1em" height="1em" class="icon icon-close">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>

                      <div class="col col-selects">
                        <div
                            class="form-control-group form-control-group-client"
                            v-for="(
                            clientOption, clientOptionIndex
                          ) in item.clients"
                            :key="clientOptionIndex"
                            :style="{height: '36px'}">
                          <div
                              :class="[
                              'select-wrapper',
                              {'is-active': clientOption.isOpen},
                              {'is-error': clientOption.error},
                            ]"
                              @click="
                              clientOption.error = false
                              item.clients = item.clients.map((c, ci) => ({
                                ...c,
                                isOpen:
                                  clientOptionIndex === ci ? !c.isOpen : false,
                              }))
                            ">
                            <div class="form-control-group-client-icon">
                              <svg
                                  width="1em"
                                  height="1em"
                                  :class="
                                  'icon icon-' + (clientOption.type || 'adult')
                                ">
                                <use
                                    :xlink:href="
                                    '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                                    (clientOption.type || 'adult')
                                  "></use>
                              </svg>
                            </div>
                            <div class="select-trigger">
                              <span class="select-trigger__name">{{
                                  participants.find(
                                      (par) => par.id === clientOption.id
                                  )
                                      ? participants.find(
                                          (par) => par.id === clientOption.id
                                      ).name
                                      : ''
                                }}</span
                              ><span class="select-trigger__icon">
                                <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-chevron">
                                  <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                                ></span>
                            </div>
                            <div class="select-body">
                              <div
                                  v-if="clientOption.name.length > 0"
                                  :class="[
                                  'select-option',
                                  {'is-selected': true},
                                ]"
                                  @click="
                                  clientOption.name = ''
                                  clientOption.id = ''
                                ">
                                --
                              </div>
                              <div
                                  v-for="(
                                  client, clientIndex
                                ) in additionalPopup.participantsIds.filter(
                                  (client) => client.active && !item.clients.some(c => c.id === client.id)
                                )"
                                  :key="clientIndex"
                                  :class="[
                                  'select-option',
                                  {
                                    'is-selected':
                                      clientOption.name === client.name,
                                  },
                                ]"
                                  @click="
                                  clientOption.name =
                                    client.name || 'Adult ' + (clientIndex + 1)
                                  clientOption.id = client.id
                                  clientOption.type = client.ageType
                                ">
                                <span class="select-option__name">{{
                                    client.name || 'Adult ' + (clientIndex + 1)
                                  }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="options-additional__btns">
            <button
                type="button"
                class="btn btn--silver btn_options"
                @click="
                $emit('deleteModalHandler', {
                  entity: 'Data',
                  name: 'this',
                  handler: () => {
                    additionalPopupData.pax = null
                    additionalPopupData.option = null
                    additionalPopupData.additionalOptions = []
                  },
                  id: null,
                })
                isEditFlag = true
              ">
              <span>Reset</span>
            </button>
            <button
                type="submit"
                class="btn btn--green btn--shadowed btn_options"
                @click="
                () => {
                  if (checkAdditionalErrors()) {
                    return false
                  }
                  additionalPopup.additionalOptions = JSON.parse(
                    JSON.stringify(additionalPopupData.additionalOptions)
                  )
                  additionalPopup = false
                }
              ">
              <span>Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && safariDriverPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--itinerary">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-car">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-car"></use>
                </svg>
              </div>
              <span>Itinerary for Safari Driver</span>
            </div>
            <div class="edit-popup__close" @click="safariDriverPopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="form-control-group">
              <span class="form-control-label">Notes for driver</span>
              <div class="form-control-wrap">
                <textarea
                    placeholder="Notes for driver"
                    v-model="data.itineraryForSafariDriver"
                    @input="isEditFlag = true"
                    class="form-control"></textarea>
              </div>
            </div>
            <div class="options-additional__btns">
              <button type="submit" class="btn btn--green edit-popup__submit">
                <span>Generate PDF</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && copyFromDayPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--copy-another">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon edit-popup__title__icon--mod">
                <svg width="1em" height="1em" class="icon icon-copy">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                </svg>
              </div>
              <span>Copy from another day</span>
            </div>
            <div class="edit-popup__close" @click="copyFromDayPopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="edit-popup--choose-hotel__copy-another">
              <span class="form-control__name-other">Copy From:</span>
              <div class="form-control-group">
                <div
                    :class="[
                    'select-wrapper select-wrapper--md',
                    {'is-active': selects.hotelPopup.copy},
                  ]"
                    :style="{
                    opacity: dataSelects.copyHotelsData.filter(
                      (hotel) => !(hotel.day === hotelPopup.day)
                    ).length
                      ? 1
                      : 0.6,
                    cursor: dataSelects.copyHotelsData.filter(
                      (hotel) => !(hotel.day === hotelPopup.day)
                    ).length
                      ? 'pointer'
                      : 'default',
                    pointerEvents: dataSelects.copyHotelsData.filter(
                      (hotel) => !(hotel.day === hotelPopup.day)
                    ).length
                      ? 'auto'
                      : 'none',
                  }"
                    @click="selects.hotelPopup.copy = !selects.hotelPopup.copy">
                  <div class="select-trigger">
                    <span class="select-trigger__name"
                    >{{
                        dataSelects.copyHotelsData.find((day) => day.active)
                            ? 'Day'
                            : ''
                      }}
                      {{
                        dataSelects.copyHotelsData.find((day) => day.active)
                            ? dataSelects.copyHotelsData.find((day) => day.active)
                                .day
                            : ''
                      }}</span
                    ><span class="select-trigger__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                      ></span>
                  </div>
                  <div class="select-body">
                    <div
                        class="select-inner js-scrollbar"
                        v-for="(item, index) in dataSelects.copyHotelsData
                        .filter((hotel) => !(hotel.day === hotelPopup.day))
                        .sort((a, b) => (a.day > b.day ? 1 : -1))"
                        :key="index">
                      <div
                          :class="[
                          'select-option',
                          {
                            'is-selected':
                              dataSelects.copyHotelsData.find(
                                (day) => day.active
                              ) &&
                              dataSelects.copyHotelsData.find(
                                (day) => day.active
                              ).day === item.day,
                          },
                        ]"
                          @click="
                          dataSelects.copyHotelsData =
                            dataSelects.copyHotelsData.map((day) => ({
                              ...day,
                              active: day.day === item.day,
                            }))
                        ">
                        <span class="select-option__name"
                        >Day {{ item.day }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup--choose-hotel__submit">
              <button
                  type="reset"
                  class="btn btn--silver"
                  @click="copyFromDayPopup = false">
                <span>Reset</span>
              </button>
              <button
                  type="submit"
                  class="btn btn--green"
                  @click="
                  hotelPopupData.hotelsData = dataSelects.copyHotelsData
                    .find((day) => day.active)
                    .hotelsData.map((data) => ({
                      ...data,
                      day:
                        hotelPopup.type.data === 'CLIMBING'
                          ? hotelPopup.day +
                            ((hotelPopup.climb.durationDays ||
                              hotelPopup.climb.days) -
                              1)
                          : hotelPopup.day,
                      date:
                        hotelPopup.type.data === 'CLIMBING' && hotelPopup.date
                          ? dateCalc(
                              +new Date(
                                +('20' + hotelPopup.date.split('/')[2]),
                                +hotelPopup.date.split('/')[1] - 1,
                                +hotelPopup.date.split('/')[0]
                              ).getTime() +
                                ((hotelPopup.climb.durationDays ||
                                  hotelPopup.climb.days) -
                                  1) *
                                  24 *
                                  60 *
                                  60 *
                                  1000
                            )
                          : hotelPopup.date,
                    }))
                  hotelPopupData.hotel = dataSelects.hotels.find(
                    (item) =>
                      dataSelects.copyHotelsData.find((day) => day.active)
                        .hotelsData[0].hotelId === item.id
                  )
                  hotelPopupData.meal = dataSelects.copyHotelsData.find(
                    (day) => day.active
                  ).hotelsData[0].mealData
                  getHotelData(
                    dataSelects.copyHotelsData.find((day) => day.active)
                      .hotelsData[0].hotelId
                  )
                  copyFromDayPopup = false
                ">
                <span>Save</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && participantsPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner" style="align-items: flex-start">
        <div class="edit-popup edit-popup--participants">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon edit-popup__title__icon--mod">
                <svg width="1em" height="1em" class="icon icon-adult">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                </svg>
              </div>
              <span
              >Participants
                <span
                >|
                  {{
                    participantsPopup.type.data === 'CLIMBING'
                        ? 'Climbing'
                        : 'Safari'
                  }}</span
                ></span
              >
            </div>
            <div class="edit-popup__close" @click="participantsPopup = null">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="list-edit-participants">
              <div
                  class="list-edit-participants__item"
                  v-for="(item, index) in participantsPopup.participantsIds"
                  :key="index">
                <div class="list-edit-participants__checkbox">
                  <label
                      :for="'chk_1110__free' + index"
                      class="form-control-checkbox">
                    <input
                        :id="'chk_1110__free' + index"
                        type="checkbox"
                        v-model="item.active"
                        @change="
                        participantsPopup.additionalOptions
                          ? (participantsPopup.additionalOptions =
                              participantsPopup.additionalOptions.map(
                                (option) => ({
                                  ...option,
                                  clients: option.clients.filter((client) =>
                                    participantsPopup.participantsIds
                                      .filter((p) => p.active)
                                      .map((p) => p.id)
                                      .includes(client.id)
                                  ),
                                  pax: option.clients.filter((client) =>
                                    participantsPopup.participantsIds
                                      .filter((p) => p.active)
                                      .map((p) => p.id)
                                      .includes(client.id)
                                  ).length,
                                })
                              ))
                          : false
                        participantsPopup.days
                          ? (participantsPopup.days =
                              participantsPopup.days.map((d) => ({
                                ...d,
                                totalCars: Math.ceil(
                                  participantsPopup.participantsIds.filter(
                                    (p) => p.active
                                  ).length / participantsPopup.pax
                                ),
                              })))
                          : false
                        if (participantsPopup.additionalOptions)
                          participantsPopup.additionalOptions =
                            participantsPopup.additionalOptions.filter(
                              (item) => item.clients.length > 0
                            )
                      "/>
                    <span class="form-control-checkbox__box">
                      <svg width="1em" height="1em" class="icon icon-check">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                    ><span class="form-control-checkbox__name">{{
                      item.name
                    }}</span>
                  </label>
                </div>
                <div class="list-edit-participants__info">
                  <span class="list-edit-participants__age"
                  >{{ item.age }} yo</span
                  >
                  <svg
                      width="1em"
                      height="1em"
                      :class="['icon icon-' + item.gender]">
                    <use
                        :xlink:href="
                        '/images/useful/svg/theme/symbol-defs.svg#icon-' +
                        item.gender
                      "></use>
                  </svg>
                </div>
              </div>
            </div>
          </form>
          <!--          {{participantsPopup}}-->
          <div
              class="options-additional__btns options-additional__btns-participants">
            <button
                type="button"
                class="btn btn--silver btn_options"
                @click="
                participantsPopup.priceFor =
                  participantsPopup.type.subData === 'JOIN'
                    ? participantsPopup.participantsIds.length > 3
                      ? participantsPopup.participantsIds.length
                      : 3
                    : participantsPopup.participantsIds.length
                participantsPopup.participantsIds =
                  participantsPopup.participantsIds.map((item) => ({
                    ...item,
                    active: true,
                  }))
                participantsPopup = null
                calcTemplatePriceHandler()
              ">
              <span>Reset</span>
            </button>
            <button
                type="submit"
                class="btn btn--green btn--shadowed btn_options"
                @click="
                participantsPopup.priceFor =
                  participantsPopup.type.subData === 'JOIN'
                    ? participantsPopup.participantsIds.filter((p) => p.active)
                        .length > 3
                      ? participantsPopup.participantsIds.filter(
                          (p) => p.active
                        ).length
                      : 3
                    : participantsPopup.participantsIds.filter((p) => p.active)
                        .length
                if (data.program.find((item) => item.type.data === 'SAFARI'))
                  participantsPopup.totalCars =
                    participantsPopup.totalCars === 0
                      ? 0
                      : Math.ceil(
                          participantsPopup.participantsIds.filter(
                            (p) => p.active
                          ).length /
                            data.program.find(
                              (item) => item.type.data === 'SAFARI'
                            ).pax
                        )
                participantsPopup.days
                  ? (participantsPopup.days = participantsPopup.days.map(
                      (d) => ({
                        ...d,
                        totalCars: Math.ceil(
                          participantsPopup.participantsIds.filter(
                            (p) => p.active
                          ).length / participantsPopup.pax
                        ),
                      })
                    ))
                  : false
                participantsPopup.participantsSave = true
                if (
                  participantsPopup.participantsIds.filter((p) => p.active)
                    .length < 1 &&
                  participantsPopup.type.data === 'CLIMBING'
                )
                  participantsPopup.additionalOptions.splice(
                    0,
                    participantsPopup.additionalOptions.length
                  )
                participantsPopup = null
                calcTemplatePriceHandler()
              ">
              <span>Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && recoveryPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--recover">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon edit-popup__title__icon--mod">
                <svg width="1em" height="1em" class="icon icon-recover">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                </svg>
              </div>
              <div>
                <span>Recover version</span>
                <div class="recover-currnet-version">
                  Current version:
                  <span class="nowrap">{{
                      recoveries.length ? recoveries[0].date : ''
                    }}</span>
                </div>
              </div>
            </div>
            <div class="edit-popup__close" @click="recoveryPopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="edit-popup__inner">
            <div class="list-recovers js-scrollbar">
              <div
                  class="list-recovers__item"
                  v-for="(item, index) in recoveries"
                  :key="index">
                <span class="recover-date">
                  <svg width="1em" height="1em" class="icon icon-other">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-other"></use>
                  </svg>
                  <span class="list-recover__date">{{
                      item.date.slice(0, -6)
                    }}</span>
                </span>
                <span class="recover-time">{{ item.date.split(' ')[3] }}</span>
                <span class="recover-price">{{ item.totalCost }}$</span>
                <button
                    type="button"
                    class="btn btn--green btn_recover"
                    @click="recoverVersion(item.id)">
                  <span>Recover</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && recalculationPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner" @click="recalculationPopup = false">
        <div class="edit-popup recalculation-popup" @click.stop>
          <div class="edit-popup__header">
            <div class="edit-popup__title">
            </div>
            <div class="edit-popup__close" @click="recalculationPopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="recalculation-popup__title">
            <div class="edit-popup__title__icon edit-popup__title__icon--mod">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="#3889BD"/>
                <g clip-path="url(#clip0_8073_4671)">
                  <path
                      d="M10.4521 10.2368C10.483 10.1843 10.5 10.1372 10.5 10.0983C10.5 6.21046 12.4655 5.31414 12.9375 5.01857C13.0195 4.97006 13.0145 4.94986 12.9205 4.94986C9.87901 4.94986 8.00001 7.15778 8.00001 10.0983C8.00001 10.1464 8.0013 10.1924 8.00372 10.2368H6.25L9.25 14.118L12.25 10.2368H10.4521Z"
                      fill="white" stroke="white" stroke-miterlimit="10" stroke-linecap="round"
                      stroke-linejoin="round"/>
                  <path
                      d="M18.7501 12.7631L15.7501 8.88177L12.7501 12.7631H14.5477C14.517 12.8153 14.5001 12.8622 14.5001 12.901C14.5001 16.7894 12.5346 17.6852 12.0626 17.9807C11.9806 18.0297 11.9856 18.05 12.0796 18.05C15.1211 18.05 17.0001 15.8415 17.0001 12.901C17.0001 12.8531 16.9988 12.8072 16.9964 12.7631H18.7501V12.7631Z"
                      fill="white" stroke="white" stroke-miterlimit="10" stroke-linecap="round"
                      stroke-linejoin="round"/>
                </g>
                <defs>
                  <clipPath id="clip0_8073_4671">
                    <rect width="13" height="17" fill="white" transform="translate(6 3)"/>
                  </clipPath>
                </defs>
              </svg>

            </div>
            <span>Recalculate the Price</span>
          </div>
          <div class="edit-popup--choose-hotel__form">
            <div class="recalculation-popup__text">
              Warning!<br><br>

              Recalculate the Price will fully recalculate the program cost at the current prices.<br><br>

              If your program is in € / £, the price of the program will definitely change, as the most current exchange
              rates will be applied.<br>
            </div>
            <div class="edit-popup--choose-hotel__submit">
              <button
                  class="btn btn--green"
                  @click="
                  () => {
                    recalculationPopup = false
                    calcTemplatePriceHandler(true);
                  }
                ">
                <span>Recalculate the Price</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && notesPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner" :style="{alignItems: 'flex-start'}">
        <div class="edit-popup edit-popup--notes">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon edit-popup__title__icon--mod">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none">
                  <g clip-path="url(#a)" fill="#2E2E2E">
                    <path
                        d="M.007 11.466a.469.469 0 0 0 .38.543l2.08.367-1.31-7.433-1.15 6.523ZM2.507.008a.47.47 0 0 0-.546.38l-.497 2.819 9.458-1.668L2.507.008ZM15.992 13.496 14.04 2.417a.469.469 0 0 0-.543-.38L2.416 3.99a.469.469 0 0 0-.38.543l1.954 11.08a.469.469 0 0 0 .543.38l11.08-1.954a.469.469 0 0 0 .38-.543ZM4.534 7.901a.469.469 0 0 1 .38-.543L12.3 6.056a.469.469 0 1 1 .163.923L5.077 8.28a.469.469 0 0 1-.543-.38Zm6.118 3.205-4.924.868a.467.467 0 0 1-.543-.38.469.469 0 0 1 .38-.543l4.925-.868a.469.469 0 1 1 .162.923Zm2.137-2.28-7.386 1.302a.469.469 0 0 1-.163-.923l7.386-1.303a.469.469 0 1 1 .163.923Z"/>
                  </g>
                  <defs>
                    <clipPath id="a">
                      <path fill="#fff" d="M0 0h16v16H0z"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span
              >Note for the Clients - Day {{ currentDay.day }}
                <span class="edit-popup__subtitle"
                >(visible for clients)</span
                ></span
              >
            </div>
            <div class="edit-popup__close" @click="notesPopup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="edit-popup--choose-hotel__form">
            <div class="js-ckeditor">
              <editor
                  :editor="editor"
                  v-model="currentDay.notes"
                  :config="editorConfig"></editor>
            </div>

            <div class="edit-popup--choose-hotel__submit">
              <button
                  type="reset"
                  class="btn btn--silver"
                  @click="
                  $emit('deleteModalHandler', {
                    entity: 'Data',
                    name: 'this',
                    handler: () => {
                      currentDay.notes = ''
                      notesPopup = false
                    },
                  })
                ">
                <span>Reset</span>
              </button>
              <button
                  type="submit"
                  class="btn btn--green"
                  @click="
                  () => {
                    notesPopup = false
                  }
                ">
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && transferPopup">
      <div class="modal-backdrop"></div>
      <div class="modal-inner" :style="{transferPopup: 'flex-start'}">
        <div class="edit-popup edit-popup--notes">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon edit-popup__title__icon--mod">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none">
                  <g clip-path="url(#a)" fill="#2E2E2E">
                    <path
                        d="M.007 11.466a.469.469 0 0 0 .38.543l2.08.367-1.31-7.433-1.15 6.523ZM2.507.008a.47.47 0 0 0-.546.38l-.497 2.819 9.458-1.668L2.507.008ZM15.992 13.496 14.04 2.417a.469.469 0 0 0-.543-.38L2.416 3.99a.469.469 0 0 0-.38.543l1.954 11.08a.469.469 0 0 0 .543.38l11.08-1.954a.469.469 0 0 0 .38-.543ZM4.534 7.901a.469.469 0 0 1 .38-.543L12.3 6.056a.469.469 0 1 1 .163.923L5.077 8.28a.469.469 0 0 1-.543-.38Zm6.118 3.205-4.924.868a.467.467 0 0 1-.543-.38.469.469 0 0 1 .38-.543l4.925-.868a.469.469 0 1 1 .162.923Zm2.137-2.28-7.386 1.302a.469.469 0 0 1-.163-.923l7.386-1.303a.469.469 0 1 1 .163.923Z"/>
                  </g>
                  <defs>
                    <clipPath id="a">
                      <path fill="#fff" d="M0 0h16v16H0z"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span>Transfer</span>
            </div>
            <!--            <div class="edit-popup__close" @click="transferPopup = false">-->
            <!--              <svg width="1em" height="1em" class="icon icon-close">-->
            <!--                <use-->
            <!--                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>-->
            <!--              </svg>-->
            <!--            </div>-->
          </div>
          <div class="edit-popup--choose-hotel__form">
            <div class="js-ckeditor"></div>
            <div
                v-if="transitParkPopup"
                :class="[
                'select-wrapper',
                {'is-active': transitParkPopup.transitSelectOpen},
              ]"
                @click="
                transitParkPopup.transitSelectOpen =
                  !transitParkPopup.transitSelectOpen
              ">
              <div class="select-trigger">
                <span class="select-trigger__name">
                  {{
                    (transitParkPopup.transitPark.transitType &&
                        transitOptions.find(
                            (item) =>
                                item.transitType ===
                                transitParkPopup.transitPark.transitType
                        ).name) ||
                    ''
                  }}
                </span>
                <span class="select-trigger__icon">
                  <svg width="1em" height="1em" class="icon icon-chevron">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                  ></span>
              </div>
              <div class="select-body">
                <div class="select-inner js-scrollbar">
                  <div
                      v-for="transit of transitOptions"
                      :key="transit.transitType"
                      :class="['select-option', {'is-selected': true}]"
                      @click="
                      isEditFlag = true
                      transitParkPopup.transitPark.transitType =
                        transit.transitType
                      transitParkPopup.transitPark.transitParkId = transitParkID
                    ">
                    <span class="select-option__name">{{ transit.name }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="edit-popup--choose-hotel__submit">
              <button
                  type="reset"
                  class="btn btn--silver"
                  @click="transitParkPopup.transitPark = {}">
                <span>Reset</span>
              </button>
              <button
                  type="submit"
                  class="btn btn--green"
                  @click="
                  () => {
                    transferPopup = false
                    saveTransitParkToggleHandler(transitParkPopup)
                  }
                ">
                <span>Save</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isLoad && isBreakdownCostErrorsWarningModalActive">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup warning-modal__wrapper">
          <div class="warning-modal__title">
              <span class="warning-modal__icon">
                <svg width="30px" height="30px" class="">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#new-warning-modal-icon"></use>
                  </svg>
              </span>
            <span>WARNING</span>
          </div>
          <div class="warning-modal__text">
            Your itinerary is saved but the Cost tab has errors - be sure to double-check and correct it
          </div>
          <button class="warning-modal__button" @click="isBreakdownCostErrorsWarningModalActive = false">
            Ok, got it!
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
import AppPhone from '@/components/AppPhone'
import {
  getAirstripsAll,
  getTanzaniaAll,
  getRoutesAll,
  getParks,
  getAdditionals,
  getSafariAll,
  getIslandsAll,
  getPointsAll,
  getAirlinesAll,
  getHotelsAll,
  getHotelsMeals,
  getHotelsRoom,
  getRoomAccommodations,
  getHotelPrice,
  getAlternativeHotels,
  getPricesAll,
  getAdvicesRecommended,
  getClientRecoveries,
  getRoutesGroups,
  calcTemplatePrice,
  getClientRecover,
  createTemplate,
  updateTemplate,
  updateClients,
  getTemplate,
  createClients,
  getAdvices,
  getClient,
  getHotelMinNightStay,
  getHotelClosedDay,
  searchPrice,
  getFlightsAll,
  getFlightsFind,
  getPartners, getTerritoriesAll, getLocationsAll, API,
  // getLocationsAll
} from '@/utilites/api'

import {date, validateEmail} from '@/utilites/functions'

import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@/utilites/ckeditor'
import {TheMask} from 'vue-the-mask'

import simplebar from 'simplebar-vue'
import Lightpick from 'lightpick'
import {format, parse, isWithinInterval, isBefore} from 'date-fns'
import {actionTypes as actionTypesInvoices, getterTypes as getterTypesInvoices} from "@/store/modules/invoices";
import {actionTypes as actionTypesPartners, getterTypes as getterTypesPartners} from "@/store/modules/partners";
import AtModalInvoiceStatusPaid from "@/components/invoices/Modal/ModalInvoiceStatusPiad";
import AtModalInvoiceStatusCancel from "@/components/invoices/Modal/ModalInvoiceStatusCancel";
import AtModalInvoiceStatusPartiallyPaid from "@/components/invoices/Modal/ModalInvoiceStatusPertiallyPaid";
import AtModalInvoiceNote from "@/components/invoices/Modal/ModalInvoiceTotalAmount";
import AtModalInvoiceTotalAmount from "@/components/invoices/Modal/ModalInvoiceTotalAmount";
import {actionTypes as actionTypesBanks, getterTypes as getterTypesBanks} from "@/store/modules/banks";
import {debounce} from "lodash";
import AtModalInvoiceAmountPaid from "@/components/invoices/Modal/ModalInvoiceAmountPaid";
import _ from 'lodash'
import TimeInput from "@/components/UI/Inputs/TimeInput";
import Input from "@/components/UI/Inputs/BasicInput";
import HotelCheckInOutTime from "@/components/HotelCheckInOutTime/HotelCheckInOutTime";
import HotelCheckInOutTimeLabel from "@/components/HotelCheckInOutTime/HotelCheckInOutTimeLabel";
import draggable from 'vuedraggable'
import Checkbox from "@/components/UI/Checkbox/Checkbox.vue";
import {getCurrencySign} from '../common/helpers/currency'

export default {
  components: {
    Checkbox,
    HotelCheckInOutTimeLabel,
    HotelCheckInOutTime,
    Input,
    TimeInput,
    AtModalInvoiceAmountPaid,
    AtModalInvoiceTotalAmount,
    AtModalInvoiceNote,
    AtModalInvoiceStatusPartiallyPaid,
    AtModalInvoiceStatusCancel,
    AtModalInvoiceStatusPaid,
    simplebar,
    Lightpick,
    editor: CKEditor.component,
    TheMask,
    AppPhone,
    draggable,
  },
  data() {
    return {
      selectedHotel: {
        notes: null,
        transferTimeMin: null,
        closest: null,
      },
      programCurrency: 'USD',
      isFirstLoading: true,
      now: Date.now(),
      fromNationalPark: false,
      isActiveFlightTab: 'REGULAR',
      isOpenModalDelete: false,
      isModalInvoiceTotalAmount: false,
      isModalInvoicePaid: false,
      isModalInvoicePartiallyPaid: false,
      IsModalInvoiceAmountPaid: false,
      isBreakdownCostErrorsWarningModalActive: false,
      currentInvoiceModal: {},
      currentDay: null,
      notesPopup: false,
      recalculationPopup: false,
      transferPopup: false,
      transitParkPopup: null,
      additionalServices: [],
      participantPersonalDiscounts: [],
      filteredParticipantDiscounts: [],
      watchComission: false,
      extraCarSelectOpen: false,
      transferNgoroSelectOpen: false,
      flightDepSelectInput: '',
      flightArrSelectInput: '',
      hotelSelectInput: '',
      hotelSelectInputRoom: '',
      showActivityComission: false,
      transferToSelectInput: '',
      transferFromSelectInput: '',
      transitParkID: null,
      editor: ClassicEditor,
      editorConfig: {
        placeholder: 'Write notes',
      },
      nav: false,
      tab: 0,
      isLoad: false,
      showNames: false,
      commisionInclude: true,
      printMode: '',
      printLoad: false,
      show0: false,
      emailEnter: false,
      recoveries: [],
      selects: {
        status: false,
        operator: false,
        currency: false,
        lang: false,
        priceValid: false,
        country: false,
        residence: false,
        additionalPopup: {
          options: false,
          pax: false,
        },
        activityPopup: {
          activity: false,
          type: false,
          pax: false,
        },
        flightsPopup: {
          dep: false,
          arr: false,
          air: false,
          depTime: false,
          type: false,
          lug: false,
          pax: false,
        },
        transfersPopup: {
          from: false,
          to: false,
          pax: false,
          prices: false,
        },
        hotelPopup: {
          hotel: false,
          meal: false,
          room: false,
          alternative: false,
          copy: false,
        },
      },
      mouse: {
        top: 0,
      },
      mouseDay: {
        top: 0,
      },
      collapse: {
        hotels: true,
        activities: true,
        flights: true,
        transfers: true,
        folio: true,
        cost: true,
        comiss: true,
        summary: true,
        disc: true,
      },
      mainErrors: {
        name: false,
        email: false,
        duration: false,
      },
      insuranseErrors: {
        from: false,
        to: false,
        company: false,
        policy: false,
      },
      insurancePopup: false,
      invoicesProgram: {
        totalA: 0,
        aPaid: 0,
        remainBalance: 0
      },
      currentInvoice: {},
      dietaryPopup: false,
      changeDaysPopup: false,
      participantsPopup: false,
      safariDriverPopup: false,
      recoveryPopup: false,
      commissionPopup: false,
      commissionPopupValue: '',
      hotelPopup: false,
      copyFromDayPopup: false,
      flightsPopup: false,
      activityPopup: false,
      hotelZanzibarPopup: false,
      transfersPopup: false,
      additionalPopup: false,
      weddingPopup: false,
      dragIndex: null,
      dragHeight: '0px',
      countDeleteDays: '',
      isEditFlag: false,
      yearsDiff: 0,
      userId: null,
      clientId: null,
      boardLeadId: null,
      additionalPopupData: {
        option: null,
        pax: null,
        additionalOptions: [],
      },
      activityPopupData: {
        activity: null,
        time: '0900',
        type: null,
        pax: null,
        paxList: [],
        activitiesData: [],
      },
      flightsPopupData: {
        lug: null,
        type: null,
        pax: null,
        paxList: [],
        timeActivity: false,
        flightsData: [],
      },
      transfersPopupData: {
        pickUpTime: '',
        pax: null,
        participants: [],
        confirmed: false,
        free: false,
        alternative: false,
        transferId: null,
        price: null,
        error: null,
        transfersData: [],
        timeActivity: true,
      },
      hotelPopupData: {
        hotel: {names: {EN: ''}},
        meal: null,
        room: null,
        price: 0,
        copy: false,
        free: false,
        bookedByGuest: false,
        earlyCheckIn: false,
        lateCheckOut: false,
        checkInOutInputsData: {
          earlyCheckIn: {
            time: '',
            percent: ''
          },
          lateCheckOut: {
            time: '',
            percent: ''
          },
        },
        hotelsData: [],
      },
      data: {
        id: null,
        contract: null,
        version: 0,
        groupName: '',
        groupEmail: '',
        itineraryWithoutPrice: false,
        itineraryWithNames: false,
        itineraryForSafariDriver: '',
        notesForClients: '',
        notesForManager: '',
        program: [],
        link: '',
        priority: false,
        hideWelcomeTexts: false,
        groupEmailCheck: false,
        telegram: false,
        whatsapp: false,
        priceValidUpTo: '',
        status: '',
        number: '',
        country: {
          code: '(+7)',
          data: 'ru',
        },
      },
      allowStripe: false,
      participants: [],
      newPart: [],
      duration: '',
      durationData: '',
      tourStart: '',
      tourFinish: '',
      dataSelects: {
        selectedFlight: {
          comments: '',
          frequency: [],
          minPax: 0,
        },
        statusInvoices: [
          {name: 'Sent', type: 'SENT'},
          {name: 'Paid', type: 'PAID'},
          {name: 'Cancelled', type: 'CANCEL'},
          {name: 'Refund', type: 'REFUND'},
        ],
        status: [
          {
            data: 'LEAD',
            name: 'Lead',
            active: true,
            class: 'status-lead',
          },
          {
            data: 'NEGOTIATION',
            name: 'Negotiation',
            active: false,
            class: 'status-negotiation',
          },
          {
            data: 'PROFORMA',
            name: 'Pro-forma',
            active: false,
            class: 'status-pro',
          },
          {
            data: 'DEPOSIT_PAID',
            name: 'Deposit Paid',
            active: false,
            class: 'status-deposit',
          },
          {
            data: 'FULL_PAID',
            name: 'Full Paid',
            active: false,
            class: 'status-full',
          },
          {
            data: 'COMPLETED',
            name: 'Completed',
            active: false,
            class: 'status-completed',
          },
          {
            data: 'NO_RESPONSE_1',
            name: 'No Response 1',
            active: false,
            class: 'status-respose',
          },
          {
            data: 'NO_RESPONSE_2',
            name: 'No Response 2',
            active: false,
            class: 'status-respose',
          },
          {
            data: 'POSTPONE',
            name: 'Postpone',
            active: false,
            class: 'status-postpone',
          },
          {
            data: 'CANCELLED',
            name: 'Cancelled',
            active: false,
            class: 'status-cancelled',
          },
          {
            data: 'PROPOSAL',
            name: 'Proposal',
            active: false,
            class: 'status-proposal',
          },
        ],
        operator: [],
        currency: [
          {
            name: 'USD',
            active: true,
          },
          {
            name: 'EUR',
            active: false,
          },
          {
            name: 'GBP',
            active: false,
          },
          {
            name: 'CAD',
            active: false,
          },
          {
            name: 'CHF',
            active: false,
          },
          {
            name: 'AUD',
            active: false,
          },
          {
            name: 'AED',
            active: false,
          },
        ],
        lang: [
          {
            name: 'English',
            data: 'EN',
            icon: 'gb',
            active: true,
          },
          {
            name: 'Russian',
            icon: 'ru',
            data: 'RU',
            active: false,
          },
          {
            name: 'Deutch',
            icon: 'de',
            data: 'DE',
            active: false,
          },
          {
            name: 'Spanish',
            icon: 'es',
            data: 'ES',
            active: false,
          },
          {
          name: 'French',
          icon: 'fr',
          data: 'FR',
           active: false,
         },
          //{
          //  name: 'Portuguese',
          //  icon: 'pt',
          //  data: 'PT',
          //  active: false,
          //},
          {
            name: 'Dutch',
            icon: 'nl',
            data: 'NL',
            active: false,
          },
          //
          // NEW LANGUAGES SUPPORTED BY BACKEND
          //
           {
             name: 'Norwegian',
             icon: 'no',
             data: 'NO',
             active: false,
           },
           {
             name: 'Swedish',
             icon: 'se',
             data: 'SV',
             active: false,
           },
           {
             name: 'Danish',
             icon: 'dk',
             data: 'DA',
             active: false,
           },
          // {
          //   name: 'Arabic (UAE)',
          //   icon: 'ae',
          //   data: 'AE',
          //   active: false,
          // },
          // {
          //   name: 'German (Austria)',
          //   icon: 'at',
          //   data: 'AT',
          //   active: false,
          // },
          // {
          //   name: 'Spanish (Chile)',
          //   icon: 'es',
          //   data: 'CL',
          //   active: false,
          // },
          // {
          //   name: 'Spanish (Latin America)',
          //   icon: 'es',
          //   data: 'EA',
          //   active: false,
          // },
           {
             name: 'Czech',
             icon: 'cz',
             data: 'CS',
             active: false,
           },
          // {
          //   name: 'Georgian',
          //   icon: 'ge',
          //   data: 'KA',
          //   active: false,
          // },
           {
             name: 'Italian',
             icon: 'it',
             data: 'IT',
             active: false,
           },
          // {
          //   name: 'Latvian',
          //   icon: 'lv',
          //   data: 'LV',
          //   active: false,
          // },
          // {
          //   name: 'Macedonian',
          //   icon: 'mk',
          //   data: 'MK',
          //   active: false,
          // },
           {
             name: 'Polish',
             icon: 'pl',
             data: 'PL',
             active: false,
           },
           {
             name: 'Ukrainian',
             icon: 'ua',
             data: 'UA',
             active: false,
           },
          // {
          //   name: 'Catalan',
          //   icon: 'es-ca',
          //   data: 'CA',
          //   active: false,
          // },
          // {
          //   name: 'Armenian',
          //   icon: 'am',
          //   data: 'HY',
          //   active: false,
          // },
          // {
          //   name: 'Afrikaans',
          //   icon: 'za',
          //   data: 'AF',
          //   active: false,
          // },
          // {
          //   name: 'Albanian',
          //   icon: 'al',
          //   data: 'SQ',
          //   active: false,
          // },
          // {
          //   name: 'Azerbaijani',
          //   icon: 'az',
          //   data: 'AZ',
          //   active: false,
          // },
          // {
          //   name: 'Bosnian',
          //   icon: 'ba',
          //   data: 'BS',
          //   active: false,
          // },
          // {
          //   name: 'Belarusian',
          //   icon: 'by',
          //   data: 'BE',
          //   active: false,
          // },
          // {
          //   name: 'Bulgarian',
          //   icon: 'bg',
          //   data: 'BG',
          //   active: false,
          // },
          // {
          //   name: 'Arabic (Bahrain)',
          //   icon: 'bh',
          //   data: 'BH',
          //   active: false,
          // },
          // {
          //   name: 'Chechen',
          //   icon: 'ru',
          //   data: 'CE',
          //   active: false,
          // },
          // {
          //   name: 'French (Canada)',
          //   icon: 'ca',
          //   data: 'FC',
          //   active: false,
          // },
           {
             name: 'Deutsh (Switzerland)',
             icon: 'ch',
             data: 'CH',
             active: false,
           },
          // {
          //   name: 'Hebrew',
          //   icon: 'il',
          //   data: 'HE',
          //   active: false,
          // },
          // {
          //   name: 'Swahili',
          //   icon: 'tz',
          //   data: 'SW',
          //   active: false,
          // },
          // {
          //   name: 'English (New Zealand)',
          //   icon: 'nz',
          //   data: 'NZ',
          //   active: false,
          // },
          // {
          //   name: 'Thai',
          //   icon: 'th',
          //   data: 'TH',
          //   active: false,
          // },
          // {
          //   name: 'English (United Kingdom)',
          //   icon: 'gb',
          //   data: 'GB',
          //   active: false,
          // },
          // {
          //   name: 'English (South Africa)',
          //   icon: 'za',
          //   data: 'ZA',
          //   active: false,
          // },
          // {
          //   name: 'English (Australia)',
          //   icon: 'au',
          //   data: 'AU',
          //   active: false,
          // },
          // {
          //   name: 'Bengali',
          //   icon: 'bd',
          //   data: 'BN',
          //   active: false,
          // },
           {
             name: 'Portuguese (Brazil)',
             icon: 'br',
             data: 'BR',
             active: false,
           },
           {
             name: 'Croatian',
             icon: 'hr',
             data: 'HR',
             active: false,
           },
          // {
          //   name: 'Spanish (Mexico)',
          //   icon: 'es',
          //   data: 'MX',
          //   active: false,
          // },
          // {
          //   name: 'Turkish',
          //   icon: 'tr',
          //   data: 'TR',
          //   active: false,
          // },
          // {
          //   name: 'English (Uganda)',
          //   icon: 'ug',
          //   data: 'UG',
          //   active: false,
          // },
          // {
          //   name: 'Greek',
          //   icon: 'gr',
          //   data: 'EL',
          //   active: false,
          // },
          // {
          //   name: 'Estonian',
          //   icon: 'ee',
          //   data: 'ET',
          //   active: false,
          // },
           {
             name: 'Finnish',
             icon: 'fi',
             data: 'FI',
             active: false,
           },
          // {
          //   name: 'Chinese (Hong Kong)',
          //   icon: 'hk',
          //   data: 'HK',
          //   active: false,
          // },
          // {
          //   name: 'Hungarian',
          //   icon: 'hu',
          //   data: 'HU',
          //   active: false,
          // },
          // {
          //   name: 'Indonesian',
          //   icon: 'id',
          //   data: 'ID',
          //   active: false,
          // },
          // {
          //   name: 'English (Ireland)',
          //   icon: 'ie',
          //   data: 'IE',
          //   active: false,
          // },
          // {
          //   name: 'Hindi',
          //   icon: 'in',
          //   data: 'HI',
          //   active: false,
          // },
          // {
          //   name: 'Icelandic',
          //   icon: 'is',
          //   data: 'IS',
          //   active: false,
          // },
           {
             name: 'Japanese',
             icon: 'jp',
             data: 'JA',
             active: false,
           },
          // {
          //   name: 'Kyrgyz',
          //   icon: 'kg',
          //   data: 'KY',
          //   active: false,
          // },
          // {
          //   name: 'Korean',
          //   icon: 'kr',
          //   data: 'KO',
          //   active: false,
          // },
          // {
          //   name: 'Sinhala',
          //   icon: 'lk',
          //   data: 'SI',
          //   active: false,
          // },
          // {
          //   name: 'Lithuanian',
          //   icon: 'lt',
          //   data: 'LT',
          //   active: false,
          // },
          // {
          //   name: 'Luxembourgish',
          //   icon: 'lu',
          //   data: 'LB',
          //   active: false,
          // },
          // {
          //   name: 'Arabic (Morocco)',
          //   icon: 'ma',
          //   data: 'MA',
          //   active: false,
          // },
          // {
          //   name: 'Romanian',
          //   icon: 'ro',
          //   data: 'RO',
          //   active: false,
          // },
          // {
          //   name: 'Malay',
          //   icon: 'my',
          //   data: 'MS',
          //   active: false,
          // },
          // {
          //   name: 'English (Nigeria)',
          //   icon: 'ng',
          //   data: 'NG',
          //   active: false,
          // },
          // {
          //   name: 'Arabic',
          //   icon: 'sa',
          //   data: 'AR',
          //   active: false,
          // },
          // {
          //   name: 'Spanish (Peru)',
          //   icon: 'es',
          //   data: 'PE',
          //   active: false,
          // },
          // {
          //   name: 'Filipino',
          //   icon: 'ph',
          //   data: 'PH',
          //   active: false,
          // },
          // {
          //   name: 'Urdu',
          //   icon: 'pk',
          //   data: 'UR',
          //   active: false,
          // },
          // {
          //   name: 'Arabic (Qatar)',
          //   icon: 'qa',
          //   data: 'QA',
          //   active: false,
          // },
          // {
          //   name: 'Serbian',
          //   icon: 'rs',
          //   data: 'SR',
          //   active: false,
          // },
          // {
          //   name: 'Kinyarwanda',
          //   icon: 'rw',
          //   data: 'RW',
          //   active: false,
          // },
          // {
          //   name: 'English (Singapore)',
          //   icon: 'sg',
          //   data: 'SG',
          //   active: false,
          // },
          // {
          //   name: 'Slovenian',
          //   icon: 'si',
          //   data: 'SL',
          //   active: false,
          // },
          // {
          //   name: 'Slovak',
          //   icon: 'sk',
          //   data: 'SK',
          //   active: false,
          // },
          // {
          //   name: 'Tajik',
          //   icon: 'tj',
          //   data: 'TG',
          //   active: false,
          // },
          // {
          //   name: 'Chinese (Traditional)',
          //   icon: 'tw',
          //   data: 'TW',
          //   active: false,
          // },
          // {
          //   name: 'Spanish (Uruguay)',
          //   icon: 'es',
          //   data: 'UY',
          //   active: false,
          // },
          // {
          //   name: 'Uzbek',
          //   icon: 'uz',
          //   data: 'UZ',
          //   active: false,
          // },
          // {
          //   name: 'Vietnamese',
          //   icon: 'vn',
          //   data: 'VI',
          //   active: false,
          // },
        ],
        residence: [
          {
            data: 'FOREIGN',
            name: 'Foreign',
          },
          {
            data: 'RESIDENCE',
            name: 'Resident',
          },
          {
            data: 'EAST_AFRICAN',
            name: 'East African',
          },
        ],
        programTypes: [
          {
            name: 'Arrival to Tanzania',
            data: 'ARRIVAL',
          },
          {
            name: 'Climbing (Classic)',
            data: 'CLIMBING',
            subData: 'CLASSIC',
          },
          {
            name: 'Climbing (Join)',
            data: 'CLIMBING',
            subData: 'JOIN',
          },
          {
            name: 'Climbing (Premium)',
            data: 'CLIMBING',
            subData: 'PREMIUM',
          },
          {
            name: 'Safari (Private)',
            data: 'SAFARI',
          },
          {
            name: 'Day Trip',
            data: 'DAY_TRIP',
          },
          {
            name: 'Departure',
            data: 'DEPARTURE',
          },
          {
            name: 'Island Vacation',
            data: 'ISLAND',
          },
          {
            name: 'Island - Short ',
            data: 'ISLAND_COMPACTED',
          },
          {
            name: 'Own Arrangements',
            data: 'OWN_ARRANGEMENTS',
          },
          {
            name: 'Rest Day',
            data: 'REST_DAY',
          },
        ],
        airstrips: [{names: {EN: ''}}],
        activities: [],
        routes: [],
        routesGroups: [],
        additionalOptions: [],
        priceFor: [1, 2, 3, 4, 5, 6, 7, 8],
        parks: [],
        foodPreferences: [
          {
            name: 'Regular',
          },
          {
            name: 'Vegetarian',
          },
          {
            name: 'Vegan',
          },
          {
            name: 'Halal',
          },
          {
            name: 'Gluten-Free',
          },
          {
            name: 'Other',
          },
        ],
        pointsDep: [{names: {EN: ''}}],
        pointsArr: [{names: {EN: ''}}],
        airlines: [{names: {EN: ''}}],
        pointsTransferFrom: [{names: {EN: ''}}],
        pointsTransferTo: [{names: {EN: ''}}],
        flights: [{names: {EN: ''}}],
        flightsTimes: [],
        flightsTimesPrivateStart: '',
        flightsTimesPrivateEnd: '',
        flightsNetPricePrivate: null,
        luggage: ['15kg', '30kg'],
        hotels: [{names: {}}],
        meal: {
          mealPlanTypes: [],
        },
        room: [],
        accommodations: [],
        accommodationType: '',
        alternativeHotels: [],
        copyHotelsData: [],
        transfersAll: [{names: {EN: ''}}],
        advices: null,
        advicesData: null,
        activitiesTrips: [],
        islandsCompacted: [],
        allergiesDefaults: [
          'No allergies',
          'Milk',
          'Eggs',
          'Peanuts',
          'Tree nuts',
          'Soy',
          'Wheat',
          'Fish',
          'Shellfish',
          'Corn',
          'Gelatin',
          'Beef',
          'Wheat',
          'Mustard',
          'Red Meat',
          'Rice',
          'Sulfites',
          'Buckwheat',
          'Garlic',
          'Mango',
          'Tomatoes',
          'Strawberries',
          'Banana',
          'Avocado',
          'Sesame',
          'Chicken',
          'Mutton',
          'Pork',
          'Seeds',
          'Spices',
        ],
      },
      sharedUsers: null,
      totalPrice: null,
      advicesRecomended: null,
      hotelsClosedMinNights: {
        closed: [],
        minNights: [],
      },
      transitOptions: [
        {name: 'Before the main Park', transitType: 'BEFORE_MAIN_PARK'},
        {name: 'After the main Park', transitType: 'AFTER_MAIN_PARK'},
      ],
      currentClimbDay: null,
      hotelNotes: '',
    }
  },
  props: ['user'],
  beforeRouteLeave(to, from, next) {
    if (this.isEditFlag) {
      this.$emit('notLeaveHandler')
    }
    next()
  },
  created() {
    if (this.$route.params.invoice) this.tab = 3
    if (this.$route.query.invoice) this.tab = 3
  },
  beforeCreate() {
    document.title = 'Make a story'
  },
  mounted() {
    this.findAllBanks()
    this.findAllPartners()
    window.addEventListener('keydown', (event) => {
      var key = event.keyCode || event.which
      let save = String.fromCharCode(key).toLowerCase() === 's'
      if (!this.emailEnter) {
        if (event.ctrlKey && save) {
          if (event.preventDefault) event.preventDefault()
          event.returnValue = false
          if (this.isEdit) {
            this.updateClientsHandler()
          }
          window.focus()
          return false
        } else if (event.shiftKey && key === 49) {
          this.tab = 0
          window.scrollTo({
            top: 0,
            behavior: 'auto',
          })
        } else if (event.shiftKey && key === 50) {
          this.tab = 1
          window.scrollTo({
            top: 0,
            behavior: 'auto',
          })
        } else if (event.shiftKey && key === 51) {
          this.tab = 2
          window.scrollTo({
            top: 0,
            behavior: 'auto',
          })
        } else if (event.shiftKey && key === 52) {
          this.tab = 3
          window.scrollTo({
            top: 0,
            behavior: 'auto',
          })
        }
      }
    })
    window.addEventListener('beforeprint', (event) => {
      this.printLoad = true
    })
    window.addEventListener('afterprint', (event) => {
      this.printLoad = false
    })
    window.addEventListener('click', (event) => {
      event.stopPropagation()
      if (
          !event.target.closest('.edit-popup') &&
          !event.target.closest('.btn')
      ) {
        // this.insurancePopup = false
        // this.dietaryPopup = false
        this.changeDaysPopup = false
        this.safariDriverPopup = false
        // this.commissionPopup = false
        // this.hotelPopup = false
        // this.flightsPopup = false
        // this.activityPopup = false
        // this.transfersPopup = false
        // this.additionalPopup = false
        this.participants = this.participants.map((item) => ({...item}))
      }
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          status: false,
          operator: false,
          currency: false,
          lang: false,
          priceValid: false,
          residence: false,
          additionalPopup: {
            options: false,
            pax: false,
          },
          activityPopup: {
            activity: false,
            type: false,
            pax: false,
          },
          flightsPopup: {
            dep: false,
            arr: false,
            air: false,
            depTime: false,
            type: false,
            lug: false,
            pax: false,
          },
          transfersPopup: {
            from: false,
            to: false,
            pax: false,
          },
          hotelPopup: {
            hotel: false,
            meal: false,
            room: false,
            alternative: false,
            copy: false,
          },
        }
        if (this.hotelPopup && this.hotelPopup.hotelsData) {
          this.hotelPopup.hotelsData = this.hotelPopup.hotelsData.map(
              (item) => {
                item.clients = item.clients.map((client) => {
                  client.isOpen = false
                  return client
                })
                return item
              }
          )
        }
        if (this.activityPopup && this.activityPopup.activitiesData) {
          this.activityPopupData.paxList = this.activityPopupData.paxList.map(
              (item) => ({...item, open: false})
          )
          this.activityPopup.activitiesData =
              this.activityPopup.activitiesData.map((item) => {
                item.clients = item.clients.map((client) => {
                  client.isOpen = false
                  return client
                })
                return item
              })
        }
        if (this.flightsPopup && this.flightsPopup.flightsData) {
          this.flightsPopup.flightsData = this.flightsPopup.flightsData.map(
              (item) => {
                item.clients = item.clients.map((client) => {
                  client.isOpen = false
                  return client
                })
                return item
              }
          )
        }
        if (this.transfersPopup && this.transfersPopup.transfersData) {
          this.transfersPopupData.paxList = this.transfersPopupData.paxList.map(
              (item) => ({...item, open: false})
          )
          this.transfersPopup.transfersData =
              this.transfersPopup.transfersData.map((item) => {
                item.clients = item.clients.map((client) => {
                  client.isOpen = false
                  return client
                })
                return item
              })
        }
        if (this.additionalPopup && this.additionalPopup.additionalOptions) {
          this.additionalPopup.additionalOptions =
              this.additionalPopup.additionalOptions.map((item) => {
                item.clients = item.clients.map((client) => {
                  client.isOpen = false
                  return client
                })
                return item
              })
        }
        this.participants = this.participants.map((item) => ({
          ...item,
          genderSelect: false,
          residenceSelect: false,
          foodPreferencesSelect: false,
          alergiesSelect: false,
          weddingPopupOpen: false,
        }))
      }
      if (
          !event.target.closest('.select-wrapper') &&
          !event.target.closest('.modal-wrapper') &&
          !event.target.closest('.select-body')
      ) {
        this.data.program = this.data.program.map((item) => {
          item.airstripSelect = false
          item.airportError = false
          item.typeSelect = false
          item.climbSelect = false
          item.priceForSelect = false
          item.islandSelect = false
          item.carsSelect = false
          item.mountainSelect = false
          item.days = item.days.map((day) => {
            day.parkSelect = false
            day.transitSelectOpen = false
            return day
          })
          return item
        })
      }
    })
    getAdvices().then(() => {
      Promise.all([
        getAirstripsAll(),
        getRoutesAll(),
        getParks(),
        getAdditionals(),
        getPointsAll(),
        getAirlinesAll(),
        getFlightsAll(`01.01.${new Date().getFullYear()}`),
        getHotelsAll(),
        getPricesAll(),
        getTanzaniaAll(),
        getRoutesGroups(),
        getAdvicesRecommended(
            this.data.tourStart ||
            date(new Date('01 July ' + new Date().getFullYear()), 'start')
        ),
        getPartners(),
        getLocationsAll(),
      ]).then((res) => {
        this.dataSelects.islandsCompacted = res[13].filter(island => island.territory.id === 16)

        this.dataSelects.routes = res[1]
        this.dataSelects.parks = res[2].sort((a, b) =>
            a.nameForSystem > b.nameForSystem
                ? 1
                : b.nameForSystem > a.nameForSystem
                    ? -1
                    : 0
        )
        this.dataSelects.additionalOptions = res[3]
        this.transitParkID = this.dataSelects.parks.find(
            (park) => park.nameForSystem === 'Ngorongoro '
        ).id

        const operatorOther = res[12].find(
            (item) => item.companyName === 'Other'
        )
        const operatorAltezza = res[12].find(
            (item) => item.companyName === 'Altezza Travel'
        )
        if (!this.isEdit) operatorAltezza.active = true
        this.dataSelects.operator = res[12]
            .map((item) => ({
              ...item,
              active: false,
            }))
            .sort((a, b) => (a.companyName > b.companyName ? 1 : -1))
            .filter(
                (item) =>
                    item.companyName !== 'Other' &&
                    item.companyName !== 'Altezza Travel'
            )
        this.dataSelects.operator.push(operatorOther)
        this.dataSelects.operator.unshift(operatorAltezza)
        this.dataSelects.airstrips = res[0]
            .map((item) => ({
              ...item.airstrip,
            }))
            .sort((a, b) => (a.names.EN > b.names.EN ? 1 : -1))

        this.dataSelects.pointsDep = res[0]
            .map((item) => ({
              ...item.airstrip,
              active: false,
            }))
            .sort((a, b) => (a.names.EN > b.names.EN ? 1 : -1))

        this.dataSelects.pointsArr = res[0]
            .map((item) => ({
              ...item.airstrip,
              active: false,
            }))
            .sort((a, b) => (a.names.EN > b.names.EN ? 1 : -1))

        this.dataSelects.pointsTransferFrom = res[4]
            .map((item) => ({
              ...item,
              active: false,
            }))
            .sort((a, b) =>
                a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1
            )
        this.dataSelects.pointsTransferTo = res[4]
            .map((item) => ({
              ...item,
              active: false,
            }))
            .sort((a, b) =>
                a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1
            )

        this.dataSelects.airlines = res[5]
            .map((item) => ({
              ...item,
              active: false,
            }))
            .sort((a, b) =>
                a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
            )
        // this.dataSelects.flights = res[6].data
        // console.log('this.dataSelects.flights = res[6].data', res[6].data)
        this.dataSelects.hotels = res[7].sort((a, b) =>
            a.names.EN.toLowerCase() > b.names.EN.toLowerCase() ? 1 : -1
        )
        // this.dataSelects.hotels = res[7]
        this.dataSelects.transfersAll = res[8]
        this.dataSelects.activitiesTrips = res[9]
        this.dataSelects.routesGroups = res[10]
        this.advicesRecomended = {...res[11]}
        // console.log('this.advicesRecomended', this.advicesRecomended)
        this.dataSelects.advices = {...res[11]}
        // Remove adviced safari commission
        this.dataSelects.advices.commissions.safari = 0
        // console.log('this.dataSelects.advices', this.dataSelects.advices)
        this.isEdit = this.$route.params.id
        // this.updateDatePickers()
        if (this.isEdit) {
          let isTemplate = this.$route.fullPath.includes('template')
              // console.log(
              //   "let isTemplate = this.$route.fullPath.includes('template')",
              //   isTemplate
              // )
          ;(isTemplate
                  ? getTemplate(this.isEdit)
                  : getClient(this.isEdit)
          ).then((res) => {

            // console.log(
            //   'getClient res.program.frontendMeta',
            //   res.program.frontendMeta
            // )
            //
            this.programCurrency = res[isTemplate ? 'data' : 'program'].currency;
            this.sharedUsers = res.sharedUsers;
            this.totalPrice = isTemplate ? null : res.calculationResult;
            this.userId = res.userId
            this.clientId = res.id
            this.boardLeadId = isTemplate ? null : res.boardLeadId
            // console.log('getClient res.program.program', res)
            this.yearsDiff =
                res[isTemplate ? 'data' : 'program'].frontendMeta.yearsDiff || 0
            this.showNames =
                res[isTemplate ? 'data' : 'program'].frontendMeta.showNames ||
                false
            this.commisionInclude =
                res[isTemplate ? 'data' : 'program'].frontendMeta.commisionInclude
            document.title = res[isTemplate ? 'data' : 'program'].groupName
            // console.log(res[isTemplate ? 'data' : 'program'].frontendMeta.program)
            this.data = {
              ...this.data,
              id: res.id,
              contract: res.contract || null,
              groupName: res[isTemplate ? 'data' : 'program'].groupName,
              groupEmail: res[isTemplate ? 'data' : 'program'].groupEmail,
              tourDuration: res[isTemplate ? 'data' : 'program'].tourDuration,
              tourStart: res[isTemplate ? 'data' : 'program'].tourStart,
              tourFinish: res[isTemplate ? 'data' : 'program'].tourFinish,
              itineraryWithoutPrice:
              res[isTemplate ? 'data' : 'program'].itineraryWithoutPrice,
              itineraryWithNames:
              res[isTemplate ? 'data' : 'program'].itineraryWithNames,
              itineraryForSafariDriver:
              res[isTemplate ? 'data' : 'program'].itineraryForSafariDriver,
              notesForClients:
              res[isTemplate ? 'data' : 'program'].notesForClients,
              notesForManager:
              res[isTemplate ? 'data' : 'program'].notesForManager,
              program:
              res[isTemplate ? 'data' : 'program'].frontendMeta.program,
              link: res.link,
              priority: res[isTemplate ? 'data' : 'program'].priorityClient,
              hideWelcomeTexts: res[isTemplate ? 'data' : 'program'].hideWelcomeTexts,
              status: res[isTemplate ? 'data' : 'program'].status,
              // number: res[isTemplate ? 'data' : 'program'].phone.split(')')[1],
              number: res[isTemplate ? 'data' : 'program'].phone,
              whatsapp: res[isTemplate ? 'data' : 'program'].whatsApp,
              telegram: res[isTemplate ? 'data' : 'program'].telegram,
              country: res[isTemplate ? 'data' : 'program'].frontendMeta
                  .country || {
                data: 'ru',
                code: '(+7)',
              },
              priceValidUpTo: res[isTemplate ? 'data' : 'program']
                  .priceValidUpTo
                  ? date(
                      new Date(
                          (+res[
                              isTemplate ? 'data' : 'program'
                              ].priceValidUpTo.split('.')[2]).toString(),
                          (+res[
                              isTemplate ? 'data' : 'program'
                              ].priceValidUpTo.split('.')[1]).toString() - 1,
                          (+res[
                              isTemplate ? 'data' : 'program'
                              ].priceValidUpTo.split('.')[0]).toString()
                      ).getTime(),
                      'd'
                  )
                  : date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30, 'd'),
            }

            // console.log('this.data', this.data)
            // console.log('this.data.program', this.data.program)

            this.dataSelects.advices = {
              discounts: {
                climbAdditionalOptions:
                res[isTemplate ? 'data' : 'program'].discounts
                    .climbAdditionalOptions,
                climbing:
                res[isTemplate ? 'data' : 'program'].discounts.climbing,
                climb:
                res[isTemplate ? 'data' : 'program'].discounts.climbing,
                dayTrips:
                res[isTemplate ? 'data' : 'program'].discounts.dayTrips,
              },
              commissions: {
                activity:
                res[isTemplate ? 'data' : 'program'].commissions.activity,
                flights:
                res[isTemplate ? 'data' : 'program'].commissions.flight,
                island: res[isTemplate ? 'data' : 'program'].commissions.island,
                other: res[isTemplate ? 'data' : 'program'].commissions.other,
                safari: res[isTemplate ? 'data' : 'program'].commissions.safari,
                extraAccommodation:
                res[isTemplate ? 'data' : 'program'].commissions
                    .extraAccommodation,
                transfer:
                res[isTemplate ? 'data' : 'program'].commissions.transfer,
                airportVipServices:
                res[isTemplate ? 'data' : 'program'].commissions
                    .airportVipServices,
              },
            }

            getAdvicesRecommended(this.data.tourStart)
                .then((response) => {
                  // console.log('getAdvicesRecommended', this.data.tourStart)
                  // console.log('getAdvicesRecommended this.dataSelects.advices response', response)
                  this.advicesRecomended = {...response}
                  // this.dataSelects.advices = {...response}
                })
            this.tourStart = res[isTemplate ? 'data' : 'program'].frontendMeta
                .tourStart
                ? date(
                    new Date(
                        (+res[
                            isTemplate ? 'data' : 'program'
                            ].frontendMeta.tourStart.split('.')[2]).toString(),
                        (+res[
                            isTemplate ? 'data' : 'program'
                            ].frontendMeta.tourStart.split('.')[1]).toString() - 1,
                        (+res[
                            isTemplate ? 'data' : 'program'
                            ].frontendMeta.tourStart.split('.')[0]).toString()
                    ).getTime(),
                    'd'
                )
                : ''
            this.tourFinish = res[isTemplate ? 'data' : 'program'].frontendMeta
                .tourFinish
                ? date(
                    new Date(
                        (+res[
                            isTemplate ? 'data' : 'program'
                            ].frontendMeta.tourFinish.split('.')[2]).toString(),
                        (+res[
                            isTemplate ? 'data' : 'program'
                            ].frontendMeta.tourFinish.split('.')[1]).toString() - 1,
                        (+res[
                            isTemplate ? 'data' : 'program'
                            ].frontendMeta.tourFinish.split('.')[0]).toString()
                    ).getTime(),
                    'd'
                )
                : ''
            setTimeout(() => {
              this.watchComission = true
              this.durationData = this.duration =
                  res[isTemplate ? 'data' : 'program'].tourDuration
              // console.log(this.$refs.tourStart.value)
              this.setRefValue('tourStart', res[isTemplate ? 'data' : 'program']
                  .frontendMeta.tourStart
                  ? date(
                      new Date(
                          (+res[
                              isTemplate ? 'data' : 'program'
                              ].frontendMeta.tourStart.split('.')[2]).toString(),
                          (+res[
                              isTemplate ? 'data' : 'program'
                              ].frontendMeta.tourStart.split('.')[1]).toString() - 1,
                          (+res[
                              isTemplate ? 'data' : 'program'
                              ].frontendMeta.tourStart.split('.')[0]).toString()
                      ).getTime(),
                      'd'
                  )
                  : '')
              this.setRefValue('tourFinish', res[isTemplate ? 'data' : 'program']
                  .frontendMeta.tourFinish
                  ? date(
                      new Date(
                          (+res[
                              isTemplate ? 'data' : 'program'
                              ].frontendMeta.tourFinish.split('.')[2]).toString(),
                          (+res[
                              isTemplate ? 'data' : 'program'
                              ].frontendMeta.tourFinish.split('.')[1]).toString() - 1,
                          (+res[
                              isTemplate ? 'data' : 'program'
                              ].frontendMeta.tourFinish.split('.')[0]).toString()
                      ).getTime(),
                      'd'
                  )
                  : '')
            }, 300)
            this.dataSelects.status = this.dataSelects.status.map((item) => ({
              ...item,
              active: item.data === res[isTemplate ? 'data' : 'program'].status,
            }))
            this.dataSelects.operator = this.dataSelects.operator.map(
                (item) => ({
                  ...item,
                  active:
                      item.id ===
                      res[isTemplate ? 'data' : 'program'].tourOperatorId,
                })
            )
            this.dataSelects.currency = this.dataSelects.currency.map(
                (item) => ({
                  ...item,
                  active:
                      item.name === res[isTemplate ? 'data' : 'program'].currency,
                })
            )
            this.dataSelects.lang = this.dataSelects.lang.map((item) => ({
              ...item,
              active: item.data === res[isTemplate ? 'data' : 'program'].lang,
            }))
            // this.dataSelects.valid = this.dataSelects.valid.map(item => ({...item, active: +item.name === res[isTemplate ? 'data' : 'program'].priceValidUpTo}))
            this.participants =
                res[isTemplate ? 'data' : 'program'].frontendMeta.participants.map(
                    ({citizenship, passportNumber, citySelect, citySelectInput, ...participant}) => participant
                )
            // this.newPart = [ ...res[isTemplate ? 'data' : 'program'].frontendMeta.participants ]
            this.participantPersonalDiscounts = res[isTemplate ? 'data' : 'program'].participantPersonalDiscounts.map((item) => ({
              ...item,
              participantId: this.participants.find(
                  (elem) => elem.id === item.participantId
              ),
            }))
            this.additionalServices =
                res[isTemplate ? 'data' : 'program'].additionalServices

            if (isTemplate) {
              this.calcTemplatePriceHandler()
            }
            setTimeout(() => {
              this.participants.map((item, index) => {
                this.setRefValue('participantsDateRef' + index, item.dateOfBirth)
              })
            }, 500)
            this.isLoad = true
          }).then(() => {
            this.isFirstLoading = false;
            this.findAllInvoices();
            this.findAmountSummariesInvoice()
          })
        } else {
          this.isLoad = true
          this.addParticipant(true)
        }
        this.updateDatePickers()
      })
    })
  },
  methods: {
    getCurrencySign,
    ...Vuex.mapActions({
      findSearchInvoices: actionTypesInvoices.findSearchInvoices,
      findBanks: actionTypesBanks.findBanks,
      findPartners: actionTypesPartners.findPartners,
      updateInvoiceStatus: actionTypesInvoices.updateInvoiceStatus,
      getAmountSummariesInvoice: actionTypesInvoices.getAmountSummariesInvoice
    }),
    getRefElement(refName) {
      const ref = this.$refs[refName]

      if (Array.isArray(ref)) {
        return ref[0] || null
      }

      return ref || null
    },
    setRefValue(refName, value) {
      const element = this.getRefElement(refName)

      if (element) {
        element.value = value
      }
    },
    clearSelectedHotelInModal() {
      this.selectedHotel = {
        notes: null,
        transferTimeMin: null,
        closest: null,
      }
    },
    fillSelectedFlight() {
      this.dataSelects.selectedFlight = this.dataSelects.flights.find(
          (flight) =>
              flight.origin ===
              this.dataSelects.pointsDep.find(
                  (item) => item.active
              ).id &&
              flight.destination ===
              this.dataSelects.pointsArr.find(
                  (item) => item.active
              ).id &&
              flight.departureTime ===
              this.dataSelects.flightsTimes.find(
                  (item) => item.active
              ).name &&
              flight.companyId ===
              this.dataSelects.airlines.find(
                  (item) => item.active
              ).id
      )
    },
    removeParticipantFromClimbing(participant) {
      this.data.program.filter(item =>
          item.type.data === "CLIMBING"
          && (item.type.subData === 'CLASSIC'
              || item.type.subData === 'PREMIUM'))
          .forEach((item) => {
            item.participantsIds = item.participantsIds.filter((p) => p.active && p.ageType !== 'child' && participant.id !== p.id)
            item.priceFor = item.participantsIds.length;
          })
    },
    getHotelNamesList(hotelsData) {
      if (hotelsData[0]) {
        return `\n ${hotelsData[0].name}`
      }

      return '';
    },
    onAddDragUpdate() {
      this.calcTemplatePriceHandler()
    },
    findAmountSummariesInvoice() {
      this.getAmountSummariesInvoice({
        clientId: this.clientId
      })
    },
    openMenu(id) {
      this.allInvoices.map((item) =>
          item.id === id ? item.menu = !item.menu : item.menu = false
      )
    },
    openModalAmountPaid(invoice) {
      if (invoice.status === 'PARTIALLY') {
        this.currentInvoiceModal = invoice
        this.IsModalInvoiceAmountPaid = true
      }
    },
    closeModalInvoiceStatusPaid(value) {
      this.findAllInvoices()
      this.isModalInvoicePaid = value
    },
    closeModalInvoiceAmountPaid(value) {
      this.findAllInvoices()
      this.IsModalInvoiceAmountPaid = value
    },
    closeModalInvoiceStatusPartiallyPaid(value) {
      this.findAllInvoices()
      this.isModalInvoicePartiallyPaid = value
    },
    selectedOption(invoice) {
      if (invoice.status === 'PAID') {
        this.currentInvoiceModal = invoice
        this.isModalInvoicePaid = true
      }

      if (invoice.status === 'PARTIALLY') {
        this.currentInvoiceModal = invoice
        this.isModalInvoicePartiallyPaid = true
      }

      if (invoice.status === 'CANCEL') {
        const payload = {
          param: {
            status: {
              type: invoice.status,
            },
            userId: invoice.userId
          },
          invoiceId: invoice.id
        }
        this.updateInvoiceStatus(payload).then(() => this.findAllInvoices())
      }

      if (invoice.status === 'REFUND') {
        this.currentInvoiceModal = invoice
        const payload = {
          param: {
            status: {
              type: invoice.status,
            },
            userId: invoice.userId
          },
          invoiceId: invoice.id
        }
        this.updateInvoiceStatus(payload).then(() => this.findAllInvoices())
      }

      if (invoice.status === 'SENT') {
        this.currentInvoiceModal = invoice
        const payload = {
          param: {
            status: {
              type: invoice.status,
            },
            userId: invoice.userId
          },
          invoiceId: invoice.id
        }
        this.updateInvoiceStatus(payload).then(() => this.findAllInvoices())
      }
    },
    closeModalInvoiceTotalAmount(value) {
      this.isModalInvoiceTotalAmount = value
    },
    findCurrentTotalAmountInvoices(invoice) {
      this.currentInvoice = invoice
      this.isModalInvoiceTotalAmount = true
    },
    findCurrentBankInvoice(bankId) {
      return this.allBanks.filter(b => b.id === bankId)[0].shortName
    },
    findCurrentPartnersInvoice(partnerId) {
      return this.allPartners.filter(p => p.id === partnerId)[0].companyName
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    calculatePriceInvoices(invoices) {
      // console.log(invoices)
      const arrayA = invoices.map(a => a.totalAmount)
      const initialValueA = 0;
      this.invoicesProgram.totalA = arrayA.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValueA
      );
      const arrayPFilter = invoices.filter(i => i.status === 'SENT' || i.status === 'PAID' || i.status === 'PARTIALLY')

      const arrayP = arrayPFilter.map(a => a.amountPaid)
      const initialValueP = 0;
      this.invoicesProgram.aPaid = arrayP.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          initialValueP
      );

      if (this.invoicesProgram.aPaid !== 0) {
        this.invoicesProgram.remainBalance = this.invoicesProgram.totalA - this.invoicesProgram.aPaid
      } else {
        this.invoicesProgram.remainBalance = this.invoicesProgram.totalA
      }
    },
    countPrice: debounce((invoices) => {
    }, 350),
    findAllInvoices() {
      this.findSearchInvoices({
        trackingTotalCount: true,
        filter: {
          clientId: this.clientId,
          userId: this.userId,
        },
        sort: {
          invoiceNumber: {
            order: "ASC"
          },
          deadline: {
            order: "ASC"
          }
        },

      }).then((res) => this.calculatePriceInvoices(res.data.results))
    },
    findAllBanks() {
      this.findBanks()
    },
    findAllPartners() {
      this.findPartners()
    },
    itemTypeName(name) {
      if (name.length === 0) {
        this.isOpenModalDelete = false
        return name
      }

      if (name.length !== 0) {
        this.isOpenModalDelete = true
        return name
      }
    },
    addToCalculatorHotelButtonClick() {
      this.hotelPopupData.hotelsData = this.hotelPopupData.hotelsData.concat({
        free: this.hotelPopupData.free,
        bookedByGuest: this.hotelPopupData.bookedByGuest,
        earlyCheckIn: this.hotelPopupData.earlyCheckIn ? this.hotelPopupData.checkInOutInputsData.earlyCheckIn : null,
        lateCheckOut: this.hotelPopupData.lateCheckOut ? this.hotelPopupData.checkInOutInputsData.lateCheckOut : null,
        day:
            this.hotelPopup.type.data === 'CLIMBING'
                ? this.hotelPopup.day +
                ((this.hotelPopup.climb.durationDays ||
                        this.hotelPopup.climb.days) -
                    1)
                : this.hotelPopup.day,
        name: this.hotelPopupData.hotel.names.EN,
        hotelId: this.hotelPopupData.hotel.id,
        meal: this.hotelPopupData.meal,
        mealData: this.hotelPopupData.meal,
        mealType: this.hotelPopupData.meal,
        accommodationType: this.dataSelects.accommodationType[0],
        participantIds: [],
        room: this.hotelPopupData.room.names.EN,
        date:
            this.hotelPopup.type.data === 'CLIMBING' && this.hotelPopup.date
                ? this.dateCalc(
                    +new Date(
                        +('20' + this.hotelPopup.date.split('/')[2]),
                        +this.hotelPopup.date.split('/')[1] - 1,
                        +this.hotelPopup.date.split('/')[0]
                    ).getTime() +
                    ((this.hotelPopup.climb.durationDays ||
                            this.hotelPopup.climb.days) -
                        1) *
                    24 *
                    60 *
                    60 *
                    1000
                )
                : this.hotelPopup.date,
        roomId: this.hotelPopupData.room.id,
        roomType: this.hotelPopupData.room.names.EN,
        clients:
            this.dataSelects.accommodations
                .find((item) => item.active)
                .data.map((item) =>
                Array(item.count).fill({
                  name: '',
                  isOpen: false,
                  id: '',
                  type: item.type,
                })
            )
                .flat()
        //     .length === this.participants.length &&
        // this.participants.length <= 2
        //   ? this.participants.map((p) => ({
        //       name: p.name,
        //       age: p.age,
        //       id: p.id,
        //       type:
        //         p.ageType === 'teenager'
        //           ? 'T'
        //           : p.ageType === 'child'
        //           ? 'C'
        //           : 'A',
        //     }))
        //   : this.dataSelects.accommodations
        //       .find((item) => item.active)
        //       .data.map((item) =>
        //         Array(item.count).fill({
        //           name: '',
        //           isOpen: false,
        //           id: '',
        //           type: item.type,
        //         })
        //       )
        //       .flat()
        ,
        accommodations: this.dataSelects.accommodations.find(
            (item) => item.active
        ),
        price: this.hotelPopupData.price,
      })
      this.isEditFlag = true
    },
    onNotesButtonClick(day) {
      this.notesPopup = true
      this.currentDay = day
    },
    onChangeAdditional(part, descr, price) {
      if (part && descr && price) this.calcTemplatePriceHandler()
    },
    onAdditionalAdd() {
      this.additionalServices.push({})
    },
    onAdditionalDelete(index) {
      this.additionalServices.splice(index, 1)
      this.calcTemplatePriceHandler()
    },
    filteredParticipant() {
      // filtering removed
      this.filteredParticipantDiscounts = this.participants;
    },
    onDiscountValueInput(event) {
      if (
          event.keyCode === 187 ||
          event.keyCode === 189 ||
          event.keyCode === 69
      ) {
        event.preventDefault()
      }
    },
    onDiscountAdd() {
      this.participantPersonalDiscounts.push({
        participantId: {name: '', id: null},
        discount: null,
        description: '',
        discountType: 'AMOUNT',
      })
      this.filteredParticipant()
    },
    onDiscountDelete(index) {
      this.participantPersonalDiscounts.splice(index, 1)
      this.calcTemplatePriceHandler()
    },
    onClickAltOptions(item) {
      this.hotelPopupData.hotel = this.dataSelects.hotels.find(
          (hotel) => hotel.id === item.hotelId
      )
      this.hotelSelectInput = this.hotelPopupData.hotel.names.EN
      this.getHotelData(item.hotelId)
      this.hotelPopupData.room = null
      this.dataSelects.accommodations = []
      this.hotelPopupData.price = ''
      this.selects.hotelPopup.alternative = false
    },
    onChangeAdditionalServicesHideCheckbox() {
      this.calcTemplatePriceHandler()
    },
    onChangeComission() {
      if (this.commisionInclude) {
        this.calcTemplatePriceHandler()
      } else {
        this.calcTemplatePriceHandler()
      }
    },
    onChangeBirthdayCalendar(event, item) {
      let ageFix =
          new Date(
              new Date().getTime() - new Date(event.target.value).getTime()
          ).getFullYear() - new Date(0).getFullYear()

      if (this.tourStart && this.tourFinish) {
        const bd = new Date(event.target.value)
        const tsd = new Date(this.tourStart)
        const tfd = new Date(this.tourFinish)
        var now = new Date()
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        var dob = new Date(bd.getFullYear(), bd.getMonth(), bd.getDate())
        var dobnow = new Date(
            today.getFullYear(),
            dob.getMonth(),
            dob.getDate()
        )
        var age
        age = today.getFullYear() - dob.getFullYear()
        if (today < dobnow) {
          age = age - 1
        }
        const ageFix1 =
            new Date(tsd.getTime() - bd.getTime()).getFullYear() -
            new Date(0).getFullYear()
        const ageFix2 =
            new Date(tfd.getTime() - bd.getTime()).getFullYear() -
            new Date(0).getFullYear()
        ageFix = Math.max(ageFix1, ageFix2)
      }

      item.age = ageFix
      item.ageType =
          item.age > 0 && item.age <= 4
              ? 'child'
              : item.age > 4 && item.age <= 15
                  ? 'teenager'
                  : 'adult'
      item.dateOfBirth = event.target.value
      if (item.age > 0 && item.age <= 4) {
        item.name = item.name
            .replace('Adult', 'Child')
            .replace('Teenager', 'Child')
      } else if (item.age > 4 && item.age <= 15) {
        item.name = item.name
            .replace('Child', 'Teenager')
            .replace('Adult', 'Teenager')
      } else if (item.age > 15) {
        item.name = item.name
            .replace('Child', 'Adult')
            .replace('Teenager', 'Adult')
      }
    },
    participantsFiltered(clientOption) {
      if (this.dataSelects.meal.ageSettings) {
        return this.participants
            .filter((par) =>
                clientOption.type === 'T'
                    ? par.age >= this.dataSelects.meal.ageSettings.teenager.from &&
                    par.age <= this.dataSelects.meal.ageSettings.teenager.to
                    : clientOption.type === 'C'
                        ? par.age <= this.dataSelects.meal.ageSettings.child.to
                        : par.age >= this.dataSelects.meal.ageSettings.adult.from
            )
            .filter(
                (par) =>
                    !this.hotelPopupData.hotelsData
                        .map((data) => data.clients)
                        .flat()
                        .map((client) => client.id)
                        .includes(par.id)
            )
      }
    },
    onAutocompletePaxClick() {
      this.transfersPopupData.participants = this.participants.map((item) => ({
        id: item.id,
        name: item.name,
        ageType: item.ageType,
        open: false,
      }))
    },
    onAutocompleteActivityClick() {
      this.activityPopupData.paxList = this.participants.map(item => ({
        id: item.id,
        name: item.name,
        ageType: item.ageType,
        open: false,
      }))
    },
    onAutocompleteHotelClick() {
      if (this.hotelPopupData.hotelsData.length > 0) {
        const hotel = JSON.parse(JSON.stringify(this.hotelPopupData.hotelsData))
        this.newPart = [...this.participants]
        hotel.map((hotel) => {
          hotel.clients.map((client) => {
            if (client.type === 'A') {
              let part = this.newPart.find(p => p.ageType === 'adult')
              if (part) {
                client.id = part.id
                client.name = part.name
                client.ageType = part.ageType
                const index = this.newPart.findIndex(n => n.id === part.id);
                if (index !== -1) {
                  this.newPart.splice(index, 1);
                }
              }
            }
            if (client.type === 'T') {
              let part = this.newPart.find(p => p.ageType === 'teenager')
              if (part) {
                client.id = part.id
                client.name = part.name
                client.ageType = part.ageType
                const index = this.newPart.findIndex(n => n.id === part.id);
                if (index !== -1) {
                  this.newPart.splice(index, 1);
                }
              }
            }
            if (client.type === 'C') {
              let part = this.newPart.find(p => p.ageType === 'child')
              if (part) {
                client.id = part.id
                client.name = part.name
                client.ageType = part.ageType
                const index = this.newPart.findIndex(n => n.id === part.id);
                if (index !== -1) {
                  this.newPart.splice(index, 1);
                }
              }
            }
          })
          hotel.participantIds = []
          hotel.clients.map(h => {
            hotel.participantIds.push(h.id)
          })
        })


        this.hotelPopupData.hotelsData = hotel
      }
    },
    onTransferPaxClick(pax) {
      this.transfersPopupData.pax = pax
      if (this.participants.length <= 2) {
        if (this.transfersPopupData.pax === 1) {
          this.transfersPopupData.participants = Array({
            id: this.participants[0].id,
            name: this.participants[0].name,
            ageType: this.participants[0].ageType,
            open: false,
          })
        } else if (this.transfersPopupData.pax === 2) {
          this.transfersPopupData.participants = Array(
              {
                id: this.participants[0].id,
                name: this.participants[0].name,
                ageType: this.participants[0].ageType,
                open: false,
              },
              {
                id: this.participants[1].id,
                name: this.participants[1].name,
                ageType: this.participants[1].ageType,
                open: false,
              }
          )
        }
      } else {
        this.transfersPopupData.participants = Array(+pax).fill({
          name: '',
          open: false,
          id: '',
        })
      }
    },
    resetTransferPopup() {
      this.dataSelects.pointsTransferFrom =
          this.dataSelects.pointsTransferFrom.map((item) => ({
            ...item,
            active: false,
          }))
      this.dataSelects.pointsTransferTo = this.dataSelects.pointsTransferTo.map(
          (item) => ({...item, active: false})
      )
      this.transfersPopupData.pax = ''
      this.transfersPopupData.free = false
      this.transfersPopupData.time = ''
      this.transfersPopupData.alternative = ''
      this.transfersPopupData.participants = []
      this.transfersPopupData.transfersData = []
      this.transferToSelectInput = ''
      this.transferFromSelectInput = ''
    },
    onGetFlightsFind(from, to = '') {
      let date = ''

      if (this.flightsPopup.date) {
        date = {...this.flightsPopup}.date.replaceAll('/', '.')
        let tempDateArr = date.split('.')
        tempDateArr.push(`20${tempDateArr.pop()}`)
        date = tempDateArr.join('.')
      } else {
        date =
            new Date().getMonth() <= 6
                ? `01.07.${new Date().getFullYear()}`
                : `01.07.${new Date().getFullYear() + 1}`
      }
      return new Promise((resolve) => {
        getFlightsFind({startDate: date, from, to}).then((res) => {
          this.dataSelects.flights = res.data
          resolve(res.data)
        })
      })
    },
    onDepartureChecked(item) {
      this.dataSelects.pointsDep = this.dataSelects.pointsDep.map((point) => ({
        ...point,
        active: point.id === item.id,
      }))
      this.dataSelects.pointsArr = this.dataSelects.pointsArr.map((point) => ({
        ...point,
        active: false,
      }))
      this.dataSelects.airlines = this.dataSelects.airlines.map((point) => ({
        ...point,
        active: false,
      }))
      const depActive = this.dataSelects.pointsDep.find((item) => item.active)
      this.flightDepSelectInput = depActive.names.EN

      this.onGetFlightsFind(depActive.id).then(() => {
        this.dataSelects.flights.filter((flight) => item.id === flight.origin)
            .length === 1
            ? (this.dataSelects.pointsArr = this.dataSelects.pointsArr.map(
                (pt) => ({
                  ...pt,
                  active:
                      this.dataSelects.flights.find(
                          (flight) => item.id === flight.origin
                      ).destination === pt.id,
                })
            ))
            : false
        if (this.dataSelects.pointsArr.find((pt) => pt.active)) {
          this.dataSelects.flights.filter(
              (flight) =>
                  item.id === flight.origin &&
                  this.dataSelects.pointsArr.find((pt) => pt.active).id ===
                  flight.destination
          ).length === 1
              ? (this.dataSelects.airlines = this.dataSelects.airlines.map(
                  (air) => ({
                    ...air,
                    active:
                        this.dataSelects.flights.find(
                            (flight) =>
                                item.id === flight.origin &&
                                this.dataSelects.pointsArr.find((pt) => pt.active)
                                    .id === flight.destination
                        ).companyId === air.id,
                  })
              ))
              : false
          this.dataSelects.flights.filter(
              (flight) =>
                  item.id === flight.origin &&
                  this.dataSelects.pointsArr.find((pt) => pt.active).id ===
                  flight.destination &&
                  this.dataSelects.airlines.find((air) => air.active).id ===
                  flight.companyId
          ).length === 1
              ? (this.dataSelects.flightsTimes = [
                {
                  name: this.dataSelects.flights.find(
                      (flight) =>
                          item.id === flight.origin &&
                          this.dataSelects.pointsArr.find((pt) => pt.active).id ===
                          flight.destination &&
                          this.dataSelects.airlines.find((air) => air.active).id ===
                          flight.companyId
                  ).departureTime,
                  active: true,
                },
              ])
              : (this.dataSelects.flightsTimes = this.dataSelects.flights
                  .filter(
                      (flight) =>
                          this.dataSelects.pointsDep.find((item) => item.active) &&
                          this.dataSelects.pointsDep.find((item) => item.active)
                              .id === flight.origin &&
                          this.dataSelects.pointsArr.find((item) => item.active) &&
                          this.dataSelects.pointsArr.find((item) => item.active)
                              .id === flight.destination &&
                          this.dataSelects.airlines.find((item) => item.active) &&
                          this.dataSelects.airlines.find((item) => item.active).id ===
                          flight.companyId
                  )
                  .map((flight) => ({
                    name: flight.departureTime,
                    active: false,
                  })))
        }
      })
    },
    onArrivalChecked(item) {
      this.dataSelects.pointsArr = this.dataSelects.pointsArr.map((point) => ({
        ...point,
        active: point.id === item.id,
      }))
      this.dataSelects.airlines = this.dataSelects.airlines.map((point) => ({
        ...point,
        active: false,
      }))

      const depActive = this.dataSelects.pointsDep.find((pt) => pt.active)
      const arrActive = this.dataSelects.pointsArr.find((pt) => pt.active)
      this.flightArrSelectInput = arrActive.names.EN

      this.onGetFlightsFind(depActive.id, arrActive.id).then(() => {
        this.dataSelects.flights.filter((flight) => item.id === flight.origin)
            .length === 1
            ? (this.dataSelects.pointsArr = this.dataSelects.pointsArr.map(
                (pt) => ({
                  ...pt,
                  active:
                      this.dataSelects.flights.find(
                          (flight) => item.id === flight.origin
                      ).destination === pt.id,
                })
            ))
            : false
        if (this.dataSelects.airlines.find((air) => air.active)) {
          this.dataSelects.flights.filter(
              (flight) =>
                  depActive.id === flight.origin && item.id === flight.destination
          ).length === 1
              ? (this.dataSelects.airlines = this.dataSelects.airlines.map(
                  (air) => ({
                    ...air,
                    active:
                        this.dataSelects.flights.find(
                            (flight) =>
                                depActive.id === flight.origin &&
                                item.id === flight.destination
                        ).companyId === air.id,
                  })
              ))
              : false
          this.dataSelects.flights.filter(
              (flight) =>
                  depActive.id === flight.origin &&
                  item.id === flight.destination &&
                  this.dataSelects.airlines.find((air) => air.active).id ===
                  flight.companyId
          ).length === 1
              ? (this.dataSelects.flightsTimes = [
                {
                  name: this.dataSelects.flights.find(
                      (flight) =>
                          depActive.id === flight.origin &&
                          item.id === flight.destination &&
                          this.dataSelects.airlines.find((air) => air.active).id ===
                          flight.companyId
                  ).departureTime,
                  active: true,
                },
              ])
              : (this.dataSelects.flightsTimes = this.dataSelects.flights
                  .filter(
                      (flight) =>
                          depActive &&
                          depActive.id === flight.origin &&
                          arrActive &&
                          arrActive.id === flight.destination &&
                          this.dataSelects.airlines.find((item) => item.active) &&
                          this.dataSelects.airlines.find((item) => item.active).id ===
                          flight.companyId
                  )
                  .map((flight) => ({
                    name: flight.departureTime,
                    active: false,
                  })))
        }
      })
    },
    onInputTotalCars(day) {
      this.isEditFlag = true
      if (day.priceFor > 7 && day.totalCars === 1) day.totalCars = 2
      if (day.totalCars > day.priceFor) day.totalCars = day.priceFor
    },
    removeFractional(price) {
      return Math.ceil(price)
    },
    getSafariCommission(cost) {
      return (cost.dynamicCommissions && cost.dynamicCommissions.safari && cost.dynamicCommissions.safari.percent) ||
          this.dataSelects.advices.commissions.safari || 0
    },
    getSafariCommissionPercent(response) {
      if (
          response.calculationResult &&
          response.calculationResult.dynamicCommissions &&
          response.calculationResult.dynamicCommissions.safari.percent &&
          response.program.commissions.safari === 0
      ) {
        return response.calculationResult.dynamicCommissions.safari.percent
      } else {
        return response.program.commissions.safari
      }
    },
    searchPrice(dataSelects) {
      const from = dataSelects.pointsTransferFrom.find((x) => x.active)
      const to = dataSelects.pointsTransferTo.find((x) => x.active)

      this.transfersPopupData.alternative = false
      this.transfersPopupData.price = null
      this.transfersPopupData.error = null

      if (from == null || to == null) {
        return
      }

      searchPrice(from.id, to.id)
          .then((data) => {
            const transferExist =
                (data.departureId == from.id && data.arrivalId == to.id) ||
                (data.departureId == to.id && data.arrivalId == from.id)
            if (!transferExist) {
              this.transfersPopupData.alternative = true
            }
            this.transfersPopupData.price = data
          })
          .catch(() => {
            this.transfersPopupData.alternative = false
            this.transfersPopupData.price = null
            this.transfersPopupData.error = 'Transfers not found'
          })
    },
    transitParkToggleHandler(day) {
      this.transferPopup = true
      this.transitParkPopup = day

      if (!day.transitPark) day.transitPark = {}
    },
    saveTransitParkToggleHandler(day) {
      if (Object.keys(day.transitPark).length === 0) day.transitPark = null
    },
    parseDate(date) {
      if (!date) return
      return new Date(
          format(parse(date, 'dd.MM.yyyy', new Date()), 'yyyy, MM, dd')
      )
    },
    parseDateToString(date) {
      if (!date) return
      return format(parse(date, 'dd.MM.yyyy', new Date()), 'dd MMM yyyy')
    },
    getHotelsMinNightAndClosedDays(hotelId) {
      Promise.all([
        getHotelMinNightStay(hotelId),
        getHotelClosedDay(hotelId),
      ]).then((response) => {
        this.hotelsClosedMinNights.minNights = response[0].data
        this.hotelsClosedMinNights.closed = response[1].data
      })
    },
    recoverVersion(id) {
      this.isLoad = false
      getClientRecover(id).then((res) => {
        let isTemplate = false
        this.yearsDiff =
            res[isTemplate ? 'data' : 'program'].frontendMeta.yearsDiff || 0
        this.showNames =
            res[isTemplate ? 'data' : 'program'].frontendMeta.showNames || false
        this.commisionInclude =
            res[isTemplate ? 'data' : 'program'].frontendMeta.commisionInclude
        this.data = {
          ...this.data,
          id: this.data.id,
          groupName: res[isTemplate ? 'data' : 'program'].groupName,
          groupEmail: res[isTemplate ? 'data' : 'program'].groupEmail,
          tourDuration: res[isTemplate ? 'data' : 'program'].tourDuration,
          tourStart: res[isTemplate ? 'data' : 'program'].tourStart,
          tourFinish: res[isTemplate ? 'data' : 'program'].tourFinish,
          itineraryWithoutPrice:
          res[isTemplate ? 'data' : 'program'].itineraryWithoutPrice,
          itineraryWithNames:
          res[isTemplate ? 'data' : 'program'].itineraryWithNames,
          itineraryForSafariDriver:
          res[isTemplate ? 'data' : 'program'].itineraryForSafariDriver,
          notesForClients: res[isTemplate ? 'data' : 'program'].notesForClients,
          notesForManager: res[isTemplate ? 'data' : 'program'].notesForManager,
          program: res[isTemplate ? 'data' : 'program'].frontendMeta.program,
          link: res.link,
          priority: res[isTemplate ? 'data' : 'program'].priorityClient,
          hideWelcomeTexts: res[isTemplate ? 'data' : 'program'].hideWelcomeTexts,
          status: res[isTemplate ? 'data' : 'program'].status,
          number: res[isTemplate ? 'data' : 'program'].phone,
          whatsapp: res[isTemplate ? 'data' : 'program'].whatsApp,
          telegram: res[isTemplate ? 'data' : 'program'].telegram,
          country: res[isTemplate ? 'data' : 'program'].frontendMeta
              .country || {data: 'ru', code: '(+7)'},
          priceValidUpTo: res[isTemplate ? 'data' : 'program'].priceValidUpTo
              ? date(
                  new Date(
                      (+res[isTemplate ? 'data' : 'program'].priceValidUpTo.split(
                          '.'
                      )[2]).toString(),
                      (+res[isTemplate ? 'data' : 'program'].priceValidUpTo.split(
                          '.'
                      )[1]).toString() - 1,
                      (+res[isTemplate ? 'data' : 'program'].priceValidUpTo.split(
                          '.'
                      )[0]).toString()
                  ).getTime(),
                  'd'
              )
              : date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30, 'd'),
        }
        this.totalPrice = res.calculationResult
        this.tourStart = res[isTemplate ? 'data' : 'program'].frontendMeta
            .tourStart
            ? date(
                new Date(
                    (+res[
                        isTemplate ? 'data' : 'program'
                        ].frontendMeta.tourStart.split('.')[2]).toString(),
                    (+res[
                        isTemplate ? 'data' : 'program'
                        ].frontendMeta.tourStart.split('.')[1]).toString() - 1,
                    (+res[
                        isTemplate ? 'data' : 'program'
                        ].frontendMeta.tourStart.split('.')[0]).toString()
                ).getTime(),
                'd'
            )
            : ''
        this.tourFinish = res[isTemplate ? 'data' : 'program'].frontendMeta
            .tourFinish
            ? date(
                new Date(
                    (+res[
                        isTemplate ? 'data' : 'program'
                        ].frontendMeta.tourFinish.split('.')[2]).toString(),
                    (+res[
                        isTemplate ? 'data' : 'program'
                        ].frontendMeta.tourFinish.split('.')[1]).toString() - 1,
                    (+res[
                        isTemplate ? 'data' : 'program'
                        ].frontendMeta.tourFinish.split('.')[0]).toString()
                ).getTime(),
                'd'
            )
            : ''
        setTimeout(() => {
          this.durationData = this.duration =
              res[isTemplate ? 'data' : 'program'].tourDuration
          this.setRefValue('tourStart', res[isTemplate ? 'data' : 'program']
              .frontendMeta.tourStart
              ? date(
                  new Date(
                      (+res[
                          isTemplate ? 'data' : 'program'
                          ].frontendMeta.tourStart.split('.')[2]).toString(),
                      (+res[
                          isTemplate ? 'data' : 'program'
                          ].frontendMeta.tourStart.split('.')[1]).toString() - 1,
                      (+res[
                          isTemplate ? 'data' : 'program'
                          ].frontendMeta.tourStart.split('.')[0]).toString()
                  ).getTime(),
                  'd'
              )
              : '')
          this.setRefValue('tourFinish', res[isTemplate ? 'data' : 'program']
              .frontendMeta.tourFinish
              ? date(
                  new Date(
                      (+res[
                          isTemplate ? 'data' : 'program'
                          ].frontendMeta.tourFinish.split('.')[2]).toString(),
                      (+res[
                          isTemplate ? 'data' : 'program'
                          ].frontendMeta.tourFinish.split('.')[1]).toString() - 1,
                      (+res[
                          isTemplate ? 'data' : 'program'
                          ].frontendMeta.tourFinish.split('.')[0]).toString()
                  ).getTime(),
                  'd'
              )
              : '')
        }, 300)
        this.dataSelects.status = this.dataSelects.status.map((item) => ({
          ...item,
          active: item.data === res[isTemplate ? 'data' : 'program'].status,
        }))
        this.dataSelects.operator = this.dataSelects.operator.map((item) => ({
          ...item,
          active:
              item.id === res[isTemplate ? 'data' : 'program'].tourOperatorId,
        }))
        this.dataSelects.currency = this.dataSelects.currency.map((item) => ({
          ...item,
          active: item.name === res[isTemplate ? 'data' : 'program'].currency,
        }))
        this.dataSelects.lang = this.dataSelects.lang.map((item) => ({
          ...item,
          active: item.data === res[isTemplate ? 'data' : 'program'].lang,
        }))
        // this.dataSelects.valid = this.dataSelects.valid.map(item => ({...item, active: +item.name === res[isTemplate ? 'data' : 'program'].priceValidUpTo}))
        this.participants =
            res[isTemplate ? 'data' : 'program'].frontendMeta.participants.map(
                ({citizenship, passportNumber, citySelect, citySelectInput, ...participant}) => participant
            )
        this.dataSelects.advices = {
          discounts: {
            climbAdditionalOptions:
            res[isTemplate ? 'data' : 'program'].discounts
                .climbAdditionalOptions,
            climbing: res[isTemplate ? 'data' : 'program'].discounts.climbing,
            dayTrips: res[isTemplate ? 'data' : 'program'].discounts.dayTrips,
          },
          commissions: {
            activity: res[isTemplate ? 'data' : 'program'].commissions.activity,
            flights: res[isTemplate ? 'data' : 'program'].commissions.flight,
            island: res[isTemplate ? 'data' : 'program'].commissions.island,
            other: res[isTemplate ? 'data' : 'program'].commissions.other,
            safari: isTemplate ? res.data.commissions.safari : this.getSafariCommissionPercent(res),
            extraAccommodation:
            res[isTemplate ? 'data' : 'program'].commissions
                .extraAccommodation,
            transfer: res[isTemplate ? 'data' : 'program'].commissions.transfer,
            airportVipServices:
            res[isTemplate ? 'data' : 'program'].commissions
                .airportVipServices,
          },
        }
        if (isTemplate) {
          this.calcTemplatePriceHandler()
        }
        setTimeout(() => {
          this.participants.map((item, index) => {
            this.setRefValue('participantsDateRef' + index, item.dateOfBirth)
          })
        }, 500)
        this.isLoad = true
        this.recoveryPopup = false
      })
    },
    calcProgramDaysForDuration(index, newVal, currentVal) {
      // hueta
      setTimeout(() => {
        this.calcDates()
        this.durationData = this.duration = +this.data.program.reduce(
            (acc, day) => acc + +day.duration,
            0
        )
      }, 300)
      this.isEditFlag = true
    },
    changeSelectsMain(target) {
      this.selects = {
        ...this.selects,
        status: false,
        operator: false,
        currency: false,
        lang: false,
        priceValid: false,
        country: false,
        [target]: !this.selects[target],
      }
    },
    changeSelectsAdditional(target) {
      this.selects = {
        ...this.selects,
        additionalPopup: {
          options: false,
          pax: false,
          [target]: !this.selects.additionalPopup[target],
        },
      }
    },
    changeSelectsActivities(target) {
      this.selects = {
        ...this.selects,
        activityPopup: {
          activity: false,
          type: false,
          pax: false,
          [target]: !this.selects.activityPopup[target],
        },
      }
      if (target) {
        this.activityPopupData.paxList = this.activityPopupData.paxList.map(
            (item) => ({...item, open: false})
        )
      }
    },
    changeSelectsFlights(target) {
      this.selects = {
        ...this.selects,
        flightsPopup: {
          dep: false,
          arr: false,
          air: false,
          depTime: false,
          type: false,
          lug: false,
          pax: false,
          [target]: !this.selects.flightsPopup[target],
        },
      }
    },
    changeSelectsTransfers(target) {
      this.selects = {
        ...this.selects,
        transfersPopup: {
          from: false,
          to: false,
          pax: false,
          [target]: !this.selects.transfersPopup[target],
        },
      }
    },
    changeSelectsHotels(target) {
      this.selects = {
        ...this.selects,
        hotelPopup: {
          hotel: false,
          meal: false,
          room: false,
          alternative: false,
          copy: false,
          [target]: !this.selects.hotelPopup[target],
        },
      }
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: 'auto',
      })
    },
    collapsed(item, target) {
      this[item] = !this[item]
      target.setAttribute('disabled', true)
      setTimeout(() => {
        target.removeAttribute('disabled')
      }, 500)
    },
    checkMainErrors(follow) {
      this.mainErrors = {
        name: this.data.groupName.trim().length === 0,
        email:
            this.data.groupEmail.trim().length === 0
                ? false
                : !validateEmail(this.data.groupEmail.trim()),
        duration: follow ? false : this.durationData < 1,
        number: !this.data.number && (this.data.telegram || this.data.whatsapp),
      }
      let error = false
      for (const key in this.mainErrors) {
        if (this.mainErrors[key]) {
          error = true
        }
      }
      if (error) {
        window.scrollTo({
          top: 0,
        })
        return true
      }
      return false
    },
    checkClientsErrors() {
      this.participants = this.participants.map((item) => {
        if (item.dateOfBirth.trim().length === 0) {
          return {
            ...item,
            errorBirth: true,
          }
        }
        return item
      })
      if (this.participants.find((item) => item.errorBirth)) {
        this.$refs.participants.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        })
        return true
      }
      return false
    },
    checkInsuranceErrors() {
      let dateFrom = this.participants.find((item) => item.insurancePopup)
          .insurance.validFrom
      let dateTo = this.participants.find((item) => item.insurancePopup)
          .insurance.validUpTo
      let company = this.participants.find((item) => item.insurancePopup)
          .insurance.companyName
      let policy = this.participants.find((item) => item.insurancePopup)
          .insurance.policyNumber

      if (dateFrom && dateTo) {
        dateFrom = new Date(dateFrom).getTime()
        dateTo = new Date(dateTo).getTime()
      }
      let error = false
      this.insuranseErrors = {
        from: dateFrom ? (dateFrom > dateTo ? true : false) : true,
        to: dateTo ? (dateFrom > dateTo ? true : false) : true,
        company: company ? false : true,
        policy: policy ? false : true,
      }
      for (const key in this.insuranseErrors) {
        if (this.insuranseErrors[key]) {
          error = true
        }
      }
      return error
    },
    checkProgramErrors() {
      this.data.program = this.data.program.map((item) => {
        return {
          ...item,
          typeError: !item.type.data,
          airportError:
              (item.type.data === 'ARRIVAL' || item.type.data === 'DEPARTURE') &&
              !item.airport,
          climbingError:
              item.climb && item.type.subData === 'JOIN' && item.date
                  ? new Date(
                      (+item.climb.dateStart.split('.')[2]).toString(),
                      (+item.climb.dateStart.split('.')[1]).toString() - 1,
                      (+item.climb.dateStart.split('.')[0]).toString()
                  ).getTime() ===
                  new Date(
                      item.date.split('/')[1] +
                      '/' +
                      item.date.split('/')[0] +
                      '/' +
                      item.date.split('/')[2]
                  ).getTime()
                  &&
                  new Date(
                      (+item.climb.dateEnd.split('.')[2]).toString(),
                      (+item.climb.dateEnd.split('.')[1]).toString() - 1,
                      (+item.climb.dateEnd.split('.')[0]).toString()
                  ).getTime() <= new Date(this.tourFinish).getTime()
                      ? false
                      : true
                  : false,
          dayTripError:
              item.type.data === 'DAY_TRIP' && item.activitiesData.length === 0,
          // activityError: item.type.data === 'DAY_TRIP' &&  !item.activity,
        }
      })
      if (
          this.data.program.find(
              (item) =>
                  item.typeError ||
                  item.airportError ||
                  item.climbingError ||
                  item.dayTripError
          )
      ) {
        this.$refs.program.scrollIntoView({block: 'start', behavior: 'smooth'})
        return true
      }
      return false
    },
    checkAdditionalServicesErrors(isScrollToErrors = true) {
      this.additionalServices = this.additionalServices.map((service) => {
        const errors = {
          participantError: !service.participantId,
          descriptionError: !service.description,
          priceError: !(service.price > 0) || service.price === '',
        }
        return {
          ...service,
          errors
        }
      });

      if (
          this.additionalServices.find(
              (service) =>
                  service.errors.participantError ||
                  service.errors.descriptionError ||
                  service.errors.priceError
          )
      ) {
        if (isScrollToErrors) {
          this.$refs.additionalServices.scrollIntoView({block: 'start', behavior: 'smooth'})
        }
        return true
      }
      return false
    },
    checkDiscountsErrors(isScrollToErrors = true) {
      this.participantPersonalDiscounts = this.participantPersonalDiscounts.map((discount) => {
        const errors = {
          descriptionError: !discount.description,
        }
        return {
          ...discount,
          errors
        }
      });

      if (
          this.participantPersonalDiscounts.find(
              (discount) =>
                  discount.errors.descriptionError
          )
      ) {
        if (isScrollToErrors) {
          this.$refs.discounts.scrollIntoView({block: 'start', behavior: 'smooth'})
        }
        return true
      }
      return false
    },
    checkHotelsErrors() {
      this.hotelPopupData.hotelsData = this.hotelPopupData.hotelsData.map(
          (item) =>
              item.clients.find((client) => client.id !== '')
                  ? {
                    ...item,
                    error: false,
                  }
                  : {...item, error: true}
      )
      return this.hotelPopupData.hotelsData.find((item) => item.error)
    },
    checkFlightsErrors() {
      this.flightsPopupData.flightsData = this.flightsPopupData.flightsData.map(
          (item) => ({
            ...item,
            clients: item.clients.map((client) => ({
              ...client,
              error: client.id === '',
            })),
          })
      )
      return this.flightsPopupData.flightsData.find((item) =>
          item.clients.find((client) => client.error)
      )
    },
    checkTransfersErrors() {
      this.transfersPopupData.transfersData =
          this.transfersPopupData.transfersData.map((item) => ({
            ...item,
            clients: item.clients.map((client) => ({
              ...client,
              error: client.id === '',
            })),
          }))
      return this.transfersPopupData.transfersData.find((item) =>
          item.clients.find((client) => client.error)
      )
    },
    checkActivitiesErrors() {
      this.activityPopupData.activitiesData =
          this.activityPopupData.activitiesData.map((item) => ({
            ...item,
            clients: item.clients.map((client) => ({
              ...client,
              error: client.id === '',
            })),
          }))
      return this.activityPopupData.activitiesData.find((item) =>
          item.clients.find((client) => client.error)
      )
    },
    checkAdditionalErrors() {
      this.additionalPopupData.additionalOptions =
          this.additionalPopupData.additionalOptions.map((item) => ({
            ...item,
            clients: item.clients.map((client) => ({
              ...client,
              error: item.clients.find((c) => c.id == null || c.id === ''),
            })),
          }))
      this.additionalPopupData.additionalOptions.forEach((option) => {
        option.clients.forEach((client, index, array) => {
          if (index !== 0 && client.name === array[0].name) client.error = true
        })
      })
      return this.additionalPopupData.additionalOptions.find((item) =>
          item.clients.find((client) => client.error)
      )
    },
    updateTemplateHandler() {
      if (
          !this.checkMainErrors() &&
          !this.checkClientsErrors() &&
          !this.checkAdditionalServicesErrors() &&
          !this.checkDiscountsErrors() &&
          !this.checkProgramErrors()
      ) {
        updateTemplate({
          id: this.data.id,
          userId: this.user.id,
          data: this.generateTemplateData(),
        }).then((res) => {
          this.isEditFlag = false
          this.$emit('confirmed')
        })
      }
    },
    createTemplateHandler(follow = false) {
      if (
          follow
              ? true
              : !this.checkMainErrors() &&
              !this.checkClientsErrors() &&
              !this.checkAdditionalServicesErrors() &&
              !this.checkDiscountsErrors() &&
              !this.checkProgramErrors()
      ) {
        createTemplate({
          userId: this.user.id,
          data: this.generateTemplateData(),
        }).then((res) => {
          // if(follow){
          // 	this.isEdit = res.id
          // 	this.data.id = res.id
          // } else {
          if (follow) {
            // this.addParticipant()
          }
          this.isEditFlag = false
          this.$emit('confirmed')
          // }
        })
      }
    },
    createClientsHandler(follow = false, newTab = false) {
      if (
          follow
              ? !this.checkMainErrors(follow)
              : !this.checkMainErrors() &&
              !this.checkClientsErrors() &&
              !this.checkAdditionalServicesErrors() &&
              !this.checkDiscountsErrors() &&
              !this.checkProgramErrors()
      ) {
        createClients({
          userId: this.user.id,
          program: this.generateTemplateData(),
          calculationResult: this.totalPrice,
        }).then((res) => {
          if (newTab) window.open(`${origin}/clients/${res.id}`, '_blank').focus();
          if (follow) {
            this.isEdit = res.id
            this.data.id = res.id
            this.data.link = res.link
            this.updateDatePickers()
            this.isEditFlag = false
            window.history.pushState('', '', '/clients/' + res.id)
            // this.addParticipant()
          } else {
            this.$emit('confirmed')
          }
        })
      }
    },
    print(className) {
      document.body.classList.remove('print-cost')
      document.body.classList.remove('print-clients')
      document.body.classList.remove('print-hotels')
      document.body.classList.add(className)
      setTimeout(() => {
        window.print()
      }, 200)
    },
    isErrorsInBreakdownCost() {
      const breakdownCost = this.totalPrice.breakdownCost;
      return ((breakdownCost.transferCost && breakdownCost.transferCost.errors.length)
          || (breakdownCost.safariCost && breakdownCost.safariCost.errors.length)
          || (breakdownCost.climbingCost && breakdownCost.climbingCost.errors.length)
          || (breakdownCost.islandCost && breakdownCost.islandCost.errors.length)
          || (breakdownCost.dayTripsCost && breakdownCost.dayTripsCost.errors.length)
          || (breakdownCost.extraAccommodationCost && breakdownCost.extraAccommodationCost.errors.length)
          || (breakdownCost.flightTickets && breakdownCost.flightTickets.errors.length)
          || (breakdownCost.other && breakdownCost.other.errors.length)
          || (breakdownCost.airportVipServices && breakdownCost.airportVipServices.errors.length));
    },
    updateClientsHandler() {
      if (
          !this.checkMainErrors() &&
          !this.checkClientsErrors() &&
          !this.checkAdditionalServicesErrors() &&
          !this.checkDiscountsErrors() &&
          !this.checkProgramErrors()
      ) {
        if (
            this.participantPersonalDiscounts.length &&
            this.participantPersonalDiscounts.some(
                (elem) => elem.participantId.id === null
            )
        ) {
          this.participantPersonalDiscounts =
              this.participantPersonalDiscounts.filter(
                  (item) => item.participantId.id !== null
              )
        }
        updateClients({
          id: this.data.id,
          userId: this.user.id,
          program: this.generateTemplateData(),
          calculationResult: this.totalPrice,
          recalculated: true,
        }).then((res) => {
          this.isEditFlag = false
          if (this.isErrorsInBreakdownCost()) {
            this.isBreakdownCostErrorsWarningModalActive = true;
          } else {
            this.$emit('confirmed')
          }
        })
      }
    },
    updateClientsHandlerIncludeHotelAndTransfer() {
      if (
          !this.checkMainErrors() &&
          !this.checkClientsErrors() &&
          !this.checkAdditionalServicesErrors() &&
          !this.checkDiscountsErrors() &&
          !this.checkProgramErrors()
      ) {
        if (
            this.participantPersonalDiscounts.length &&
            this.participantPersonalDiscounts.some(
                (elem) => elem.participantId.id === null
            )
        ) {
          this.participantPersonalDiscounts =
              this.participantPersonalDiscounts.filter(
                  (item) => item.participantId.id !== null
              )
        }
        this.calcTemplatePriceHandler()
        updateClients({
          id: this.data.id,
          userId: this.user.id,
          program: this.generateTemplateData(),
          calculationResult: this.totalPrice,
          recalculated: true,
        }).then((res) => {
          this.isEditFlag = false
        })
      }
    },
    changeComissions() {
      this.dataSelects.advices = {
        ...this.dataSelects.advices,
        [this.commissionPopup.split('.')[0]]: {
          ...this.dataSelects.advices[this.commissionPopup.split('.')[0]],
          [this.commissionPopup.split('.')[1]]: this.commissionPopupValue,
        },
      }
      this.isEditFlag = true
    },
    recalculateCleanup() {
      // clean up for special cases
      this.dataSelects.advices.commissions.safari = 0
    },
    generateTemplateData(recalculate = false) {
      if (recalculate) {
        this.recalculateCleanup()
      }

      const activeStatus = this.dataSelects.status.find((item) => item.active)

      return {
        version: 1,
        groupName: this.data.groupName,
        groupEmail: this.data.groupEmail,
        status: activeStatus ? activeStatus.data : this.data.status,
        tourOperatorId: this.dataSelects.operator.find((item) => item.active)
            ? this.dataSelects.operator.find((item) => item.active).id
            : 1,
        currency: this.dataSelects.currency.find((item) => item.active).name,
        lang: this.dataSelects.lang.find((item) => item.active).data,
        priceValidUpTo: this.data.priceValidUpTo
            ? date(new Date(this.data.priceValidUpTo), 'start')
            : date(Date.now(), 'start'),
        tourDuration: +this.durationData,
        tourStart: this.tourStart
            ? date(new Date(this.tourStart), 'start')
            : new Date().getMonth() <= 6
                ? `01.07.${new Date().getFullYear()}`
                : `01.07.${new Date().getFullYear() + 1}`,
        tourFinish: this.tourFinish
            ? date(new Date(this.tourFinish), 'start')
            : new Date().getMonth() <= 6
                ? `${
                    +this.durationData > 9
                        ? this.durationData
                        : `0${this.durationData || 1}`
                }.07.${new Date().getFullYear()}`
                : `${
                    +this.durationData > 9
                        ? this.durationData
                        : `0${this.durationData || 1}`
                }.07.${new Date().getFullYear() + 1}`,
        itineraryWithoutPrice: this.data.itineraryWithoutPrice,
        itineraryWithNames: this.data.itineraryWithNames,
        itineraryForSafariDriver: this.data.itineraryForSafariDriver,
        showClientNames: this.showNames,
        showBreakdownCostWithCommission: this.commisionInclude,
        // showFullPrice: this.show0,
        // phone: this.data.number ? `${this.data.country.code}${this.data.number}` : this.data.number,
        phone: this.data.number,
        telegram: this.data.telegram,
        whatsApp: this.data.whatsapp,
        priorityClient: this.data.priority,
        hideWelcomeTexts: this.data.hideWelcomeTexts,
        participants: this.participants.map((item, index) => {
          return {
            id: +item.id,
            name: item.name,
            dateOfBirth: item.dateOfBirth
                ? date(new Date(item.dateOfBirth), 'start')
                : date(Date.now(), 'start'),
            age: +item.age,
            residence: item.residence.data,
            coupleId: item.coupleId,
            weddingDate:
                item.weddingDate != null && item.weddingDate !== ''
                    ? new Date(item.weddingDate)
                        .toLocaleDateString()
                        .replace(/\//g, '.')
                    : null,
            dietaryRequirements: {
              foodPreferences: item.dietaryRequirements.foodPreferences
                  .toUpperCase()
                  .replace('-', '_'),
              allergies: item.dietaryRequirements.allergies,
            },
            insurance: {
              companyName: item.insurance.companyName,
              policyNumber: item.insurance.policyNumber,
              validFrom: item.insurance.validFrom
                  ? date(new Date(item.insurance.validFrom), 'start')
                  : date(Date.now(), 'start'),
              validUpTo: item.insurance.validUpTo
                  ? date(new Date(item.insurance.validUpTo), 'start')
                  : date(Date.now(), 'start'),
            },
            // "info": "string"
          }
        }),
        notesForClients: this.data.notesForClients,
        notesForManager: this.data.notesForManager,
        discounts: {
          climbing: +this.dataSelects.advices.discounts.climb,
          climbAdditionalOptions:
              +this.dataSelects.advices.discounts.climbAdditionalOptions,
          dayTrips: +this.dataSelects.advices.discounts.dayTrips,
        },
        commissions: {
          safari: this.totalPrice && this.totalPrice.dynamicCommissions && this.totalPrice.dynamicCommissions.safari.percent && (+this.dataSelects.advices.commissions.safari === 0)
              ? 0
              : +this.dataSelects.advices.commissions.safari,
          island: +this.dataSelects.advices.commissions.island,
          activity: +this.dataSelects.advices.commissions.activity,
          flight: +this.dataSelects.advices.commissions.flights,
          other: +this.dataSelects.advices.commissions.other,
          extraAccommodation:
              +this.dataSelects.advices.commissions.extraAccommodation,
          transfer: +this.dataSelects.advices.commissions.transfer,
          airportVipServices:
              +this.dataSelects.advices.commissions.airportVipServices,
        },
        participantPersonalDiscounts: this.participantPersonalDiscounts.length
            ? this.participantPersonalDiscounts.map((item) => ({
              ...item,
              participantId: item.participantId.id,
            }))
            : [],
        additionalServices: this.additionalServices,
        program: this.data.program
            .filter((item) =>
                item.type.data === 'CLIMBING' ? (item.climb ? true : false) : true
            )
            .map((item) => {
              if (
                  item.type.data === 'ARRIVAL' ||
                  item.type.data === 'DEPARTURE'
              ) {
                return {
                  notes: item.notes,
                  day: item.day,
                  date: item.date
                      ? item.date
                          .split('/')
                          .map((d, i) => (i === 2 ? '20' + d : d))
                          .join('.')
                      : new Date().getMonth() <= 6
                          ? `01.07.${new Date().getFullYear()}`
                          : `01.07.${new Date().getFullYear() + 1}`,
                  type: item.type.data,
                  fromNationalPark: this.fromNationalPark,
                  airstripId: item.airport.id,
                  vipService: item.vipService,
                  services: {
                    hotels: item.hotelsData
                        .map((hotel) => ({
                          hotelId: hotel.hotelId,
                          mealType: hotel.meal,
                          roomId: hotel.roomId,
                          free: hotel.free || false,
                          bookedByGuest: hotel.bookedByGuest || false,
                          earlyCheckIn: hotel.earlyCheckIn || null,
                          lateCheckOut: hotel.lateCheckOut || null,
                          accommodationType: `${hotel.accommodations[0]}${
                              hotel.accommodations[1]
                          }${hotel.accommodations[2] || ''}${
                              hotel.accommodations[3] || ''
                          }${hotel.accommodations[4] || ''}${
                              hotel.accommodations[5] || ''
                          }`,
                          participantIds: hotel.clients
                              .map((client) => client.id)
                              .filter((client) =>
                                  this.participants.some((item) => item.id === client)
                              ),
                        }))
                        .filter((item) => item.participantIds.length),
                    activities: item.activitiesData
                        .map((activity) => ({
                          type: 'MAINLAND',
                          activityId: activity.activityId,
                          pickUpTime: activity.time
                              ? `${activity.time.substring(
                                  0,
                                  2
                              )}:${activity.time.substring(
                                  activity.time.length - 2
                              )}`
                              : '',
                          pickUpTimeToBeConfirmed: activity.confirmed,
                          participantIds: activity.clients
                              .map((client) => client.id)
                              .filter((client) =>
                                  this.participants.some((item) => item.id === client)
                              ),
                        }))
                        .filter((item) => item.participantIds.length),
                    flights: item.flightsData.map((flight) => {
                      if (flight.type === 'REGULAR' || !flight.type) {
                        return {
                          // "flightId": this.dataSelects.flights.find(flightItem => flight.depId === flightItem.origin && flight.arrId === flightItem.destination && flight.comId === flightItem.companyId && flight.depTime.replace(':', '') === flightItem.departureTime) ? this.dataSelects.flights.find(flightItem => flight.depId === flightItem.origin && flight.arrId === flightItem.destination && flight.comId === flightItem.companyId && flight.depTime.replace(':', '') === flightItem.departureTime).id : '',
                          flightId: flight.flightId,
                          beforeActivity: !flight.timeActivity,
                          afterActivity: flight.timeActivity,
                          type: !flight.type ? 'REGULAR' : flight.type,
                          passengers: flight.clients
                              .filter((client) => client)
                              .map((client) => ({
                                id: client.id,
                                luggage: +client.lug.replace('kg', ''),
                              }))
                              .filter((client) =>
                                  this.participants.some(
                                      (item) => item.id === client.id
                                  )
                              ),
                        }
                      }
                      if (flight.type === 'PRIVATE') {
                        return {
                          departureId: flight.depId,
                          arrivalId: flight.arrId,
                          companyId: flight.comId,
                          departureTime: flight.flightsTimesPrivateStart,
                          arrivalTime: flight.flightsTimesPrivateEnd,
                          priceWithCurrency: {
                            price: flight.flightsNetPricePrivate,
                            currency: 'USD',
                          },
                          passengerIds: flight.clients
                              .filter((client) => client)
                              .map((client) => client.id),
                          beforeActivity: !flight.timeActivity,
                          afterActivity: flight.timeActivity,
                          type: 'PRIVATE',
                        }
                      }
                    }),
                    // .filter((item) => item.passengers.length),
                    transfers: item.transfersData
                        .map((transfer) => ({
                          transferId: transfer.transferId,
                          pickUpTime: transfer.time === ':' ? '' : transfer.time,
                          pointFromId: transfer.fromId,
                          pointToId: transfer.toId,
                          free: transfer.free || false,
                          pickUpTimeToBeConfirmed: transfer.confirmed || false,
                          participantIds: transfer.clients
                              .map((client) => client.id)
                              .filter((client) =>
                                  this.participants.some((item) => item.id === client)
                              ),
                          beforeActivity: transfer.timeActivity,
                          afterActivity: !transfer.timeActivity,
                        }))
                        .filter((item) => item.participantIds.length),
                  },
                }
              } else if (
                  item.type.data === 'REST_DAY' ||
                  item.type.data === 'OWN_ARRANGEMENTS' ||
                  item.type.data === 'DAY_TRIP'
              ) {
                return {
                  notes: item.notes,
                  day: item.day,
                  date: item.date
                      ? item.date
                          .split('/')
                          .map((d, i) => (i === 2 ? '20' + d : d))
                          .join('.')
                      : new Date().getMonth() <= 6
                          ? `01.07.${new Date().getFullYear()}`
                          : `01.07.${new Date().getFullYear() + 1}`,
                  type: item.type.data,
                  services: {
                    hotels: item.hotelsData
                        .map((hotel) => {
                          return {
                            hotelId: hotel.hotelId,
                            mealType: hotel.meal,
                            roomId: hotel.roomId,
                            free: hotel.free || false,
                            bookedByGuest: hotel.bookedByGuest || false,
                            earlyCheckIn: hotel.earlyCheckIn || null,
                            lateCheckOut: hotel.lateCheckOut || null,
                            accommodationType: `${hotel.accommodations[0]}${
                                hotel.accommodations[1]
                            }${hotel.accommodations[2] || ''}${
                                hotel.accommodations[3] || ''
                            }${hotel.accommodations[4] || ''}${
                                hotel.accommodations[5] || ''
                            }`,
                            participantIds: hotel.clients
                                .map((client) => client.id)
                                .filter((client) =>
                                    this.participants.some((item) => item.id === client)
                                ),
                          }
                        })
                        .filter((item) => item.participantIds.length),
                    activities: item.activitiesData
                        .map((activity) => ({
                          type: 'MAINLAND',
                          activityId: activity.activityId,
                          pickUpTime: activity.time
                              ? `${activity.time.substring(
                                  0,
                                  2
                              )}:${activity.time.substring(
                                  activity.time.length - 2
                              )}`
                              : '',
                          pickUpTimeToBeConfirmed: activity.confirmed,
                          participantIds: activity.clients
                              .map((client) => client.id)
                              .filter((client) =>
                                  this.participants.some((item) => item.id === client)
                              ),
                        }))
                        .filter((item) => item.participantIds.length),
                    flights: item.flightsData.map((flight) => {
                      if (flight.type === 'REGULAR' || !flight.type) {
                        return {
                          // "flightId": this.dataSelects.flights.find(flightItem => flight.depId === flightItem.origin && flight.arrId === flightItem.destination && flight.comId === flightItem.companyId && flight.depTime.replace(':', '') === flightItem.departureTime) ? this.dataSelects.flights.find(flightItem => flight.depId === flightItem.origin && flight.arrId === flightItem.destination && flight.comId === flightItem.companyId && flight.depTime.replace(':', '') === flightItem.departureTime).id : '',
                          flightId: flight.flightId,
                          beforeActivity: !flight.timeActivity,
                          afterActivity: flight.timeActivity,
                          type: !flight.type ? 'REGULAR' : flight.type,
                          passengers: flight.clients
                              .filter((client) => client)
                              .map((client) => ({
                                id: client.id,
                                luggage: +client.lug.replace('kg', ''),
                              }))
                              .filter((client) =>
                                  this.participants.some(
                                      (item) => item.id === client.id
                                  )
                              ),
                        }
                      }
                      if (flight.type === 'PRIVATE') {
                        return {
                          departureId: flight.depId,
                          arrivalId: flight.arrId,
                          companyId: flight.comId,
                          departureTime: flight.flightsTimesPrivateStart,
                          arrivalTime: flight.flightsTimesPrivateEnd,
                          priceWithCurrency: {
                            price: flight.flightsNetPricePrivate,
                            currency: 'USD',
                          },
                          passengerIds: flight.clients
                              .filter((client) => client)
                              .map((client) => client.id),
                          beforeActivity: !flight.timeActivity,
                          afterActivity: flight.timeActivity,
                          type: 'PRIVATE',
                        }
                      }
                    }),
                    // .filter((item) => item.passengers.length),
                    transfers: item.transfersData
                        .map((transfer) => ({
                          transferId: transfer.transferId,
                          pointFromId: transfer.fromId,
                          pointToId: transfer.toId,
                          pickUpTime: transfer.time === ':' ? '' : transfer.time,
                          free: transfer.free || false,
                          pickUpTimeToBeConfirmed: transfer.confirmed || false,
                          participantIds: transfer.clients
                              .map((client) => client.id)
                              .filter((client) =>
                                  this.participants.some((item) => item.id === client)
                              ),
                          beforeActivity: transfer.timeActivity,
                          afterActivity: !transfer.timeActivity,
                        }))
                        .filter((item) => item.participantIds.length),
                  },
                }
              } else if (item.type.data === 'SAFARI') {
                return {
                  day: item.day,
                  date: item.date
                      ? item.date
                          .split('/')
                          .map((d, i) => (i === 2 ? '20' + d : d))
                          .join('.')
                      : new Date().getMonth() <= 6
                          ? `01.07.${new Date().getFullYear()}`
                          : `01.07.${new Date().getFullYear() + 1}`,
                  type: item.type.data,
                  duration: item.duration,
                  carDetails: {
                    extraDays: +item.carsSelectItem,
                  },
                  days: item.days.map((day) => ({
                    notes: day.notes,
                    date: day.date
                        ? day.date
                            .split('/')
                            .map((d, i) => (i === 2 ? '20' + d : d))
                            .join('.')
                        : new Date().getMonth() <= 6
                            ? `01.07.${new Date().getFullYear()}`
                            : `01.07.${new Date().getFullYear() + 1}`,
                    parkId: day.park.id,
                    participantIds: day.participantsSave
                        ? day.participantsIds
                            ? day.participantsIds
                                .filter((item) => item.active)
                                .filter((client) =>
                                    this.participants.some(
                                        (item) => item.id === client.id
                                    )
                                )
                                .map((item) => item.id)
                            : []
                        : this.participants.map((item) => item.id),
                    totalCars:
                        day.totalCars === 0 || day.totalCars ? +day.totalCars : 1,
                    transitPark: day.transitPark,
                    services: {
                      hotels: day.hotelsData
                          .map((hotel) => ({
                            hotelId: hotel.hotelId,
                            mealType: hotel.meal,
                            roomId: hotel.roomId,
                            free: hotel.free || false,
                            bookedByGuest: hotel.bookedByGuest || false,
                            earlyCheckIn: hotel.earlyCheckIn || null,
                            lateCheckOut: hotel.lateCheckOut || null,
                            accommodationType: `${hotel.accommodations[0]}${
                                hotel.accommodations[1]
                            }${hotel.accommodations[2] || ''}${
                                hotel.accommodations[3] || ''
                            }${hotel.accommodations[4] || ''}${
                                hotel.accommodations[5] || ''
                            }`,
                            participantIds: hotel.clients
                                .map((client) => client.id)
                                .filter((client) =>
                                    this.participants.some((item) => item.id === client)
                                ),
                          }))
                          .filter((hotel) => hotel.participantIds.length),
                      activities: day.activitiesData
                          .map((activity) => ({
                            type: 'SAFARI',
                            activityId: activity.activityId,
                            pickUpTime: activity.time
                                ? `${activity.time.substring(
                                    0,
                                    2
                                )}:${activity.time.substring(
                                    activity.time.length - 2
                                )}`
                                : '',
                            pickUpTimeToBeConfirmed: activity.confirmed,
                            participantIds: activity.clients
                                .map((client) => client.id)
                                .filter((client) =>
                                    this.participants.some((item) => item.id === client)
                                ),
                          }))
                          .filter((item) => item.participantIds.length),
                      flights: day.flightsData.map((flight) => {
                        if (flight.type === 'REGULAR' || !flight.type) {
                          return {
                            // "flightId": this.dataSelects.flights.find(flightItem => flight.depId === flightItem.origin && flight.arrId === flightItem.destination && flight.comId === flightItem.companyId && flight.depTime.replace(':', '') === flightItem.departureTime) ? this.dataSelects.flights.find(flightItem => flight.depId === flightItem.origin && flight.arrId === flightItem.destination && flight.comId === flightItem.companyId && flight.depTime.replace(':', '') === flightItem.departureTime).id : '',
                            flightId: flight.flightId,
                            beforeActivity: !flight.timeActivity,
                            afterActivity: flight.timeActivity,
                            type: !flight.type ? 'REGULAR' : flight.type,
                            passengers: flight.clients
                                .filter((client) => client)
                                .map((client) => ({
                                  id: client.id,
                                  luggage: +client.lug.replace('kg', ''),
                                }))
                                .filter((client) =>
                                    this.participants.some(
                                        (item) => item.id === client.id
                                    )
                                ),
                          }
                        }
                        if (flight.type === 'PRIVATE') {
                          return {
                            departureId: flight.depId,
                            arrivalId: flight.arrId,
                            companyId: flight.comId,
                            departureTime: flight.flightsTimesPrivateStart,
                            arrivalTime: flight.flightsTimesPrivateEnd,
                            priceWithCurrency: {
                              price: flight.flightsNetPricePrivate,
                              currency: 'USD',
                            },
                            passengerIds: flight.clients
                                .filter((client) => client)
                                .map((client) => client.id),
                            beforeActivity: !flight.timeActivity,
                            afterActivity: flight.timeActivity,
                            type: 'PRIVATE',
                          }
                        }
                      }),
                      // .filter((item) => item.passengers.length),
                      transfers: day.transfersData
                          .map((transfer) => ({
                            transferId: transfer.transferId,
                            pointFromId: transfer.fromId,
                            pointToId: transfer.toId,
                            pickUpTime: transfer.time === ':' ? '' : transfer.time,
                            pickUpTimeToBeConfirmed: transfer.confirmed || false,
                            free: transfer.free || false,
                            participantIds: transfer.clients
                                .map((client) => client.id)
                                .filter((client) =>
                                    this.participants.some((item) => item.id === client)
                                ),
                            beforeActivity: transfer.timeActivity,
                            afterActivity: !transfer.timeActivity,
                          }))
                          .filter((item) => item.participantIds.length),
                    },
                  })),
                }
              } else if (item.type.data === 'ISLAND') {
                return {
                  day: item.day,
                  date: item.date
                      ? item.date
                          .split('/')
                          .map((d, i) => (i === 2 ? '20' + d : d))
                          .join('.')
                      : new Date().getMonth() <= 6
                          ? `01.07.${new Date().getFullYear()}`
                          : `01.07.${new Date().getFullYear() + 1}`,
                  type: item.type.data,
                  duration: item.duration,
                  territoryType: 'Island',
                  locationId: item.island.location ? item.island.location.id : -1,
                  showDetails: true, // hard boolean
                  days: item.days.map((day) => ({
                    notes: day.notes,
                    date: day.date
                        ? day.date
                            .split('/')
                            .map((d, i) => (i === 2 ? '20' + d : d))
                            .join('.')
                        : new Date().getMonth() <= 6
                            ? `01.07.${new Date().getFullYear()}`
                            : `01.07.${new Date().getFullYear() + 1}`,
                    services: {
                      hotels: day.hotelsData
                          .map((hotel) => ({
                            hotelId: hotel.hotelId,
                            mealType: hotel.meal,
                            roomId: hotel.roomId,
                            free: hotel.free || false,
                            bookedByGuest: hotel.bookedByGuest || false,
                            earlyCheckIn: hotel.earlyCheckIn || null,
                            lateCheckOut: hotel.lateCheckOut || null,
                            accommodationType: `${hotel.accommodations[0]}${
                                hotel.accommodations[1]
                            }${hotel.accommodations[2] || ''}${
                                hotel.accommodations[3] || ''
                            }${hotel.accommodations[4] || ''}${
                                hotel.accommodations[5] || ''
                            }`,
                            participantIds: hotel.clients
                                .map((client) => client.id)
                                .filter((client) =>
                                    this.participants.some((item) => item.id === client)
                                ),
                          }))
                          .filter((item) => item.participantIds.length),
                      activities: day.activitiesData
                          .map((activity) => ({
                            type: 'ISLAND',
                            activityId: activity.activityId,
                            pickUpTime: activity.time
                                ? `${activity.time.substring(
                                    0,
                                    2
                                )}:${activity.time.substring(
                                    activity.time.length - 2
                                )}`
                                : '',
                            pickUpTimeToBeConfirmed: activity.confirmed,
                            participantIds: activity.clients
                                .map((client) => client.id)
                                .filter((client) =>
                                    this.participants.some((item) => item.id === client)
                                ),
                          }))
                          .filter((item) => item.participantIds.length),
                      flights: day.flightsData.map((flight) => {
                        if (flight.type === 'REGULAR' || !flight.type) {
                          return {
                            // "flightId": this.dataSelects.flights.find(flightItem => flight.depId === flightItem.origin && flight.arrId === flightItem.destination && flight.comId === flightItem.companyId && flight.depTime.replace(':', '') === flightItem.departureTime) ? this.dataSelects.flights.find(flightItem => flight.depId === flightItem.origin && flight.arrId === flightItem.destination && flight.comId === flightItem.companyId && flight.depTime.replace(':', '') === flightItem.departureTime).id : '',
                            flightId: flight.flightId,
                            beforeActivity: !flight.timeActivity,
                            afterActivity: flight.timeActivity,
                            type: !flight.type ? 'REGULAR' : flight.type,
                            passengers: flight.clients
                                .filter((client) => client)
                                .map((client) => ({
                                  id: client.id,
                                  luggage: +client.lug.replace('kg', ''),
                                }))
                                .filter((client) =>
                                    this.participants.some(
                                        (item) => item.id === client.id
                                    )
                                ),
                          }
                        }
                        if (flight.type === 'PRIVATE') {
                          // console.log('PRIVATE')
                          return {
                            departureId: flight.depId,
                            arrivalId: flight.arrId,
                            companyId: flight.comId,
                            departureTime: flight.flightsTimesPrivateStart,
                            arrivalTime: flight.flightsTimesPrivateEnd,
                            priceWithCurrency: {
                              price: flight.flightsNetPricePrivate,
                              currency: 'USD',
                            },
                            passengerIds: flight.clients
                                .filter((client) => client)
                                .map((client) => client.id),
                            beforeActivity: !flight.timeActivity,
                            afterActivity: flight.timeActivity,
                            type: 'PRIVATE',
                          }
                        }
                      }),
                      // .filter((item) => item.passengers.length),
                      transfers: day.transfersData
                          .map((transfer) => ({
                            transferId: transfer.transferId,
                            pointFromId: transfer.fromId,
                            pointToId: transfer.toId,
                            pickUpTime: transfer.time === ':' ? '' : transfer.time,
                            free: transfer.free || false,
                            pickUpTimeToBeConfirmed: transfer.confirmed || false,
                            participantIds: transfer.clients
                                .map((client) => client.id)
                                .filter((client) =>
                                    this.participants.some((item) => item.id === client)
                                ),
                            beforeActivity: transfer.timeActivity,
                            afterActivity: !transfer.timeActivity,
                          }))
                          .filter((item) => item.participantIds.length),
                    },
                  })),
                }
              } else if (item.type.data === 'ISLAND_COMPACTED') {
                return {
                  day: item.day,
                  dayTo: item.days.length ? (item.day + item.days.length) - 1 : null,
                  date: item.date
                      ? item.date
                          .split('/')
                          .map((d, i) => (i === 2 ? '20' + d : d))
                          .join('.')
                      : new Date().getMonth() <= 6
                          ? `01.07.${new Date().getFullYear()}`
                          : `01.07.${new Date().getFullYear() + 1}`,
                  type: item.type.data,
                  duration: item.duration,
                  notes: item.notes,
                  territoryType: 'Island',
                  showDetails: true, // hard boolean
                  locationId: item.islandCompacted.location.id,
                  hotels: item.hotelsData
                      .map((hotel) => ({
                        hotelId: hotel.hotelId,
                        mealType: hotel.meal,
                        roomId: hotel.roomId,
                        free: hotel.free || false,
                        bookedByGuest: hotel.bookedByGuest || false,
                        earlyCheckIn: hotel.earlyCheckIn || null,
                        lateCheckOut: hotel.lateCheckOut || null,
                        accommodationType: `${hotel.accommodations[0]}${
                            hotel.accommodations[1]
                        }${hotel.accommodations[2] || ''}${
                            hotel.accommodations[3] || ''
                        }${hotel.accommodations[4] || ''}${
                            hotel.accommodations[5] || ''
                        }`,
                        participantIds: hotel.clients
                            .map((client) => client.id)
                            .filter((client) =>
                                this.participants.some((item) => item.id === client)
                            ),
                      })),
                  days: item.days.map((day) => ({
                    date: day.date
                        ? day.date
                            .split('/')
                            .map((d, i) => (i === 2 ? '20' + d : d))
                            .join('.')
                        : new Date().getMonth() <= 6
                            ? `01.07.${new Date().getFullYear()}`
                            : `01.07.${new Date().getFullYear() + 1}`,
                    services: {
                      activities: day.activitiesData
                          .map((activity) => ({
                            type: 'ISLAND_COMPACTED',
                            activityId: activity.activityId,
                            pickUpTime: activity.time
                                ? `${activity.time.substring(
                                    0,
                                    2
                                )}:${activity.time.substring(
                                    activity.time.length - 2
                                )}`
                                : '',
                            pickUpTimeToBeConfirmed: activity.confirmed,
                            participantIds: activity.clients
                                .map((client) => client.id)
                                .filter((client) =>
                                    this.participants.some((item) => item.id === client)
                                ),
                          }))
                          .filter((item) => item.participantIds.length),
                      flights: day.flightsData.map((flight) => {
                        if (flight.type === 'REGULAR' || !flight.type) {
                          return {
                            flightId: flight.flightId,
                            beforeActivity: !flight.timeActivity,
                            afterActivity: flight.timeActivity,
                            type: !flight.type ? 'REGULAR' : flight.type,
                            passengers: flight.clients
                                .filter((client) => client)
                                .map((client) => ({
                                  id: client.id,
                                  luggage: +client.lug.replace('kg', ''),
                                }))
                                .filter((client) =>
                                    this.participants.some(
                                        (item) => item.id === client.id
                                    )
                                ),
                          }
                        }
                        if (flight.type === 'PRIVATE') {
                          return {
                            departureId: flight.depId,
                            arrivalId: flight.arrId,
                            companyId: flight.comId,
                            departureTime: flight.flightsTimesPrivateStart,
                            arrivalTime: flight.flightsTimesPrivateEnd,
                            priceWithCurrency: {
                              price: flight.flightsNetPricePrivate,
                              currency: 'USD',
                            },
                            passengerIds: flight.clients
                                .filter((client) => client)
                                .map((client) => client.id),
                            beforeActivity: !flight.timeActivity,
                            afterActivity: flight.timeActivity,
                            type: 'PRIVATE',
                          }
                        }
                      }),
                      transfers: day.transfersData
                          .map((transfer) => ({
                            transferId: transfer.transferId,
                            pointFromId: transfer.fromId,
                            pointToId: transfer.toId,
                            pickUpTime: transfer.time === ':' ? '' : transfer.time,
                            free: transfer.free || false,
                            pickUpTimeToBeConfirmed: transfer.confirmed || false,
                            participantIds: transfer.clients
                                .map((client) => client.id)
                                .filter((client) =>
                                    this.participants.some((item) => item.id === client)
                                ),
                            beforeActivity: transfer.timeActivity,
                            afterActivity: !transfer.timeActivity,
                          }))
                          .filter((item) => item.participantIds.length),
                    },
                  })),
                }
              } else if (
                  item.type.data === 'CLIMBING' &&
                  (item.type.subData === 'CLASSIC' ||
                      item.type.subData === 'PREMIUM')
              ) {
                return {
                  notes: item.notes,
                  day: item.day,
                  date: item.date
                      ? item.date
                          .split('/')
                          .map((d, i) => (i === 2 ? '20' + d : d))
                          .join('.')
                      : new Date().getMonth() <= 6
                          ? `01.07.${new Date().getFullYear()}`
                          : `01.07.${new Date().getFullYear() + 1}`,
                  type: item.type.data,
                  includeHotelsAndTransfers: item.includeHotelsAndTransfers,
                  climbingType: item.type.subData,
                  climbingId: item.climbingId,
                  priceFor: +item.priceFor,
                  tourLeader: item.tourLeader,
                  tourLeaderId:
                      item.tourLeader && item.tourLeaderPer
                          ? +item.tourLeaderPer.id
                          : null,
                  additionalOptions: item.additionalOptions.map((option) => ({
                    id: option.id,
                    participantIds: option.clients
                        .map((client) => client.id)
                        .filter((client) =>
                            this.participants.some((item) => item.id === client)
                        ),
                  })),
                  participantIds: item.participantsSave
                      ? item.participantsIds
                          ? item.participantsIds
                              .filter((item) => item.active)
                              .filter((client) =>
                                  this.participants.some(
                                      (item) => item.id === client.id
                                  )
                              )
                              .map((item) => item.id)
                          : []
                      : this.participants.map((item) => item.id),
                  services: {
                    hotels: item.hotelsData
                        .map((hotel) => ({
                          hotelId: hotel.hotelId,
                          mealType: hotel.meal,
                          roomId: hotel.roomId,
                          free: hotel.free || false,
                          bookedByGuest: hotel.bookedByGuest || false,
                          earlyCheckIn: hotel.earlyCheckIn || null,
                          lateCheckOut: hotel.lateCheckOut || null,
                          accommodationType: `${hotel.accommodations[0]}${
                              hotel.accommodations[1]
                          }${hotel.accommodations[2] || ''}${
                              hotel.accommodations[3] || ''
                          }${hotel.accommodations[4] || ''}${
                              hotel.accommodations[5] || ''
                          }`,
                          participantIds: hotel.clients
                              .map((client) => client.id)
                              .filter((client) =>
                                  this.participants.some((item) => item.id === client)
                              ),
                        }))
                        .filter((item) => item.participantIds.length),
                    flights: item.flightsData.map((flight) => {
                      if (flight.type === 'REGULAR' || !flight.type) {
                        return {
                          // "flightId": this.dataSelects.flights.find(flightItem => flight.depId === flightItem.origin && flight.arrId === flightItem.destination && flight.comId === flightItem.companyId && flight.depTime.replace(':', '') === flightItem.departureTime) ? this.dataSelects.flights.find(flightItem => flight.depId === flightItem.origin && flight.arrId === flightItem.destination && flight.comId === flightItem.companyId && flight.depTime.replace(':', '') === flightItem.departureTime).id : '',
                          flightId: this.dataSelects.flights.find(
                              (flightItem) =>
                                  flight.depId === flightItem.origin &&
                                  flight.arrId === flightItem.destination &&
                                  flight.comId === flightItem.companyId &&
                                  flight.depTime.replace(':', '') ===
                                  flightItem.departureTime
                          )
                              ? this.dataSelects.flights.find(
                                  (flightItem) =>
                                      flight.depId === flightItem.origin &&
                                      flight.arrId === flightItem.destination &&
                                      flight.comId === flightItem.companyId &&
                                      flight.depTime.replace(':', '') ===
                                      flightItem.departureTime
                              ).id
                              : '',
                          beforeActivity: !flight.timeActivity,
                          afterActivity: flight.timeActivity,
                          type: !flight.type ? 'REGULAR' : flight.type,
                          passengers: flight.clients
                              .filter((client) => client)
                              .map((client) => ({
                                id: client.id,
                                luggage: +client.lug.replace('kg', ''),
                              }))
                              .filter((client) =>
                                  this.participants.some(
                                      (item) => item.id === client.id
                                  )
                              ),
                        }
                      }
                      if (flight.type === 'PRIVATE') {
                        return {
                          departureId: flight.depId,
                          arrivalId: flight.arrId,
                          companyId: flight.comId,
                          departureTime: flight.flightsTimesPrivateStart,
                          arrivalTime: flight.flightsTimesPrivateEnd,
                          priceWithCurrency: {
                            price: flight.flightsNetPricePrivate,
                            currency: 'USD',
                          },
                          passengerIds: flight.clients
                              .filter((client) => client)
                              .map((client) => client.id),
                          beforeActivity: !flight.timeActivity,
                          afterActivity: flight.timeActivity,
                          type: 'PRIVATE',
                        }
                      }
                    }),
                    // .filter((item) => item.passengers.length),
                    transfers: item.transfersData
                        .map((transfer) => ({
                          transferId: transfer.transferId,
                          pointFromId: transfer.fromId,
                          pointToId: transfer.toId,
                          pickUpTime: transfer.time === ':' ? '' : transfer.time,
                          free: transfer.free || false,
                          pickUpTimeToBeConfirmed: transfer.confirmed || false,
                          participantIds: transfer.clients
                              .map((client) => client.id)
                              .filter((client) =>
                                  this.participants.some((item) => item.id === client)
                              ),
                          beforeActivity: transfer.timeActivity,
                          afterActivity: !transfer.timeActivity,
                        }))
                        .filter((item) => item.participantIds.length),
                  },
                }
              } else if (
                  item.type.data === 'CLIMBING' &&
                  item.type.subData === 'JOIN'
              ) {
                return {
                  notes: item.notes,
                  day: item.day,
                  date: item.date
                      ? item.date
                          .split('/')
                          .map((d, i) => (i === 2 ? '20' + d : d))
                          .join('.')
                      : new Date().getMonth() <= 6
                          ? `01.07.${new Date().getFullYear()}`
                          : `01.07.${new Date().getFullYear() + 1}`,
                  type: item.type.data,
                  climbingType: item.type.subData,
                  joinGroupId: item.climb ? item.climb.id : null,
                  // TODO: remove joinGroup after release new join groups
                  joinGroup: {
                    date_start: item.climb ? item.climb.dateStart : '',
                    date_end: item.climb ? item.climb.dateEnd : '',
                    route: item.climb ? item.climb.route : '',
                    price: item.climb ? item.climb.price : '',
                    days: item.climb ? item.climb.days : '',
                  },
                  priceFor: +item.priceFor,
                  tourLeader: item.tourLeader,
                  tourLeaderId:
                      item.tourLeader && item.tourLeaderPer
                          ? +item.tourLeaderPer.id
                          : null,
                  additionalOptions: item.additionalOptions.map((option) => ({
                    id: option.id,
                    participantIds: option.clients
                        .map((client) => client.id)
                        .filter((client) =>
                            this.participants.some((item) => item.id === client)
                        ),
                  })),
                  participantIds: item.participantsSave
                      ? item.participantsIds
                          ? item.participantsIds
                              .filter((item) => item.active)
                              .filter((client) =>
                                  this.participants.some(
                                      (item) => item.id === client.id
                                  )
                              )
                              .map((item) => item.id)
                          : []
                      : this.participants.map((item) => item.id),
                  services: {
                    hotels: item.hotelsData
                        .map((hotel) => ({
                          hotelId: hotel.hotelId,
                          mealType: hotel.meal,
                          roomId: hotel.roomId,
                          free: hotel.free || false,
                          bookedByGuest: hotel.bookedByGuest || false,
                          earlyCheckIn: hotel.earlyCheckIn || null,
                          lateCheckOut: hotel.lateCheckOut || null,
                          accommodationType: `${hotel.accommodations[0]}${
                              hotel.accommodations[1]
                          }${hotel.accommodations[2] || ''}${
                              hotel.accommodations[3] || ''
                          }${hotel.accommodations[4] || ''}${
                              hotel.accommodations[5] || ''
                          }`,
                          participantIds: hotel.clients
                              .map((client) => client.id)
                              .filter((client) =>
                                  this.participants.some((item) => item.id === client)
                              ),
                        }))
                        .filter((item) => item.participantIds.length),
                    flights: item.flightsData.map((flight) => {
                      if (flight.type === 'REGULAR' || !flight.type) {
                        const selectedFlight = this.dataSelects.flights.find(
                            (flightItem) =>
                                flight.depId === flightItem.origin &&
                                flight.arrId === flightItem.destination &&
                                flight.comId === flightItem.companyId &&
                                flight.depTime.replace(':', '') ===
                                flightItem.departureTime
                        )
                        return {
                          // "flightId": this.dataSelects.flights.find(flightItem => flight.depId === flightItem.origin && flight.arrId === flightItem.destination && flight.comId === flightItem.companyId && flight.depTime.replace(':', '') === flightItem.departureTime) ? this.dataSelects.flights.find(flightItem => flight.depId === flightItem.origin && flight.arrId === flightItem.destination && flight.comId === flightItem.companyId && flight.depTime.replace(':', '') === flightItem.departureTime).id : '',
                          flightId: selectedFlight ? selectedFlight.id : '',
                          beforeActivity: !flight.timeActivity,
                          afterActivity: flight.timeActivity,
                          type: !flight.type ? 'REGULAR' : flight.type,
                          passengers: flight.clients
                              .filter((client) => client)
                              .map((client) => ({
                                id: client.id,
                                luggage: +client.lug.replace('kg', ''),
                              }))
                              .filter((client) =>
                                  this.participants.some(
                                      (item) => item.id === client.id
                                  )
                              ),
                        }
                      }
                      if (flight.type === 'PRIVATE') {
                        return {
                          departureId: flight.depId,
                          arrivalId: flight.arrId,
                          companyId: flight.comId,
                          departureTime: flight.flightsTimesPrivateStart,
                          arrivalTime: flight.flightsTimesPrivateEnd,
                          priceWithCurrency: {
                            price: flight.flightsNetPricePrivate,
                            currency: 'USD',
                          },
                          passengerIds: flight.clients
                              .filter((client) => client)
                              .map((client) => client.id),
                          beforeActivity: !flight.timeActivity,
                          afterActivity: flight.timeActivity,
                          type: 'PRIVATE',
                        }
                      }
                    }),
                    // .filter((item) => item.passengers.length),
                    transfers: item.transfersData
                        .map((transfer) => ({
                          transferId: transfer.transferId,
                          pickUpTime: transfer.time === ':' ? '' : transfer.time,
                          pointFromId: transfer.fromId,
                          pointToId: transfer.toId,
                          free: transfer.free || false,
                          pickUpTimeToBeConfirmed: transfer.confirmed || false,
                          participantIds: transfer.clients
                              .map((client) => client.id)
                              .filter((client) =>
                                  this.participants.some((item) => item.id === client)
                              ),
                          beforeActivity: transfer.timeActivity,
                          afterActivity: !transfer.timeActivity,
                        }))
                        .filter((item) => item.participantIds.length),
                  },
                }
              }
            })
            .filter((item) => (item ? true : false)),
        allowStripe: this.allowStripe,
        frontendMeta: {
          tourStart: this.tourStart
              ? date(new Date(this.tourStart), 'start')
              : '',
          tourFinish: this.tourFinish
              ? date(new Date(this.tourFinish), 'start')
              : '',
          program: this.data.program,
          participants: this.participants,
          showNames: this.showNames,
          commisionInclude: this.commisionInclude,
          priceValidUpTo: this.data.priceValidUpTo,
          country: this.data.country,
          yearsDiff: this.yearsDiff,
        },
      }
    },
    calcTemplatePriceHandler(needRecalculate = false) {
      if (this.dataSelects.advices) {
        let data = this.generateTemplateData(needRecalculate)
        data = {...data, program: data.program.filter((item) => item)}

        const filterProgram = data.program.filter(
            (item) =>
                item.services &&
                item.services.activities &&
                item.services.activities.length
        )
        const filterProgramWithDays = data.program.filter(
            (item) => item.days && item.days.length
        )
        const filterProgramActivities = filterProgram.filter((item) =>
            item.services.activities.some(
                (activity) =>
                    activity.type === 'SAFARI' || activity.type === 'ISLAND'
            )
        )
        let filterDaysActivities = []
        let programDays = []
        filterProgramWithDays.forEach((item) => {
          if (item.days.length) programDays.push(item.days)
        })
        programDays = programDays.flat()
        filterDaysActivities = programDays.filter((item) =>
            item.services.activities.some(
                (activity) =>
                    activity.type === 'SAFARI' || activity.type === 'ISLAND'
            )
        )
        this.showActivityComission =
            !!filterProgramActivities.length || !!filterDaysActivities.length

        const clientId = this.data.id || ''

        if (this.checkAdditionalServicesErrors(false)) {
          return;
        }

        if (this.checkDiscountsErrors(true)) {
          return;
        }

        calcTemplatePrice(data, clientId, needRecalculate)
            .then((res) => {
              this.totalPrice = res
            })
            .catch(() => false)
      }
    },
    openLink(link) {
      window.open(link, '_blank')
    },
    addParticipant(none = false) {
      this.participants = this.participants.concat({
        // id: this.participants.length + Math.max.apply(null, this.participants.map(item => item.id)) + 1,
        // id: Math.max.apply(null, this.participants.map(item => item.id)) + 1,
        // id: +(this.participants.length + 1) + Math.floor(Math.random() * (1000 - 1 + 1)) + 1,
        // id: Math.floor(Math.random() * (1000 - 1 + 1)) + Math.max.apply(null, this.participants.map(item => item.id)) + 1,
        id: none
            ? this.user.id
            : Math.max.apply(
            null,
            this.participants.map((item) => item.id)
        ) + 1,
        name: 'Adult ' + (this.participants.length + 1),
        dateOfBirth: '01 Jun ' + (new Date().getFullYear() - 25),
        age: 25,
        ageType: 'adult',
        gender: 'male',
        genderSelect: false,
        residence: {
          name: 'Foreign',
          data: 'FOREIGN',
        },
        residenceSelect: false,
        insurance: {
          companyName: '',
          policyNumber: '',
          validFrom: '',
          validUpTo: '',
        },
        insurancePopup: false,
        dietarySave: false,
        dietaryRequirements: {
          foodPreferences: 'Regular',
          allergies: ['No allergies'],
        },
        dietaryRequirementsSaved: false,
        dietaryPopup: false,
        weddingPopup: false,
        weddingPopupOpen: false,
        coupleId: null,
        weddingDate: '',
        foodPreferencesSelect: false,
        alergiesSelect: false,
      })
      if (!none) {
        setTimeout(() => {
          this.setRefValue(
              'participantsDateRef' + (this.participants.length - 1),
              '01 Jun ' + (new Date().getFullYear() - 25)
          )
          this.updateDatePickers()
        }, 500)
      }
      // console.log('>> add part: ', this.participants)
      this.calcTemplatePriceHandler()
      // this.updateClientsHandler()
    },
    removeParticipant(id) {
      this.participants = this.participants.map((p) =>
          p.coupleId === this.participants[id].id
              ? {
                ...p,
                coupleId: null,
                weddingDate: null,
              }
              : p
      )
      this.participants = this.participants.filter(
          (_, index) => !(index === id)
      )
      this.calcTemplatePriceHandler()
      this.isEditFlag = true
    },
    removeParticipantPersonalDiscounts(item) {
      this.participantPersonalDiscounts = this.participantPersonalDiscounts.filter(p => p.participantId.id !== item.id)
    },
    forcedRecalculateDays() {
      this.data.program = this.data.program.concat(
          Array(
              +this.duration -
              +this.data.program.reduce((acc, day) => acc + +day.duration, 0)
          ).fill({
            notes: '',
            day: 0,
            dayTo: null,
            date: '',
            type: {
              name: '',
              data: '',
            },
            typeSelect: false,
            pickUpTime: '',
            pax: '',
            duration: 1,
            showDetails: true,
            days: [
              {
                type: '',
                activitiesData: [],
                flightsData: [],
                transfersData: [],
                hotelsData: [],
                park: {},
              },
            ],
            drag: false,
            carsSelect: false,
            islandSelect: false,
            additionalOptions: [],
            activitiesData: [],
            participantsSave: false,
            participantsIds: this.participants.map((item) => ({
              ...item,
              active: true,
            })),
            flightsData: [],
            transfersData: [],
            hotelsData: [],
            climbingId: null,
            tourLeader: false,
            tourLeaderPer: {},
            airport: null,
            extraCar: false,
            carsSelectItem: 0,
            warning: false,
          })
      )
      this.durationData = this.duration = +this.data.program.reduce(
          (acc, day) => acc + +day.duration,
          0
      )
      this.calcDates()
    },
    changeNumDays() {
      if (+this.duration > +this.durationData) {
        this.forcedRecalculateDays()
      } else if (+this.duration < +this.durationData) {
        this.changeDaysPopup = true
        this.countDeleteDays = +this.durationData - +this.duration
        this.calcDates()
      }
      this.isEditFlag = true
      this.calcTemplatePriceHandler()
    },
    calcDates() {
      this.data.program = this.data.program.map((item, index) => ({
        ...item,
        id: index,
        day:
            this.data.program
                .slice(0, index)
                .reduce((acc, day) => acc + +day.duration, 0) + 1,
        date: this.tourStart
            ? this.dateCalc(
                +new Date(this.tourStart).getTime() +
                this.data.program
                    .slice(0, index)
                    .reduce((acc, day) => acc + +day.duration, 0) * 24 * 60 * 60 * 1000 + (60 * 60 * 1000)
            )
            : '',
        days: item.days.map((itemDay, itemDayIndex) => ({
          ...itemDay,
          day:
              this.data.program
                  .slice(0, index)
                  .reduce((acc, day) => acc + +day.duration, 0) +
              1 +
              itemDayIndex,
          date: this.tourStart
              ? this.dateCalc(
                  +new Date(this.tourStart).getTime() +
                  (this.data.program
                      .slice(0, index)
                      .reduce((acc, day) => acc + +day.duration, 0) + itemDayIndex) * 24 * 60 * 60 * 1000 + (60 * 60 * 1000)
              )
              : '',
        })),
      }))
    },
    dragDayFly(elem) {
      let element = Array.from(
          document.querySelectorAll('.tour-program-table__row')
      )[elem]
      let elementOffset = element.getBoundingClientRect().y
      let elementsOffset = Array.from(
          document.querySelectorAll('.tour-program-table__row')
      ).map((item, i) => ({
        top: item.getBoundingClientRect().y + 25,
        index: i,
      }))
      let findElement = elementsOffset.find(
          (item) => item.top > elementOffset + 25
      )
      if (findElement) {
        let pushIndexPre = findElement.index - 1
        let pushIndexPost = findElement.index
        this.dragIndex = elem
        this.dragHeight = element.getBoundingClientRect().height
        this.data.program = this.data.program.map((item, i) => {
          if (i === pushIndexPre) {
            item.pre = true
            item.post = false
          } else if (i === pushIndexPost) {
            item.post = true
            item.pre = false
          } else {
            item.pre = false
            item.post = false
          }
          return item
        })
      } else {
        this.data.program = this.data.program.map((item, i, arr) => {
          item.pre = false
          item.post = false
          if (i === arr.length - 1) {
            item.pre = true
          }
          return item
        })
      }
    },
    dragDay(elem) {
      this.isEditFlag = true
      let id = +this.$refs.programItem[elem].getAttribute('data-index')
      let element = Array.from(
          document.querySelectorAll('.tour-program-table__row')
      )[elem]
      let elementOffset = element.getBoundingClientRect().y
      let elementsOffset = Array.from(
          document.querySelectorAll('.tour-program-table__row')
      ).map((item, i) => ({
        top: item.getBoundingClientRect().y + 25,
        index: i,
      }))
      let findElement = elementsOffset.find(
          (item) => item.top > elementOffset + 25
      )
      let copy = [...this.data.program]
      let movable = this.data.program.find((_, i) => i === elem)
      this.dragIndex = null
      this.dragHeight = '0px'
      copy.splice(elem, 1)

      if (findElement) {
        let pushIndex = findElement.index - 1
        if (pushIndex === -1) {
          //push first
          copy.unshift(movable)
        } else {
          copy.splice(elem > pushIndex ? pushIndex + 1 : pushIndex, 0, movable)
        }
      } else {
        //push last
        copy.push(movable)
      }
      this.data.program = [
        ...copy.map((item) => {
          item.pre = false
          item.post = false
          return item
        }),
      ]
      this.calcDates()
      this.checkProgramErrors()
    },
    mouseFind(event) {
      this.mouse = {
        top: event.clientY - 25,
      }
    },
    removeCurrentDayTour(indexP, indexD) {
      // console.log('removeCurrentDayTour indexP', indexP)
      // console.log('removeCurrentDayTour indexD', indexD)
      let days = this.data.program[indexP].days
      // console.log('removeCurrentDayTour days', days)
      this.data.program[indexP].duration = this.data.program[indexP].duration - 1
      // console.log('removeCurrentDayTour daysDuration', this.data.program[indexP].duration)

      days.splice(indexD, 1)
      this.calcTemplatePriceHandler()
      this.calcDates();
      this.durationData = this.duration = +this.data.program.reduce(
          (acc, day) => acc + +day.duration,
          0
      )
    },
    mouseFindDay(event, indexP, indexD) {
      // console.log('mouseFindDay event', event.clientY)
      // console.log('mouseFindDay indexP', indexP)
      // console.log('mouseFindDay indexD', indexD)

      // console.log(this.data.program[indexP].days[indexD].drag)
      this.mouseDay = {
        top: event.clientY - 25
      }
      // console.log('mouseFindDay mouseDay', this.mouseDay)
    },
    dragCurrentDay(indexProgram, elem) {
      // console.log('dragCurrentDay elem', elem)
      // console.log('dragCurrentDay indexProgram', indexProgram)

      // :style="{
      //   top: day.drag ? mouseDay.top + 'px' : 'unset',
      //       marginBottom: day.pre
      //       ? indexDay === data.program[index].days.length - 1
      //           ? dragHeight + 50 + 'px'
      //           : dragHeight + 'px'
      //       : '0px',
      //       marginTop: day.post ? dragHeight + 30 + 'px' : '0px',
      // }"

      this.isEditFlag = true
      let id = +this.$refs.daysItem[elem].getAttribute('data-indexDay')
      let element = Array.from(
          document.querySelectorAll('.tour-program-table__line-item')
      )[elem]
      // console.log('dragCurrentDay element', element)
      let elementOffset = element.getBoundingClientRect().y
      // console.log('dragCurrentDay elementOffset', elementOffset)
      let elementsOffset = Array.from(
          document.querySelectorAll('.tour-program-table__line-item')
      ).map((item, i) => ({
        top: item.getBoundingClientRect().y + 25,
        index: i,
      }))
      // console.log('dragCurrentDay elementsOffset', elementsOffset)
      let findElement = elementsOffset.find(
          (item) => item.top > elementOffset + 25
      )
      // console.log('dragCurrentDay findElement', findElement)
      let copy = [...this.data.program[indexProgram].days]
      // console.log('dragCurrentDay copy', copy)
      let movable = this.data.program[indexProgram].days.find((_, i) => i === elem)
      // console.log('dragCurrentDay movable', movable)
      this.dragIndex = null
      this.dragHeight = '0px'
      copy.splice(elem, 1)

      if (findElement) {
        let pushIndex = findElement.index - 1
        if (pushIndex === -1) {
          //push first
          copy.unshift(movable)
        } else {
          copy.splice(elem > pushIndex ? pushIndex + 1 : pushIndex, 0, movable)
        }
      } else {
        //push last
        copy.push(movable)
      }
      this.data.program[indexProgram].days = [
        ...copy.map((item) => {
          item.pre = false
          item.post = false
          return item
        }),
      ]
      this.calcDates()
    },
    dragCurrentDayFly(indexProgram, elem) {
      // console.log('dragCurrentDayFly elem', elem)
      // console.log('dragCurrentDayFly indexProgram', indexProgram)
      let element = Array.from(
          document.querySelectorAll('.tour-program-table__line-item')
      )[elem]
      let elementOffset = element.getBoundingClientRect().y
      let elementsOffset = Array.from(
          document.querySelectorAll('.tour-program-table__line-item')
      ).map((item, i) => ({
        top: item.getBoundingClientRect().y + 25,
        index: i,
      }))
      let findElement = elementsOffset.find(
          (item) => item.top > elementOffset + 25
      )
      if (findElement) {
        let pushIndexPre = findElement.index - 1
        let pushIndexPost = findElement.index
        this.dragIndex = elem
        this.dragHeight = element.getBoundingClientRect().height
        this.data.program[indexProgram].days = this.data.program[indexProgram].days.map((item, i) => {
          if (i === pushIndexPre) {
            item.pre = true
            item.post = false
          } else if (i === pushIndexPost) {
            item.post = true
            item.pre = false
          } else {
            item.pre = false
            item.post = false
          }
          return item
        })
      } else {
        this.data.program[indexProgram].days = this.data.program[indexProgram].days.map((item, i, arr) => {
          item.pre = false
          item.post = false
          if (i === arr.length - 1) {
            item.pre = true
          }
          return item
        })
      }
    },
    removeDays() {
      let count = 0
      this.data.program = this.data.program.filter((item) => {
        if (count >= +this.duration) {
          return false
        }
        count += item.duration
        return true
      })
      count = 0
      this.data.program = this.data.program.map((item, index) => {
        if (
            count < this.duration &&
            (item.type.data === 'SAFARI' || item.type.data === 'ISLAND') &&
            index === this.data.program.length - 1
        ) {
          return {
            ...item,
            duration: this.duration - count,
          }
        }
        count += item.duration
        return item
      })
      this.durationData = this.duration = +this.data.program.reduce(
          (acc, day) => acc + +day.duration,
          0
      )
      this.calcTemplatePriceHandler()
      this.isEditFlag = true
    },
    updateDatePickers() {
      document.querySelectorAll('.lightpick').forEach((elem) => {
        elem.remove()
      })
      setTimeout(() => {
        let datepickers1 = document.querySelectorAll('.js-datepicker-single')
        let datepickers2 = document.querySelectorAll(
            '.js-datepicker-single-age'
        )
        if (datepickers1.length) {
          datepickers1.forEach((item) => {
            const datePicker = new Lightpick({
              field: item,
              singleDate: true,
              dropdowns: {
                years: {
                  min: new Date().getFullYear(),
                  max: 2030,
                },
                months: true,
              },
              lang: 'en',
              format: 'DD MMM YYYY',
              onClose: function () {
                item.blur()
              },
              onSelect: function () {
                item.focus()
                item.blur()
              },
            })
            // item.addEventListener('blur', () => {
            //   datePicker.hide()
            // })
          })
        } else {
          this.updateDatePickers()
        }
        if (datepickers2) {
          datepickers2.forEach((item) => {
            const datePicker = new Lightpick({
              field: item,
              // singleDate: true,
              lang: 'en',
              minDate: new Date(
                  new Date().getFullYear() - 100,
                  new Date().getMonth(),
                  new Date().getDate()
              ),
              maxDate: new Date(),
              format: 'DD MMM YYYY',
              onClose: function () {
                item.blur()
              },
              onSelect: function () {
                item.focus()
                item.blur()
              },
            })
            // item.addEventListener('blur', () => {
            //   datePicker.hide()
            // })
          })
        } else {
          this.updateDatePickers()
        }
      }, 500)
    },
    removeProgramDay(id) {
      this.data.program = this.data.program.filter(
          (item, index) => !(index === id)
      )
      this.durationData = this.duration = +this.data.program.reduce(
          (acc, day) => acc + +day.duration,
          0
      )
      this.calcTemplatePriceHandler()
      this.calcDates()
      this.isEditFlag = true
    },
    dateCalc(value) {
      return date(value, 'sl')
    },
    dateCalcStart(value) {
      return date(value, 'd')
    },
    getHotelData(id) {
      this.hotelSelectInputRoom = ''
      this.dataSelects.room = []
      Promise.all([getHotelsMeals(id), getHotelsRoom(id)]).then((res) => {
        this.selectedHotel.notes = res[0].notes;
        this.selectedHotel.transferTimeMin = res[0].transferTimeMin;
        this.selectedHotel.closest = res[0].airstripId !== null ? this.dataSelects.airstrips.find((airstrip) => airstrip.id === res[0].airstripId) : null;
        this.dataSelects.meal = res[0]
        this.hotelNotes = res[0].notes
        // if (res[0].length === 1) {
        //   this.hotelPopupData.meal = res[0][0]
        // }
        this.dataSelects.room = res[1]
      })
      this.isEditFlag = true
    },
    getRoomAccommodationsHandler(accomodations) {
      this.dataSelects.accommodations = accomodations
      this.dataSelects.accommodationType = accomodations
      let calculateResult = this.dataSelects.accommodations
          .filter((item) => {
            let adult = item.search('A')
            let teen = item.search('T')
            let child = item.search('C')

            let error = true

            if (
                adult > 0 &&
                !this.participants.find(
                    (par) => par.age >= this.dataSelects.meal.ageSettings.adult.from
                )
            ) {
              error = false
            }

            if (
                teen > 0 &&
                !this.participants.find(
                    (par) =>
                        par.age >= this.dataSelects.meal.ageSettings.teenager.from &&
                        par.age <= this.dataSelects.meal.ageSettings.teenager.to
                )
            ) {
              error = false
            }

            if (
                child > 0 &&
                !this.participants.find(
                    (par) => par.age <= this.dataSelects.meal.ageSettings.child.to
                )
            ) {
              error = false
            }

            // if (adult > 0 && !this.participants.find(par => par.ageType === 'adult')) {
            //   error = false
            // }
            // if (teen > 0 && !this.participants.find(par => par.ageType === 'teenager')) {
            //   error = false
            // }
            // if (child > 0 && !this.participants.find(par => par.ageType === 'child')) {
            //   error = false
            // }
            return error
          })
          .map((item, _, arr) => {
            return {
              ...item,
              data: item.match(/.{1,2}/g).map((str) => {
                return {
                  count: +str[0],
                  type: str[1],
                }
              }),
              active: arr.length === 1,
            }
          })

      let calculateResultType = this.dataSelects.accommodationType
          .filter((item) => {
            let adult = item.search('A')
            let teen = item.search('T')
            let child = item.search('C')

            let error = true

            if (
                adult > 0 &&
                !this.participants.find(
                    (par) => par.age >= this.dataSelects.meal.ageSettings.adult.from
                )
            ) {
              error = false
            }

            if (
                teen > 0 &&
                !this.participants.find(
                    (par) =>
                        par.age >= this.dataSelects.meal.ageSettings.teenager.from &&
                        par.age <= this.dataSelects.meal.ageSettings.teenager.to
                )
            ) {
              error = false
            }

            if (
                child > 0 &&
                !this.participants.find(
                    (par) => par.age <= this.dataSelects.meal.ageSettings.child.to
                )
            ) {
              error = false
            }

            // if (adult > 0 && !this.participants.find(par => par.ageType === 'adult')) {
            //   error = false
            // }
            // if (teen > 0 && !this.participants.find(par => par.ageType === 'teenager')) {
            //   error = false
            // }
            // if (child > 0 && !this.participants.find(par => par.ageType === 'child')) {
            //   error = false
            // }
            return error
          })

      this.dataSelects.accommodationType = calculateResultType
      this.dataSelects.accommodations = [...calculateResult]

      if (calculateResult.length === 1) {
        this.calcHotelPrice(this.hotelPopup.day)
      } else {
        this.hotelPopupData.price = '0'
      }
    },
    calcHotelPrice(id) {
      if (this.dataSelects.accommodations.find((item) => item.active)) {
        const now = new Date()
        const curr = now.getFullYear()
        const next = curr + 1
        const noDatesYear = now.getMonth() < 6 ? curr : now.getMonth() > 6 ? next : now.getDate() === 1 ? curr : next
        getHotelPrice({
          date: this.hotelPopup.date.length
              ? format(
                  parse(this.hotelPopup.date, 'dd/MM/yy', new Date()),
                  'dd.MM.yyyy'
              )
              : format(
                  new Date(noDatesYear, 6, 1),
                  'dd.MM.yyyy'
              ),
          hotelId: this.hotelPopupData.hotel.id,
          accommodationType: `${
              this.dataSelects.accommodations.find((item) => item.active)[0]
          }${this.dataSelects.accommodations.find((item) => item.active)[1]}${
              this.dataSelects.accommodations.find((item) => item.active)[2] || ''
          }${
              this.dataSelects.accommodations.find((item) => item.active)[3] || ''
          }${
              this.dataSelects.accommodations.find((item) => item.active)[4] || ''
          }${
              this.dataSelects.accommodations.find((item) => item.active)[5] || ''
          }`,
          mealType: this.hotelPopupData.meal,
          roomId: this.hotelPopupData.room.id,
        })
            .then((res) => {
              this.hotelPopupData.price = res.priceWithFees + ' USD'
            })
            .catch(() => {
              // this.dataSelects.accommodations = this.dataSelects.accommodations.map(acc => ({...acc, active: false}))
              this.hotelPopupData.price = '0'
            })
      } else {
        this.hotelPopupData.price = '0'
      }
    },
    getAlternativeHotelsHandler() {
      let seasonDate = null
      if (this.hotelPopup.date) {
        seasonDate = this.hotelPopup.date.replace(/\//g, '.')
        seasonDate = new Date(
            (+seasonDate.split('.')[1]).toString() +
            '.' +
            (+seasonDate.split('.')[0]).toString() +
            '.' +
            (+seasonDate.split('.')[2]).toString()
        )
      } else {
        seasonDate = new Date(
            format(new Date(this.data.tourStart), 'dd, MM, yyyy')
        )
      }
      getAlternativeHotels({
        searchDate: seasonDate ? format(seasonDate, 'dd.MM.yyyy') : '',
        hotelId: this.hotelPopupData.hotel.id,
        mealType: this.hotelPopupData.meal,
        rooms: this.dataSelects.accommodations
            .filter((item) => item.active)
            .map((item) => {
              return {
                roomId: this.hotelPopupData.room.id,
                accommodationType: `${item[0]}${item[1]}${item[2] || ''}${
                    item[3] || ''
                }${item[4] || ''}${item[5] || ''}`,
              }
            }),
      }).then((res) => {
        this.dataSelects.alternativeHotels = res
      })
    },
    getHotelsHandler(filter) {
      getHotelsAll(filter)
          .then((res) => {
            // this.dataSelects.hotels = res.sort((a, b) => a.names.EN.toLowerCase() > b.names.EN.toLowerCase() ? 1 : -1)
            this.dataSelects.hotels = res
          })
          .catch(() => (this.dataSelects.hotels = []))
      this.isEditFlag = true
    },
    climbingPrice(type, itemClimbing) {
      // console.log('>> participantsIds: ', itemClimbing.participantsIds)

      let index = itemClimbing.participantsIds.filter((p) => p.active && p.ageType !== 'child').length
      let priceSeed = []

      if (type === 'JOIN') {
        priceSeed = [3]
        if (index > 3) {
          priceSeed.push(
              ...Array(index - 3)
                  .fill(true)
                  .map((_, ind) => ind + 4)
          )
        }
      } else {
        priceSeed.push(
            ...Array(index)
                .fill(true)
                .map((_, ind) => ind + 1)
        )
      }

      return priceSeed
    },
    getClimbingRoutes(item) {
      let currentRoutes = this.dataSelects.routes
          .filter((route) => route.mountTitle === item.mountain)
          .sort((a, b) => (a.durationDays > b.durationDays ? -1 : 1))
          .sort((a, b) => (a.name > b.name ? 1 : -1))
      currentRoutes = currentRoutes.map((route) => ({
        ...route,
        name:
            route.name.split('Kilimanjaro climb via').length > 1
                ? route.name.split('Kilimanjaro climb via')[1]
                : route.name && route.name.split('Kilimanjaro').length > 1
                    ? route.name.split('Kilimanjaro')[1]
                    : route.name,
      }))
      return currentRoutes
    },
  },
  watch: {
    '$route.fullPath': {
      handler() {
        this.$emit('forceRerender')
        // if(this.$route.fullPath === '/new'){
        // 	this.$emit('forceRerender')
        // }
      },
    },
    duration() {
      if (this.tourStart && this.duration) {
        let d = new Date(
            +new Date(this.tourStart).getTime() +
            (+this.duration - 1) * 24 * 60 * 60 * 1000
        )
        this.tourFinish = date(d, 'd')
        setTimeout(() => {
          this.setRefValue('tourFinish', date(d, 'd'))
        }, 100)
      }
      // this.isEditFlag = true
    },
    tourStart() {
      if (this.tourStart && this.duration) {
        this.calcDates()
        let d = new Date(
            +new Date(this.tourStart).getTime() +
            (+this.duration - 1) * 24 * 60 * 60 * 1000
        )
        this.tourFinish = date(d, 'd')
        this.setRefValue('tourFinish', date(d, 'd'))
      }
      if (this.tourStart && !this.isFirstLoading) {
        getAdvicesRecommended(date(new Date(this.tourStart), 'start')).then(
            (res) => {
              this.advicesRecomended = {...res}
              if (this.isLoad) {
                setTimeout(() => {
                  this.calcTemplatePriceHandler()
                }, 0)
              }
              this.isLoad = true
            }
        )
      } else {
        this.calcDates()
        this.tourFinish = ''
        this.setRefValue('tourFinish', '')
      }
      if (this.tourStart && this.tourFinish) {
        Object.values(this.participants).forEach((p) => {
          let ageFix
          const bd = new Date(p.dateOfBirth)
          const tsd = new Date(this.tourStart)
          const tfd = new Date(this.tourFinish)

          const ageFix1 =
              new Date(tsd.getTime() - bd.getTime()).getFullYear() -
              new Date(0).getFullYear()
          const ageFix2 =
              new Date(tfd.getTime() - bd.getTime()).getFullYear() -
              new Date(0).getFullYear()
          p.age = Math.max(ageFix1, ageFix2)
        })
      }
      // this.isEditFlag = true
    },
    tourFinish() {
      if (this.tourFinish) {
        this.yearsDiff =
            new Date(this.tourFinish).getFullYear() - new Date().getFullYear()
      } else {
        this.yearsDiff = 0
      }
    },
    participants(newVal, oldVal) {
      // console.log('>> watch participants')
      if (newVal.length !== oldVal.length) {
        const safariDays = this.data.program.find(
            (item) => item.type.data === 'SAFARI'
        )
        if (safariDays && safariDays.days.length) {
          safariDays.days.forEach((day) => {
            day.priceFor = this.participants.length
          })
          safariDays.days.forEach((day) => {
            // day.totalCars = day.totalCars === 0 ? 0 : Math.ceil(this.participants.length / safariDays.pax)
            //   // day.totalCars = 777
          })
        }
      }
      if (newVal.length < oldVal.length) {
        const deletedParticipantId = oldVal
            .filter((i) => !newVal.includes(i))
            .concat(newVal.filter((i) => !oldVal.includes(i)))[0].id

        this.data.program = this.data.program.map((programItem) => {
          return {
            ...programItem,
            // priceFor: this.participants.length,
            activitiesData: programItem.activitiesData
                .map((activitiesItem) => {
                  return {
                    ...activitiesItem,
                    clients: activitiesItem.clients.filter(
                        (item) => item.id !== deletedParticipantId
                    ),
                  }
                })
                .filter((item) => item.clients.length),
            flightsData: programItem.flightsData
                .map((flightsItem) => {
                  return {
                    ...flightsItem,
                    clients: flightsItem.clients.filter(
                        (item) => item.id !== deletedParticipantId
                    ),
                  }
                })
                .filter((item) => item.clients.length),
            hotelsData: programItem.hotelsData
                .map((hotelsItem) => {
                  return {
                    ...hotelsItem,
                    clients: hotelsItem.clients.filter(
                        (item) => item.id !== deletedParticipantId
                    ),
                  }
                })
                .filter((item) => item.clients.length),
            transfersData: programItem.transfersData
                .map((transfersItem) => {
                  return {
                    ...transfersItem,
                    clients: transfersItem.clients.filter(
                        (item) => item.id !== deletedParticipantId
                    ),
                  }
                })
                .filter((item) => item.clients.length),
            additionalOptions: programItem.additionalOptions.map((option) => {
              return {
                ...option,
                clients: option.clients.filter((client) =>
                    this.participants.some((item) => item.id === client.id)
                ),
                pax: option.clients.filter((client) =>
                    this.participants.some((item) => item.id === client.id)
                ).length,
              }
            }),
            days: programItem.days.map((day) => {
              return {
                ...day,
                activitiesData: day.activitiesData
                    .map((activitiesItem) => {
                      return {
                        ...activitiesItem,
                        clients: activitiesItem.clients.filter(
                            (item) => item.id !== deletedParticipantId
                        ),
                      }
                    })
                    .filter((item) => item.clients.length),
                flightsData: day.flightsData
                    .map((flightsItem) => {
                      return {
                        ...flightsItem,
                        clients: flightsItem.clients.filter(
                            (item) => item.id !== deletedParticipantId
                        ),
                      }
                    })
                    .filter((item) => item.clients.length),
                hotelsData: day.hotelsData
                    .map((hotelsItem) => {
                      return {
                        ...hotelsItem,
                        clients: hotelsItem.clients.filter(
                            (item) => item.id !== deletedParticipantId
                        ),
                      }
                    })
                    .filter((item) => item.clients.length),
                transfersData: day.transfersData
                    .map((transfersItem) => {
                      return {
                        ...transfersItem,
                        clients: transfersItem.clients.filter(
                            (item) => item.id !== deletedParticipantId
                        ),
                      }
                    })
                    .filter((item) => item.clients.length),
              }
            }),
          }
        })
      }
    },
    recoveryPopup() {
      if (this.recoveryPopup) {
        getClientRecoveries(this.data.id).then((res) => {
          this.recoveries = res
        })
      }
    },
    weddingPopup() {
      if (this.weddingPopup) {
        this.updateDatePickers()
      }
      this.isEditFlag = true
      this.calcTemplatePriceHandler()
    },
    insurancePopup() {
      if (this.insurancePopup) {
        this.updateDatePickers()
        setTimeout(() => {
          const participant = this.participants.find((item) => item.insurancePopup)

          if (participant) {
            this.setRefValue('insuranceFrom', participant.insurance.validFrom)
            this.setRefValue('insuranceTo', participant.insurance.validUpTo)
          }
        }, 300)
      }
      this.isEditFlag = true
      this.calcTemplatePriceHandler()
    },
    activityPopup() {
      if (this.activityPopup) {
        if (this.participants.length <= 2) {
          if (this.participants.length === 1) {
            this.activityPopupData.paxList = Array({
              id: this.participants[0].id,
              name: this.participants[0].name,
              ageType: this.participants[0].ageType,
              open: false,
            })
          } else if (this.participants.length === 2) {
            this.activityPopupData.paxList = Array(
                {
                  id: this.participants[0].id,
                  name: this.participants[0].name,
                  ageType: this.participants[0].ageType,
                  open: false,
                },
                {
                  id: this.participants[1].id,
                  name: this.participants[1].name,
                  ageType: this.participants[1].ageType,
                  open: false,
                }
            )
          }
        } else {
          this.activityPopupData.paxList = Array(this.participants.length).fill(
              {open: false}
          )
        }
        if (this.activityPopup.type.data === 'SAFARI') {
          getSafariAll().then((res) => {
            this.dataSelects.activities = res
          })
        } else if (this.activityPopup.type.data === 'ISLAND') {
          getIslandsAll().then((res) => {
            this.dataSelects.activities = res
          })
        } else {
          getTanzaniaAll().then((res) => {
            this.dataSelects.activities = res
          })
        }
      }
      if (!this.activityPopup) {
        this.calcTemplatePriceHandler()
        this.activityPopupData.activity = null
        this.activityPopupData.time = '0900'
        this.activityPopupData.type = null
        this.activityPopupData.pax = null
        this.activityPopupData.paxList = this.activityPopupData.paxList.map(
            () => ({open: false})
        )
      } else {
        if (
            this.participants.filter((item) => item.ageType === 'adult')
                .length === this.participants.length
        ) {
          this.activityPopupData.type = {name: 'Adult', icon: 'adult'}
        } else if (
            this.participants.filter((item) => item.ageType === 'teenager')
                .length === this.participants.length
        ) {
          this.activityPopupData.type = {name: 'Teenager', icon: 'teenager'}
        } else if (
            this.participants.filter((item) => item.ageType === 'child')
                .length === this.participants.length
        ) {
          this.activityPopupData.type = {name: 'Child', icon: 'child'}
        }
      }
      this.isEditFlag = true
    },
    hotelPopup() {
      this.dataSelects.copyHotelsData = this.data.program
          .filter((item) => item.hotelsData.length)
          .map((item) =>
              item.hotelsData.map((data) => ({
                ...data,
                day: item.day,
              }))
          )
          .concat(
              this.data.program
                  .filter((item) => item.days && item.days.length)
                  .map((item) =>
                      item.days.map((day) =>
                          day.hotelsData.map((data) => ({
                            ...data,
                            day: day.day,
                            date: day.date,
                          }))
                      )
                  )
                  .flat()
                  .filter((item) => item.length)
          )
          .map((item) => {
            return {
              day: item[0].day,
              hotelsData: item,
              active: false,
            }
          })
      if (!this.hotelPopup) {
        this.dataSelects.meal = {mealPlanTypes: []}
        this.dataSelects.room = []
        this.dataSelects.accommodations = []
        this.hotelPopupData.price = ''
        this.hotelPopupData.copy = false
        this.hotelPopupData.meal = null
        this.hotelPopupData.room = null
        this.hotelPopupData.hotel = {names: {EN: ''}}
        this.hotelSelectInput = ''
        this.hotelSelectInputRoom = ''
        this.hotelNotes = ''
        this.calcTemplatePriceHandler()
      } else {
        if (this.hotelPopup.hotelsData.length) {
          this.hotelPopupData.hotel = this.dataSelects.hotels.find(
              (item) => this.hotelPopup.hotelsData[0].hotelId === item.id
          )
          this.hotelPopupData.meal = this.hotelPopup.hotelsData[0].mealData
          this.hotelSelectInput = this.hotelPopupData.hotel.names.EN || ''
          this.getHotelData(this.hotelPopup.hotelsData[0].hotelId)
        }
      }
      this.isEditFlag = true
    },
    commissionPopup() {
      if (!this.commissionPopup) {
        this.calcTemplatePriceHandler()
      }
    },
    dietaryPopup() {
      if (!this.dietaryPopup) {
        this.calcTemplatePriceHandler()
      }
    },
    flightsPopup() {
      if (!this.flightsPopup) {
        this.calcTemplatePriceHandler()
      } else {
        if (
            this.participants.filter((item) => item.ageType === 'adult')
                .length === this.participants.length
        ) {
          this.flightsPopupData.type = {name: 'Adult', icon: 'adult'}
        } else if (
            this.participants.filter((item) => item.ageType === 'teenager')
                .length === this.participants.length
        ) {
          this.flightsPopupData.type = {name: 'Teenager', icon: 'teenager'}
        } else if (
            this.participants.filter((item) => item.ageType === 'child')
                .length === this.participants.length
        ) {
          this.flightsPopupData.type = {name: 'Child', icon: 'child'}
        }
      }
    },
    transfersPopup() {
      if (!this.transfersPopup) {
        this.transfersPopupData.paxList = this.transfersPopupData.paxList.map(
            () => ({open: false})
        )
        this.calcTemplatePriceHandler()
      } else {
        if (
            this.transfersPopup.type &&
            (this.transfersPopup.type.data === 'ARRIVAL' ||
                this.transfersPopup.type.data === 'DEPARTURE') &&
            this.transfersPopup.airport &&
            this.transfersPopup.airport.id &&
            this.transfersPopup.hotelsData.length &&
            this.transfersPopup.hotelsData[0]
        ) {
          this.dataSelects.pointsTransferFrom =
              this.dataSelects.pointsTransferFrom.map((point) => ({
                ...point,
                active: point.id === this.transfersPopup.airport.id,
              }))

          let routes = this.dataSelects.pointsTransferTo.filter((item) =>
              this.dataSelects.transfersAll
                  .filter(
                      (transfer) =>
                          transfer.departure ===
                          this.dataSelects.pointsTransferFrom.find(
                              (item) => item.active
                          ).title
                  )
                  .map((transfer) => transfer.arrival)
                  .includes(item.title)
          )

          this.dataSelects.pointsTransferTo =
              this.dataSelects.pointsTransferTo.map((point) => ({
                ...point,
                active:
                    point.title === this.transfersPopup.hotelsData[0].name &&
                    routes.find((r) => r.title === point.title),
              }))
        }
        this.transfersPopupData.paxList = Array(this.participants.length).fill({
          open: false,
        })
      }
    },
    additionalPopup() {
      if (!this.additionalPopup) {
        this.additionalPopupData.pax = null
        this.additionalPopupData.option = null
        this.calcTemplatePriceHandler()
      }
    },
    hotelZanzibarPopup() {
      if (!this.hotelZanzibarPopup) {
        this.calcTemplatePriceHandler()
      }
    },
    tab() {
      this.collapse = {
        hotels: true,
        activities: true,
        flights: true,
        transfers: true,
        folio: true,
        cost: true,
        comiss: true,
        summary: true,
      }
    },
  },
  computed: {
    API() {
      return API
    },
    isAdmin() {
      return Boolean(
          this.user &&
          this.user.scope &&
          this.user.scope.includes('ADMIN')
      )
    },
    currentStatusOption() {
      const activeStatus = this.dataSelects.status.find((item) => item.active)

      if (activeStatus) {
        return activeStatus
      }

      if (this.data.status === 'DELETED') {
        return {
          name: 'Deleted',
          class: '',
        }
      }

      return {
        name: this.data.status || '',
        class: '',
      }
    },
    ...Vuex.mapGetters({
      allInvoices: getterTypesInvoices.allInvoices,
      allBanks: getterTypesBanks.allBanks,
      allPartners: getterTypesPartners.allPartners,
      amountSummariesInvoice: getterTypesInvoices.amountSummariesInvoice
    }),
    getSelectedCurrency() {
      return this.dataSelects.currency.find((currency) => currency.active === true).name;
    },
    discountInSorteredParticipantPresent() {
      return this.sorteredParticipants.filter((item) => item.personalDiscount)
          .length
    },
    getSomeTransfers() {
      return this.data.program
          .filter(
              (item) =>
                  item.type.data === 'SAFARI' ||
                  item.type.data === 'ISLAND' ||
                  item.transfersData.length
          )
          .map((item) =>
              item.type.data === 'SAFARI' || item.type.data === 'ISLAND'
                  ? item.days
                      .filter((day) => day.transfersData.length)
                      .map((day) => ({
                        transfersData: day.transfersData,
                        day: day.day,
                        date: day.date,
                      }))
                  : [
                    {
                      transfersData: item.transfersData,
                      day: item.day,
                      date: item.date,
                    },
                  ]
          )
          .flat()
          .map((item) =>
              item.transfersData.map((data) => ({
                ...data,
                day: item.day,
                date: item.date,
              }))
          )
          .flat()
          .filter((item) => !item.free)
    },
    flightArrSelectOptions() {
      if (
          this.dataSelects.pointsArr.some(
              (item) =>
                  item.names.EN.toLowerCase() ===
                  this.flightArrSelectInput.toLowerCase()
          )
      ) {
        return this.dataSelects.pointsArr
      } else {
        return this.dataSelects.pointsArr.filter((item) =>
            item.names.EN.toLowerCase().includes(
                this.flightArrSelectInput.toLowerCase()
            )
        )
      }
    },
    flightDepSelectOptions() {
      if (
          this.dataSelects.pointsDep.some(
              (item) =>
                  item.names.EN.toLowerCase() ===
                  this.flightDepSelectInput.toLowerCase()
          )
      ) {
        return this.dataSelects.pointsDep
      } else {
        return this.dataSelects.pointsDep.filter((item) =>
            item.names.EN.toLowerCase().includes(
                this.flightDepSelectInput.toLowerCase()
            )
        )
      }
    },
    tranferFromSelectOptions() {
      const points = this.dataSelects.pointsTransferFrom
      if (
          points.some(
              (item) =>
                  item.title.toLowerCase() ===
                  this.transferFromSelectInput.toLowerCase()
          )
      ) {
        return points
      } else {
        return points.filter((item) =>
            item.title
                .toLowerCase()
                .includes(this.transferFromSelectInput.toLowerCase())
        )
      }
    },
    tranferToSelectOptions() {
      const points = this.dataSelects.pointsTransferTo
      if (
          points.some(
              (item) =>
                  item.title.toLowerCase() ===
                  this.transferToSelectInput.toLowerCase()
          )
      ) {
        return points
      } else {
        return points.filter((item) =>
            item.title
                .toLowerCase()
                .includes(this.transferToSelectInput.toLowerCase())
        )
      }
    },
    hotelSelectRoomOptions() {
      if (this.dataSelects.room.some((room) => room.names.EN.toLowerCase() === this.hotelSelectInputRoom.toLowerCase())) {
        return this.dataSelects.room;
      } else {
        return this.dataSelects.room.filter((room) => room.names.EN.toLowerCase().includes(this.hotelSelectInputRoom.toLowerCase()))
      }
    },
    isSelectedHotelDisplayed() {
      return Boolean(
          this.hotelPopupData.hotel &&
          this.hotelPopupData.hotel.names &&
          this.hotelPopupData.hotel.names.EN === this.hotelSelectInput
      )
    },
    hotelSelectOptions() {
      return this.dataSelects.hotels
          .filter(h => this.hotelSelectInput
              ? h.names.EN.toLowerCase().includes(this.hotelSelectInput.toLowerCase())
              : true
          )
    },
    isHotelClosedThisDay() {
      if (this.hotelsClosedMinNights.closed.length && this.hotelPopup.date) {
        const start = this.parseDate(
            this.hotelsClosedMinNights.closed[0].dateFrom
        )
        const end = this.parseDate(this.hotelsClosedMinNights.closed[0].dateTo)
        const hotelDay = this.hotelPopup.date.split('/')
        if (isBefore(start, end)) {
          return isWithinInterval(
              this.parseDate(`${hotelDay[0]}.${hotelDay[1]}.20${hotelDay[2]}`),
              {start, end}
          )
        } else return false
      }
    },
    isHotelMinNightThisDay() {
      if (this.hotelsClosedMinNights.minNights.length && this.hotelPopup.date) {
        const start = this.parseDate(
            this.hotelsClosedMinNights.minNights[0].dateFrom
        )
        const end = this.parseDate(
            this.hotelsClosedMinNights.minNights[0].dateTo
        )
        const hotelDay = this.hotelPopup.date.split('/')
        if (isBefore(start, end)) {
          return isWithinInterval(
              this.parseDate(`${hotelDay[0]}.${hotelDay[1]}.20${hotelDay[2]}`),
              {start, end}
          )
        } else return false
      }
    },
    sorteredParticipants() {

      if (this.totalPrice && this.totalPrice.breakdownCost) {
        const dlfkldkfl =
            this.totalPrice.breakdownCost.summary.participantCosts.sort((a, b) =>
                a.id < b.id ? -1 : 1
            )
        // console.log('this.totalPrice.breakdownCost', dlfkldkfl)
        return this.totalPrice.breakdownCost.summary.participantCosts.sort(
            (a, b) => (a.id < b.id ? -1 : 1)
        )
      } else {
        return []
      }
    },
    filteredRoutesGroup() {
      if (this.tourStart && this.tourFinish) {
        if (this.currentClimbDay) {
          let tourStartFormatted = format(
              parse(this.currentClimbDay, 'dd/MM/yy', new Date()),
              'dd.MM.yyyy'
          )
          return this.dataSelects.routesGroups
              .filter((route) => route.dateStart === tourStartFormatted)
              .sort((a, b) =>
                  +new Date(
                      (+a.dateStart.split('.')[1]).toString() +
                      '.' +
                      (+a.dateStart.split('.')[0]).toString() +
                      '.' +
                      (+a.dateStart.split('.')[2]).toString()
                  ).getTime() <
                  +new Date(
                      (+b.dateStart.split('.')[1]).toString() +
                      '.' +
                      (+b.dateStart.split('.')[0]).toString() +
                      '.' +
                      (+b.dateStart.split('.')[2]).toString()
                  ).getTime()
                      ? -1
                      : 1
              )
        } else {
          return []
        }
      } else {
        return this.dataSelects.routesGroups.sort((a, b) =>
            +new Date(
                (+a.dateStart.split('.')[1]).toString() +
                '.' +
                (+a.dateStart.split('.')[0]).toString() +
                '.' +
                (+a.dateStart.split('.')[2]).toString()
            ).getTime() <
            +new Date(
                (+b.dateStart.split('.')[1]).toString() +
                '.' +
                (+b.dateStart.split('.')[0]).toString() +
                '.' +
                (+b.dateStart.split('.')[2]).toString()
            ).getTime()
                ? -1
                : 1
        )
        // return this.dataSelects.routesGroups
        //     .filter(route => +new Date((+route.dateStart.split('.')[1]).toString() + '.' + (+route.dateStart.split('.')[0]).toString() + '.' + (+route.dateStart.split('.')[2]).toString()).getTime() >= +new Date().getTime())
        //     .sort((a, b) => +new Date((+a.dateStart.split('.')[1]).toString() + '.' + (+a.dateStart.split('.')[0]).toString() + '.' + (+a.dateStart.split('.')[2]).toString()).getTime() < +new Date((+b.dateStart.split('.')[1]).toString() + '.' + (+b.dateStart.split('.')[0]).toString() + '.' + (+b.dateStart.split('.')[2]).toString()).getTime() ? -1 : 1)
      }
    },
    filteredHotelsData() {
      // console.log('this.data.program', this.data.program)
      // console.log(this.data.program
      //     .filter(
      //         (item) =>
      //             item.type.data === 'SAFARI' ||
      //             item.type.data === 'ISLAND' ||
      //             item.hotelsData.length
      //     )
      //     .map((item) =>
      //         item.type.data === 'SAFARI' || item.type.data === 'ISLAND'
      //             ? item.days
      //                 .filter((day) => day.hotelsData.length)
      //                 .map((day) => ({
      //                   hotelsData: day.hotelsData,
      //                   day: day.day,
      //                   date: day.date,
      //                 }))
      //             : {
      //               hotelsData: item.hotelsData,
      //               day: item.day,
      //               date: item.date,
      //               dayTo: item.days.length ? (item.day + item.days.length) - 1 : null,
      //               type: item.type.data,
      //             }
      //     ))
      // console.log('>',this.data.program
      //     .filter(
      //         (item) =>
      //             item.type.data === 'SAFARI' ||
      //             item.type.data === 'ISLAND' ||
      //             item.hotelsData.length
      //     )
      //     .map((item) =>
      //         item.type.data === 'SAFARI' || item.type.data === 'ISLAND'
      //             ? item.days
      //                 .filter((day) => day.hotelsData.length)
      //                 .map((day) => ({
      //                   hotelsData: day.hotelsData,
      //                   day: day.day,
      //                   date: day.date,
      //                 }))
      //             : {
      //               hotelsData: item.hotelsData,
      //               day: item.day,
      //               date: item.date,
      //               dayTo: item.days.length ? (item.day + item.days.length) - 1 : null,
      //               type: item.type.data,
      //             }
      //     )
      //     .flat())
      // console.log('>>',this.data.program
      //     .filter(
      //         (item) =>
      //             item.type.data === 'SAFARI' ||
      //             item.type.data === 'ISLAND' ||
      //             item.hotelsData.length
      //     )
      //     .map((item) =>
      //         item.type.data === 'SAFARI' || item.type.data === 'ISLAND'
      //             ? item.days
      //                 .filter((day) => day.hotelsData.length)
      //                 .map((day) => ({
      //                   hotelsData: day.hotelsData,
      //                   day: day.day,
      //                   date: day.date,
      //                 }))
      //             : {
      //               hotelsData: item.hotelsData,
      //               day: item.day,
      //               date: item.date,
      //               dayTo: item.days.length ? (item.day + item.days.length) - 1 : null,
      //               type: item.type.data,
      //               duration: item.duration
      //             }
      //     )
      //     .flat()
      //     .map((hd) => (console.log(">> map hd.hotelsData", hd.hotelsData[0].day),{
      //       ...hd,
      //       day: hd.type === 'CLIMBING' ? hd.hotelsData[0].day : hd.day,
      //       date:
      //           hd.type === 'CLIMBING' && hd.date
      //               ? date(
      //                   +new Date(
      //                       +('20' + hd.date.split('/')[2]),
      //                       +hd.date.split('/')[1] - 1,
      //                       +hd.date.split('/')[0]
      //                   ).getTime() +
      //                   (hd.duration - 1) * 24 * 60 * 60 * 1000 + (60 * 60 * 1000),
      //                   'd'
      //               )
      //               : hd.date
      //                   ? date(
      //                       +new Date(
      //                           +('20' + hd.date.split('/')[2]),
      //                           +hd.date.split('/')[1] - 1,
      //                           +hd.date.split('/')[0]
      //                       ).getTime(),
      //                       'd'
      //                   )
      //                   : '',
      //       hotelsData: hd.hotelsData.map((data) => ({
      //         ...data,
      //         day: hd.type === 'CLIMBING' ? data.day : hd.day,
      //         date: hd.type === 'CLIMBING' ? data.date : hd.date,
      //       })),
      //     })))
      // .filter(item => item.type.data === 'SAFARI' || item.type.data === 'ISLAND' || item.hotelsData.length)
      // .map(item =>
      // 	item.type.data === 'SAFARI' || item.type.data === 'ISLAND' ?
      // 	item.days
      // 		.filter(day => day.hotelsData.length)
      // 		.map(day => ({hotelsData : day.hotelsData, day: day.day, date: day.date})) :
      // 	{hotelsData: item.hotelsData, day: item.day, date: item.date, type: item.type.data})
      // 	.flat()
      // 	.map(hd =>
      // 		({...hd,
      // 			day: hd.type === 'CLIMBING' ?
      // 				hd.hotelsData[0].day :
      // 				hd.day,
      // 			date: hd.type === 'CLIMBING' && hd.date ?
      // 				date(+new Date(+('20' + hd.date.split('/')[2]), +hd.date.split('/')[1] - 1, +hd.date.split('/')[0]).getTime() + ((hd.hotelsData[0].day - 2) * 24 * 60 * 60 * 1000), 'd') : hd.date ?
      // 				date(+new Date(+('20' + hd.date.split('/')[2]), +hd.date.split('/')[1] - 1, +hd.date.split('/')[0]).getTime(), 'd') : '',
      // 			hotelsData :
      // 				hd.hotelsData.map(data => ({...data, day: hd.type === 'CLIMBING' ? data.day : hd.day, date: hd.type === 'CLIMBING' ? data.date :  hd.date}))})))
      return this.data.program
          .filter(
              (item) =>
                  item.type.data === 'SAFARI' ||
                  item.type.data === 'ISLAND' ||
                  item.hotelsData.length
          )
          .map((item) =>
              item.type.data === 'SAFARI' || item.type.data === 'ISLAND'
                  ? item.days
                      .filter((day) => day.hotelsData.length)
                      .map((day) => ({
                        hotelsData: day.hotelsData,
                        day: day.day,
                        date: day.date,
                      }))
                  : {
                    hotelsData: item.hotelsData,
                    day: item.day,
                    date: item.date,
                    dayTo: item.days.length ? (item.day + item.days.length) - 1 : null,
                    type: item.type.data,
                    duration: item.duration
                  }
          )
          .flat()
          .map((hd) => ({
            ...hd,
            day: hd.type === 'CLIMBING' ? hd.hotelsData[0].day : hd.day,
            date:
                hd.type === 'CLIMBING' && hd.date
                    ? date(
                        +new Date(
                            +('20' + hd.date.split('/')[2]),
                            +hd.date.split('/')[1] - 1,
                            +hd.date.split('/')[0]
                        ).getTime() +
                        (hd.duration - 1) * 24 * 60 * 60 * 1000 + (60 * 60 * 1000),
                        'd'
                    )
                    : hd.date
                        ? date(
                            +new Date(
                                +('20' + hd.date.split('/')[2]),
                                +hd.date.split('/')[1] - 1,
                                +hd.date.split('/')[0]
                            ).getTime(),
                            'd'
                        )
                        : '',
            hotelsData: hd.hotelsData.map((data) => ({
              ...data,
              day: hd.type === 'CLIMBING' ? data.day : hd.day,
              date: hd.type === 'CLIMBING' ? data.date : hd.date,
            })),
          }))
    },
  },
}
</script>
<style scoped lang="scss">
.safari-park-select {
  width: 20rem;

  ::v-deep .vs__selected {
    width: calc(100% - 6rem);
  }

  ::v-deep .vs__actions .icon-chevron {
    width: 0.8rem;
    height: 0.5rem;
    color: #676767;
  }

  &.vs--open ::v-deep .vs__selected {
    opacity: 0;
  }

  ::v-deep .vs__dropdown-option--highlight {
    background: #f0f0f0;
  }
}

@media (min-width: 768px) and (max-width: 1279px) {
  .safari-park-select {
    width: 17rem;
  }
}

@media (min-width: 768px) {
  .edit-popup--choose-hotel {
    max-width: 84rem;
  }

  .hotel-select-wrapper {
    .hotel-select-trigger {
      width: 34rem;
    }

    .select-body {
      width: 44rem;
      border-radius: 0 3px 3px 3px;
    }
  }

  .hotel-meal-plan-select {
    .select-trigger {
      width: 8rem;
    }
  }

  .hotel-room-type-select {
    .select-trigger {
      width: 23rem;
    }
  }
}

.hotel-select-trigger {
  align-items: center;

  &__input-wrapper {
    position: relative;
    flex: 1;
    min-width: 0;
    height: 100%;
  }

  .select-trigger__name {
    width: 100%;
    padding-right: 1.2rem;
  }

  .select-trigger__icon {
    flex: none;
    margin-left: auto;
  }
}

.hotel-select-trigger__name--with-preferred-partner {
  padding-left: 0;
}

.hotel-select-trigger__name--with-badge {
  padding-right: 65px;
}

.hotel-select-trigger__name--with-two-badges {
  padding-right: 126px;
}

.hotel-select-trigger__name--with-badge:focus {
  padding-right: 1.2rem;
}

.hotel-select-trigger__badge-positioner {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 0 4px 0 1.2rem;
  overflow: hidden;
  pointer-events: none;

  &--with-preferred-partner {
    padding-left: 0;
  }
}

.hotel-select-trigger__text-measure {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  visibility: hidden;
  white-space: pre;
  font-size: 1.2rem;
  line-height: 2.8em;
  font-weight: 500;
}

.hotel-select-trigger__name:focus + .hotel-select-trigger__badge-positioner {
  opacity: 0;
}

.hotel-select-option {
  align-items: center;
  padding-left: 4px;

  .select-option__name {
    flex: 0 1 auto;
    min-width: 0;
    width: auto;
  }
}

.hotel-preferred-partner-icon {
  display: block;
  width: 21px;
  height: 15px;
  flex: none;

  &--trigger {
    margin-left: 10px;
  }

  &--option {
    margin-right: 0;
  }
}

.hotel-best-price-badge,
.hotel-low-priority-badge {
  display: block;
  width: 57px;
  height: 14px;
  flex: none;
}

.hotel-best-price-badge--trigger,
.hotel-low-priority-badge--trigger {
  margin-left: 4px;
}

.hotel-best-price-badge--option,
.hotel-low-priority-badge--option {
  margin-left: 8px;
}

.hotel-alternative-diff--option {
  margin-left: 8px;
}

.choose-hotel__check {
  &--col {
    width: 100%;
  }
}

.movethis {
  &-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-button {
    width: 27px;
    height: 27px;
    background: #FFFFFF;
    border: 1px solid rgba(221, 221, 221, 0.5);
    box-shadow: 0px 1px 2px rgb(0 0 0 / 10%);
    border-radius: 30px;
    color: #4B4B4B;
    transition: 0.3s;
  }
}

.commissions {
  &-header {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.2em;
    color: #1a1a1a;
    padding-right: 32px;
    padding-bottom: 5px;
    border-bottom: 1px solid #cecece;
  }
}

.recalculation-popup {
  max-width: 50rem;
  padding: 2.5rem;
  border-radius: 14px;

  &__title {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 20px;
    font-size: 17px;
    font-weight: 600;
    margin-top: -20px;
  }

  &__text {
    text-align: center;
    font-size: 13px;
  }
}

.hotel-alert {
  &__help-content {
    display: none;
    position: absolute;
    right: 0;
    bottom: 25px;
    background: rgba(17, 17, 17, 0.7);
    color: white;
    border-radius: 10px;
    width: 200px;
    padding: 5px 10px;
    font-size: 12px;
  }

  &__help-icon {
    width: 20px;
    cursor: pointer;
    position: relative;

    svg {
      font-size: 20px;
      color: red;
    }

    &:hover .hotel-alert__help-content {
      display: block;
    }
  }
}

.discount-block__input--description {
  width: 320px;
}

.managers-header-wrapper {
  display: flex;
  align-items: center;
}

.managers-header__name {
  font-size: 12px;
  font-weight: 500;
  color: #2E2E2E;
}

.managers-header__title {
  font-size: 12px;
  font-weight: 500;
  color: #2E2E2E;
}

.managers-item__wrapper {
  display: flex;
  align-items: center;
  margin-left: 13px;
}

.managers-icon-resize {
  user-select: none;
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 50%;
  background-color: #606060;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  outline: #A6A6A6 solid 2px;
  outline-offset: 1px;

  img {
    margin: 1px;
  }
}

.select-wrapper__lang .select-trigger__flag__icon {
  border-radius: 0;
  overflow: hidden;
}

.language-flag {
  display: block;
  border-radius: 0;
}

.warning-modal {
  &__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    max-width: 434px;
  }

  &__icon {
    margin-right: 10px;
  }

  &__title {
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 1.2;
    margin: 15px 0;
  }

  &__text {
    font-size: 13px;
    font-weight: 400;
    line-height: 1.2;
    text-align: center;
  }

  &__button {
    margin: 20px 0 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline: none;
    box-shadow: none;
    border: none;
    color: white;
    background: linear-gradient(180deg, #639a05 0%, #5c8f07 100%);
    padding: 0 2rem;
    font-size: 1.3rem;
    line-height: 1em;
    font-weight: 500;
    min-width: 13rem;
    height: 3.4rem;
    border-radius: 5px;
    transition: all .3s;

    &:hover {
      transition: all .3s;
      background: linear-gradient(180deg, #639a05 0%, #528008 100%);
    }
  }
}

.flights__additional-info {
  display: flex;
  margin-top: 30px;
  margin-left: 5px;
  flex-direction: column;
  font-size: 12px;
  gap: 20px;
  line-height: 14.32px;

  &__name {
    display: inline-flex;


    &--second {
      margin-left: 45px;
    }
  }

  &--bold {
    font-weight: 700;
    margin-right: 5px;
  }

  &__icon {
    display: flex;
    margin-left: 2px;
  }
}

.hotel-modal__add-info {
  &-container {
    padding: 10px 5px;
    font-size: 12px;
    line-height: 15px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &-double {
    display: flex;
    gap: 60px;
  }

  &-label {
    font-weight: 700;
    text-transform: uppercase;
  }
}

.breakdown-cost__summary-notification {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  padding: 0 0 30px 0;

  &__top {
    width: fit-content;
    display: flex;
    align-items: center;
    font-size: 15px;
    position: relative;

    & > span {
      margin-left: 10px;
      line-height: 20px;
    }
  }

  &__bottom {
    margin-top: 10px;
  }

  &__icons {
    position: relative;

    & svg {
      position: relative;
      z-index: 1;
    }

    & svg:last-child {
      z-index: 0;
      position: relative;
      left: -5px;
    }
  }
}
</style>
